window.slate = window.slate || {};
window.theme = window.theme || {};
window.timber = window.timber || {};

/* Defensive fallback: theme.strings and theme.moneyFormat are normally set
   by the inline <script> in theme.liquid.  If that script fails (e.g. syntax
   error from a Shopify admin edit), provide safe defaults so the Product
   section constructor doesn't crash. */
theme.strings = theme.strings || { addToCart: 'Add to Cart', soldOut: 'Sold Out', unavailable: 'Unavailable', preOrder: 'Pre-Order Now', join: 'Join Now' };
theme.moneyFormat = theme.moneyFormat || '${{amount}}';


/*================ Vendor ================*/
/*! lazysizes - v4.0.0 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";if(a.addEventListener){var d=a.requestAnimationFrame||setTimeout,e=function(){var f,g,h,i,j=c.cfg,k={"data-bgset":1,"data-include":1,"data-poster":1,"data-bg":1,"data-script":1},l="(\\s|^)("+j.loadedClass,m=b.documentElement,n=function(a){d(function(){c.rC(a,j.loadedClass),j.unloadedClass&&c.rC(a,j.unloadedClass),c.aC(a,j.lazyClass)})},o=function(a){var b,c,d,e;for(b=0,c=a.length;c>b;b++)d=a[b],e=d.target,e.getAttribute(d.attributeName)&&("source"==e.localName&&e.parentNode&&(e=e.parentNode.querySelector("img")),e&&l.test(e.className)&&n(e))};j.unloadedClass&&(l+="|"+j.unloadedClass),l+="|"+j.loadingClass+")(\\s|$)",l=new RegExp(l),k[j.srcAttr]=1,k[j.srcsetAttr]=1,a.MutationObserver?(h=new MutationObserver(o),f=function(){i||(i=!0,h.observe(m,{subtree:!0,attributes:!0,attributeFilter:Object.keys(k)}))},g=function(){i&&(i=!1,h.disconnect())}):(m.addEventListener("DOMAttrModified",function(){var a,b=[],c=function(){o(b),b=[],a=!1};return function(d){i&&k[d.attrName]&&d.newValue&&(b.push({target:d.target,attributeName:d.attrName}),a||(setTimeout(c),a=!0))}}(),!0),f=function(){i=!0},g=function(){i=!1}),addEventListener("lazybeforeunveil",g,!0),addEventListener("lazybeforeunveil",f),addEventListener("lazybeforesizes",g,!0),addEventListener("lazybeforesizes",f),f(),removeEventListener("lazybeforeunveil",e)};addEventListener("lazybeforeunveil",e)}});
/*! lazysizes - v4.0.0 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";if(a.addEventListener){var d=/\s+/g,e=/\s*\|\s+|\s+\|\s*/g,f=/^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,g=/\(|\)|'/,h={contain:1,cover:1},i=function(a){var b=c.gW(a,a.parentNode);return(!a._lazysizesWidth||b>a._lazysizesWidth)&&(a._lazysizesWidth=b),a._lazysizesWidth},j=function(a){var b;return b=(getComputedStyle(a)||{getPropertyValue:function(){}}).getPropertyValue("background-size"),!h[b]&&h[a.style.backgroundSize]&&(b=a.style.backgroundSize),b},k=function(a,c,g){var h=b.createElement("picture"),i=c.getAttribute(lazySizesConfig.sizesAttr),j=c.getAttribute("data-ratio"),k=c.getAttribute("data-optimumx");c._lazybgset&&c._lazybgset.parentNode==c&&c.removeChild(c._lazybgset),Object.defineProperty(g,"_lazybgset",{value:c,writable:!0}),Object.defineProperty(c,"_lazybgset",{value:h,writable:!0}),a=a.replace(d," ").split(e),h.style.display="none",g.className=lazySizesConfig.lazyClass,1!=a.length||i||(i="auto"),a.forEach(function(a){var c=b.createElement("source");i&&"auto"!=i&&c.setAttribute("sizes",i),a.match(f)&&(c.setAttribute(lazySizesConfig.srcsetAttr,RegExp.$1),RegExp.$2&&c.setAttribute("media",lazySizesConfig.customMedia[RegExp.$2]||RegExp.$2)),h.appendChild(c)}),i&&(g.setAttribute(lazySizesConfig.sizesAttr,i),c.removeAttribute(lazySizesConfig.sizesAttr),c.removeAttribute("sizes")),k&&g.setAttribute("data-optimumx",k),j&&g.setAttribute("data-ratio",j),h.appendChild(g),c.appendChild(h)},l=function(a){if(a.target._lazybgset){var b=a.target,d=b._lazybgset,e=b.currentSrc||b.src;e&&(d.style.backgroundImage="url("+(g.test(e)?JSON.stringify(e):e)+")"),b._lazybgsetLoading&&(c.fire(d,"_lazyloaded",{},!1,!0),delete b._lazybgsetLoading)}};addEventListener("lazybeforeunveil",function(a){var d,e,f;!a.defaultPrevented&&(d=a.target.getAttribute("data-bgset"))&&(f=a.target,e=b.createElement("img"),e.alt="",e._lazybgsetLoading=!0,a.detail.firesLoad=!0,k(d,f,e),setTimeout(function(){c.loader.unveil(e),c.rAF(function(){c.fire(e,"_lazyloaded",{},!0,!0),e.complete&&l({target:e})})}))}),b.addEventListener("load",l,!0),a.addEventListener("lazybeforesizes",function(a){if(a.detail.instance==c&&a.target._lazybgset&&a.detail.dataAttr){var b=a.target._lazybgset,d=j(b);h[d]&&(a.target._lazysizesParentFit=d,c.rAF(function(){a.target.setAttribute("data-parent-fit",d),a.target._lazysizesParentFit&&delete a.target._lazysizesParentFit}))}},!0),b.documentElement.addEventListener("lazybeforesizes",function(a){!a.defaultPrevented&&a.target._lazybgset&&a.detail.instance==c&&(a.detail.width=i(a.target._lazybgset))})}});
/*! lazysizes - v4.0.0 */
!function(a,b){var c=function(d){b(a.lazySizes,d),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c,d){"use strict";function e(a){var b=getComputedStyle(a,null)||{},c=b.fontFamily||"",d=c.match(j)||"",e=d&&c.match(k)||"";return e&&(e=e[1]),{fit:d&&d[1]||"",position:n[e]||e||"center"}}function f(a,b){var d,e=c.cfg,f=a.cloneNode(!1),g=f.style,h=function(){var b=a.currentSrc||a.src;b&&(g.backgroundImage="url("+(m.test(b)?JSON.stringify(b):b)+")",d||(d=!0,c.rC(f,e.loadingClass),c.aC(f,e.loadedClass)))};a._lazysizesParentFit=b.fit,a.addEventListener("load",function(){c.rAF(h)},!0),f.addEventListener("load",function(){var a=f.currentSrc||f.src;a&&a!=l&&(f.src=l,f.srcset="")}),c.rAF(function(){var d=a,i=a.parentNode;"PICTURE"==i.nodeName.toUpperCase()&&(d=i,i=i.parentNode),c.rC(f,e.loadedClass),c.rC(f,e.lazyClass),c.aC(f,e.loadingClass),c.aC(f,e.objectFitClass||"lazysizes-display-clone"),f.getAttribute(e.srcsetAttr)&&f.setAttribute(e.srcsetAttr,""),f.getAttribute(e.srcAttr)&&f.setAttribute(e.srcAttr,""),f.src=l,f.srcset="",g.backgroundRepeat="no-repeat",g.backgroundPosition=b.position,g.backgroundSize=b.fit,d.style.display="none",a.setAttribute("data-parent-fit",b.fit),a.setAttribute("data-parent-container","prev"),i.insertBefore(f,d),a._lazysizesParentFit&&delete a._lazysizesParentFit,a.complete&&h()})}var g=b.createElement("a").style,h="objectFit"in g,i=h&&"objectPosition"in g,j=/object-fit["']*\s*:\s*["']*(contain|cover)/,k=/object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,l="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",m=/\(|\)|'/,n={center:"center","50% 50%":"center"};if(!h||!i){var o=function(a){if(a.detail.instance==c){var b=a.target,d=e(b);!d.fit||h&&"center"==d.position||f(b,d)}};a.addEventListener("lazyunveilread",o,!0),d&&d.detail&&o(d)}});
/*! lazysizes - v4.0.0 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";if(a.addEventListener){var d,e=/^picture$/i,f=b.documentElement,g=function(){var a,b=/(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g,c=function(b,c,d,e,f,g,h,i){a.push({c:c,u:d,w:1*("w"==i?h:e)})};return function(d){return a=[],d.replace(b,c),a}}(),h=function(){var a=function(a,b){return a.w-b.w},b=function(b,d){var e={srcset:b.getAttribute(c.cfg.srcsetAttr)||""},f=g(e.srcset);return Object.defineProperty(b,d,{value:e,writable:!0}),e.cands=f,e.index=0,e.dirty=!1,f[0]&&f[0].w?(f.sort(a),e.cSrcset=[f[e.index].c]):(e.cSrcset=e.srcset?[e.srcset]:[],e.cands=[]),e};return function(a,c){var d,f,g,h;if(!a[c]&&(h=a.parentNode||{},a[c]=b(a,c),a[c].isImg=!0,e.test(h.nodeName||"")))for(a[c].picture=!0,d=h.getElementsByTagName("source"),f=0,g=d.length;g>f;f++)b(d[f],c).isImg=!1;return a[c]}}(),i={_lazyOptimumx:function(){var a=function(a,b,c){var d,e,f;return a&&a.d?(f=c>.7?.6:.4,a.d>=c?!1:(e=Math.pow(a.d-f,1.6)||.1,.1>e?e=.1:e>3&&(e=3),d=a.d+(b-c)*e,c>d)):!0};return function(b,c,d){var e,f;for(e=0;e<b.cands.length;e++)if(f=b.cands[e],f.d=(f.w||1)/c,!(b.index>=e)){if(!(f.d<=d||a(b.cands[e-1],f.d,d)))break;b.cSrcset.push(f.c),b.index=e}}}()},j=function(){var a=function(a,b,c,d,e){var f,g=a[e];g&&(f=g.index,i[e](g,b,c),g.dirty&&f==g.index||(g.cSrcset.join(", "),a.setAttribute(d,g.cSrcset.join(", ")),g.dirty=!0))};return function(b,c,d,e,f){var g,h,i,j,k=b[f];if(k.width=c,k.picture&&(h=b.parentNode))for(g=h.getElementsByTagName("source"),j=0,i=g.length;i>j;j++)a(g[j],c,d,e,f);a(b,c,d,e,f)}}(),k=function(a){var b=a.getAttribute("data-optimumx")||a.getAttribute("data-maxdpr");return!b&&d.constrainPixelDensity&&(b="auto"),b&&(b="auto"==b?d.getOptimumX(a):parseFloat(b,10)),b},l=function(){c&&!c.getOptimumX&&(c.getX=k,c.pWS=g,f.removeEventListener("lazybeforeunveil",l))};f.addEventListener("lazybeforeunveil",l),setTimeout(l),d=c&&c.cfg||a.lazySizesConfig,d||(d={},a.lazySizesConfig=d),"function"!=typeof d.getOptimumX&&(d.getOptimumX=function(){var b=a.devicePixelRatio||1;return b>2.6?b*=.6:b>1.9?b*=.8:b-=.01,Math.min(Math.round(100*b)/100,2)}),a.devicePixelRatio&&addEventListener("lazybeforesizes",function(a){if(a.detail.instance==c){var b,e,f,g,i=a.target,l=a.detail,m=l.dataAttr;a.defaultPrevented||!(b=k(i))||b>=devicePixelRatio||(!m||!i._lazyOptimumx||l.reloaded||d.unloadedClass&&c.hC(i,d.unloadedClass)||(i._lazyOptimumx=null),e=h(i,"_lazyOptimumx"),f=l.width,f&&(e.width||0)<f&&(g=m?c.cfg.srcsetAttr:"srcset",c.rAF(function(){j(i,f,b,g,"_lazyOptimumx")})))}})}});
/*! lazysizes - v4.0.0 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";if(a.addEventListener){var d=/\s+(\d+)(w|h)\s+(\d+)(w|h)/,e=/parent-fit["']*\s*:\s*["']*(contain|cover|width)/,f=/parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,g=/^picture$/i,h=function(a){return getComputedStyle(a,null)||{}},i={getParent:function(b,c){var d=b,e=b.parentNode;return c&&"prev"!=c||!e||!g.test(e.nodeName||"")||(e=e.parentNode),"self"!=c&&(d="prev"==c?b.previousElementSibling:c&&(e.closest||a.jQuery)?(e.closest?e.closest(c):jQuery(e).closest(c)[0])||e:e),d},getFit:function(a){var b,c,d=h(a),g=d.content||d.fontFamily,j={fit:a._lazysizesParentFit||a.getAttribute("data-parent-fit")};return!j.fit&&g&&(b=g.match(e))&&(j.fit=b[1]),j.fit?(c=a._lazysizesParentContainer||a.getAttribute("data-parent-container"),!c&&g&&(b=g.match(f))&&(c=b[1]),j.parent=i.getParent(a,c)):j.fit=d.objectFit,j},getImageRatio:function(b){var c,e,f,h,i=b.parentNode,j=i&&g.test(i.nodeName||"")?i.querySelectorAll("source, img"):[b];for(c=0;c<j.length;c++)if(b=j[c],e=b.getAttribute(lazySizesConfig.srcsetAttr)||b.getAttribute("srcset")||b.getAttribute("data-pfsrcset")||b.getAttribute("data-risrcset")||"",f=b._lsMedia||b.getAttribute("media"),f=lazySizesConfig.customMedia[b.getAttribute("data-media")||f]||f,e&&(!f||(a.matchMedia&&matchMedia(f)||{}).matches)){h=parseFloat(b.getAttribute("data-aspectratio")),!h&&e.match(d)&&(h="w"==RegExp.$2?RegExp.$1/RegExp.$3:RegExp.$3/RegExp.$1);break}return h},calculateSize:function(a,b){var c,d,e,f,g=this.getFit(a),h=g.fit,i=g.parent;return"width"==h||("contain"==h||"cover"==h)&&(e=this.getImageRatio(a))?(i?b=i.clientWidth:i=a,f=b,"width"==h?f=b:(d=i.clientHeight,d>40&&(c=b/d)&&("cover"==h&&e>c||"contain"==h&&c>e)&&(f=b*(e/c))),f):b}};c.parentFit=i,b.addEventListener("lazybeforesizes",function(a){if(!a.defaultPrevented&&a.detail.instance==c){var b=a.target;a.detail.width=i.calculateSize(b,a.detail.width)}})}});
/*! lazysizes - v4.0.0 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes"),require("../fix-ios-sizes/fix-ios-sizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";var d,e=c&&c.cfg||a.lazySizesConfig,f=b.createElement("img"),g="sizes"in f&&"srcset"in f,h=/\s+\d+h/g,i=function(){var a=/\s+(\d+)(w|h)\s+(\d+)(w|h)/,c=Array.prototype.forEach;return function(d){var e=b.createElement("img"),f=function(b){var c,d=b.getAttribute(lazySizesConfig.srcsetAttr);d&&(d.match(a)&&(c="w"==RegExp.$2?RegExp.$1/RegExp.$3:RegExp.$3/RegExp.$1,c&&b.setAttribute("data-aspectratio",c)),b.setAttribute(lazySizesConfig.srcsetAttr,d.replace(h,"")))},g=function(a){var b=a.target.parentNode;b&&"PICTURE"==b.nodeName&&c.call(b.getElementsByTagName("source"),f),f(a.target)},i=function(){e.currentSrc&&b.removeEventListener("lazybeforeunveil",g)};d[1]&&(b.addEventListener("lazybeforeunveil",g),e.onload=i,e.onerror=i,e.srcset="data:,a 1w 1h",e.complete&&i())}}();if(e||(e={},a.lazySizesConfig=e),e.supportsType||(e.supportsType=function(a){return!a}),!a.picturefill&&!e.pf){if(a.HTMLPictureElement&&g)return b.msElementsFromPoint&&i(navigator.userAgent.match(/Edge\/(\d+)/)),void(e.pf=function(){});e.pf=function(b){var c,e;if(!a.picturefill)for(c=0,e=b.elements.length;e>c;c++)d(b.elements[c])},d=function(){var f=function(a,b){return a.w-b.w},i=/^\s*\d+\.*\d*px\s*$/,j=function(a){var b,c,d=a.length,e=a[d-1],f=0;for(f;d>f;f++)if(e=a[f],e.d=e.w/a.w,e.d>=a.d){!e.cached&&(b=a[f-1])&&b.d>a.d-.13*Math.pow(a.d,2.2)&&(c=Math.pow(b.d-.6,1.6),b.cached&&(b.d+=.15*c),b.d+(e.d-a.d)*c>a.d&&(e=b));break}return e},k=function(){var a,b=/(([^,\s].[^\s]+)\s+(\d+)w)/g,c=/\s/,d=function(b,c,d,e){a.push({c:c,u:d,w:1*e})};return function(e){return a=[],e=e.trim(),e.replace(h,"").replace(b,d),a.length||!e||c.test(e)||a.push({c:e,u:e,w:99}),a}}(),l=function(){l.init||(l.init=!0,addEventListener("resize",function(){var a,c=b.getElementsByClassName("lazymatchmedia"),e=function(){var a,b;for(a=0,b=c.length;b>a;a++)d(c[a])};return function(){clearTimeout(a),a=setTimeout(e,66)}}()))},m=function(b,d){var f,g=b.getAttribute("srcset")||b.getAttribute(e.srcsetAttr);!g&&d&&(g=b._lazypolyfill?b._lazypolyfill._set:b.getAttribute(e.srcAttr)||b.getAttribute("src")),b._lazypolyfill&&b._lazypolyfill._set==g||(f=k(g||""),d&&b.parentNode&&(f.isPicture="PICTURE"==b.parentNode.nodeName.toUpperCase(),f.isPicture&&a.matchMedia&&(c.aC(b,"lazymatchmedia"),l())),f._set=g,Object.defineProperty(b,"_lazypolyfill",{value:f,writable:!0}))},n=function(b){var d=a.devicePixelRatio||1,e=c.getX&&c.getX(b);return Math.min(e||d,2.5,d)},o=function(b){return a.matchMedia?(o=function(a){return!a||(matchMedia(a)||{}).matches})(b):!b},p=function(a){var b,d,g,h,k,l,p;if(h=a,m(h,!0),k=h._lazypolyfill,k.isPicture)for(d=0,b=a.parentNode.getElementsByTagName("source"),g=b.length;g>d;d++)if(e.supportsType(b[d].getAttribute("type"),a)&&o(b[d].getAttribute("media"))){h=b[d],m(h),k=h._lazypolyfill;break}return k.length>1?(p=h.getAttribute("sizes")||"",p=i.test(p)&&parseInt(p,10)||c.gW(a,a.parentNode),k.d=n(a),!k.src||!k.w||k.w<p?(k.w=p,l=j(k.sort(f)),k.src=l):l=k.src):l=k[0],l},q=function(a){if(!g||!a.parentNode||"PICTURE"==a.parentNode.nodeName.toUpperCase()){var b=p(a);b&&b.u&&a._lazypolyfill.cur!=b.u&&(a._lazypolyfill.cur=b.u,b.cached=!0,a.setAttribute(e.srcAttr,b.u),a.setAttribute("src",b.u))}};return q.parse=k,q}(),e.loadedClass&&e.loadingClass&&!function(){var a=[];['img[sizes$="px"][srcset].',"picture > img:not([srcset])."].forEach(function(b){a.push(b+e.loadedClass),a.push(b+e.loadingClass)}),e.pf({elements:b.querySelectorAll(a.join(", "))})}()}});
/*! lazysizes - v4.0.0 */
!function(a,b){var c=function(){b(a.lazySizes),a.removeEventListener("lazyunveilread",c,!0)};b=b.bind(null,a,a.document),"object"==typeof module&&module.exports?b(require("lazysizes")):a.lazySizes?c():a.addEventListener("lazyunveilread",c,!0)}(window,function(a,b,c){"use strict";function d(b,c){var d,e,f,g,h=a.getComputedStyle(b);e=b.parentNode,g={isPicture:!(!e||!m.test(e.nodeName||""))},f=function(a,c){var d=b.getAttribute("data-"+a);if(!d){var e=h.getPropertyValue("--ls-"+a);e&&(d=e.trim())}if(d){if("true"==d)d=!0;else if("false"==d)d=!1;else if(l.test(d))d=parseFloat(d);else if("function"==typeof j[a])d=j[a](b,d);else if(q.test(d))try{d=JSON.parse(d)}catch(f){}g[a]=d}else a in j&&"function"!=typeof j[a]?g[a]=j[a]:c&&"function"==typeof j[a]&&(g[a]=j[a](b,d))};for(d in j)f(d);return c.replace(p,function(a,b){b in g||f(b,!0)}),g}function e(a,b){var c=[],d=function(a,c){return k[typeof b[c]]?b[c]:a};return c.srcset=[],b.absUrl&&(s.setAttribute("href",a),a=s.href),a=((b.prefix||"")+a+(b.postfix||"")).replace(p,d),b.widths.forEach(function(d){var e=b.widthmap[d]||d,f={u:a.replace(n,e).replace(o,b.ratio?Math.round(d*b.ratio):""),w:d};c.push(f),c.srcset.push(f.c=f.u+" "+d+"w")}),c}function f(a,c,d){var f=0,g=0,h=d;if(a){if("container"===c.ratio){for(f=h.scrollWidth,g=h.scrollHeight;!(f&&g||h===b);)h=h.parentNode,f=h.scrollWidth,g=h.scrollHeight;f&&g&&(c.ratio=g/f)}a=e(a,c),a.isPicture=c.isPicture,u&&"IMG"==d.nodeName.toUpperCase()?d.removeAttribute(i.srcsetAttr):d.setAttribute(i.srcsetAttr,a.srcset.join(", ")),Object.defineProperty(d,"_lazyrias",{value:a,writable:!0})}}function g(a,b){var e=d(a,b);return j.modifyOptions.call(a,{target:a,details:e,detail:e}),c.fire(a,"lazyriasmodifyoptions",e),e}function h(a){return a.getAttribute(a.getAttribute("data-srcattr")||j.srcAttr)||a.getAttribute(i.srcsetAttr)||a.getAttribute(i.srcAttr)||a.getAttribute("data-pfsrcset")||""}var i,j,k={string:1,number:1},l=/^\-*\+*\d+\.*\d*$/,m=/^picture$/i,n=/\s*\{\s*width\s*\}\s*/i,o=/\s*\{\s*height\s*\}\s*/i,p=/\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,q=/^\[.*\]|\{.*\}$/,r=/^(?:auto|\d+(px)?)$/,s=b.createElement("a"),t=b.createElement("img"),u="srcset"in t&&!("sizes"in t),v=!!a.HTMLPictureElement&&!u;!function(){var b,d=function(){},e={prefix:"",postfix:"",srcAttr:"data-src",absUrl:!1,modifyOptions:d,widthmap:{},ratio:!1};i=c&&c.cfg||a.lazySizesConfig,i||(i={},a.lazySizesConfig=i),i.supportsType||(i.supportsType=function(a){return!a}),i.rias||(i.rias={}),j=i.rias,"widths"in j||(j.widths=[],function(a){for(var b,c=0;!b||3e3>b;)c+=5,c>30&&(c+=1),b=36*c,a.push(b)}(j.widths));for(b in e)b in j||(j[b]=e[b])}(),addEventListener("lazybeforesizes",function(a){if(a.detail.instance==c){var b,d,e,k,l,m,o,p,q,s,t,u,x;if(b=a.target,a.detail.dataAttr&&!a.defaultPrevented&&!j.disabled&&(q=b.getAttribute(i.sizesAttr)||b.getAttribute("sizes"))&&r.test(q)){if(d=h(b),e=g(b,d),t=n.test(e.prefix)||n.test(e.postfix),e.isPicture&&(k=b.parentNode))for(l=k.getElementsByTagName("source"),m=0,o=l.length;o>m;m++)(t||n.test(p=h(l[m])))&&(f(p,e,l[m]),u=!0);t||n.test(d)?(f(d,e,b),u=!0):u&&(x=[],x.srcset=[],x.isPicture=!0,Object.defineProperty(b,"_lazyrias",{value:x,writable:!0})),u&&(v?b.removeAttribute(i.srcAttr):"auto"!=q&&(s={width:parseInt(q,10)},w({target:b,detail:s})))}}},!0);var w=function(){var d=function(a,b){return a.w-b.w},e=function(a){var b,c,d=a.length,e=a[d-1],f=0;for(f;d>f;f++)if(e=a[f],e.d=e.w/a.w,e.d>=a.d){!e.cached&&(b=a[f-1])&&b.d>a.d-.13*Math.pow(a.d,2.2)&&(c=Math.pow(b.d-.6,1.6),b.cached&&(b.d+=.15*c),b.d+(e.d-a.d)*c>a.d&&(e=b));break}return e},f=function(a,b){var d;return!a._lazyrias&&c.pWS&&(d=c.pWS(a.getAttribute(i.srcsetAttr||""))).length&&(Object.defineProperty(a,"_lazyrias",{value:d,writable:!0}),b&&a.parentNode&&(d.isPicture="PICTURE"==a.parentNode.nodeName.toUpperCase())),a._lazyrias},g=function(b){var d=a.devicePixelRatio||1,e=c.getX&&c.getX(b);return Math.min(e||d,2.4,d)},h=function(b,c){var h,i,j,k,l,m;if(l=b._lazyrias,l.isPicture&&a.matchMedia)for(i=0,h=b.parentNode.getElementsByTagName("source"),j=h.length;j>i;i++)if(f(h[i])&&!h[i].getAttribute("type")&&(!(k=h[i].getAttribute("media"))||(matchMedia(k)||{}).matches)){l=h[i]._lazyrias;break}return(!l.w||l.w<c)&&(l.w=c,l.d=g(b),m=e(l.sort(d))),m},j=function(d){if(d.detail.instance==c){var e,g=d.target;return!u&&(a.respimage||a.picturefill||lazySizesConfig.pf)?void b.removeEventListener("lazybeforesizes",j):void(("_lazyrias"in g||d.detail.dataAttr&&f(g,!0))&&(e=h(g,d.detail.width),e&&e.u&&g._lazyrias.cur!=e.u&&(g._lazyrias.cur=e.u,e.cached=!0,c.rAF(function(){g.setAttribute(i.srcAttr,e.u),g.setAttribute("src",e.u)}))))}};return v?j=function(){}:addEventListener("lazybeforesizes",j),j}()});
/*! lazysizes - v4.0.0 */
!function(a,b){var c=b(a,a.document);a.lazySizes=c,"object"==typeof module&&module.exports&&(module.exports=c)}(window,function(a,b){"use strict";if(b.getElementsByClassName){var c,d,e=b.documentElement,f=a.Date,g=a.HTMLPictureElement,h="addEventListener",i="getAttribute",j=a[h],k=a.setTimeout,l=a.requestAnimationFrame||k,m=a.requestIdleCallback,n=/^picture$/i,o=["load","error","lazyincluded","_lazyloaded"],p={},q=Array.prototype.forEach,r=function(a,b){return p[b]||(p[b]=new RegExp("(\\s|^)"+b+"(\\s|$)")),p[b].test(a[i]("class")||"")&&p[b]},s=function(a,b){r(a,b)||a.setAttribute("class",(a[i]("class")||"").trim()+" "+b)},t=function(a,b){var c;(c=r(a,b))&&a.setAttribute("class",(a[i]("class")||"").replace(c," "))},u=function(a,b,c){var d=c?h:"removeEventListener";c&&u(a,b),o.forEach(function(c){a[d](c,b)})},v=function(a,d,e,f,g){var h=b.createEvent("CustomEvent");return e||(e={}),e.instance=c,h.initCustomEvent(d,!f,!g,e),a.dispatchEvent(h),h},w=function(b,c){var e;!g&&(e=a.picturefill||d.pf)?e({reevaluate:!0,elements:[b]}):c&&c.src&&(b.src=c.src)},x=function(a,b){return(getComputedStyle(a,null)||{})[b]},y=function(a,b,c){for(c=c||a.offsetWidth;c<d.minSize&&b&&!a._lazysizesWidth;)c=b.offsetWidth,b=b.parentNode;return c},z=function(){var a,c,d=[],e=[],f=d,g=function(){var b=f;for(f=d.length?e:d,a=!0,c=!1;b.length;)b.shift()();a=!1},h=function(d,e){a&&!e?d.apply(this,arguments):(f.push(d),c||(c=!0,(b.hidden?k:l)(g)))};return h._lsFlush=g,h}(),A=function(a,b){return b?function(){z(a)}:function(){var b=this,c=arguments;z(function(){a.apply(b,c)})}},B=function(a){var b,c=0,e=125,g=d.ricTimeout,h=function(){b=!1,c=f.now(),a()},i=m&&d.ricTimeout?function(){m(h,{timeout:g}),g!==d.ricTimeout&&(g=d.ricTimeout)}:A(function(){k(h)},!0);return function(a){var d;(a=a===!0)&&(g=33),b||(b=!0,d=e-(f.now()-c),0>d&&(d=0),a||9>d&&m?i():k(i,d))}},C=function(a){var b,c,d=99,e=function(){b=null,a()},g=function(){var a=f.now()-c;d>a?k(g,d-a):(m||e)(e)};return function(){c=f.now(),b||(b=k(g,d))}};!function(){var b,c={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:!0,ricTimeout:300};d=a.lazySizesConfig||a.lazysizesConfig||{};for(b in c)b in d||(d[b]=c[b]);a.lazySizesConfig=d,k(function(){d.init&&F()})}();var D=function(){var g,l,m,o,p,y,D,F,G,H,I,J,K,L,M=/^img$/i,N=/^iframe$/i,O="onscroll"in a&&!/glebot/.test(navigator.userAgent),P=0,Q=0,R=0,S=-1,T=function(a){R--,a&&a.target&&u(a.target,T),(!a||0>R||!a.target)&&(R=0)},U=function(a,c){var d,f=a,g="hidden"==x(b.body,"visibility")||"hidden"!=x(a,"visibility");for(F-=c,I+=c,G-=c,H+=c;g&&(f=f.offsetParent)&&f!=b.body&&f!=e;)g=(x(f,"opacity")||1)>0,g&&"visible"!=x(f,"overflow")&&(d=f.getBoundingClientRect(),g=H>d.left&&G<d.right&&I>d.top-1&&F<d.bottom+1);return g},V=function(){var a,f,h,j,k,m,n,p,q,r=c.elements;if((o=d.loadMode)&&8>R&&(a=r.length)){f=0,S++,null==K&&("expand"in d||(d.expand=e.clientHeight>500&&e.clientWidth>500?500:370),J=d.expand,K=J*d.expFactor),K>Q&&1>R&&S>2&&o>2&&!b.hidden?(Q=K,S=0):Q=o>1&&S>1&&6>R?J:P;for(;a>f;f++)if(r[f]&&!r[f]._lazyRace)if(O)if((p=r[f][i]("data-expand"))&&(m=1*p)||(m=Q),q!==m&&(y=innerWidth+m*L,D=innerHeight+m,n=-1*m,q=m),h=r[f].getBoundingClientRect(),(I=h.bottom)>=n&&(F=h.top)<=D&&(H=h.right)>=n*L&&(G=h.left)<=y&&(I||H||G||F)&&(d.loadHidden||"hidden"!=x(r[f],"visibility"))&&(l&&3>R&&!p&&(3>o||4>S)||U(r[f],m))){if(ba(r[f]),k=!0,R>9)break}else!k&&l&&!j&&4>R&&4>S&&o>2&&(g[0]||d.preloadAfterLoad)&&(g[0]||!p&&(I||H||G||F||"auto"!=r[f][i](d.sizesAttr)))&&(j=g[0]||r[f]);else ba(r[f]);j&&!k&&ba(j)}},W=B(V),X=function(a){s(a.target,d.loadedClass),t(a.target,d.loadingClass),u(a.target,Z),v(a.target,"lazyloaded")},Y=A(X),Z=function(a){Y({target:a.target})},$=function(a,b){try{a.contentWindow.location.replace(b)}catch(c){a.src=b}},_=function(a){var b,c=a[i](d.srcsetAttr);(b=d.customMedia[a[i]("data-media")||a[i]("media")])&&a.setAttribute("media",b),c&&a.setAttribute("srcset",c)},aa=A(function(a,b,c,e,f){var g,h,j,l,o,p;(o=v(a,"lazybeforeunveil",b)).defaultPrevented||(e&&(c?s(a,d.autosizesClass):a.setAttribute("sizes",e)),h=a[i](d.srcsetAttr),g=a[i](d.srcAttr),f&&(j=a.parentNode,l=j&&n.test(j.nodeName||"")),p=b.firesLoad||"src"in a&&(h||g||l),o={target:a},p&&(u(a,T,!0),clearTimeout(m),m=k(T,2500),s(a,d.loadingClass),u(a,Z,!0)),l&&q.call(j.getElementsByTagName("source"),_),h?a.setAttribute("srcset",h):g&&!l&&(N.test(a.nodeName)?$(a,g):a.src=g),f&&(h||l)&&w(a,{src:g})),a._lazyRace&&delete a._lazyRace,t(a,d.lazyClass),z(function(){(!p||a.complete&&a.naturalWidth>1)&&(p?T(o):R--,X(o))},!0)}),ba=function(a){var b,c=M.test(a.nodeName),e=c&&(a[i](d.sizesAttr)||a[i]("sizes")),f="auto"==e;(!f&&l||!c||!a[i]("src")&&!a.srcset||a.complete||r(a,d.errorClass)||!r(a,d.lazyClass))&&(b=v(a,"lazyunveilread").detail,f&&E.updateElem(a,!0,a.offsetWidth),a._lazyRace=!0,R++,aa(a,b,f,e,c))},ca=function(){if(!l){if(f.now()-p<999)return void k(ca,999);var a=C(function(){d.loadMode=3,W()});l=!0,d.loadMode=3,W(),j("scroll",function(){3==d.loadMode&&(d.loadMode=2),a()},!0)}};return{_:function(){p=f.now(),c.elements=b.getElementsByClassName(d.lazyClass),g=b.getElementsByClassName(d.lazyClass+" "+d.preloadClass),L=d.hFac,j("scroll",W,!0),j("resize",W,!0),a.MutationObserver?new MutationObserver(W).observe(e,{childList:!0,subtree:!0,attributes:!0}):(e[h]("DOMNodeInserted",W,!0),e[h]("DOMAttrModified",W,!0),setInterval(W,999)),j("hashchange",W,!0),["focus","mouseover","click","load","transitionend","animationend","webkitAnimationEnd"].forEach(function(a){b[h](a,W,!0)}),/d$|^c/.test(b.readyState)?ca():(j("load",ca),b[h]("DOMContentLoaded",W),k(ca,2e4)),c.elements.length?(V(),z._lsFlush()):W()},checkElems:W,unveil:ba}}(),E=function(){var a,c=A(function(a,b,c,d){var e,f,g;if(a._lazysizesWidth=d,d+="px",a.setAttribute("sizes",d),n.test(b.nodeName||""))for(e=b.getElementsByTagName("source"),f=0,g=e.length;g>f;f++)e[f].setAttribute("sizes",d);c.detail.dataAttr||w(a,c.detail)}),e=function(a,b,d){var e,f=a.parentNode;f&&(d=y(a,f,d),e=v(a,"lazybeforesizes",{width:d,dataAttr:!!b}),e.defaultPrevented||(d=e.detail.width,d&&d!==a._lazysizesWidth&&c(a,f,e,d)))},f=function(){var b,c=a.length;if(c)for(b=0;c>b;b++)e(a[b])},g=C(f);return{_:function(){a=b.getElementsByClassName(d.autosizesClass),j("resize",g)},checkElems:g,updateElem:e}}(),F=function(){F.i||(F.i=!0,E._(),D._())};return c={cfg:d,autoSizer:E,loader:D,init:F,uP:w,aC:s,rC:t,hC:r,fire:v,gW:y,rAF:z}}});
/**
 * @license
 * lodash 4.5.1 (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash core -o ./dist/lodash.core.js`
 */
;(function(){function n(n,t){for(var r=-1,e=t.length,u=n.length;++r<e;)n[u+r]=t[r];return n}function t(n,t,r){for(var e=-1,u=n.length;++e<u;){var o=n[e],i=t(o);if(null!=i&&(c===an?i===i:r(i,c)))var c=i,f=o}return f}function r(n,t,r){var e;return r(n,function(n,r,u){return t(n,r,u)?(e=n,false):void 0}),e}function e(n,t,r,e,u){return u(n,function(n,u,o){r=e?(e=false,n):t(r,n,u,o)}),r}function u(n,t){return O(t,function(t){return n[t]})}function o(n){return n&&n.Object===Object?n:null}function i(n){return vn[n];
}function c(n){var t=false;if(null!=n&&typeof n.toString!="function")try{t=!!(n+"")}catch(r){}return t}function f(n,t){return n=typeof n=="number"||hn.test(n)?+n:-1,n>-1&&0==n%1&&(null==t?9007199254740991:t)>n}function a(n){if(Y(n)&&!Pn(n)){if(n instanceof l)return n;if(En.call(n,"__wrapped__")){var t=new l(n.__wrapped__,n.__chain__);return t.__actions__=N(n.__actions__),t}}return new l(n)}function l(n,t){this.__wrapped__=n,this.__actions__=[],this.__chain__=!!t}function p(n,t,r,e){var u;return(u=n===an)||(u=xn[r],
u=(n===u||n!==n&&u!==u)&&!En.call(e,r)),u?t:n}function s(n){return X(n)?Fn(n):{}}function h(n,t,r){if(typeof n!="function")throw new TypeError("Expected a function");return setTimeout(function(){n.apply(an,r)},t)}function v(n,t){var r=true;return $n(n,function(n,e,u){return r=!!t(n,e,u)}),r}function y(n,t){var r=[];return $n(n,function(n,e,u){t(n,e,u)&&r.push(n)}),r}function _(t,r,e,u){u||(u=[]);for(var o=-1,i=t.length;++o<i;){var c=t[o];r>0&&Y(c)&&L(c)&&(e||Pn(c)||K(c))?r>1?_(c,r-1,e,u):n(u,c):e||(u[u.length]=c);
}return u}function g(n,t){return n&&qn(n,t,en)}function b(n,t){return y(t,function(t){return Q(n[t])})}function j(n,t,r,e,u){return n===t?true:null==n||null==t||!X(n)&&!Y(t)?n!==n&&t!==t:m(n,t,j,r,e,u)}function m(n,t,r,e,u,o){var i=Pn(n),f=Pn(t),a="[object Array]",l="[object Array]";i||(a=kn.call(n),"[object Arguments]"==a&&(a="[object Object]")),f||(l=kn.call(t),"[object Arguments]"==l&&(l="[object Object]"));var p="[object Object]"==a&&!c(n),f="[object Object]"==l&&!c(t);return!(l=a==l)||i||p?2&u||(a=p&&En.call(n,"__wrapped__"),
f=f&&En.call(t,"__wrapped__"),!a&&!f)?l?(o||(o=[]),(a=J(o,function(t){return t[0]===n}))&&a[1]?a[1]==t:(o.push([n,t]),t=(i?I:q)(n,t,r,e,u,o),o.pop(),t)):false:r(a?n.value():n,f?t.value():t,e,u,o):$(n,t,a)}function d(n){var t=typeof n;return"function"==t?n:null==n?cn:("object"==t?x:A)(n)}function w(n){n=null==n?n:Object(n);var t,r=[];for(t in n)r.push(t);return r}function O(n,t){var r=-1,e=L(n)?Array(n.length):[];return $n(n,function(n,u,o){e[++r]=t(n,u,o)}),e}function x(n){var t=en(n);return function(r){
var e=t.length;if(null==r)return!e;for(r=Object(r);e--;){var u=t[e];if(!(u in r&&j(n[u],r[u],an,3)))return false}return true}}function E(n,t){return n=Object(n),P(t,function(t,r){return r in n&&(t[r]=n[r]),t},{})}function A(n){return function(t){return null==t?an:t[n]}}function k(n,t,r){var e=-1,u=n.length;for(0>t&&(t=-t>u?0:u+t),r=r>u?u:r,0>r&&(r+=u),u=t>r?0:r-t>>>0,t>>>=0,r=Array(u);++e<u;)r[e]=n[e+t];return r}function N(n){return k(n,0,n.length)}function S(n,t){var r;return $n(n,function(n,e,u){return r=t(n,e,u),
!r}),!!r}function T(t,r){return P(r,function(t,r){return r.func.apply(r.thisArg,n([t],r.args))},t)}function F(n,t,r,e){r||(r={});for(var u=-1,o=t.length;++u<o;){var i=t[u],c=e?e(r[i],n[i],i,r,n):n[i],f=r,a=f[i];En.call(f,i)&&(a===c||a!==a&&c!==c)&&(c!==an||i in f)||(f[i]=c)}return r}function R(n){return V(function(t,r){var e=-1,u=r.length,o=u>1?r[u-1]:an,o=typeof o=="function"?(u--,o):an;for(t=Object(t);++e<u;){var i=r[e];i&&n(t,i,e,o)}return t})}function B(n){return function(){var t=arguments,r=s(n.prototype),t=n.apply(r,t);
return X(t)?t:r}}function D(n,t,r){function e(){for(var o=-1,i=arguments.length,c=-1,f=r.length,a=Array(f+i),l=this&&this!==wn&&this instanceof e?u:n;++c<f;)a[c]=r[c];for(;i--;)a[c++]=arguments[++o];return l.apply(t,a)}if(typeof n!="function")throw new TypeError("Expected a function");var u=B(n);return e}function I(n,t,r,e,u,o){var i=-1,c=1&u,f=n.length,a=t.length;if(f!=a&&!(2&u&&a>f))return false;for(a=true;++i<f;){var l=n[i],p=t[i];if(void 0!==an){a=false;break}if(c){if(!S(t,function(n){return l===n||r(l,n,e,u,o);
})){a=false;break}}else if(l!==p&&!r(l,p,e,u,o)){a=false;break}}return a}function $(n,t,r){switch(r){case"[object Boolean]":case"[object Date]":return+n==+t;case"[object Error]":return n.name==t.name&&n.message==t.message;case"[object Number]":return n!=+n?t!=+t:n==+t;case"[object RegExp]":case"[object String]":return n==t+""}return false}function q(n,t,r,e,u,o){var i=2&u,c=en(n),f=c.length,a=en(t).length;if(f!=a&&!i)return false;for(var l=f;l--;){var p=c[l];if(!(i?p in t:En.call(t,p)))return false}for(a=true;++l<f;){
var p=c[l],s=n[p],h=t[p];if(void 0!==an||s!==h&&!r(s,h,e,u,o)){a=false;break}i||(i="constructor"==p)}return a&&!i&&(r=n.constructor,e=t.constructor,r!=e&&"constructor"in n&&"constructor"in t&&!(typeof r=="function"&&r instanceof r&&typeof e=="function"&&e instanceof e)&&(a=false)),a}function z(n){var t=n?n.length:an;if(W(t)&&(Pn(n)||nn(n)||K(n))){n=String;for(var r=-1,e=Array(t);++r<t;)e[r]=n(r);t=e}else t=null;return t}function C(n){var t=n&&n.constructor,t=Q(t)&&t.prototype||xn;return n===t}function G(n){
return n?n[0]:an}function J(n,t){return r(n,d(t),$n)}function M(n,t){return $n(n,typeof t=="function"?t:cn)}function P(n,t,r){return e(n,d(t),r,3>arguments.length,$n)}function U(n,t){var r;if(typeof t!="function")throw new TypeError("Expected a function");return n=Un(n),function(){return 0<--n&&(r=t.apply(this,arguments)),1>=n&&(t=an),r}}function V(n){var t;if(typeof n!="function")throw new TypeError("Expected a function");return t=In(t===an?n.length-1:Un(t),0),function(){for(var r=arguments,e=-1,u=In(r.length-t,0),o=Array(u);++e<u;)o[e]=r[t+e];
for(u=Array(t+1),e=-1;++e<t;)u[e]=r[e];return u[t]=o,n.apply(this,u)}}function H(n,t){return n>t}function K(n){return Y(n)&&L(n)&&En.call(n,"callee")&&(!Rn.call(n,"callee")||"[object Arguments]"==kn.call(n))}function L(n){return null!=n&&!(typeof n=="function"&&Q(n))&&W(zn(n))}function Q(n){return n=X(n)?kn.call(n):"","[object Function]"==n||"[object GeneratorFunction]"==n}function W(n){return typeof n=="number"&&n>-1&&0==n%1&&9007199254740991>=n}function X(n){var t=typeof n;return!!n&&("object"==t||"function"==t);
}function Y(n){return!!n&&typeof n=="object"}function Z(n){return typeof n=="number"||Y(n)&&"[object Number]"==kn.call(n)}function nn(n){return typeof n=="string"||!Pn(n)&&Y(n)&&"[object String]"==kn.call(n)}function tn(n,t){return t>n}function rn(n){return typeof n=="string"?n:null==n?"":n+""}function en(n){var t=C(n);if(!t&&!L(n))return Dn(Object(n));var r,e=z(n),u=!!e,e=e||[],o=e.length;for(r in n)!En.call(n,r)||u&&("length"==r||f(r,o))||t&&"constructor"==r||e.push(r);return e}function un(n){for(var t=-1,r=C(n),e=w(n),u=e.length,o=z(n),i=!!o,o=o||[],c=o.length;++t<u;){
var a=e[t];i&&("length"==a||f(a,c))||"constructor"==a&&(r||!En.call(n,a))||o.push(a)}return o}function on(n){return n?u(n,en(n)):[]}function cn(n){return n}function fn(t,r,e){var u=en(r),o=b(r,u);null!=e||X(r)&&(o.length||!u.length)||(e=r,r=t,t=this,o=b(r,en(r)));var i=X(e)&&"chain"in e?e.chain:true,c=Q(t);return $n(o,function(e){var u=r[e];t[e]=u,c&&(t.prototype[e]=function(){var r=this.__chain__;if(i||r){var e=t(this.__wrapped__);return(e.__actions__=N(this.__actions__)).push({func:u,args:arguments,
thisArg:t}),e.__chain__=r,e}return u.apply(t,n([this.value()],arguments))})}),t}var an,ln=1/0,pn=/[&<>"'`]/g,sn=RegExp(pn.source),hn=/^(?:0|[1-9]\d*)$/,vn={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","`":"&#96;"},yn={"function":true,object:true},_n=yn[typeof exports]&&exports&&!exports.nodeType?exports:an,gn=yn[typeof module]&&module&&!module.nodeType?module:an,bn=gn&&gn.exports===_n?_n:an,jn=o(yn[typeof self]&&self),mn=o(yn[typeof window]&&window),dn=o(yn[typeof this]&&this),wn=o(_n&&gn&&typeof global=="object"&&global)||mn!==(dn&&dn.window)&&mn||jn||dn||Function("return this")(),On=Array.prototype,xn=Object.prototype,En=xn.hasOwnProperty,An=0,kn=xn.toString,Nn=wn._,Sn=wn.Reflect,Tn=Sn?Sn.f:an,Fn=Object.create,Rn=xn.propertyIsEnumerable,Bn=wn.isFinite,Dn=Object.keys,In=Math.max,$n=function(n,t){
return function(r,e){if(null==r)return r;if(!L(r))return n(r,e);for(var u=r.length,o=t?u:-1,i=Object(r);(t?o--:++o<u)&&false!==e(i[o],o,i););return r}}(g),qn=function(n){return function(t,r,e){var u=-1,o=Object(t);e=e(t);for(var i=e.length;i--;){var c=e[n?i:++u];if(false===r(o[c],c,o))break}return t}}();Tn&&!Rn.call({valueOf:1},"valueOf")&&(w=function(n){n=Tn(n);for(var t,r=[];!(t=n.next()).done;)r.push(t.value);return r});var zn=A("length"),Cn=V(function(t,r){return Pn(t)||(t=null==t?[]:[Object(t)]),_(r,1),
n(N(t),on)}),Gn=V(function(n,t,r){return D(n,t,r)}),Jn=V(function(n,t){return h(n,1,t)}),Mn=V(function(n,t,r){return h(n,Vn(t)||0,r)}),Pn=Array.isArray,Un=Number,Vn=Number,Hn=R(function(n,t){F(t,en(t),n)}),Kn=R(function(n,t){F(t,un(t),n)}),Ln=R(function(n,t,r,e){F(t,un(t),n,e)}),Qn=V(function(n){return n.push(an,p),Ln.apply(an,n)}),Wn=V(function(n,t){return null==n?{}:E(n,_(t,1))}),Xn=d;l.prototype=s(a.prototype),l.prototype.constructor=l,a.assignIn=Kn,a.before=U,a.bind=Gn,a.chain=function(n){return n=a(n),
n.__chain__=true,n},a.compact=function(n){return y(n,Boolean)},a.concat=Cn,a.create=function(n,t){var r=s(n);return t?Hn(r,t):r},a.defaults=Qn,a.defer=Jn,a.delay=Mn,a.filter=function(n,t){return y(n,d(t))},a.flatten=function(n){return n&&n.length?_(n,1):[]},a.flattenDeep=function(n){return n&&n.length?_(n,ln):[]},a.iteratee=Xn,a.keys=en,a.map=function(n,t){return O(n,d(t))},a.matches=function(n){return x(Hn({},n))},a.mixin=fn,a.negate=function(n){if(typeof n!="function")throw new TypeError("Expected a function");
return function(){return!n.apply(this,arguments)}},a.once=function(n){return U(2,n)},a.pick=Wn,a.slice=function(n,t,r){var e=n?n.length:0;return r=r===an?e:+r,e?k(n,null==t?0:+t,r):[]},a.sortBy=function(n,t){var r=0;return t=d(t),O(O(n,function(n,e,u){return{c:n,b:r++,a:t(n,e,u)}}).sort(function(n,t){var r;n:{r=n.a;var e=t.a;if(r!==e){var u=null===r,o=r===an,i=r===r,c=null===e,f=e===an,a=e===e;if(r>e&&!c||!i||u&&!f&&a||o&&a){r=1;break n}if(e>r&&!u||!a||c&&!o&&i||f&&i){r=-1;break n}}r=0}return r||n.b-t.b;
}),A("c"))},a.tap=function(n,t){return t(n),n},a.thru=function(n,t){return t(n)},a.toArray=function(n){return L(n)?n.length?N(n):[]:on(n)},a.values=on,a.extend=Kn,fn(a,a),a.clone=function(n){return X(n)?Pn(n)?N(n):F(n,en(n)):n},a.escape=function(n){return(n=rn(n))&&sn.test(n)?n.replace(pn,i):n},a.every=function(n,t,r){return t=r?an:t,v(n,d(t))},a.find=J,a.forEach=M,a.has=function(n,t){return null!=n&&En.call(n,t)},a.head=G,a.identity=cn,a.indexOf=function(n,t,r){var e=n?n.length:0;r=typeof r=="number"?0>r?In(e+r,0):r:0,
r=(r||0)-1;for(var u=t===t;++r<e;){var o=n[r];if(u?o===t:o!==o)return r}return-1},a.isArguments=K,a.isArray=Pn,a.isBoolean=function(n){return true===n||false===n||Y(n)&&"[object Boolean]"==kn.call(n)},a.isDate=function(n){return Y(n)&&"[object Date]"==kn.call(n)},a.isEmpty=function(n){if(L(n)&&(Pn(n)||nn(n)||Q(n.splice)||K(n)))return!n.length;for(var t in n)if(En.call(n,t))return false;return true},a.isEqual=function(n,t){return j(n,t)},a.isFinite=function(n){return typeof n=="number"&&Bn(n)},a.isFunction=Q,a.isNaN=function(n){
return Z(n)&&n!=+n},a.isNull=function(n){return null===n},a.isNumber=Z,a.isObject=X,a.isRegExp=function(n){return X(n)&&"[object RegExp]"==kn.call(n)},a.isString=nn,a.isUndefined=function(n){return n===an},a.last=function(n){var t=n?n.length:0;return t?n[t-1]:an},a.max=function(n){return n&&n.length?t(n,cn,H):an},a.min=function(n){return n&&n.length?t(n,cn,tn):an},a.noConflict=function(){return wn._===this&&(wn._=Nn),this},a.noop=function(){},a.reduce=P,a.result=function(n,t,r){return t=null==n?an:n[t],
t===an&&(t=r),Q(t)?t.call(n):t},a.size=function(n){return null==n?0:(n=L(n)?n:en(n),n.length)},a.some=function(n,t,r){return t=r?an:t,S(n,d(t))},a.uniqueId=function(n){var t=++An;return rn(n)+t},a.each=M,a.first=G,fn(a,function(){var n={};return g(a,function(t,r){En.call(a.prototype,r)||(n[r]=t)}),n}(),{chain:false}),a.VERSION="4.5.1",$n("pop join replace reverse split push shift sort splice unshift".split(" "),function(n){var t=(/^(?:replace|split)$/.test(n)?String.prototype:On)[n],r=/^(?:push|sort|unshift)$/.test(n)?"tap":"thru",e=/^(?:pop|join|replace|shift)$/.test(n);
a.prototype[n]=function(){var n=arguments;return e&&!this.__chain__?t.apply(this.value(),n):this[r](function(r){return t.apply(r,n)})}}),a.prototype.toJSON=a.prototype.valueOf=a.prototype.value=function(){return T(this.__wrapped__,this.__actions__)},(mn||jn||{})._=a,typeof define=="function"&&typeof define.amd=="object"&&define.amd? define(function(){return a}):_n&&gn?(bn&&((gn.exports=a)._=a),_n._=a):wn._=a}).call(this);

/*
 * jQuery MD5 Plugin 1.2.1
 * https://github.com/blueimp/jQuery-MD5
 *
 * Copyright 2010, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://creativecommons.org/licenses/MIT/
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */

/*jslint bitwise: true */
/*global unescape, jQuery */
!function(n){"use strict";function r(n,r){var t=(65535&n)+(65535&r);return(n>>16)+(r>>16)+(t>>16)<<16|65535&t}function t(n,t,e,u,o,c){return r((f=r(r(t,n),r(u,c)))<<(i=o)|f>>>32-i,e);var f,i}function e(n,r,e,u,o,c,f){return t(r&e|~r&u,n,r,o,c,f)}function u(n,r,e,u,o,c,f){return t(r&u|e&~u,n,r,o,c,f)}function o(n,r,e,u,o,c,f){return t(r^e^u,n,r,o,c,f)}function c(n,r,e,u,o,c,f){return t(e^(r|~u),n,r,o,c,f)}function f(n,t){n[t>>5]|=128<<t%32,n[14+(t+64>>>9<<4)]=t;var f,i,a,h,g,l=1732584193,v=-271733879,d=-1732584194,C=271733878;for(f=0;f<n.length;f+=16)i=l,a=v,h=d,g=C,v=c(v=c(v=c(v=c(v=o(v=o(v=o(v=o(v=u(v=u(v=u(v=u(v=e(v=e(v=e(v=e(v,d=e(d,C=e(C,l=e(l,v,d,C,n[f],7,-680876936),v,d,n[f+1],12,-389564586),l,v,n[f+2],17,606105819),C,l,n[f+3],22,-1044525330),d=e(d,C=e(C,l=e(l,v,d,C,n[f+4],7,-176418897),v,d,n[f+5],12,1200080426),l,v,n[f+6],17,-1473231341),C,l,n[f+7],22,-45705983),d=e(d,C=e(C,l=e(l,v,d,C,n[f+8],7,1770035416),v,d,n[f+9],12,-1958414417),l,v,n[f+10],17,-42063),C,l,n[f+11],22,-1990404162),d=e(d,C=e(C,l=e(l,v,d,C,n[f+12],7,1804603682),v,d,n[f+13],12,-40341101),l,v,n[f+14],17,-1502002290),C,l,n[f+15],22,1236535329),d=u(d,C=u(C,l=u(l,v,d,C,n[f+1],5,-165796510),v,d,n[f+6],9,-1069501632),l,v,n[f+11],14,643717713),C,l,n[f],20,-373897302),d=u(d,C=u(C,l=u(l,v,d,C,n[f+5],5,-701558691),v,d,n[f+10],9,38016083),l,v,n[f+15],14,-660478335),C,l,n[f+4],20,-405537848),d=u(d,C=u(C,l=u(l,v,d,C,n[f+9],5,568446438),v,d,n[f+14],9,-1019803690),l,v,n[f+3],14,-187363961),C,l,n[f+8],20,1163531501),d=u(d,C=u(C,l=u(l,v,d,C,n[f+13],5,-1444681467),v,d,n[f+2],9,-51403784),l,v,n[f+7],14,1735328473),C,l,n[f+12],20,-1926607734),d=o(d,C=o(C,l=o(l,v,d,C,n[f+5],4,-378558),v,d,n[f+8],11,-2022574463),l,v,n[f+11],16,1839030562),C,l,n[f+14],23,-35309556),d=o(d,C=o(C,l=o(l,v,d,C,n[f+1],4,-1530992060),v,d,n[f+4],11,1272893353),l,v,n[f+7],16,-155497632),C,l,n[f+10],23,-1094730640),d=o(d,C=o(C,l=o(l,v,d,C,n[f+13],4,681279174),v,d,n[f],11,-358537222),l,v,n[f+3],16,-722521979),C,l,n[f+6],23,76029189),d=o(d,C=o(C,l=o(l,v,d,C,n[f+9],4,-640364487),v,d,n[f+12],11,-421815835),l,v,n[f+15],16,530742520),C,l,n[f+2],23,-995338651),d=c(d,C=c(C,l=c(l,v,d,C,n[f],6,-198630844),v,d,n[f+7],10,1126891415),l,v,n[f+14],15,-1416354905),C,l,n[f+5],21,-57434055),d=c(d,C=c(C,l=c(l,v,d,C,n[f+12],6,1700485571),v,d,n[f+3],10,-1894986606),l,v,n[f+10],15,-1051523),C,l,n[f+1],21,-2054922799),d=c(d,C=c(C,l=c(l,v,d,C,n[f+8],6,1873313359),v,d,n[f+15],10,-30611744),l,v,n[f+6],15,-1560198380),C,l,n[f+13],21,1309151649),d=c(d,C=c(C,l=c(l,v,d,C,n[f+4],6,-145523070),v,d,n[f+11],10,-1120210379),l,v,n[f+2],15,718787259),C,l,n[f+9],21,-343485551),l=r(l,i),v=r(v,a),d=r(d,h),C=r(C,g);return[l,v,d,C]}function i(n){var r,t="";for(r=0;r<32*n.length;r+=8)t+=String.fromCharCode(n[r>>5]>>>r%32&255);return t}function a(n){var r,t=[];for(t[(n.length>>2)-1]=void 0,r=0;r<t.length;r+=1)t[r]=0;for(r=0;r<8*n.length;r+=8)t[r>>5]|=(255&n.charCodeAt(r/8))<<r%32;return t}function h(n){var r,t,e="0123456789abcdef",u="";for(t=0;t<n.length;t+=1)r=n.charCodeAt(t),u+=e.charAt(r>>>4&15)+e.charAt(15&r);return u}function g(n){return unescape(encodeURIComponent(n))}function l(n){return i(f(a(r=g(n)),8*r.length));var r}function v(n,r){return function(n,r){var t,e,u=a(n),o=[],c=[];for(o[15]=c[15]=void 0,u.length>16&&(u=f(u,8*n.length)),t=0;t<16;t+=1)o[t]=909522486^u[t],c[t]=1549556828^u[t];return e=f(o.concat(a(r)),512+8*r.length),i(f(c.concat(e),640))}(g(n),g(r))}n.md5=function(n,r,t){return r?t?v(r,n):h(v(r,n)):t?l(n):h(l(n))}}("function"==typeof jQuery?jQuery:this);

/*!
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */

// Script: jQuery throttle / debounce: Sometimes, less is more!
//
// *Version: 1.1, Last updated: 3/7/2010*
//
// Project Home - http://benalman.com/projects/jquery-throttle-debounce-plugin/
// GitHub       - http://github.com/cowboy/jquery-throttle-debounce/
// Source       - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.js
// (Minified)   - http://github.com/cowboy/jquery-throttle-debounce/raw/master/jquery.ba-throttle-debounce.min.js (0.7kb)
//
// About: License
//
// Copyright (c) 2010 "Cowboy" Ben Alman,
// Dual licensed under the MIT and GPL licenses.
// http://benalman.com/about/license/
//
// About: Examples
//
// These working examples, complete with fully commented code, illustrate a few
// ways in which this plugin can be used.
//
// Throttle - http://benalman.com/code/projects/jquery-throttle-debounce/examples/throttle/
// Debounce - http://benalman.com/code/projects/jquery-throttle-debounce/examples/debounce/
//
// About: Support and Testing
//
// Information about what version or versions of jQuery this plugin has been
// tested with, what browsers it has been tested in, and where the unit tests
// reside (so you can test it yourself).
//
// jQuery Versions - none, 1.3.2, 1.4.2
// Browsers Tested - Internet Explorer 6-8, Firefox 2-3.6, Safari 3-4, Chrome 4-5, Opera 9.6-10.1.
// Unit Tests      - http://benalman.com/code/projects/jquery-throttle-debounce/unit/
//
// About: Release History
//
// 1.1 - (3/7/2010) Fixed a bug in <jQuery.throttle> where trailing callbacks
//       executed later than they should. Reworked a fair amount of internal
//       logic as well.
// 1.0 - (3/6/2010) Initial release as a stand-alone project. Migrated over
//       from jquery-misc repo v0.4 to jquery-throttle repo v1.0, added the
//       no_trailing throttle parameter and debounce functionality.
//
// Topic: Note for non-jQuery users
//
// jQuery isn't actually required for this plugin, because nothing internal
// uses any jQuery methods or properties. jQuery is just used as a namespace
// under which these methods can exist.
//
// Since jQuery isn't actually required for this plugin, if jQuery doesn't exist
// when this plugin is loaded, the method described below will be created in
// the `Cowboy` namespace. Usage will be exactly the same, but instead of
// $.method() or jQuery.method(), you'll need to use Cowboy.method().

(function(window,undefined){
  '$:nomunge'; // Used by YUI compressor.

  // Since jQuery really isn't required for this plugin, use `jQuery` as the
  // namespace only if it already exists, otherwise use the `Cowboy` namespace,
  // creating it if necessary.
  var $ = window.jQuery || window.Cowboy || ( window.Cowboy = {} ),

    // Internal method reference.
    jq_throttle;

  // Method: jQuery.throttle
  //
  // Throttle execution of a function. Especially useful for rate limiting
  // execution of handlers on events like resize and scroll. If you want to
  // rate-limit execution of a function to a single time, see the
  // <jQuery.debounce> method.
  //
  // In this visualization, | is a throttled-function call and X is the actual
  // callback execution:
  //
  // > Throttled with `no_trailing` specified as false or unspecified:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X    X    X    X    X    X        X    X    X    X    X    X
  // >
  // > Throttled with `no_trailing` specified as true:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X    X    X    X    X             X    X    X    X    X
  //
  // Usage:
  //
  // > var throttled = jQuery.throttle( delay, [ no_trailing, ] callback );
  // >
  // > jQuery('selector').bind( 'someevent', throttled );
  // > jQuery('selector').unbind( 'someevent', throttled );
  //
  // This also works in jQuery 1.4+:
  //
  // > jQuery('selector').bind( 'someevent', jQuery.throttle( delay, [ no_trailing, ] callback ) );
  // > jQuery('selector').unbind( 'someevent', callback );
  //
  // Arguments:
  //
  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
  //    callbacks, values around 100 or 250 (or even higher) are most useful.
  //  no_trailing - (Boolean) Optional, defaults to false. If no_trailing is
  //    true, callback will only execute every `delay` milliseconds while the
  //    throttled-function is being called. If no_trailing is false or
  //    unspecified, callback will be executed one final time after the last
  //    throttled-function call. (After the throttled-function has not been
  //    called for `delay` milliseconds, the internal counter is reset)
  //  callback - (Function) A function to be executed after delay milliseconds.
  //    The `this` context and all arguments are passed through, as-is, to
  //    `callback` when the throttled-function is executed.
  //
  // Returns:
  //
  //  (Function) A new, throttled, function.

  $.throttle = jq_throttle = function( delay, no_trailing, callback, debounce_mode ) {
    // After wrapper has stopped being called, this timeout ensures that
    // `callback` is executed at the proper times in `throttle` and `end`
    // debounce modes.
    var timeout_id,

      // Keep track of the last time `callback` was executed.
      last_exec = 0;

    // `no_trailing` defaults to falsy.
    if ( typeof no_trailing !== 'boolean' ) {
      debounce_mode = callback;
      callback = no_trailing;
      no_trailing = undefined;
    }

    // The `wrapper` function encapsulates all of the throttling / debouncing
    // functionality and when executed will limit the rate at which `callback`
    // is executed.
    function wrapper() {
      var that = this,
        elapsed = +new Date() - last_exec,
        args = arguments;

      // Execute `callback` and update the `last_exec` timestamp.
      function exec() {
        last_exec = +new Date();
        callback.apply( that, args );
      };

      // If `debounce_mode` is true (at_begin) this is used to clear the flag
      // to allow future `callback` executions.
      function clear() {
        timeout_id = undefined;
      };

      if ( debounce_mode && !timeout_id ) {
        // Since `wrapper` is being called for the first time and
        // `debounce_mode` is true (at_begin), execute `callback`.
        exec();
      }

      // Clear any existing timeout.
      timeout_id && clearTimeout( timeout_id );

      if ( debounce_mode === undefined && elapsed > delay ) {
        // In throttle mode, if `delay` time has been exceeded, execute
        // `callback`.
        exec();

      } else if ( no_trailing !== true ) {
        // In trailing throttle mode, since `delay` time has not been
        // exceeded, schedule `callback` to execute `delay` ms after most
        // recent execution.
        //
        // If `debounce_mode` is true (at_begin), schedule `clear` to execute
        // after `delay` ms.
        //
        // If `debounce_mode` is false (at end), schedule `callback` to
        // execute after `delay` ms.
        timeout_id = setTimeout( debounce_mode ? clear : exec, debounce_mode === undefined ? delay - elapsed : delay );
      }
    };

    // Set the guid of `wrapper` function to the same of original callback, so
    // it can be removed in jQuery 1.4+ .unbind or .die by using the original
    // callback as a reference.
    if ( $.guid ) {
      wrapper.guid = callback.guid = callback.guid || $.guid++;
    }

    // Return the wrapper function.
    return wrapper;
  };

  // Method: jQuery.debounce
  //
  // Debounce execution of a function. Debouncing, unlike throttling,
  // guarantees that a function is only executed a single time, either at the
  // very beginning of a series of calls, or at the very end. If you want to
  // simply rate-limit execution of a function, see the <jQuery.throttle>
  // method.
  //
  // In this visualization, | is a debounced-function call and X is the actual
  // callback execution:
  //
  // > Debounced with `at_begin` specified as false or unspecified:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // >                          X                                 X
  // >
  // > Debounced with `at_begin` specified as true:
  // > ||||||||||||||||||||||||| (pause) |||||||||||||||||||||||||
  // > X                                 X
  //
  // Usage:
  //
  // > var debounced = jQuery.debounce( delay, [ at_begin, ] callback );
  // >
  // > jQuery('selector').bind( 'someevent', debounced );
  // > jQuery('selector').unbind( 'someevent', debounced );
  //
  // This also works in jQuery 1.4+:
  //
  // > jQuery('selector').bind( 'someevent', jQuery.debounce( delay, [ at_begin, ] callback ) );
  // > jQuery('selector').unbind( 'someevent', callback );
  //
  // Arguments:
  //
  //  delay - (Number) A zero-or-greater delay in milliseconds. For event
  //    callbacks, values around 100 or 250 (or even higher) are most useful.
  //  at_begin - (Boolean) Optional, defaults to false. If at_begin is false or
  //    unspecified, callback will only be executed `delay` milliseconds after
  //    the last debounced-function call. If at_begin is true, callback will be
  //    executed only at the first debounced-function call. (After the
  //    throttled-function has not been called for `delay` milliseconds, the
  //    internal counter is reset)
  //  callback - (Function) A function to be executed after delay milliseconds.
  //    The `this` context and all arguments are passed through, as-is, to
  //    `callback` when the debounced-function is executed.
  //
  // Returns:
  //
  //  (Function) A new, debounced, function.

  $.debounce = function( delay, at_begin, callback ) {
    return callback === undefined
      ? jq_throttle( delay, at_begin, false )
      : jq_throttle( delay, callback, at_begin !== false );
  };

})(this);

/*
 Version: 1.6.0
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues
 */
!function(a){"use strict";"function"==typeof define&&define.amd?define(["jquery"],a):"undefined"!=typeof exports?module.exports=a(require("jquery")):a(jQuery)}(function(a){"use strict";var b=window.Slick||{};b=function(){function c(c,d){var f,e=this;e.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:a(c),appendDots:a(c),arrows:!0,asNavFor:null,prevArrow:'<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',nextArrow:'<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(b,c){return a('<button type="button" data-role="none" role="button" tabindex="0" />').text(c+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},e.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},a.extend(e,e.initials),e.activeBreakpoint=null,e.animType=null,e.animProp=null,e.breakpoints=[],e.breakpointSettings=[],e.cssTransitions=!1,e.focussed=!1,e.interrupted=!1,e.hidden="hidden",e.paused=!0,e.positionProp=null,e.respondTo=null,e.rowCount=1,e.shouldClick=!0,e.$slider=a(c),e.$slidesCache=null,e.transformType=null,e.transitionType=null,e.visibilityChange="visibilitychange",e.windowWidth=0,e.windowTimer=null,f=a(c).data("slick")||{},e.options=a.extend({},e.defaults,d,f),e.currentSlide=e.options.initialSlide,e.originalSettings=e.options,"undefined"!=typeof document.mozHidden?(e.hidden="mozHidden",e.visibilityChange="mozvisibilitychange"):"undefined"!=typeof document.webkitHidden&&(e.hidden="webkitHidden",e.visibilityChange="webkitvisibilitychange"),e.autoPlay=a.proxy(e.autoPlay,e),e.autoPlayClear=a.proxy(e.autoPlayClear,e),e.autoPlayIterator=a.proxy(e.autoPlayIterator,e),e.changeSlide=a.proxy(e.changeSlide,e),e.clickHandler=a.proxy(e.clickHandler,e),e.selectHandler=a.proxy(e.selectHandler,e),e.setPosition=a.proxy(e.setPosition,e),e.swipeHandler=a.proxy(e.swipeHandler,e),e.dragHandler=a.proxy(e.dragHandler,e),e.keyHandler=a.proxy(e.keyHandler,e),e.instanceUid=b++,e.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,e.registerBreakpoints(),e.init(!0)}var b=0;return c}(),b.prototype.activateADA=function(){var a=this;a.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},b.prototype.addSlide=b.prototype.slickAdd=function(b,c,d){var e=this;if("boolean"==typeof c)d=c,c=null;else if(0>c||c>=e.slideCount)return!1;e.unload(),"number"==typeof c?0===c&&0===e.$slides.length?a(b).appendTo(e.$slideTrack):d?a(b).insertBefore(e.$slides.eq(c)):a(b).insertAfter(e.$slides.eq(c)):d===!0?a(b).prependTo(e.$slideTrack):a(b).appendTo(e.$slideTrack),e.$slides=e.$slideTrack.children(this.options.slide),e.$slideTrack.children(this.options.slide).detach(),e.$slideTrack.append(e.$slides),e.$slides.each(function(b,c){a(c).attr("data-slick-index",b)}),e.$slidesCache=e.$slides,e.reinit()},b.prototype.animateHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.animate({height:b},a.options.speed)}},b.prototype.animateSlide=function(b,c){var d={},e=this;e.animateHeight(),e.options.rtl===!0&&e.options.vertical===!1&&(b=-b),e.transformsEnabled===!1?e.options.vertical===!1?e.$slideTrack.animate({left:b},e.options.speed,e.options.easing,c):e.$slideTrack.animate({top:b},e.options.speed,e.options.easing,c):e.cssTransitions===!1?(e.options.rtl===!0&&(e.currentLeft=-e.currentLeft),a({animStart:e.currentLeft}).animate({animStart:b},{duration:e.options.speed,easing:e.options.easing,step:function(a){a=Math.ceil(a),e.options.vertical===!1?(d[e.animType]="translate("+a+"px, 0px)",e.$slideTrack.css(d)):(d[e.animType]="translate(0px,"+a+"px)",e.$slideTrack.css(d))},complete:function(){c&&c.call()}})):(e.applyTransition(),b=Math.ceil(b),e.options.vertical===!1?d[e.animType]="translate3d("+b+"px, 0px, 0px)":d[e.animType]="translate3d(0px,"+b+"px, 0px)",e.$slideTrack.css(d),c&&setTimeout(function(){e.disableTransition(),c.call()},e.options.speed))},b.prototype.getNavTarget=function(){var b=this,c=b.options.asNavFor;return c&&null!==c&&(c=a(c).not(b.$slider)),c},b.prototype.asNavFor=function(b){var c=this,d=c.getNavTarget();null!==d&&"object"==typeof d&&d.each(function(){var c=a(this).slick("getSlick");c.unslicked||c.slideHandler(b,!0)})},b.prototype.applyTransition=function(a){var b=this,c={};b.options.fade===!1?c[b.transitionType]=b.transformType+" "+b.options.speed+"ms "+b.options.cssEase:c[b.transitionType]="opacity "+b.options.speed+"ms "+b.options.cssEase,b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.autoPlay=function(){var a=this;a.autoPlayClear(),a.slideCount>a.options.slidesToShow&&(a.autoPlayTimer=setInterval(a.autoPlayIterator,a.options.autoplaySpeed))},b.prototype.autoPlayClear=function(){var a=this;a.autoPlayTimer&&clearInterval(a.autoPlayTimer)},b.prototype.autoPlayIterator=function(){var a=this,b=a.currentSlide+a.options.slidesToScroll;a.paused||a.interrupted||a.focussed||(a.options.infinite===!1&&(1===a.direction&&a.currentSlide+1===a.slideCount-1?a.direction=0:0===a.direction&&(b=a.currentSlide-a.options.slidesToScroll,a.currentSlide-1===0&&(a.direction=1))),a.slideHandler(b))},b.prototype.buildArrows=function(){var b=this;b.options.arrows===!0&&(b.$prevArrow=a(b.options.prevArrow).addClass("slick-arrow"),b.$nextArrow=a(b.options.nextArrow).addClass("slick-arrow"),b.slideCount>b.options.slidesToShow?(b.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.prependTo(b.options.appendArrows),b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.appendTo(b.options.appendArrows),b.options.infinite!==!0&&b.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):b.$prevArrow.add(b.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},b.prototype.buildDots=function(){var c,d,b=this;if(b.options.dots===!0&&b.slideCount>b.options.slidesToShow){for(b.$slider.addClass("slick-dotted"),d=a("<ul />").addClass(b.options.dotsClass),c=0;c<=b.getDotCount();c+=1)d.append(a("<li />").append(b.options.customPaging.call(this,b,c)));b.$dots=d.appendTo(b.options.appendDots),b.$dots.find("li").first().addClass("slick-active").attr("aria-hidden","false")}},b.prototype.buildOut=function(){var b=this;b.$slides=b.$slider.children(b.options.slide+":not(.slick-cloned)").addClass("slick-slide"),b.slideCount=b.$slides.length,b.$slides.each(function(b,c){a(c).attr("data-slick-index",b).data("originalStyling",a(c).attr("style")||"")}),b.$slider.addClass("slick-slider"),b.$slideTrack=0===b.slideCount?a('<div class="slick-track"/>').appendTo(b.$slider):b.$slides.wrapAll('<div class="slick-track"/>').parent(),b.$list=b.$slideTrack.wrap('<div aria-live="polite" class="slick-list"/>').parent(),b.$slideTrack.css("opacity",0),(b.options.centerMode===!0||b.options.swipeToSlide===!0)&&(b.options.slidesToScroll=1),a("img[data-lazy]",b.$slider).not("[src]").addClass("slick-loading"),b.setupInfinite(),b.buildArrows(),b.buildDots(),b.updateDots(),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.options.draggable===!0&&b.$list.addClass("draggable")},b.prototype.buildRows=function(){var b,c,d,e,f,g,h,a=this;if(e=document.createDocumentFragment(),g=a.$slider.children(),a.options.rows>1){for(h=a.options.slidesPerRow*a.options.rows,f=Math.ceil(g.length/h),b=0;f>b;b++){var i=document.createElement("div");for(c=0;c<a.options.rows;c++){var j=document.createElement("div");for(d=0;d<a.options.slidesPerRow;d++){var k=b*h+(c*a.options.slidesPerRow+d);g.get(k)&&j.appendChild(g.get(k))}i.appendChild(j)}e.appendChild(i)}a.$slider.empty().append(e),a.$slider.children().children().children().css({width:100/a.options.slidesPerRow+"%",display:"inline-block"})}},b.prototype.checkResponsive=function(b,c){var e,f,g,d=this,h=!1,i=d.$slider.width(),j=window.innerWidth||a(window).width();if("window"===d.respondTo?g=j:"slider"===d.respondTo?g=i:"min"===d.respondTo&&(g=Math.min(j,i)),d.options.responsive&&d.options.responsive.length&&null!==d.options.responsive){f=null;for(e in d.breakpoints)d.breakpoints.hasOwnProperty(e)&&(d.originalSettings.mobileFirst===!1?g<d.breakpoints[e]&&(f=d.breakpoints[e]):g>d.breakpoints[e]&&(f=d.breakpoints[e]));null!==f?null!==d.activeBreakpoint?(f!==d.activeBreakpoint||c)&&(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):(d.activeBreakpoint=f,"unslick"===d.breakpointSettings[f]?d.unslick(f):(d.options=a.extend({},d.originalSettings,d.breakpointSettings[f]),b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b)),h=f):null!==d.activeBreakpoint&&(d.activeBreakpoint=null,d.options=d.originalSettings,b===!0&&(d.currentSlide=d.options.initialSlide),d.refresh(b),h=f),b||h===!1||d.$slider.trigger("breakpoint",[d,h])}},b.prototype.changeSlide=function(b,c){var f,g,h,d=this,e=a(b.currentTarget);switch(e.is("a")&&b.preventDefault(),e.is("li")||(e=e.closest("li")),h=d.slideCount%d.options.slidesToScroll!==0,f=h?0:(d.slideCount-d.currentSlide)%d.options.slidesToScroll,b.data.message){case"previous":g=0===f?d.options.slidesToScroll:d.options.slidesToShow-f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide-g,!1,c);break;case"next":g=0===f?d.options.slidesToScroll:f,d.slideCount>d.options.slidesToShow&&d.slideHandler(d.currentSlide+g,!1,c);break;case"index":var i=0===b.data.index?0:b.data.index||e.index()*d.options.slidesToScroll;d.slideHandler(d.checkNavigable(i),!1,c),e.children().trigger("focus");break;default:return}},b.prototype.checkNavigable=function(a){var c,d,b=this;if(c=b.getNavigableIndexes(),d=0,a>c[c.length-1])a=c[c.length-1];else for(var e in c){if(a<c[e]){a=d;break}d=c[e]}return a},b.prototype.cleanUpEvents=function(){var b=this;b.options.dots&&null!==b.$dots&&a("li",b.$dots).off("click.slick",b.changeSlide).off("mouseenter.slick",a.proxy(b.interrupt,b,!0)).off("mouseleave.slick",a.proxy(b.interrupt,b,!1)),b.$slider.off("focus.slick blur.slick"),b.options.arrows===!0&&b.slideCount>b.options.slidesToShow&&(b.$prevArrow&&b.$prevArrow.off("click.slick",b.changeSlide),b.$nextArrow&&b.$nextArrow.off("click.slick",b.changeSlide)),b.$list.off("touchstart.slick mousedown.slick",b.swipeHandler),b.$list.off("touchmove.slick mousemove.slick",b.swipeHandler),b.$list.off("touchend.slick mouseup.slick",b.swipeHandler),b.$list.off("touchcancel.slick mouseleave.slick",b.swipeHandler),b.$list.off("click.slick",b.clickHandler),a(document).off(b.visibilityChange,b.visibility),b.cleanUpSlideEvents(),b.options.accessibility===!0&&b.$list.off("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().off("click.slick",b.selectHandler),a(window).off("orientationchange.slick.slick-"+b.instanceUid,b.orientationChange),a(window).off("resize.slick.slick-"+b.instanceUid,b.resize),a("[draggable!=true]",b.$slideTrack).off("dragstart",b.preventDefault),a(window).off("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).off("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.cleanUpSlideEvents=function(){var b=this;b.$list.off("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.off("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.cleanUpRows=function(){var b,a=this;a.options.rows>1&&(b=a.$slides.children().children(),b.removeAttr("style"),a.$slider.empty().append(b))},b.prototype.clickHandler=function(a){var b=this;b.shouldClick===!1&&(a.stopImmediatePropagation(),a.stopPropagation(),a.preventDefault())},b.prototype.destroy=function(b){var c=this;c.autoPlayClear(),c.touchObject={},c.cleanUpEvents(),a(".slick-cloned",c.$slider).detach(),c.$dots&&c.$dots.remove(),c.$prevArrow&&c.$prevArrow.length&&(c.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.prevArrow)&&c.$prevArrow.remove()),c.$nextArrow&&c.$nextArrow.length&&(c.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),c.htmlExpr.test(c.options.nextArrow)&&c.$nextArrow.remove()),c.$slides&&(c.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){a(this).attr("style",a(this).data("originalStyling"))}),c.$slideTrack.children(this.options.slide).detach(),c.$slideTrack.detach(),c.$list.detach(),c.$slider.append(c.$slides)),c.cleanUpRows(),c.$slider.removeClass("slick-slider"),c.$slider.removeClass("slick-initialized"),c.$slider.removeClass("slick-dotted"),c.unslicked=!0,b||c.$slider.trigger("destroy",[c])},b.prototype.disableTransition=function(a){var b=this,c={};c[b.transitionType]="",b.options.fade===!1?b.$slideTrack.css(c):b.$slides.eq(a).css(c)},b.prototype.fadeSlide=function(a,b){var c=this;c.cssTransitions===!1?(c.$slides.eq(a).css({zIndex:c.options.zIndex}),c.$slides.eq(a).animate({opacity:1},c.options.speed,c.options.easing,b)):(c.applyTransition(a),c.$slides.eq(a).css({opacity:1,zIndex:c.options.zIndex}),b&&setTimeout(function(){c.disableTransition(a),b.call()},c.options.speed))},b.prototype.fadeSlideOut=function(a){var b=this;b.cssTransitions===!1?b.$slides.eq(a).animate({opacity:0,zIndex:b.options.zIndex-2},b.options.speed,b.options.easing):(b.applyTransition(a),b.$slides.eq(a).css({opacity:0,zIndex:b.options.zIndex-2}))},b.prototype.filterSlides=b.prototype.slickFilter=function(a){var b=this;null!==a&&(b.$slidesCache=b.$slides,b.unload(),b.$slideTrack.children(this.options.slide).detach(),b.$slidesCache.filter(a).appendTo(b.$slideTrack),b.reinit())},b.prototype.focusHandler=function(){var b=this;b.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*:not(.slick-arrow)",function(c){c.stopImmediatePropagation();var d=a(this);setTimeout(function(){b.options.pauseOnFocus&&(b.focussed=d.is(":focus"),b.autoPlay())},0)})},b.prototype.getCurrent=b.prototype.slickCurrentSlide=function(){var a=this;return a.currentSlide},b.prototype.getDotCount=function(){var a=this,b=0,c=0,d=0;if(a.options.infinite===!0)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else if(a.options.centerMode===!0)d=a.slideCount;else if(a.options.asNavFor)for(;b<a.slideCount;)++d,b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;else d=1+Math.ceil((a.slideCount-a.options.slidesToShow)/a.options.slidesToScroll);return d-1},b.prototype.getLeft=function(a){var c,d,f,b=this,e=0;return b.slideOffset=0,d=b.$slides.first().outerHeight(!0),b.options.infinite===!0?(b.slideCount>b.options.slidesToShow&&(b.slideOffset=b.slideWidth*b.options.slidesToShow*-1,e=d*b.options.slidesToShow*-1),b.slideCount%b.options.slidesToScroll!==0&&a+b.options.slidesToScroll>b.slideCount&&b.slideCount>b.options.slidesToShow&&(a>b.slideCount?(b.slideOffset=(b.options.slidesToShow-(a-b.slideCount))*b.slideWidth*-1,e=(b.options.slidesToShow-(a-b.slideCount))*d*-1):(b.slideOffset=b.slideCount%b.options.slidesToScroll*b.slideWidth*-1,e=b.slideCount%b.options.slidesToScroll*d*-1))):a+b.options.slidesToShow>b.slideCount&&(b.slideOffset=(a+b.options.slidesToShow-b.slideCount)*b.slideWidth,e=(a+b.options.slidesToShow-b.slideCount)*d),b.slideCount<=b.options.slidesToShow&&(b.slideOffset=0,e=0),b.options.centerMode===!0&&b.options.infinite===!0?b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)-b.slideWidth:b.options.centerMode===!0&&(b.slideOffset=0,b.slideOffset+=b.slideWidth*Math.floor(b.options.slidesToShow/2)),c=b.options.vertical===!1?a*b.slideWidth*-1+b.slideOffset:a*d*-1+e,b.options.variableWidth===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,b.options.centerMode===!0&&(f=b.slideCount<=b.options.slidesToShow||b.options.infinite===!1?b.$slideTrack.children(".slick-slide").eq(a):b.$slideTrack.children(".slick-slide").eq(a+b.options.slidesToShow+1),c=b.options.rtl===!0?f[0]?-1*(b.$slideTrack.width()-f[0].offsetLeft-f.width()):0:f[0]?-1*f[0].offsetLeft:0,c+=(b.$list.width()-f.outerWidth())/2)),c},b.prototype.getOption=b.prototype.slickGetOption=function(a){var b=this;return b.options[a]},b.prototype.getNavigableIndexes=function(){var e,a=this,b=0,c=0,d=[];for(a.options.infinite===!1?e=a.slideCount:(b=-1*a.options.slidesToScroll,c=-1*a.options.slidesToScroll,e=2*a.slideCount);e>b;)d.push(b),b=c+a.options.slidesToScroll,c+=a.options.slidesToScroll<=a.options.slidesToShow?a.options.slidesToScroll:a.options.slidesToShow;return d},b.prototype.getSlick=function(){return this},b.prototype.getSlideCount=function(){var c,d,e,b=this;return e=b.options.centerMode===!0?b.slideWidth*Math.floor(b.options.slidesToShow/2):0,b.options.swipeToSlide===!0?(b.$slideTrack.find(".slick-slide").each(function(c,f){return f.offsetLeft-e+a(f).outerWidth()/2>-1*b.swipeLeft?(d=f,!1):void 0}),c=Math.abs(a(d).attr("data-slick-index")-b.currentSlide)||1):b.options.slidesToScroll},b.prototype.goTo=b.prototype.slickGoTo=function(a,b){var c=this;c.changeSlide({data:{message:"index",index:parseInt(a)}},b)},b.prototype.init=function(b){var c=this;a(c.$slider).hasClass("slick-initialized")||(a(c.$slider).addClass("slick-initialized"),c.buildRows(),c.buildOut(),c.setProps(),c.startLoad(),c.loadSlider(),c.initializeEvents(),c.updateArrows(),c.updateDots(),c.checkResponsive(!0),c.focusHandler()),b&&c.$slider.trigger("init",[c]),c.options.accessibility===!0&&c.initADA(),c.options.autoplay&&(c.paused=!1,c.autoPlay())},b.prototype.initADA=function(){var b=this;b.$slides.add(b.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),b.$slideTrack.attr("role","listbox"),b.$slides.not(b.$slideTrack.find(".slick-cloned")).each(function(c){a(this).attr({role:"option","aria-describedby":"slick-slide"+b.instanceUid+c})}),null!==b.$dots&&b.$dots.attr("role","tablist").find("li").each(function(c){a(this).attr({role:"presentation","aria-selected":"false","aria-controls":"navigation"+b.instanceUid+c,id:"slick-slide"+b.instanceUid+c})}).first().attr("aria-selected","true").end().find("button").attr("role","button").end().closest("div").attr("role","toolbar"),b.activateADA()},b.prototype.initArrowEvents=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},a.changeSlide),a.$nextArrow.off("click.slick").on("click.slick",{message:"next"},a.changeSlide))},b.prototype.initDotEvents=function(){var b=this;b.options.dots===!0&&b.slideCount>b.options.slidesToShow&&a("li",b.$dots).on("click.slick",{message:"index"},b.changeSlide),b.options.dots===!0&&b.options.pauseOnDotsHover===!0&&a("li",b.$dots).on("mouseenter.slick",a.proxy(b.interrupt,b,!0)).on("mouseleave.slick",a.proxy(b.interrupt,b,!1))},b.prototype.initSlideEvents=function(){var b=this;b.options.pauseOnHover&&(b.$list.on("mouseenter.slick",a.proxy(b.interrupt,b,!0)),b.$list.on("mouseleave.slick",a.proxy(b.interrupt,b,!1)))},b.prototype.initializeEvents=function(){var b=this;b.initArrowEvents(),b.initDotEvents(),b.initSlideEvents(),b.$list.on("touchstart.slick mousedown.slick",{action:"start"},b.swipeHandler),b.$list.on("touchmove.slick mousemove.slick",{action:"move"},b.swipeHandler),b.$list.on("touchend.slick mouseup.slick",{action:"end"},b.swipeHandler),b.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},b.swipeHandler),b.$list.on("click.slick",b.clickHandler),a(document).on(b.visibilityChange,a.proxy(b.visibility,b)),b.options.accessibility===!0&&b.$list.on("keydown.slick",b.keyHandler),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),a(window).on("orientationchange.slick.slick-"+b.instanceUid,a.proxy(b.orientationChange,b)),a(window).on("resize.slick.slick-"+b.instanceUid,a.proxy(b.resize,b)),a("[draggable!=true]",b.$slideTrack).on("dragstart",b.preventDefault),a(window).on("load.slick.slick-"+b.instanceUid,b.setPosition),a(document).on("ready.slick.slick-"+b.instanceUid,b.setPosition)},b.prototype.initUI=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.show(),a.$nextArrow.show()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.show()},b.prototype.keyHandler=function(a){var b=this;a.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===a.keyCode&&b.options.accessibility===!0?b.changeSlide({data:{message:b.options.rtl===!0?"next":"previous"}}):39===a.keyCode&&b.options.accessibility===!0&&b.changeSlide({data:{message:b.options.rtl===!0?"previous":"next"}}))},b.prototype.lazyLoad=function(){function g(c){a("img[data-lazy]",c).each(function(){var c=a(this),d=a(this).attr("data-lazy"),e=document.createElement("img");e.onload=function(){c.animate({opacity:0},100,function(){c.attr("src",d).animate({opacity:1},200,function(){c.removeAttr("data-lazy").removeClass("slick-loading")}),b.$slider.trigger("lazyLoaded",[b,c,d])})},e.onerror=function(){c.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),b.$slider.trigger("lazyLoadError",[b,c,d])},e.src=d})}var c,d,e,f,b=this;b.options.centerMode===!0?b.options.infinite===!0?(e=b.currentSlide+(b.options.slidesToShow/2+1),f=e+b.options.slidesToShow+2):(e=Math.max(0,b.currentSlide-(b.options.slidesToShow/2+1)),f=2+(b.options.slidesToShow/2+1)+b.currentSlide):(e=b.options.infinite?b.options.slidesToShow+b.currentSlide:b.currentSlide,f=Math.ceil(e+b.options.slidesToShow),b.options.fade===!0&&(e>0&&e--,f<=b.slideCount&&f++)),c=b.$slider.find(".slick-slide").slice(e,f),g(c),b.slideCount<=b.options.slidesToShow?(d=b.$slider.find(".slick-slide"),g(d)):b.currentSlide>=b.slideCount-b.options.slidesToShow?(d=b.$slider.find(".slick-cloned").slice(0,b.options.slidesToShow),g(d)):0===b.currentSlide&&(d=b.$slider.find(".slick-cloned").slice(-1*b.options.slidesToShow),g(d))},b.prototype.loadSlider=function(){var a=this;a.setPosition(),a.$slideTrack.css({opacity:1}),a.$slider.removeClass("slick-loading"),a.initUI(),"progressive"===a.options.lazyLoad&&a.progressiveLazyLoad()},b.prototype.next=b.prototype.slickNext=function(){var a=this;a.changeSlide({data:{message:"next"}})},b.prototype.orientationChange=function(){var a=this;a.checkResponsive(),a.setPosition()},b.prototype.pause=b.prototype.slickPause=function(){var a=this;a.autoPlayClear(),a.paused=!0},b.prototype.play=b.prototype.slickPlay=function(){var a=this;a.autoPlay(),a.options.autoplay=!0,a.paused=!1,a.focussed=!1,a.interrupted=!1},b.prototype.postSlide=function(a){var b=this;b.unslicked||(b.$slider.trigger("afterChange",[b,a]),b.animating=!1,b.setPosition(),b.swipeLeft=null,b.options.autoplay&&b.autoPlay(),b.options.accessibility===!0&&b.initADA())},b.prototype.prev=b.prototype.slickPrev=function(){var a=this;a.changeSlide({data:{message:"previous"}})},b.prototype.preventDefault=function(a){a.preventDefault()},b.prototype.progressiveLazyLoad=function(b){b=b||1;var e,f,g,c=this,d=a("img[data-lazy]",c.$slider);d.length?(e=d.first(),f=e.attr("data-lazy"),g=document.createElement("img"),g.onload=function(){e.attr("src",f).removeAttr("data-lazy").removeClass("slick-loading"),c.options.adaptiveHeight===!0&&c.setPosition(),c.$slider.trigger("lazyLoaded",[c,e,f]),c.progressiveLazyLoad()},g.onerror=function(){3>b?setTimeout(function(){c.progressiveLazyLoad(b+1)},500):(e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),c.$slider.trigger("lazyLoadError",[c,e,f]),c.progressiveLazyLoad())},g.src=f):c.$slider.trigger("allImagesLoaded",[c])},b.prototype.refresh=function(b){var d,e,c=this;e=c.slideCount-c.options.slidesToShow,!c.options.infinite&&c.currentSlide>e&&(c.currentSlide=e),c.slideCount<=c.options.slidesToShow&&(c.currentSlide=0),d=c.currentSlide,c.destroy(!0),a.extend(c,c.initials,{currentSlide:d}),c.init(),b||c.changeSlide({data:{message:"index",index:d}},!1)},b.prototype.registerBreakpoints=function(){var c,d,e,b=this,f=b.options.responsive||null;if("array"===a.type(f)&&f.length){b.respondTo=b.options.respondTo||"window";for(c in f)if(e=b.breakpoints.length-1,d=f[c].breakpoint,f.hasOwnProperty(c)){for(;e>=0;)b.breakpoints[e]&&b.breakpoints[e]===d&&b.breakpoints.splice(e,1),e--;b.breakpoints.push(d),b.breakpointSettings[d]=f[c].settings}b.breakpoints.sort(function(a,c){return b.options.mobileFirst?a-c:c-a})}},b.prototype.reinit=function(){var b=this;b.$slides=b.$slideTrack.children(b.options.slide).addClass("slick-slide"),b.slideCount=b.$slides.length,b.currentSlide>=b.slideCount&&0!==b.currentSlide&&(b.currentSlide=b.currentSlide-b.options.slidesToScroll),b.slideCount<=b.options.slidesToShow&&(b.currentSlide=0),b.registerBreakpoints(),b.setProps(),b.setupInfinite(),b.buildArrows(),b.updateArrows(),b.initArrowEvents(),b.buildDots(),b.updateDots(),b.initDotEvents(),b.cleanUpSlideEvents(),b.initSlideEvents(),b.checkResponsive(!1,!0),b.options.focusOnSelect===!0&&a(b.$slideTrack).children().on("click.slick",b.selectHandler),b.setSlideClasses("number"==typeof b.currentSlide?b.currentSlide:0),b.setPosition(),b.focusHandler(),b.paused=!b.options.autoplay,b.autoPlay(),b.$slider.trigger("reInit",[b])},b.prototype.resize=function(){var b=this;a(window).width()!==b.windowWidth&&(clearTimeout(b.windowDelay),b.windowDelay=window.setTimeout(function(){b.windowWidth=a(window).width(),b.checkResponsive(),b.unslicked||b.setPosition()},50))},b.prototype.removeSlide=b.prototype.slickRemove=function(a,b,c){var d=this;return"boolean"==typeof a?(b=a,a=b===!0?0:d.slideCount-1):a=b===!0?--a:a,d.slideCount<1||0>a||a>d.slideCount-1?!1:(d.unload(),c===!0?d.$slideTrack.children().remove():d.$slideTrack.children(this.options.slide).eq(a).remove(),d.$slides=d.$slideTrack.children(this.options.slide),d.$slideTrack.children(this.options.slide).detach(),d.$slideTrack.append(d.$slides),d.$slidesCache=d.$slides,void d.reinit())},b.prototype.setCSS=function(a){var d,e,b=this,c={};b.options.rtl===!0&&(a=-a),d="left"==b.positionProp?Math.ceil(a)+"px":"0px",e="top"==b.positionProp?Math.ceil(a)+"px":"0px",c[b.positionProp]=a,b.transformsEnabled===!1?b.$slideTrack.css(c):(c={},b.cssTransitions===!1?(c[b.animType]="translate("+d+", "+e+")",b.$slideTrack.css(c)):(c[b.animType]="translate3d("+d+", "+e+", 0px)",b.$slideTrack.css(c)))},b.prototype.setDimensions=function(){var a=this;a.options.vertical===!1?a.options.centerMode===!0&&a.$list.css({padding:"0px "+a.options.centerPadding}):(a.$list.height(a.$slides.first().outerHeight(!0)*a.options.slidesToShow),a.options.centerMode===!0&&a.$list.css({padding:a.options.centerPadding+" 0px"})),a.listWidth=a.$list.width(),a.listHeight=a.$list.height(),a.options.vertical===!1&&a.options.variableWidth===!1?(a.slideWidth=Math.ceil(a.listWidth/a.options.slidesToShow),a.$slideTrack.width(Math.ceil(a.slideWidth*a.$slideTrack.children(".slick-slide").length))):a.options.variableWidth===!0?a.$slideTrack.width(5e3*a.slideCount):(a.slideWidth=Math.ceil(a.listWidth),a.$slideTrack.height(Math.ceil(a.$slides.first().outerHeight(!0)*a.$slideTrack.children(".slick-slide").length)));var b=a.$slides.first().outerWidth(!0)-a.$slides.first().width();a.options.variableWidth===!1&&a.$slideTrack.children(".slick-slide").width(a.slideWidth-b)},b.prototype.setFade=function(){var c,b=this;b.$slides.each(function(d,e){c=b.slideWidth*d*-1,b.options.rtl===!0?a(e).css({position:"relative",right:c,top:0,zIndex:b.options.zIndex-2,opacity:0}):a(e).css({position:"relative",left:c,top:0,zIndex:b.options.zIndex-2,opacity:0})}),b.$slides.eq(b.currentSlide).css({zIndex:b.options.zIndex-1,opacity:1})},b.prototype.setHeight=function(){var a=this;if(1===a.options.slidesToShow&&a.options.adaptiveHeight===!0&&a.options.vertical===!1){var b=a.$slides.eq(a.currentSlide).outerHeight(!0);a.$list.css("height",b)}},b.prototype.setOption=b.prototype.slickSetOption=function(){var c,d,e,f,h,b=this,g=!1;if("object"===a.type(arguments[0])?(e=arguments[0],g=arguments[1],h="multiple"):"string"===a.type(arguments[0])&&(e=arguments[0],f=arguments[1],g=arguments[2],"responsive"===arguments[0]&&"array"===a.type(arguments[1])?h="responsive":"undefined"!=typeof arguments[1]&&(h="single")),"single"===h)b.options[e]=f;else if("multiple"===h)a.each(e,function(a,c){b.options[a]=c});else if("responsive"===h)for(d in f)if("array"!==a.type(b.options.responsive))b.options.responsive=[f[d]];else{for(c=b.options.responsive.length-1;c>=0;)b.options.responsive[c].breakpoint===f[d].breakpoint&&b.options.responsive.splice(c,1),c--;b.options.responsive.push(f[d])}g&&(b.unload(),b.reinit())},b.prototype.setPosition=function(){var a=this;a.setDimensions(),a.setHeight(),a.options.fade===!1?a.setCSS(a.getLeft(a.currentSlide)):a.setFade(),a.$slider.trigger("setPosition",[a])},b.prototype.setProps=function(){var a=this,b=document.body.style;a.positionProp=a.options.vertical===!0?"top":"left","top"===a.positionProp?a.$slider.addClass("slick-vertical"):a.$slider.removeClass("slick-vertical"),(void 0!==b.WebkitTransition||void 0!==b.MozTransition||void 0!==b.msTransition)&&a.options.useCSS===!0&&(a.cssTransitions=!0),a.options.fade&&("number"==typeof a.options.zIndex?a.options.zIndex<3&&(a.options.zIndex=3):a.options.zIndex=a.defaults.zIndex),void 0!==b.OTransform&&(a.animType="OTransform",a.transformType="-o-transform",a.transitionType="OTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.MozTransform&&(a.animType="MozTransform",a.transformType="-moz-transform",a.transitionType="MozTransition",void 0===b.perspectiveProperty&&void 0===b.MozPerspective&&(a.animType=!1)),void 0!==b.webkitTransform&&(a.animType="webkitTransform",a.transformType="-webkit-transform",a.transitionType="webkitTransition",void 0===b.perspectiveProperty&&void 0===b.webkitPerspective&&(a.animType=!1)),void 0!==b.msTransform&&(a.animType="msTransform",a.transformType="-ms-transform",a.transitionType="msTransition",void 0===b.msTransform&&(a.animType=!1)),void 0!==b.transform&&a.animType!==!1&&(a.animType="transform",a.transformType="transform",a.transitionType="transition"),a.transformsEnabled=a.options.useTransform&&null!==a.animType&&a.animType!==!1},b.prototype.setSlideClasses=function(a){var c,d,e,f,b=this;d=b.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),b.$slides.eq(a).addClass("slick-current"),b.options.centerMode===!0?(c=Math.floor(b.options.slidesToShow/2),b.options.infinite===!0&&(a>=c&&a<=b.slideCount-1-c?b.$slides.slice(a-c,a+c+1).addClass("slick-active").attr("aria-hidden","false"):(e=b.options.slidesToShow+a,
d.slice(e-c+1,e+c+2).addClass("slick-active").attr("aria-hidden","false")),0===a?d.eq(d.length-1-b.options.slidesToShow).addClass("slick-center"):a===b.slideCount-1&&d.eq(b.options.slidesToShow).addClass("slick-center")),b.$slides.eq(a).addClass("slick-center")):a>=0&&a<=b.slideCount-b.options.slidesToShow?b.$slides.slice(a,a+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):d.length<=b.options.slidesToShow?d.addClass("slick-active").attr("aria-hidden","false"):(f=b.slideCount%b.options.slidesToShow,e=b.options.infinite===!0?b.options.slidesToShow+a:a,b.options.slidesToShow==b.options.slidesToScroll&&b.slideCount-a<b.options.slidesToShow?d.slice(e-(b.options.slidesToShow-f),e+f).addClass("slick-active").attr("aria-hidden","false"):d.slice(e,e+b.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")),"ondemand"===b.options.lazyLoad&&b.lazyLoad()},b.prototype.setupInfinite=function(){var c,d,e,b=this;if(b.options.fade===!0&&(b.options.centerMode=!1),b.options.infinite===!0&&b.options.fade===!1&&(d=null,b.slideCount>b.options.slidesToShow)){for(e=b.options.centerMode===!0?b.options.slidesToShow+1:b.options.slidesToShow,c=b.slideCount;c>b.slideCount-e;c-=1)d=c-1,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d-b.slideCount).prependTo(b.$slideTrack).addClass("slick-cloned");for(c=0;e>c;c+=1)d=c,a(b.$slides[d]).clone(!0).attr("id","").attr("data-slick-index",d+b.slideCount).appendTo(b.$slideTrack).addClass("slick-cloned");b.$slideTrack.find(".slick-cloned").find("[id]").each(function(){a(this).attr("id","")})}},b.prototype.interrupt=function(a){var b=this;a||b.autoPlay(),b.interrupted=a},b.prototype.selectHandler=function(b){var c=this,d=a(b.target).is(".slick-slide")?a(b.target):a(b.target).parents(".slick-slide"),e=parseInt(d.attr("data-slick-index"));return e||(e=0),c.slideCount<=c.options.slidesToShow?(c.setSlideClasses(e),void c.asNavFor(e)):void c.slideHandler(e)},b.prototype.slideHandler=function(a,b,c){var d,e,f,g,j,h=null,i=this;return b=b||!1,i.animating===!0&&i.options.waitForAnimate===!0||i.options.fade===!0&&i.currentSlide===a||i.slideCount<=i.options.slidesToShow?void 0:(b===!1&&i.asNavFor(a),d=a,h=i.getLeft(d),g=i.getLeft(i.currentSlide),i.currentLeft=null===i.swipeLeft?g:i.swipeLeft,i.options.infinite===!1&&i.options.centerMode===!1&&(0>a||a>i.getDotCount()*i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):i.options.infinite===!1&&i.options.centerMode===!0&&(0>a||a>i.slideCount-i.options.slidesToScroll)?void(i.options.fade===!1&&(d=i.currentSlide,c!==!0?i.animateSlide(g,function(){i.postSlide(d)}):i.postSlide(d))):(i.options.autoplay&&clearInterval(i.autoPlayTimer),e=0>d?i.slideCount%i.options.slidesToScroll!==0?i.slideCount-i.slideCount%i.options.slidesToScroll:i.slideCount+d:d>=i.slideCount?i.slideCount%i.options.slidesToScroll!==0?0:d-i.slideCount:d,i.animating=!0,i.$slider.trigger("beforeChange",[i,i.currentSlide,e]),f=i.currentSlide,i.currentSlide=e,i.setSlideClasses(i.currentSlide),i.options.asNavFor&&(j=i.getNavTarget(),j=j.slick("getSlick"),j.slideCount<=j.options.slidesToShow&&j.setSlideClasses(i.currentSlide)),i.updateDots(),i.updateArrows(),i.options.fade===!0?(c!==!0?(i.fadeSlideOut(f),i.fadeSlide(e,function(){i.postSlide(e)})):i.postSlide(e),void i.animateHeight()):void(c!==!0?i.animateSlide(h,function(){i.postSlide(e)}):i.postSlide(e))))},b.prototype.startLoad=function(){var a=this;a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&(a.$prevArrow.hide(),a.$nextArrow.hide()),a.options.dots===!0&&a.slideCount>a.options.slidesToShow&&a.$dots.hide(),a.$slider.addClass("slick-loading")},b.prototype.swipeDirection=function(){var a,b,c,d,e=this;return a=e.touchObject.startX-e.touchObject.curX,b=e.touchObject.startY-e.touchObject.curY,c=Math.atan2(b,a),d=Math.round(180*c/Math.PI),0>d&&(d=360-Math.abs(d)),45>=d&&d>=0?e.options.rtl===!1?"left":"right":360>=d&&d>=315?e.options.rtl===!1?"left":"right":d>=135&&225>=d?e.options.rtl===!1?"right":"left":e.options.verticalSwiping===!0?d>=35&&135>=d?"down":"up":"vertical"},b.prototype.swipeEnd=function(a){var c,d,b=this;if(b.dragging=!1,b.interrupted=!1,b.shouldClick=b.touchObject.swipeLength>10?!1:!0,void 0===b.touchObject.curX)return!1;if(b.touchObject.edgeHit===!0&&b.$slider.trigger("edge",[b,b.swipeDirection()]),b.touchObject.swipeLength>=b.touchObject.minSwipe){switch(d=b.swipeDirection()){case"left":case"down":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide+b.getSlideCount()):b.currentSlide+b.getSlideCount(),b.currentDirection=0;break;case"right":case"up":c=b.options.swipeToSlide?b.checkNavigable(b.currentSlide-b.getSlideCount()):b.currentSlide-b.getSlideCount(),b.currentDirection=1}"vertical"!=d&&(b.slideHandler(c),b.touchObject={},b.$slider.trigger("swipe",[b,d]))}else b.touchObject.startX!==b.touchObject.curX&&(b.slideHandler(b.currentSlide),b.touchObject={})},b.prototype.swipeHandler=function(a){var b=this;if(!(b.options.swipe===!1||"ontouchend"in document&&b.options.swipe===!1||b.options.draggable===!1&&-1!==a.type.indexOf("mouse")))switch(b.touchObject.fingerCount=a.originalEvent&&void 0!==a.originalEvent.touches?a.originalEvent.touches.length:1,b.touchObject.minSwipe=b.listWidth/b.options.touchThreshold,b.options.verticalSwiping===!0&&(b.touchObject.minSwipe=b.listHeight/b.options.touchThreshold),a.data.action){case"start":b.swipeStart(a);break;case"move":b.swipeMove(a);break;case"end":b.swipeEnd(a)}},b.prototype.swipeMove=function(a){var d,e,f,g,h,b=this;return h=void 0!==a.originalEvent?a.originalEvent.touches:null,!b.dragging||h&&1!==h.length?!1:(d=b.getLeft(b.currentSlide),b.touchObject.curX=void 0!==h?h[0].pageX:a.clientX,b.touchObject.curY=void 0!==h?h[0].pageY:a.clientY,b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curX-b.touchObject.startX,2))),b.options.verticalSwiping===!0&&(b.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(b.touchObject.curY-b.touchObject.startY,2)))),e=b.swipeDirection(),"vertical"!==e?(void 0!==a.originalEvent&&b.touchObject.swipeLength>4&&a.preventDefault(),g=(b.options.rtl===!1?1:-1)*(b.touchObject.curX>b.touchObject.startX?1:-1),b.options.verticalSwiping===!0&&(g=b.touchObject.curY>b.touchObject.startY?1:-1),f=b.touchObject.swipeLength,b.touchObject.edgeHit=!1,b.options.infinite===!1&&(0===b.currentSlide&&"right"===e||b.currentSlide>=b.getDotCount()&&"left"===e)&&(f=b.touchObject.swipeLength*b.options.edgeFriction,b.touchObject.edgeHit=!0),b.options.vertical===!1?b.swipeLeft=d+f*g:b.swipeLeft=d+f*(b.$list.height()/b.listWidth)*g,b.options.verticalSwiping===!0&&(b.swipeLeft=d+f*g),b.options.fade===!0||b.options.touchMove===!1?!1:b.animating===!0?(b.swipeLeft=null,!1):void b.setCSS(b.swipeLeft)):void 0)},b.prototype.swipeStart=function(a){var c,b=this;return b.interrupted=!0,1!==b.touchObject.fingerCount||b.slideCount<=b.options.slidesToShow?(b.touchObject={},!1):(void 0!==a.originalEvent&&void 0!==a.originalEvent.touches&&(c=a.originalEvent.touches[0]),b.touchObject.startX=b.touchObject.curX=void 0!==c?c.pageX:a.clientX,b.touchObject.startY=b.touchObject.curY=void 0!==c?c.pageY:a.clientY,void(b.dragging=!0))},b.prototype.unfilterSlides=b.prototype.slickUnfilter=function(){var a=this;null!==a.$slidesCache&&(a.unload(),a.$slideTrack.children(this.options.slide).detach(),a.$slidesCache.appendTo(a.$slideTrack),a.reinit())},b.prototype.unload=function(){var b=this;a(".slick-cloned",b.$slider).remove(),b.$dots&&b.$dots.remove(),b.$prevArrow&&b.htmlExpr.test(b.options.prevArrow)&&b.$prevArrow.remove(),b.$nextArrow&&b.htmlExpr.test(b.options.nextArrow)&&b.$nextArrow.remove(),b.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},b.prototype.unslick=function(a){var b=this;b.$slider.trigger("unslick",[b,a]),b.destroy()},b.prototype.updateArrows=function(){var b,a=this;b=Math.floor(a.options.slidesToShow/2),a.options.arrows===!0&&a.slideCount>a.options.slidesToShow&&!a.options.infinite&&(a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===a.currentSlide?(a.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-a.options.slidesToShow&&a.options.centerMode===!1?(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):a.currentSlide>=a.slideCount-1&&a.options.centerMode===!0&&(a.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),a.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},b.prototype.updateDots=function(){var a=this;null!==a.$dots&&(a.$dots.find("li").removeClass("slick-active").attr("aria-hidden","true"),a.$dots.find("li").eq(Math.floor(a.currentSlide/a.options.slidesToScroll)).addClass("slick-active").attr("aria-hidden","false"))},b.prototype.visibility=function(){var a=this;a.options.autoplay&&(document[a.hidden]?a.interrupted=!0:a.interrupted=!1)},a.fn.slick=function(){var f,g,a=this,c=arguments[0],d=Array.prototype.slice.call(arguments,1),e=a.length;for(f=0;e>f;f++)if("object"==typeof c||"undefined"==typeof c?a[f].slick=new b(a[f],c):g=a[f].slick[c].apply(a[f].slick,d),"undefined"!=typeof g)return g;return a}});

/*!
 * instafeed.js v1.4.1 - A simple Instagram javascript plugin
 * http://instafeedjs.com
 * repo: https://github.com/stevenschobert/instafeed.js
 * License: MIT (https://github.com/stevenschobert/instafeed.js/blob/master/LICENSE)
 */
(function(){var a;a=function(){function a(a,b){var c,d;if(this.options={target:"instafeed",get:"popular",resolution:"thumbnail",sortBy:"none",links:!0,mock:!1,useHttp:!1},"object"==typeof a)for(c in a)d=a[c],this.options[c]=d;this.context=null!=b?b:this,this.unique=this._genKey()}return a.prototype.hasNext=function(){return"string"==typeof this.context.nextUrl&&this.context.nextUrl.length>0},a.prototype.next=function(){return!!this.hasNext()&&this.run(this.context.nextUrl)},a.prototype.run=function(b){var c,d,e;if("string"!=typeof this.options.clientId&&"string"!=typeof this.options.accessToken)throw new Error("Missing clientId or accessToken.");if("string"!=typeof this.options.accessToken&&"string"!=typeof this.options.clientId)throw new Error("Missing clientId or accessToken.");return null!=this.options.before&&"function"==typeof this.options.before&&this.options.before.call(this),"undefined"!=typeof document&&null!==document&&(e=document.createElement("script"),e.id="instafeed-fetcher",e.src=b||this._buildUrl(),c=document.getElementsByTagName("head"),c[0].appendChild(e),d="instafeedCache"+this.unique,window[d]=new a(this.options,this),window[d].unique=this.unique),!0},a.prototype.parse=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H;if("object"!=typeof a){if(null!=this.options.error&&"function"==typeof this.options.error)return this.options.error.call(this,"Invalid JSON data"),!1;throw new Error("Invalid JSON response")}if(200!==a.meta.code){if(null!=this.options.error&&"function"==typeof this.options.error)return this.options.error.call(this,a.meta.error_message),!1;throw new Error("Error from Instagram: "+a.meta.error_message)}if(0===a.data.length){if(null!=this.options.error&&"function"==typeof this.options.error)return this.options.error.call(this,"No images were returned from Instagram"),!1;throw new Error("No images were returned from Instagram")}if(null!=this.options.success&&"function"==typeof this.options.success&&this.options.success.call(this,a),this.context.nextUrl="",null!=a.pagination&&(this.context.nextUrl=a.pagination.next_url),"none"!==this.options.sortBy)switch(F="random"===this.options.sortBy?["","random"]:this.options.sortBy.split("-"),E="least"===F[0],F[1]){case"random":a.data.sort(function(){return.5-Math.random()});break;case"recent":a.data=this._sortBy(a.data,"created_time",E);break;case"liked":a.data=this._sortBy(a.data,"likes.count",E);break;case"commented":a.data=this._sortBy(a.data,"comments.count",E);break;default:throw new Error("Invalid option for sortBy: '"+this.options.sortBy+"'.")}if("undefined"!=typeof document&&null!==document&&this.options.mock===!1){if(q=a.data,D=parseInt(this.options.limit,10),null!=this.options.limit&&q.length>D&&(q=q.slice(0,D)),h=document.createDocumentFragment(),null!=this.options.filter&&"function"==typeof this.options.filter&&(q=this._filter(q,this.options.filter)),null!=this.options.template&&"string"==typeof this.options.template){for(j="",o="",u="",H=document.createElement("div"),l=0,z=q.length;l<z;l++){if(m=q[l],n=m.images[this.options.resolution],"object"!=typeof n)throw g="No image found for resolution: "+this.options.resolution+".",new Error(g);v=n.width,s=n.height,t="square",v>s&&(t="landscape"),v<s&&(t="portrait"),p=n.url,k=window.location.protocol.indexOf("http")>=0,k&&!this.options.useHttp&&(p=p.replace(/https?:\/\//,"//")),o=this._makeTemplate(this.options.template,{model:m,id:m.id,link:m.link,type:m.type,image:p,width:v,height:s,orientation:t,caption:this._getObjectProperty(m,"caption.text"),likes:m.likes.count,comments:m.comments.count,location:this._getObjectProperty(m,"location.name")}),j+=o}for(H.innerHTML=j,e=[],d=0,c=H.childNodes.length;d<c;)e.push(H.childNodes[d]),d+=1;for(x=0,A=e.length;x<A;x++)C=e[x],h.appendChild(C)}else for(y=0,B=q.length;y<B;y++){if(m=q[y],r=document.createElement("img"),n=m.images[this.options.resolution],"object"!=typeof n)throw g="No image found for resolution: "+this.options.resolution+".",new Error(g);p=n.url,k=window.location.protocol.indexOf("http")>=0,k&&!this.options.useHttp&&(p=p.replace(/https?:\/\//,"//")),r.src=p,this.options.links===!0?(b=document.createElement("a"),b.href=m.link,b.appendChild(r),h.appendChild(b)):h.appendChild(r)}if(G=this.options.target,"string"==typeof G&&(G=document.getElementById(G)),null==G)throw g='No element with id="'+this.options.target+'" on page.',new Error(g);G.appendChild(h),i=document.getElementsByTagName("head")[0],i.removeChild(document.getElementById("instafeed-fetcher")),w="instafeedCache"+this.unique,window[w]=void 0;try{delete window[w]}catch(a){f=a}}return null!=this.options.after&&"function"==typeof this.options.after&&this.options.after.call(this),!0},a.prototype._buildUrl=function(){var a,b,c;switch(a="https://api.instagram.com/v1",this.options.get){case"popular":b="media/popular";break;case"tagged":if(!this.options.tagName)throw new Error("No tag name specified. Use the 'tagName' option.");b="tags/"+this.options.tagName+"/media/recent";break;case"location":if(!this.options.locationId)throw new Error("No location specified. Use the 'locationId' option.");b="locations/"+this.options.locationId+"/media/recent";break;case"user":if(!this.options.userId)throw new Error("No user specified. Use the 'userId' option.");b="users/"+this.options.userId+"/media/recent";break;default:throw new Error("Invalid option for get: '"+this.options.get+"'.")}return c=a+"/"+b,c+=null!=this.options.accessToken?"?access_token="+this.options.accessToken:"?client_id="+this.options.clientId,null!=this.options.limit&&(c+="&count="+this.options.limit),c+="&callback=instafeedCache"+this.unique+".parse"},a.prototype._genKey=function(){var a;return a=function(){return(65536*(1+Math.random())|0).toString(16).substring(1)},""+a()+a()+a()+a()},a.prototype._makeTemplate=function(a,b){var c,d,e,f,g;for(d=/(?:\{{2})([\w\[\]\.]+)(?:\}{2})/,c=a;d.test(c);)f=c.match(d)[1],g=null!=(e=this._getObjectProperty(b,f))?e:"",c=c.replace(d,function(){return""+g});return c},a.prototype._getObjectProperty=function(a,b){var c,d;for(b=b.replace(/\[(\w+)\]/g,".$1"),d=b.split(".");d.length;){if(c=d.shift(),!(null!=a&&c in a))return null;a=a[c]}return a},a.prototype._sortBy=function(a,b,c){var d;return d=function(a,d){var e,f;return e=this._getObjectProperty(a,b),f=this._getObjectProperty(d,b),c?e>f?1:-1:e<f?1:-1},a.sort(d.bind(this)),a},a.prototype._filter=function(a,b){var c,d,e,f,g;for(c=[],d=function(a){if(b(a))return c.push(a)},e=0,g=a.length;e<g;e++)f=a[e],d(f);return c},a}(),function(a,b){return"function"==typeof define&&define.amd?define([],b):"object"==typeof module&&module.exports?module.exports=b():a.Instafeed=b()}(this,function(){return a})}).call(this);

/*! Magnific Popup - v1.1.0 - 2016-02-20
* http://dimsemenov.com/plugins/magnific-popup/
* Copyright (c) 2016 Dmitry Semenov; */
!function(a){"function"==typeof define&&define.amd?define(["jquery"],a):a("object"==typeof exports?require("jquery"):window.jQuery||window.Zepto)}(function(a){var b,c,d,e,f,g,h="Close",i="BeforeClose",j="AfterClose",k="BeforeAppend",l="MarkupParse",m="Open",n="Change",o="mfp",p="."+o,q="mfp-ready",r="mfp-removing",s="mfp-prevent-close",t=function(){},u=!!window.jQuery,v=a(window),w=function(a,c){b.ev.on(o+a+p,c)},x=function(b,c,d,e){var f=document.createElement("div");return f.className="mfp-"+b,d&&(f.innerHTML=d),e?c&&c.appendChild(f):(f=a(f),c&&f.appendTo(c)),f},y=function(c,d){b.ev.triggerHandler(o+c,d),b.st.callbacks&&(c=c.charAt(0).toLowerCase()+c.slice(1),b.st.callbacks[c]&&b.st.callbacks[c].apply(b,a.isArray(d)?d:[d]))},z=function(c){return c===g&&b.currTemplate.closeBtn||(b.currTemplate.closeBtn=a(b.st.closeMarkup.replace("%title%",b.st.tClose)),g=c),b.currTemplate.closeBtn},A=function(){a.magnificPopup.instance||(b=new t,b.init(),a.magnificPopup.instance=b)},B=function(){var a=document.createElement("p").style,b=["ms","O","Moz","Webkit"];if(void 0!==a.transition)return!0;for(;b.length;)if(b.pop()+"Transition"in a)return!0;return!1};t.prototype={constructor:t,init:function(){var c=navigator.appVersion;b.isLowIE=b.isIE8=document.all&&!document.addEventListener,b.isAndroid=/android/gi.test(c),b.isIOS=/iphone|ipad|ipod/gi.test(c),b.supportsTransition=B(),b.probablyMobile=b.isAndroid||b.isIOS||/(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent),d=a(document),b.popupsCache={}},open:function(c){var e;if(c.isObj===!1){b.items=c.items.toArray(),b.index=0;var g,h=c.items;for(e=0;e<h.length;e++)if(g=h[e],g.parsed&&(g=g.el[0]),g===c.el[0]){b.index=e;break}}else b.items=a.isArray(c.items)?c.items:[c.items],b.index=c.index||0;if(b.isOpen)return void b.updateItemHTML();b.types=[],f="",c.mainEl&&c.mainEl.length?b.ev=c.mainEl.eq(0):b.ev=d,c.key?(b.popupsCache[c.key]||(b.popupsCache[c.key]={}),b.currTemplate=b.popupsCache[c.key]):b.currTemplate={},b.st=a.extend(!0,{},a.magnificPopup.defaults,c),b.fixedContentPos="auto"===b.st.fixedContentPos?!b.probablyMobile:b.st.fixedContentPos,b.st.modal&&(b.st.closeOnContentClick=!1,b.st.closeOnBgClick=!1,b.st.showCloseBtn=!1,b.st.enableEscapeKey=!1),b.bgOverlay||(b.bgOverlay=x("bg").on("click"+p,function(){b.close()}),b.wrap=x("wrap").attr("tabindex",-1).on("click"+p,function(a){b._checkIfClose(a.target)&&b.close()}),b.container=x("container",b.wrap)),b.contentContainer=x("content"),b.st.preloader&&(b.preloader=x("preloader",b.container,b.st.tLoading));var i=a.magnificPopup.modules;for(e=0;e<i.length;e++){var j=i[e];j=j.charAt(0).toUpperCase()+j.slice(1),b["init"+j].call(b)}y("BeforeOpen"),b.st.showCloseBtn&&(b.st.closeBtnInside?(w(l,function(a,b,c,d){c.close_replaceWith=z(d.type)}),f+=" mfp-close-btn-in"):b.wrap.append(z())),b.st.alignTop&&(f+=" mfp-align-top"),b.fixedContentPos?b.wrap.css({overflow:b.st.overflowY,overflowX:"hidden",overflowY:b.st.overflowY}):b.wrap.css({top:v.scrollTop(),position:"absolute"}),(b.st.fixedBgPos===!1||"auto"===b.st.fixedBgPos&&!b.fixedContentPos)&&b.bgOverlay.css({height:d.height(),position:"absolute"}),b.st.enableEscapeKey&&d.on("keyup"+p,function(a){27===a.keyCode&&b.close()}),v.on("resize"+p,function(){b.updateSize()}),b.st.closeOnContentClick||(f+=" mfp-auto-cursor"),f&&b.wrap.addClass(f);var k=b.wH=v.height(),n={};if(b.fixedContentPos&&b._hasScrollBar(k)){var o=b._getScrollbarSize();o&&(n.marginRight=o)}b.fixedContentPos&&(b.isIE7?a("body, html").css("overflow","hidden"):n.overflow="hidden");var r=b.st.mainClass;return b.isIE7&&(r+=" mfp-ie7"),r&&b._addClassToMFP(r),b.updateItemHTML(),y("BuildControls"),a("html").css(n),b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo||a(document.body)),b._lastFocusedEl=document.activeElement,setTimeout(function(){b.content?(b._addClassToMFP(q),b._setFocus()):b.bgOverlay.addClass(q),d.on("focusin"+p,b._onFocusIn)},16),b.isOpen=!0,b.updateSize(k),y(m),c},close:function(){b.isOpen&&(y(i),b.isOpen=!1,b.st.removalDelay&&!b.isLowIE&&b.supportsTransition?(b._addClassToMFP(r),setTimeout(function(){b._close()},b.st.removalDelay)):b._close())},_close:function(){y(h);var c=r+" "+q+" ";if(b.bgOverlay.detach(),b.wrap.detach(),b.container.empty(),b.st.mainClass&&(c+=b.st.mainClass+" "),b._removeClassFromMFP(c),b.fixedContentPos){var e={marginRight:""};b.isIE7?a("body, html").css("overflow",""):e.overflow="",a("html").css(e)}d.off("keyup"+p+" focusin"+p),b.ev.off(p),b.wrap.attr("class","mfp-wrap").removeAttr("style"),b.bgOverlay.attr("class","mfp-bg"),b.container.attr("class","mfp-container"),!b.st.showCloseBtn||b.st.closeBtnInside&&b.currTemplate[b.currItem.type]!==!0||b.currTemplate.closeBtn&&b.currTemplate.closeBtn.detach(),b.st.autoFocusLast&&b._lastFocusedEl&&a(b._lastFocusedEl).focus(),b.currItem=null,b.content=null,b.currTemplate=null,b.prevHeight=0,y(j)},updateSize:function(a){if(b.isIOS){var c=document.documentElement.clientWidth/window.innerWidth,d=window.innerHeight*c;b.wrap.css("height",d),b.wH=d}else b.wH=a||v.height();b.fixedContentPos||b.wrap.css("height",b.wH),y("Resize")},updateItemHTML:function(){var c=b.items[b.index];b.contentContainer.detach(),b.content&&b.content.detach(),c.parsed||(c=b.parseEl(b.index));var d=c.type;if(y("BeforeChange",[b.currItem?b.currItem.type:"",d]),b.currItem=c,!b.currTemplate[d]){var f=b.st[d]?b.st[d].markup:!1;y("FirstMarkupParse",f),f?b.currTemplate[d]=a(f):b.currTemplate[d]=!0}e&&e!==c.type&&b.container.removeClass("mfp-"+e+"-holder");var g=b["get"+d.charAt(0).toUpperCase()+d.slice(1)](c,b.currTemplate[d]);b.appendContent(g,d),c.preloaded=!0,y(n,c),e=c.type,b.container.prepend(b.contentContainer),y("AfterChange")},appendContent:function(a,c){b.content=a,a?b.st.showCloseBtn&&b.st.closeBtnInside&&b.currTemplate[c]===!0?b.content.find(".mfp-close").length||b.content.append(z()):b.content=a:b.content="",y(k),b.container.addClass("mfp-"+c+"-holder"),b.contentContainer.append(b.content)},parseEl:function(c){var d,e=b.items[c];if(e.tagName?e={el:a(e)}:(d=e.type,e={data:e,src:e.src}),e.el){for(var f=b.types,g=0;g<f.length;g++)if(e.el.hasClass("mfp-"+f[g])){d=f[g];break}e.src=e.el.attr("data-mfp-src"),e.src||(e.src=e.el.attr("href"))}return e.type=d||b.st.type||"inline",e.index=c,e.parsed=!0,b.items[c]=e,y("ElementParse",e),b.items[c]},addGroup:function(a,c){var d=function(d){d.mfpEl=this,b._openClick(d,a,c)};c||(c={});var e="click.magnificPopup";c.mainEl=a,c.items?(c.isObj=!0,a.off(e).on(e,d)):(c.isObj=!1,c.delegate?a.off(e).on(e,c.delegate,d):(c.items=a,a.off(e).on(e,d)))},_openClick:function(c,d,e){var f=void 0!==e.midClick?e.midClick:a.magnificPopup.defaults.midClick;if(f||!(2===c.which||c.ctrlKey||c.metaKey||c.altKey||c.shiftKey)){var g=void 0!==e.disableOn?e.disableOn:a.magnificPopup.defaults.disableOn;if(g)if(a.isFunction(g)){if(!g.call(b))return!0}else if(v.width()<g)return!0;c.type&&(c.preventDefault(),b.isOpen&&c.stopPropagation()),e.el=a(c.mfpEl),e.delegate&&(e.items=d.find(e.delegate)),b.open(e)}},updateStatus:function(a,d){if(b.preloader){c!==a&&b.container.removeClass("mfp-s-"+c),d||"loading"!==a||(d=b.st.tLoading);var e={status:a,text:d};y("UpdateStatus",e),a=e.status,d=e.text,b.preloader.html(d),b.preloader.find("a").on("click",function(a){a.stopImmediatePropagation()}),b.container.addClass("mfp-s-"+a),c=a}},_checkIfClose:function(c){if(!a(c).hasClass(s)){var d=b.st.closeOnContentClick,e=b.st.closeOnBgClick;if(d&&e)return!0;if(!b.content||a(c).hasClass("mfp-close")||b.preloader&&c===b.preloader[0])return!0;if(c===b.content[0]||a.contains(b.content[0],c)){if(d)return!0}else if(e&&a.contains(document,c))return!0;return!1}},_addClassToMFP:function(a){b.bgOverlay.addClass(a),b.wrap.addClass(a)},_removeClassFromMFP:function(a){this.bgOverlay.removeClass(a),b.wrap.removeClass(a)},_hasScrollBar:function(a){return(b.isIE7?d.height():document.body.scrollHeight)>(a||v.height())},_setFocus:function(){(b.st.focus?b.content.find(b.st.focus).eq(0):b.wrap).focus()},_onFocusIn:function(c){return c.target===b.wrap[0]||a.contains(b.wrap[0],c.target)?void 0:(b._setFocus(),!1)},_parseMarkup:function(b,c,d){var e;d.data&&(c=a.extend(d.data,c)),y(l,[b,c,d]),a.each(c,function(c,d){if(void 0===d||d===!1)return!0;if(e=c.split("_"),e.length>1){var f=b.find(p+"-"+e[0]);if(f.length>0){var g=e[1];"replaceWith"===g?f[0]!==d[0]&&f.replaceWith(d):"img"===g?f.is("img")?f.attr("src",d):f.replaceWith(a("<img>").attr("src",d).attr("class",f.attr("class"))):f.attr(e[1],d)}}else b.find(p+"-"+c).html(d)})},_getScrollbarSize:function(){if(void 0===b.scrollbarSize){var a=document.createElement("div");a.style.cssText="width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;",document.body.appendChild(a),b.scrollbarSize=a.offsetWidth-a.clientWidth,document.body.removeChild(a)}return b.scrollbarSize}},a.magnificPopup={instance:null,proto:t.prototype,modules:[],open:function(b,c){return A(),b=b?a.extend(!0,{},b):{},b.isObj=!0,b.index=c||0,this.instance.open(b)},close:function(){return a.magnificPopup.instance&&a.magnificPopup.instance.close()},registerModule:function(b,c){c.options&&(a.magnificPopup.defaults[b]=c.options),a.extend(this.proto,c.proto),this.modules.push(b)},defaults:{disableOn:0,key:null,midClick:!1,mainClass:"",preloader:!0,focus:"",closeOnContentClick:!1,closeOnBgClick:!0,closeBtnInside:!0,showCloseBtn:!0,enableEscapeKey:!0,modal:!1,alignTop:!1,removalDelay:0,prependTo:null,fixedContentPos:"auto",fixedBgPos:"auto",overflowY:"auto",closeMarkup:'<button title="%title%" type="button" class="mfp-close">&#215;</button>',tClose:"Close (Esc)",tLoading:"Loading...",autoFocusLast:!0}},a.fn.magnificPopup=function(c){A();var d=a(this);if("string"==typeof c)if("open"===c){var e,f=u?d.data("magnificPopup"):d[0].magnificPopup,g=parseInt(arguments[1],10)||0;f.items?e=f.items[g]:(e=d,f.delegate&&(e=e.find(f.delegate)),e=e.eq(g)),b._openClick({mfpEl:e},d,f)}else b.isOpen&&b[c].apply(b,Array.prototype.slice.call(arguments,1));else c=a.extend(!0,{},c),u?d.data("magnificPopup",c):d[0].magnificPopup=c,b.addGroup(d,c);return d};var C,D,E,F="inline",G=function(){E&&(D.after(E.addClass(C)).detach(),E=null)};a.magnificPopup.registerModule(F,{options:{hiddenClass:"hide",markup:"",tNotFound:"Content not found"},proto:{initInline:function(){b.types.push(F),w(h+"."+F,function(){G()})},getInline:function(c,d){if(G(),c.src){var e=b.st.inline,f=a(c.src);if(f.length){var g=f[0].parentNode;g&&g.tagName&&(D||(C=e.hiddenClass,D=x(C),C="mfp-"+C),E=f.after(D).detach().removeClass(C)),b.updateStatus("ready")}else b.updateStatus("error",e.tNotFound),f=a("<div>");return c.inlineElement=f,f}return b.updateStatus("ready"),b._parseMarkup(d,{},c),d}}});var H,I="ajax",J=function(){H&&a(document.body).removeClass(H)},K=function(){J(),b.req&&b.req.abort()};a.magnificPopup.registerModule(I,{options:{settings:null,cursor:"mfp-ajax-cur",tError:'<a href="%url%">The content</a> could not be loaded.'},proto:{initAjax:function(){b.types.push(I),H=b.st.ajax.cursor,w(h+"."+I,K),w("BeforeChange."+I,K)},getAjax:function(c){H&&a(document.body).addClass(H),b.updateStatus("loading");var d=a.extend({url:c.src,success:function(d,e,f){var g={data:d,xhr:f};y("ParseAjax",g),b.appendContent(a(g.data),I),c.finished=!0,J(),b._setFocus(),setTimeout(function(){b.wrap.addClass(q)},16),b.updateStatus("ready"),y("AjaxContentAdded")},error:function(){J(),c.finished=c.loadError=!0,b.updateStatus("error",b.st.ajax.tError.replace("%url%",c.src))}},b.st.ajax.settings);return b.req=a.ajax(d),""}}});var L,M=function(c){if(c.data&&void 0!==c.data.title)return c.data.title;var d=b.st.image.titleSrc;if(d){if(a.isFunction(d))return d.call(b,c);if(c.el)return c.el.attr(d)||""}return""};a.magnificPopup.registerModule("image",{options:{markup:'<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',cursor:"mfp-zoom-out-cur",titleSrc:"title",verticalFit:!0,tError:'<a href="%url%">The image</a> could not be loaded.'},proto:{initImage:function(){var c=b.st.image,d=".image";b.types.push("image"),w(m+d,function(){"image"===b.currItem.type&&c.cursor&&a(document.body).addClass(c.cursor)}),w(h+d,function(){c.cursor&&a(document.body).removeClass(c.cursor),v.off("resize"+p)}),w("Resize"+d,b.resizeImage),b.isLowIE&&w("AfterChange",b.resizeImage)},resizeImage:function(){var a=b.currItem;if(a&&a.img&&b.st.image.verticalFit){var c=0;b.isLowIE&&(c=parseInt(a.img.css("padding-top"),10)+parseInt(a.img.css("padding-bottom"),10)),a.img.css("max-height",b.wH-c)}},_onImageHasSize:function(a){a.img&&(a.hasSize=!0,L&&clearInterval(L),a.isCheckingImgSize=!1,y("ImageHasSize",a),a.imgHidden&&(b.content&&b.content.removeClass("mfp-loading"),a.imgHidden=!1))},findImageSize:function(a){var c=0,d=a.img[0],e=function(f){L&&clearInterval(L),L=setInterval(function(){return d.naturalWidth>0?void b._onImageHasSize(a):(c>200&&clearInterval(L),c++,void(3===c?e(10):40===c?e(50):100===c&&e(500)))},f)};e(1)},getImage:function(c,d){var e=0,f=function(){c&&(c.img[0].complete?(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("ready")),c.hasSize=!0,c.loaded=!0,y("ImageLoadComplete")):(e++,200>e?setTimeout(f,100):g()))},g=function(){c&&(c.img.off(".mfploader"),c===b.currItem&&(b._onImageHasSize(c),b.updateStatus("error",h.tError.replace("%url%",c.src))),c.hasSize=!0,c.loaded=!0,c.loadError=!0)},h=b.st.image,i=d.find(".mfp-img");if(i.length){var j=document.createElement("img");j.className="mfp-img",c.el&&c.el.find("img").length&&(j.alt=c.el.find("img").attr("alt")),c.img=a(j).on("load.mfploader",f).on("error.mfploader",g),j.src=c.src,i.is("img")&&(c.img=c.img.clone()),j=c.img[0],j.naturalWidth>0?c.hasSize=!0:j.width||(c.hasSize=!1)}return b._parseMarkup(d,{title:M(c),img_replaceWith:c.img},c),b.resizeImage(),c.hasSize?(L&&clearInterval(L),c.loadError?(d.addClass("mfp-loading"),b.updateStatus("error",h.tError.replace("%url%",c.src))):(d.removeClass("mfp-loading"),b.updateStatus("ready")),d):(b.updateStatus("loading"),c.loading=!0,c.hasSize||(c.imgHidden=!0,d.addClass("mfp-loading"),b.findImageSize(c)),d)}}});var N,O=function(){return void 0===N&&(N=void 0!==document.createElement("p").style.MozTransform),N};a.magnificPopup.registerModule("zoom",{options:{enabled:!1,easing:"ease-in-out",duration:300,opener:function(a){return a.is("img")?a:a.find("img")}},proto:{initZoom:function(){var a,c=b.st.zoom,d=".zoom";if(c.enabled&&b.supportsTransition){var e,f,g=c.duration,j=function(a){var b=a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),d="all "+c.duration/1e3+"s "+c.easing,e={position:"fixed",zIndex:9999,left:0,top:0,"-webkit-backface-visibility":"hidden"},f="transition";return e["-webkit-"+f]=e["-moz-"+f]=e["-o-"+f]=e[f]=d,b.css(e),b},k=function(){b.content.css("visibility","visible")};w("BuildControls"+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.content.css("visibility","hidden"),a=b._getItemToZoom(),!a)return void k();f=j(a),f.css(b._getOffset()),b.wrap.append(f),e=setTimeout(function(){f.css(b._getOffset(!0)),e=setTimeout(function(){k(),setTimeout(function(){f.remove(),a=f=null,y("ZoomAnimationEnded")},16)},g)},16)}}),w(i+d,function(){if(b._allowZoom()){if(clearTimeout(e),b.st.removalDelay=g,!a){if(a=b._getItemToZoom(),!a)return;f=j(a)}f.css(b._getOffset(!0)),b.wrap.append(f),b.content.css("visibility","hidden"),setTimeout(function(){f.css(b._getOffset())},16)}}),w(h+d,function(){b._allowZoom()&&(k(),f&&f.remove(),a=null)})}},_allowZoom:function(){return"image"===b.currItem.type},_getItemToZoom:function(){return b.currItem.hasSize?b.currItem.img:!1},_getOffset:function(c){var d;d=c?b.currItem.img:b.st.zoom.opener(b.currItem.el||b.currItem);var e=d.offset(),f=parseInt(d.css("padding-top"),10),g=parseInt(d.css("padding-bottom"),10);e.top-=a(window).scrollTop()-f;var h={width:d.width(),height:(u?d.innerHeight():d[0].offsetHeight)-g-f};return O()?h["-moz-transform"]=h.transform="translate("+e.left+"px,"+e.top+"px)":(h.left=e.left,h.top=e.top),h}}});var P="iframe",Q="//about:blank",R=function(a){if(b.currTemplate[P]){var c=b.currTemplate[P].find("iframe");c.length&&(a||(c[0].src=Q),b.isIE8&&c.css("display",a?"block":"none"))}};a.magnificPopup.registerModule(P,{options:{markup:'<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',srcAction:"iframe_src",patterns:{youtube:{index:"youtube.com",id:"v=",src:"//www.youtube.com/embed/%id%?autoplay=1"},vimeo:{index:"vimeo.com/",id:"/",src:"//player.vimeo.com/video/%id%?autoplay=1"},gmaps:{index:"//maps.google.",src:"%id%&output=embed"}}},proto:{initIframe:function(){b.types.push(P),w("BeforeChange",function(a,b,c){b!==c&&(b===P?R():c===P&&R(!0))}),w(h+"."+P,function(){R()})},getIframe:function(c,d){var e=c.src,f=b.st.iframe;a.each(f.patterns,function(){return e.indexOf(this.index)>-1?(this.id&&(e="string"==typeof this.id?e.substr(e.lastIndexOf(this.id)+this.id.length,e.length):this.id.call(this,e)),e=this.src.replace("%id%",e),!1):void 0});var g={};return f.srcAction&&(g[f.srcAction]=e),b._parseMarkup(d,g,c),b.updateStatus("ready"),d}}});var S=function(a){var c=b.items.length;return a>c-1?a-c:0>a?c+a:a},T=function(a,b,c){return a.replace(/%curr%/gi,b+1).replace(/%total%/gi,c)};a.magnificPopup.registerModule("gallery",{options:{enabled:!1,arrowMarkup:'<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',preload:[0,2],navigateByImgClick:!0,arrows:!0,tPrev:"Previous (Left arrow key)",tNext:"Next (Right arrow key)",tCounter:"%curr% of %total%"},proto:{initGallery:function(){var c=b.st.gallery,e=".mfp-gallery";return b.direction=!0,c&&c.enabled?(f+=" mfp-gallery",w(m+e,function(){c.navigateByImgClick&&b.wrap.on("click"+e,".mfp-img",function(){return b.items.length>1?(b.next(),!1):void 0}),d.on("keydown"+e,function(a){37===a.keyCode?b.prev():39===a.keyCode&&b.next()})}),w("UpdateStatus"+e,function(a,c){c.text&&(c.text=T(c.text,b.currItem.index,b.items.length))}),w(l+e,function(a,d,e,f){var g=b.items.length;e.counter=g>1?T(c.tCounter,f.index,g):""}),w("BuildControls"+e,function(){if(b.items.length>1&&c.arrows&&!b.arrowLeft){var d=c.arrowMarkup,e=b.arrowLeft=a(d.replace(/%title%/gi,c.tPrev).replace(/%dir%/gi,"left")).addClass(s),f=b.arrowRight=a(d.replace(/%title%/gi,c.tNext).replace(/%dir%/gi,"right")).addClass(s);e.click(function(){b.prev()}),f.click(function(){b.next()}),b.container.append(e.add(f))}}),w(n+e,function(){b._preloadTimeout&&clearTimeout(b._preloadTimeout),b._preloadTimeout=setTimeout(function(){b.preloadNearbyImages(),b._preloadTimeout=null},16)}),void w(h+e,function(){d.off(e),b.wrap.off("click"+e),b.arrowRight=b.arrowLeft=null})):!1},next:function(){b.direction=!0,b.index=S(b.index+1),b.updateItemHTML()},prev:function(){b.direction=!1,b.index=S(b.index-1),b.updateItemHTML()},goTo:function(a){b.direction=a>=b.index,b.index=a,b.updateItemHTML()},preloadNearbyImages:function(){var a,c=b.st.gallery.preload,d=Math.min(c[0],b.items.length),e=Math.min(c[1],b.items.length);for(a=1;a<=(b.direction?e:d);a++)b._preloadItem(b.index+a);for(a=1;a<=(b.direction?d:e);a++)b._preloadItem(b.index-a)},_preloadItem:function(c){if(c=S(c),!b.items[c].preloaded){var d=b.items[c];d.parsed||(d=b.parseEl(c)),y("LazyLoad",d),"image"===d.type&&(d.img=a('<img class="mfp-img" />').on("load.mfploader",function(){d.hasSize=!0}).on("error.mfploader",function(){d.hasSize=!0,d.loadError=!0,y("LazyLoadError",d)}).attr("src",d.src)),d.preloaded=!0}}}});var U="retina";a.magnificPopup.registerModule(U,{options:{replaceSrc:function(a){return a.src.replace(/\.\w+$/,function(a){return"@2x"+a})},ratio:1},proto:{initRetina:function(){if(window.devicePixelRatio>1){var a=b.st.retina,c=a.ratio;c=isNaN(c)?c():c,c>1&&(w("ImageHasSize."+U,function(a,b){b.img.css({"max-width":b.img[0].naturalWidth/c,width:"100%"})}),w("ElementParse."+U,function(b,d){d.src=a.replaceSrc(d,c)}))}}}}),A()});

/*!
* parallax.js v2.0.0 (http://pixelcog.github.io/parallax.js/)
* @copyright 2017 PixelCog, Inc.
* @license MIT (https://github.com/pixelcog/parallax.js/blob/master/LICENSE)
*/
!function(t){function e(i){if(o[i])return o[i].exports;var r=o[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,e),r.l=!0,r.exports}var o={};e.m=t,e.c=o,e.d=function(t,o,i){e.o(t,o)||Object.defineProperty(t,o,{configurable:!1,enumerable:!0,get:i})},e.n=function(t){var o=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(o,"a",o),o},e.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},e.p="",e(e.s=1)}([function(t,e){t.exports=jQuery},function(t,e,o){"use strict";function i(t){return t&&t.__esModule?t:{default:t}}function r(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var n=function(){function t(t,e){for(var o=0;o<e.length;o++){var i=e[o];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,o,i){return o&&t(e.prototype,o),i&&t(e,i),e}}(),s=o(0),a=i(s),f=o(2),l=i(f),d=function(){function t(e,o){function i(t,e,i){var r=parseInt(o[t]);isNaN(r)?o[t]!==e&&o[t]!==i&&(o.pos+=(o[t]="center")+" "):o.pos+=(o[t]=r)+"px "}r(this,t);var n=(0,a.default)(e);if(o.pos="",i("posX","left","right"),i("posY","top","bottom"),navigator.userAgent.match(o.excludeAgents))o.src&&!n.is("img")&&n.css("background",'url("'+o.src+'") '+o.pos+"/cover");else{o.scrollingSelector&&(t.scrollingElement=(0,a.default)(o.scrollingSelector)[0]),t.isSet||t.init(),t.iList.push(this);var s=(0,a.default)("<div>").addClass("parallax-mirror").css({visibility:"hidden",zIndex:o.zIndex,position:"fixed",top:0,left:0,overflow:"hidden"}).prependTo((0,a.default)(o.mirrorSelector)),f=n.find(o.sliderSelector);0===f.length?f=(0,a.default)("<img>").attr("src",o.src):(o.formerParent=f.parent(),o.formerStyles=f.prop("style")),f.addClass("parallax-slider").prependTo(s),f.children("img").add(f).on("load",function(){t.update(!0)}),this.$s=f,this.$m=s}this.$w=n,this.o=o,"function"==typeof o.afterSetup&&o.afterSetup(this)}return n(t,[{key:"refresh",value:function(){var e=this.$w,o=this.o;o.dH=t.dH,o.dW=t.dW;var i=o.scrollingElement;if(i&&i!==document&&(o.dH=i.scrollHeight,o.dW=i.scrollWidth),o){o.aspectRatio||function(t,e){var o=0,i=0,r=0,n=0;if(0===t.children().each(function(){var t=(0,a.default)(this),e=t.offset(),s=e.top+t.outerHeight(),f=e.left+t.outerWidth();o=e.top<o?e.top:o,r=e.left<r?e.left:r,i=s>i?s:i,n=f>n?f:n}).length)e.aspectRatio=t[0].naturalWidth/(t[0].naturalHeight||1);else{var s=t.offset(),f=i-Math.max(o,s.top),l=n-Math.max(r,s.left);e.aspectRatio=l/(f||1)}}(this.$s,o);var r=o.aspectRatio||1;o.boxWidth=e.outerWidth(),o.boxHeight=e.outerHeight()+2*o.bleed,o.boxOffsetTop=e.offset().top-o.bleed,o.boxOffsetLeft=e.offset().left,o.boxOffsetBottom=o.boxOffsetTop+o.boxHeight;var n=t.wH,s=t.dH,f=Math.min(o.boxOffsetTop,s-n),l=Math.max(o.boxOffsetTop+o.boxHeight-n,0),d=o.boxHeight+(f-l)*(1-o.speed)|0,u=(o.boxOffsetTop-f)*(1-o.speed)|0,p=void 0;o.boxWidth<d*r?(o.imageWidth=d*r|0,o.imageHeight=d,o.offsetBaseTop=u,p=o.imageWidth-o.boxWidth,"left"===o.posX?o.offsetLeft=0:"right"===o.posX?o.offsetLeft=-p:isNaN(o.posX)?o.offsetLeft=-p/2|0:o.offsetLeft=Math.max(o.posX,-p)):(o.imageWidth=o.boxWidth,o.imageHeight=o.boxWidth/r|0,o.offsetLeft=0,p=o.imageHeight-d,"top"===o.posY?o.offsetBaseTop=u:"bottom"===o.posY?o.offsetBaseTop=u-p:isNaN(o.posY)?o.offsetBaseTop=u-p/2|0:o.offsetBaseTop=u+Math.max(o.posY,-p)),"function"==typeof o.afterRefresh&&o.afterRefresh(this)}}},{key:"render",value:function(){var e=this.o,o=t.sT,i=t.sL,r=e.overScrollFix?t.overScroll:0,n=o+t.wH;e.boxOffsetBottom>o&&e.boxOffsetTop<=n?(e.visibility="visible",e.mirrorTop=e.boxOffsetTop-o,e.mirrorLeft=e.boxOffsetLeft-i,e.offsetTop=e.offsetBaseTop-e.mirrorTop*(1-e.speed)):e.visibility="hidden",this.$m.css({transform:"translate3d("+e.mirrorLeft+"px, "+(e.mirrorTop-r)+"px, 0px)",visibility:e.visibility,height:e.boxHeight,width:e.boxWidth}),this.$s.css({transform:"translate3d("+e.offsetLeft+"px, "+e.offsetTop+"px, 0px)",position:"absolute",height:e.imageHeight,width:e.imageWidth,maxWidth:"none"}),"function"==typeof e.afterRender&&e.afterRender(this)}},{key:"destroy",value:function(){if(this.$m&&this.$m.remove(),this.$s){for(var e=0;e<t.iList.length;e++)t.iList[e]===this&&t.iList.splice(e,1);this.o.formerParent&&(this.$s.prop("style",this.o.formerStyles),this.o.formerParent.append(this.$s))}0===t.iList.length&&((0,a.default)(window).off("scroll.px.parallax resize.px.parallax load.px.parallax"),t.isSet=!1),"function"==typeof this.o.afterDestroy&&this.o.afterDestroy(this)}}],[{key:"init",value:function(){function e(){t.wH=r.height(),t.wW=r.width(),t.dH=i[0].scrollHeight||i.height(),t.dW=i[0].scrollWidth||i.width()}function o(){var e=n.scrollTop(),o=t.dH-t.wH,i=t.dW-t.wW;t.sT=Math.max(0,Math.min(o,e)),t.sL=Math.max(0,Math.min(i,n.scrollLeft())),t.overScroll=Math.max(e-o,Math.min(e,0))}if(!t.isSet){var i=(0,a.default)(t.scrollingElement||document),r=(0,a.default)(window),n=(0,a.default)(t.scrollingElement||window);r.on("resize.px.parallax load.px.parallax",function(){e(),t.update(!0)}),e(),t.isSet=!0;var s=-1;!function e(){var i=n.scrollTop();s!==i&&(s=i,o(),t.update()),window.requestAnimationFrame(e)}()}}},{key:"update",value:function(){arguments.length>0&&void 0!==arguments[0]&&arguments[0]&&a.default.each(t.iList,function(){this.refresh()}),a.default.each(t.iList,function(){this.render()})}}]),t}();d.DEFAULTS={src:null,speed:.2,bleed:0,zIndex:-100,posX:"center",posY:"center",overScrollFix:!1,excludeAgents:/(iPod|iPhone|iPad|Android)/,aspectRatio:null,sliderSelector:">.parallax-slider",mirrorSelector:"body",scrollingSelector:null,afterRefresh:null,afterRender:null,afterSetup:null,afterDestroy:null},d.AUTOINIT=!0,d.sT=0,d.sL=0,d.wH=0,d.wW=0,d.dH=1<<30,d.dW=1<<30,d.iList=[],d.isSet=!1,(0,a.default)(function(){d.AUTOINIT&&(0,a.default)("[data-parallax]").parallax()}),(0,l.default)("parallax",d)},function(t,e,o){"use strict";function i(t,e){var o=arguments.length>2&&void 0!==arguments[2]&&arguments[2],i="__"+t,n=s.default.fn[t];s.default.fn[t]=function(t){return this.each(function(){var o=(0,s.default)(this),n=o.data(i);if(n||"destroy"===t)"function"==typeof n.configure&&n.configure(options);else{var a=s.default.extend({},e.DEFAULTS,o.data(),"object"===(void 0===t?"undefined":r(t))&&t);o.data(i,n=new e(this,a))}"string"==typeof t&&("destroy"===t?(n.destroy(),o.data(i,!1)):n[t]())})},o&&(s.default[t]=function(e){return(0,s.default)({})[t](e)}),s.default.fn[t].noConflict=function(){return s.default.fn[t]=n}}Object.defineProperty(e,"__esModule",{value:!0});var r="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};e.default=i;var n=o(0),s=function(t){return t&&t.__esModule?t:{default:t}}(n)}]);

/*!
handlebars v1.3.0
Copyright (C) 2011 by Yehuda Katz
MIT Licence
*/
var Handlebars=function(){var e=function(){"use strict";function t(e){this.string=e}var e;t.prototype.toString=function(){return""+this.string};e=t;return e}();var t=function(e){"use strict";function o(e){return r[e]||"&"}function u(e,t){for(var n in t){if(Object.prototype.hasOwnProperty.call(t,n)){e[n]=t[n]}}}function c(e){if(e instanceof n){return e.toString()}else if(!e&&e!==0){return""}e=""+e;if(!s.test(e)){return e}return e.replace(i,o)}function h(e){if(!e&&e!==0){return true}else if(l(e)&&e.length===0){return true}else{return false}}var t={};var n=e;var r={"&":"&","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"};var i=/[&<>"'`]/g;var s=/[&<>"'`]/;t.extend=u;var a=Object.prototype.toString;t.toString=a;var f=function(e){return typeof e==="function"};if(f(/x/)){f=function(e){return typeof e==="function"&&a.call(e)==="[object Function]"}}var f;t.isFunction=f;var l=Array.isArray||function(e){return e&&typeof e==="object"?a.call(e)==="[object Array]":false};t.isArray=l;t.escapeExpression=c;t.isEmpty=h;return t}(e);var n=function(){"use strict";function n(e,n){var r;if(n&&n.firstLine){r=n.firstLine;e+=" - "+r+":"+n.firstColumn}var i=Error.prototype.constructor.call(this,e);for(var s=0;s<t.length;s++){this[t[s]]=i[t[s]]}if(r){this.lineNumber=r;this.column=n.firstColumn}}var e;var t=["description","fileName","lineNumber","message","name","number","stack"];n.prototype=new Error;e=n;return e}();var r=function(e,t){"use strict";function h(e,t){this.helpers=e||{};this.partials=t||{};p(this)}function p(e){e.registerHelper("helperMissing",function(e){if(arguments.length===2){return undefined}else{throw new i("Missing helper: '"+e+"'")}});e.registerHelper("blockHelperMissing",function(t,n){var r=n.inverse||function(){},i=n.fn;if(f(t)){t=t.call(this)}if(t===true){return i(this)}else if(t===false||t==null){return r(this)}else if(a(t)){if(t.length>0){return e.helpers.each(t,n)}else{return r(this)}}else{return i(t)}});e.registerHelper("each",function(e,t){var n=t.fn,r=t.inverse;var i=0,s="",o;if(f(e)){e=e.call(this)}if(t.data){o=m(t.data)}if(e&&typeof e==="object"){if(a(e)){for(var u=e.length;i<u;i++){if(o){o.index=i;o.first=i===0;o.last=i===e.length-1}s=s+n(e[i],{data:o})}}else{for(var l in e){if(e.hasOwnProperty(l)){if(o){o.key=l;o.index=i;o.first=i===0}s=s+n(e[l],{data:o});i++}}}}if(i===0){s=r(this)}return s});e.registerHelper("if",function(e,t){if(f(e)){e=e.call(this)}if(!t.hash.includeZero&&!e||r.isEmpty(e)){return t.inverse(this)}else{return t.fn(this)}});e.registerHelper("unless",function(t,n){return e.helpers["if"].call(this,t,{fn:n.inverse,inverse:n.fn,hash:n.hash})});e.registerHelper("with",function(e,t){if(f(e)){e=e.call(this)}if(!r.isEmpty(e))return t.fn(e)});e.registerHelper("log",function(t,n){var r=n.data&&n.data.level!=null?parseInt(n.data.level,10):1;e.log(r,t)})}function v(e,t){d.log(e,t)}var n={};var r=e;var i=t;var s="1.3.0";n.VERSION=s;var o=4;n.COMPILER_REVISION=o;var u={1:"<= 1.0.rc.2",2:"== 1.0.0-rc.3",3:"== 1.0.0-rc.4",4:">= 1.0.0"};n.REVISION_CHANGES=u;var a=r.isArray,f=r.isFunction,l=r.toString,c="[object Object]";n.HandlebarsEnvironment=h;h.prototype={constructor:h,logger:d,log:v,registerHelper:function(e,t,n){if(l.call(e)===c){if(n||t){throw new i("Arg not supported with multiple helpers")}r.extend(this.helpers,e)}else{if(n){t.not=n}this.helpers[e]=t}},registerPartial:function(e,t){if(l.call(e)===c){r.extend(this.partials,e)}else{this.partials[e]=t}}};var d={methodMap:{0:"debug",1:"info",2:"warn",3:"error"},DEBUG:0,INFO:1,WARN:2,ERROR:3,level:3,log:function(e,t){if(d.level<=e){var n=d.methodMap[e];if(typeof console!=="undefined"&&console[n]){console[n].call(console,t)}}}};n.logger=d;n.log=v;var m=function(e){var t={};r.extend(t,e);return t};n.createFrame=m;return n}(t,n);var i=function(e,t,n){"use strict";function a(e){var t=e&&e[0]||1,n=o;if(t!==n){if(t<n){var r=u[n],i=u[t];throw new s("Template was precompiled with an older version of Handlebars than the current runtime. "+"Please update your precompiler to a newer version ("+r+") or downgrade your runtime to an older version ("+i+").")}else{throw new s("Template was precompiled with a newer version of Handlebars than the current runtime. "+"Please update your runtime to a newer version ("+e[1]+").")}}}function f(e,t){if(!t){throw new s("No environment passed to template")}var n=function(e,n,r,i,o,u){var a=t.VM.invokePartial.apply(this,arguments);if(a!=null){return a}if(t.compile){var f={helpers:i,partials:o,data:u};o[n]=t.compile(e,{data:u!==undefined},t);return o[n](r,f)}else{throw new s("The partial "+n+" could not be compiled when running in runtime-only mode")}};var r={escapeExpression:i.escapeExpression,invokePartial:n,programs:[],program:function(e,t,n){var r=this.programs[e];if(n){r=c(e,t,n)}else if(!r){r=this.programs[e]=c(e,t)}return r},merge:function(e,t){var n=e||t;if(e&&t&&e!==t){n={};i.extend(n,t);i.extend(n,e)}return n},programWithDepth:t.VM.programWithDepth,noop:t.VM.noop,compilerInfo:null};return function(n,i){i=i||{};var s=i.partial?i:t,o,u;if(!i.partial){o=i.helpers;u=i.partials}var a=e.call(r,s,n,o,u,i.data);if(!i.partial){t.VM.checkRevision(r.compilerInfo)}return a}}function l(e,t,n){var r=Array.prototype.slice.call(arguments,3);var i=function(e,i){i=i||{};return t.apply(this,[e,i.data||n].concat(r))};i.program=e;i.depth=r.length;return i}function c(e,t,n){var r=function(e,r){r=r||{};return t(e,r.data||n)};r.program=e;r.depth=0;return r}function h(e,t,n,r,i,o){var u={partial:true,helpers:r,partials:i,data:o};if(e===undefined){throw new s("The partial "+t+" could not be found")}else if(e instanceof Function){return e(n,u)}}function p(){return""}var r={};var i=e;var s=t;var o=n.COMPILER_REVISION;var u=n.REVISION_CHANGES;r.checkRevision=a;r.template=f;r.programWithDepth=l;r.program=c;r.invokePartial=h;r.noop=p;return r}(t,n,r);var s=function(e,t,n,r,i){"use strict";var s;var o=e;var u=t;var a=n;var f=r;var l=i;var c=function(){var e=new o.HandlebarsEnvironment;f.extend(e,o);e.SafeString=u;e.Exception=a;e.Utils=f;e.VM=l;e.template=function(t){return l.template(t,e)};return e};var h=c();h.create=c;s=h;return s}(r,e,n,t,i);var o=function(e){"use strict";function r(e){e=e||{};this.firstLine=e.first_line;this.firstColumn=e.first_column;this.lastColumn=e.last_column;this.lastLine=e.last_line}var t;var n=e;var i={ProgramNode:function(e,t,n,s){var o,u;if(arguments.length===3){s=n;n=null}else if(arguments.length===2){s=t;t=null}r.call(this,s);this.type="program";this.statements=e;this.strip={};if(n){u=n[0];if(u){o={first_line:u.firstLine,last_line:u.lastLine,last_column:u.lastColumn,first_column:u.firstColumn};this.inverse=new i.ProgramNode(n,t,o)}else{this.inverse=new i.ProgramNode(n,t)}this.strip.right=t.left}else if(t){this.strip.left=t.right}},MustacheNode:function(e,t,n,s,o){r.call(this,o);this.type="mustache";this.strip=s;if(n!=null&&n.charAt){var u=n.charAt(3)||n.charAt(2);this.escaped=u!=="{"&&u!=="&"}else{this.escaped=!!n}if(e instanceof i.SexprNode){this.sexpr=e}else{this.sexpr=new i.SexprNode(e,t)}this.sexpr.isRoot=true;this.id=this.sexpr.id;this.params=this.sexpr.params;this.hash=this.sexpr.hash;this.eligibleHelper=this.sexpr.eligibleHelper;this.isHelper=this.sexpr.isHelper},SexprNode:function(e,t,n){r.call(this,n);this.type="sexpr";this.hash=t;var i=this.id=e[0];var s=this.params=e.slice(1);var o=this.eligibleHelper=i.isSimple;this.isHelper=o&&(s.length||t)},PartialNode:function(e,t,n,i){r.call(this,i);this.type="partial";this.partialName=e;this.context=t;this.strip=n},BlockNode:function(e,t,i,s,o){r.call(this,o);if(e.sexpr.id.original!==s.path.original){throw new n(e.sexpr.id.original+" doesn't match "+s.path.original,this)}this.type="block";this.mustache=e;this.program=t;this.inverse=i;this.strip={left:e.strip.left,right:s.strip.right};(t||i).strip.left=e.strip.right;(i||t).strip.right=s.strip.left;if(i&&!t){this.isInverse=true}},ContentNode:function(e,t){r.call(this,t);this.type="content";this.string=e},HashNode:function(e,t){r.call(this,t);this.type="hash";this.pairs=e},IdNode:function(e,t){r.call(this,t);this.type="ID";var i="",s=[],o=0;for(var u=0,a=e.length;u<a;u++){var f=e[u].part;i+=(e[u].separator||"")+f;if(f===".."||f==="."||f==="this"){if(s.length>0){throw new n("Invalid path: "+i,this)}else if(f===".."){o++}else{this.isScoped=true}}else{s.push(f)}}this.original=i;this.parts=s;this.string=s.join(".");this.depth=o;this.isSimple=e.length===1&&!this.isScoped&&o===0;this.stringModeValue=this.string},PartialNameNode:function(e,t){r.call(this,t);this.type="PARTIAL_NAME";this.name=e.original},DataNode:function(e,t){r.call(this,t);this.type="DATA";this.id=e},StringNode:function(e,t){r.call(this,t);this.type="STRING";this.original=this.string=this.stringModeValue=e},IntegerNode:function(e,t){r.call(this,t);this.type="INTEGER";this.original=this.integer=e;this.stringModeValue=Number(e)},BooleanNode:function(e,t){r.call(this,t);this.type="BOOLEAN";this.bool=e;this.stringModeValue=e==="true"},CommentNode:function(e,t){r.call(this,t);this.type="comment";this.comment=e}};t=i;return t}(n);var u=function(){"use strict";var e;var t=function(){function t(e,t){return{left:e.charAt(2)==="~",right:t.charAt(0)==="~"||t.charAt(1)==="~"}}function r(){this.yy={}}var e={trace:function(){},yy:{},symbols_:{error:2,root:3,statements:4,EOF:5,program:6,simpleInverse:7,statement:8,openInverse:9,closeBlock:10,openBlock:11,mustache:12,partial:13,CONTENT:14,COMMENT:15,OPEN_BLOCK:16,sexpr:17,CLOSE:18,OPEN_INVERSE:19,OPEN_ENDBLOCK:20,path:21,OPEN:22,OPEN_UNESCAPED:23,CLOSE_UNESCAPED:24,OPEN_PARTIAL:25,partialName:26,partial_option0:27,sexpr_repetition0:28,sexpr_option0:29,dataName:30,param:31,STRING:32,INTEGER:33,BOOLEAN:34,OPEN_SEXPR:35,CLOSE_SEXPR:36,hash:37,hash_repetition_plus0:38,hashSegment:39,ID:40,EQUALS:41,DATA:42,pathSegments:43,SEP:44,$accept:0,$end:1},terminals_:{2:"error",5:"EOF",14:"CONTENT",15:"COMMENT",16:"OPEN_BLOCK",18:"CLOSE",19:"OPEN_INVERSE",20:"OPEN_ENDBLOCK",22:"OPEN",23:"OPEN_UNESCAPED",24:"CLOSE_UNESCAPED",25:"OPEN_PARTIAL",32:"STRING",33:"INTEGER",34:"BOOLEAN",35:"OPEN_SEXPR",36:"CLOSE_SEXPR",40:"ID",41:"EQUALS",42:"DATA",44:"SEP"},productions_:[0,[3,2],[3,1],[6,2],[6,3],[6,2],[6,1],[6,1],[6,0],[4,1],[4,2],[8,3],[8,3],[8,1],[8,1],[8,1],[8,1],[11,3],[9,3],[10,3],[12,3],[12,3],[13,4],[7,2],[17,3],[17,1],[31,1],[31,1],[31,1],[31,1],[31,1],[31,3],[37,1],[39,3],[26,1],[26,1],[26,1],[30,2],[21,1],[43,3],[43,1],[27,0],[27,1],[28,0],[28,2],[29,0],[29,1],[38,1],[38,2]],performAction:function(n,r,i,s,o,u,a){var f=u.length-1;switch(o){case 1:return new s.ProgramNode(u[f-1],this._$);break;case 2:return new s.ProgramNode([],this._$);break;case 3:this.$=new s.ProgramNode([],u[f-1],u[f],this._$);break;case 4:this.$=new s.ProgramNode(u[f-2],u[f-1],u[f],this._$);break;case 5:this.$=new s.ProgramNode(u[f-1],u[f],[],this._$);break;case 6:this.$=new s.ProgramNode(u[f],this._$);break;case 7:this.$=new s.ProgramNode([],this._$);break;case 8:this.$=new s.ProgramNode([],this._$);break;case 9:this.$=[u[f]];break;case 10:u[f-1].push(u[f]);this.$=u[f-1];break;case 11:this.$=new s.BlockNode(u[f-2],u[f-1].inverse,u[f-1],u[f],this._$);break;case 12:this.$=new s.BlockNode(u[f-2],u[f-1],u[f-1].inverse,u[f],this._$);break;case 13:this.$=u[f];break;case 14:this.$=u[f];break;case 15:this.$=new s.ContentNode(u[f],this._$);break;case 16:this.$=new s.CommentNode(u[f],this._$);break;case 17:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 18:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 19:this.$={path:u[f-1],strip:t(u[f-2],u[f])};break;case 20:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 21:this.$=new s.MustacheNode(u[f-1],null,u[f-2],t(u[f-2],u[f]),this._$);break;case 22:this.$=new s.PartialNode(u[f-2],u[f-1],t(u[f-3],u[f]),this._$);break;case 23:this.$=t(u[f-1],u[f]);break;case 24:this.$=new s.SexprNode([u[f-2]].concat(u[f-1]),u[f],this._$);break;case 25:this.$=new s.SexprNode([u[f]],null,this._$);break;case 26:this.$=u[f];break;case 27:this.$=new s.StringNode(u[f],this._$);break;case 28:this.$=new s.IntegerNode(u[f],this._$);break;case 29:this.$=new s.BooleanNode(u[f],this._$);break;case 30:this.$=u[f];break;case 31:u[f-1].isHelper=true;this.$=u[f-1];break;case 32:this.$=new s.HashNode(u[f],this._$);break;case 33:this.$=[u[f-2],u[f]];break;case 34:this.$=new s.PartialNameNode(u[f],this._$);break;case 35:this.$=new s.PartialNameNode(new s.StringNode(u[f],this._$),this._$);break;case 36:this.$=new s.PartialNameNode(new s.IntegerNode(u[f],this._$));break;case 37:this.$=new s.DataNode(u[f],this._$);break;case 38:this.$=new s.IdNode(u[f],this._$);break;case 39:u[f-2].push({part:u[f],separator:u[f-1]});this.$=u[f-2];break;case 40:this.$=[{part:u[f]}];break;case 43:this.$=[];break;case 44:u[f-1].push(u[f]);break;case 47:this.$=[u[f]];break;case 48:u[f-1].push(u[f]);break}},table:[{3:1,4:2,5:[1,3],8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],22:[1,13],23:[1,14],25:[1,15]},{1:[3]},{5:[1,16],8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],22:[1,13],23:[1,14],25:[1,15]},{1:[2,2]},{5:[2,9],14:[2,9],15:[2,9],16:[2,9],19:[2,9],20:[2,9],22:[2,9],23:[2,9],25:[2,9]},{4:20,6:18,7:19,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,8],22:[1,13],23:[1,14],25:[1,15]},{4:20,6:22,7:19,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,8],22:[1,13],23:[1,14],25:[1,15]},{5:[2,13],14:[2,13],15:[2,13],16:[2,13],19:[2,13],20:[2,13],22:[2,13],23:[2,13],25:[2,13]},{5:[2,14],14:[2,14],15:[2,14],16:[2,14],19:[2,14],20:[2,14],22:[2,14],23:[2,14],25:[2,14]},{5:[2,15],14:[2,15],15:[2,15],16:[2,15],19:[2,15],20:[2,15],22:[2,15],23:[2,15],25:[2,15]},{5:[2,16],14:[2,16],15:[2,16],16:[2,16],19:[2,16],20:[2,16],22:[2,16],23:[2,16],25:[2,16]},{17:23,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:29,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:30,21:24,30:25,40:[1,28],42:[1,27],43:26},{17:31,21:24,30:25,40:[1,28],42:[1,27],43:26},{21:33,26:32,32:[1,34],33:[1,35],40:[1,28],43:26},{1:[2,1]},{5:[2,10],14:[2,10],15:[2,10],16:[2,10],19:[2,10],20:[2,10],22:[2,10],23:[2,10],25:[2,10]},{10:36,20:[1,37]},{4:38,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,7],22:[1,13],23:[1,14],25:[1,15]},{7:39,8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,21],20:[2,6],22:[1,13],23:[1,14],25:[1,15]},{17:23,18:[1,40],21:24,30:25,40:[1,28],42:[1,27],43:26},{10:41,20:[1,37]},{18:[1,42]},{18:[2,43],24:[2,43],28:43,32:[2,43],33:[2,43],34:[2,43],35:[2,43],36:[2,43],40:[2,43],42:[2,43]},{18:[2,25],24:[2,25],36:[2,25]},{18:[2,38],24:[2,38],32:[2,38],33:[2,38],34:[2,38],35:[2,38],36:[2,38],40:[2,38],42:[2,38],44:[1,44]},{21:45,40:[1,28],43:26},{18:[2,40],24:[2,40],32:[2,40],33:[2,40],34:[2,40],35:[2,40],36:[2,40],40:[2,40],42:[2,40],44:[2,40]},{18:[1,46]},{18:[1,47]},{24:[1,48]},{18:[2,41],21:50,27:49,40:[1,28],43:26},{18:[2,34],40:[2,34]},{18:[2,35],40:[2,35]},{18:[2,36],40:[2,36]},{5:[2,11],14:[2,11],15:[2,11],16:[2,11],19:[2,11],20:[2,11],22:[2,11],23:[2,11],25:[2,11]},{21:51,40:[1,28],43:26},{8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,3],22:[1,13],23:[1,14],25:[1,15]},{4:52,8:4,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,5],22:[1,13],23:[1,14],25:[1,15]},{14:[2,23],15:[2,23],16:[2,23],19:[2,23],20:[2,23],22:[2,23],23:[2,23],25:[2,23]},{5:[2,12],14:[2,12],15:[2,12],16:[2,12],19:[2,12],20:[2,12],22:[2,12],23:[2,12],25:[2,12]},{14:[2,18],15:[2,18],16:[2,18],19:[2,18],20:[2,18],22:[2,18],23:[2,18],25:[2,18]},{18:[2,45],21:56,24:[2,45],29:53,30:60,31:54,32:[1,57],33:[1,58],34:[1,59],35:[1,61],36:[2,45],37:55,38:62,39:63,40:[1,64],42:[1,27],43:26},{40:[1,65]},{18:[2,37],24:[2,37],32:[2,37],33:[2,37],34:[2,37],35:[2,37],36:[2,37],40:[2,37],42:[2,37]},{14:[2,17],15:[2,17],16:[2,17],19:[2,17],20:[2,17],22:[2,17],23:[2,17],25:[2,17]},{5:[2,20],14:[2,20],15:[2,20],16:[2,20],19:[2,20],20:[2,20],22:[2,20],23:[2,20],25:[2,20]},{5:[2,21],14:[2,21],15:[2,21],16:[2,21],19:[2,21],20:[2,21],22:[2,21],23:[2,21],25:[2,21]},{18:[1,66]},{18:[2,42]},{18:[1,67]},{8:17,9:5,11:6,12:7,13:8,14:[1,9],15:[1,10],16:[1,12],19:[1,11],20:[2,4],22:[1,13],23:[1,14],25:[1,15]},{18:[2,24],24:[2,24],36:[2,24]},{18:[2,44],24:[2,44],32:[2,44],33:[2,44],34:[2,44],35:[2,44],36:[2,44],40:[2,44],42:[2,44]},{18:[2,46],24:[2,46],36:[2,46]},{18:[2,26],24:[2,26],32:[2,26],33:[2,26],34:[2,26],35:[2,26],36:[2,26],40:[2,26],42:[2,26]},{18:[2,27],24:[2,27],32:[2,27],33:[2,27],34:[2,27],35:[2,27],36:[2,27],40:[2,27],42:[2,27]},{18:[2,28],24:[2,28],32:[2,28],33:[2,28],34:[2,28],35:[2,28],36:[2,28],40:[2,28],42:[2,28]},{18:[2,29],24:[2,29],32:[2,29],33:[2,29],34:[2,29],35:[2,29],36:[2,29],40:[2,29],42:[2,29]},{18:[2,30],24:[2,30],32:[2,30],33:[2,30],34:[2,30],35:[2,30],36:[2,30],40:[2,30],42:[2,30]},{17:68,21:24,30:25,40:[1,28],42:[1,27],43:26},{18:[2,32],24:[2,32],36:[2,32],39:69,40:[1,70]},{18:[2,47],24:[2,47],36:[2,47],40:[2,47]},{18:[2,40],24:[2,40],32:[2,40],33:[2,40],34:[2,40],35:[2,40],36:[2,40],40:[2,40],41:[1,71],42:[2,40],44:[2,40]},{18:[2,39],24:[2,39],32:[2,39],33:[2,39],34:[2,39],35:[2,39],36:[2,39],40:[2,39],42:[2,39],44:[2,39]},{5:[2,22],14:[2,22],15:[2,22],16:[2,22],19:[2,22],20:[2,22],22:[2,22],23:[2,22],25:[2,22]},{5:[2,19],14:[2,19],15:[2,19],16:[2,19],19:[2,19],20:[2,19],22:[2,19],23:[2,19],25:[2,19]},{36:[1,72]},{18:[2,48],24:[2,48],36:[2,48],40:[2,48]},{41:[1,71]},{21:56,30:60,31:73,32:[1,57],33:[1,58],34:[1,59],35:[1,61],40:[1,28],42:[1,27],43:26},{18:[2,31],24:[2,31],32:[2,31],33:[2,31],34:[2,31],35:[2,31],36:[2,31],40:[2,31],42:[2,31]},{18:[2,33],24:[2,33],36:[2,33],40:[2,33]}],defaultActions:{3:[2,2],16:[2,1],50:[2,42]},parseError:function(t,n){throw new Error(t)},parse:function(t){function v(e){r.length=r.length-2*e;i.length=i.length-e;s.length=s.length-e}function m(){var e;e=n.lexer.lex()||1;if(typeof e!=="number"){e=n.symbols_[e]||e}return e}var n=this,r=[0],i=[null],s=[],o=this.table,u="",a=0,f=0,l=0,c=2,h=1;this.lexer.setInput(t);this.lexer.yy=this.yy;this.yy.lexer=this.lexer;this.yy.parser=this;if(typeof this.lexer.yylloc=="undefined")this.lexer.yylloc={};var p=this.lexer.yylloc;s.push(p);var d=this.lexer.options&&this.lexer.options.ranges;if(typeof this.yy.parseError==="function")this.parseError=this.yy.parseError;var g,y,b,w,E,S,x={},T,N,C,k;while(true){b=r[r.length-1];if(this.defaultActions[b]){w=this.defaultActions[b]}else{if(g===null||typeof g=="undefined"){g=m()}w=o[b]&&o[b][g]}if(typeof w==="undefined"||!w.length||!w[0]){var L="";if(!l){k=[];for(T in o[b])if(this.terminals_[T]&&T>2){k.push("'"+this.terminals_[T]+"'")}if(this.lexer.showPosition){L="Parse error on line "+(a+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+k.join(", ")+", got '"+(this.terminals_[g]||g)+"'"}else{L="Parse error on line "+(a+1)+": Unexpected "+(g==1?"end of input":"'"+(this.terminals_[g]||g)+"'")}this.parseError(L,{text:this.lexer.match,token:this.terminals_[g]||g,line:this.lexer.yylineno,loc:p,expected:k})}}if(w[0]instanceof Array&&w.length>1){throw new Error("Parse Error: multiple actions possible at state: "+b+", token: "+g)}switch(w[0]){case 1:r.push(g);i.push(this.lexer.yytext);s.push(this.lexer.yylloc);r.push(w[1]);g=null;if(!y){f=this.lexer.yyleng;u=this.lexer.yytext;a=this.lexer.yylineno;p=this.lexer.yylloc;if(l>0)l--}else{g=y;y=null}break;case 2:N=this.productions_[w[1]][1];x.$=i[i.length-N];x._$={first_line:s[s.length-(N||1)].first_line,last_line:s[s.length-1].last_line,first_column:s[s.length-(N||1)].first_column,last_column:s[s.length-1].last_column};if(d){x._$.range=[s[s.length-(N||1)].range[0],s[s.length-1].range[1]]}S=this.performAction.call(x,u,f,a,this.yy,w[1],i,s);if(typeof S!=="undefined"){return S}if(N){r=r.slice(0,-1*N*2);i=i.slice(0,-1*N);s=s.slice(0,-1*N)}r.push(this.productions_[w[1]][0]);i.push(x.$);s.push(x._$);C=o[r[r.length-2]][r[r.length-1]];r.push(C);break;case 3:return true}}return true}};var n=function(){var e={EOF:1,parseError:function(t,n){if(this.yy.parser){this.yy.parser.parseError(t,n)}else{throw new Error(t)}},setInput:function(e){this._input=e;this._more=this._less=this.done=false;this.yylineno=this.yyleng=0;this.yytext=this.matched=this.match="";this.conditionStack=["INITIAL"];this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0};if(this.options.ranges)this.yylloc.range=[0,0];this.offset=0;return this},input:function(){var e=this._input[0];this.yytext+=e;this.yyleng++;this.offset++;this.match+=e;this.matched+=e;var t=e.match(/(?:\r\n?|\n).*/g);if(t){this.yylineno++;this.yylloc.last_line++}else{this.yylloc.last_column++}if(this.options.ranges)this.yylloc.range[1]++;this._input=this._input.slice(1);return e},unput:function(e){var t=e.length;var n=e.split(/(?:\r\n?|\n)/g);this._input=e+this._input;this.yytext=this.yytext.substr(0,this.yytext.length-t-1);this.offset-=t;var r=this.match.split(/(?:\r\n?|\n)/g);this.match=this.match.substr(0,this.match.length-1);this.matched=this.matched.substr(0,this.matched.length-1);if(n.length-1)this.yylineno-=n.length-1;var i=this.yylloc.range;this.yylloc={first_line:this.yylloc.first_line,last_line:this.yylineno+1,first_column:this.yylloc.first_column,last_column:n?(n.length===r.length?this.yylloc.first_column:0)+r[r.length-n.length].length-n[0].length:this.yylloc.first_column-t};if(this.options.ranges){this.yylloc.range=[i[0],i[0]+this.yyleng-t]}return this},more:function(){this._more=true;return this},less:function(e){this.unput(this.match.slice(e))},pastInput:function(){var e=this.matched.substr(0,this.matched.length-this.match.length);return(e.length>20?"...":"")+e.substr(-20).replace(/\n/g,"")},upcomingInput:function(){var e=this.match;if(e.length<20){e+=this._input.substr(0,20-e.length)}return(e.substr(0,20)+(e.length>20?"...":"")).replace(/\n/g,"")},showPosition:function(){var e=this.pastInput();var t=(new Array(e.length+1)).join("-");return e+this.upcomingInput()+"\n"+t+"^"},next:function(){if(this.done){return this.EOF}if(!this._input)this.done=true;var e,t,n,r,i,s;if(!this._more){this.yytext="";this.match=""}var o=this._currentRules();for(var u=0;u<o.length;u++){n=this._input.match(this.rules[o[u]]);if(n&&(!t||n[0].length>t[0].length)){t=n;r=u;if(!this.options.flex)break}}if(t){s=t[0].match(/(?:\r\n?|\n).*/g);if(s)this.yylineno+=s.length;this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:s?s[s.length-1].length-s[s.length-1].match(/\r?\n?/)[0].length:this.yylloc.last_column+t[0].length};this.yytext+=t[0];this.match+=t[0];this.matches=t;this.yyleng=this.yytext.length;if(this.options.ranges){this.yylloc.range=[this.offset,this.offset+=this.yyleng]}this._more=false;this._input=this._input.slice(t[0].length);this.matched+=t[0];e=this.performAction.call(this,this.yy,this,o[r],this.conditionStack[this.conditionStack.length-1]);if(this.done&&this._input)this.done=false;if(e)return e;else return}if(this._input===""){return this.EOF}else{return this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})}},lex:function(){var t=this.next();if(typeof t!=="undefined"){return t}else{return this.lex()}},begin:function(t){this.conditionStack.push(t)},popState:function(){return this.conditionStack.pop()},_currentRules:function(){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules},topState:function(){return this.conditionStack[this.conditionStack.length-2]},pushState:function(t){this.begin(t)}};e.options={};e.performAction=function(t,n,r,i){function s(e,t){return n.yytext=n.yytext.substr(e,n.yyleng-t)}var o=i;switch(r){case 0:if(n.yytext.slice(-2)==="\\\\"){s(0,1);this.begin("mu")}else if(n.yytext.slice(-1)==="\\"){s(0,1);this.begin("emu")}else{this.begin("mu")}if(n.yytext)return 14;break;case 1:return 14;break;case 2:this.popState();return 14;break;case 3:s(0,4);this.popState();return 15;break;case 4:return 35;break;case 5:return 36;break;case 6:return 25;break;case 7:return 16;break;case 8:return 20;break;case 9:return 19;break;case 10:return 19;break;case 11:return 23;break;case 12:return 22;break;case 13:this.popState();this.begin("com");break;case 14:s(3,5);this.popState();return 15;break;case 15:return 22;break;case 16:return 41;break;case 17:return 40;break;case 18:return 40;break;case 19:return 44;break;case 20:break;case 21:this.popState();return 24;break;case 22:this.popState();return 18;break;case 23:n.yytext=s(1,2).replace(/\\"/g,'"');return 32;break;case 24:n.yytext=s(1,2).replace(/\\'/g,"'");return 32;break;case 25:return 42;break;case 26:return 34;break;case 27:return 34;break;case 28:return 33;break;case 29:return 40;break;case 30:n.yytext=s(1,2);return 40;break;case 31:return"INVALID";break;case 32:return 5;break}};e.rules=[/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,/^(?:[\s\S]*?--\}\})/,/^(?:\()/,/^(?:\))/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{!--)/,/^(?:\{\{![\s\S]*?\}\})/,/^(?:\{\{(~)?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.)])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s)])))/,/^(?:false(?=([~}\s)])))/,/^(?:-?[0-9]+(?=([~}\s)])))/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)]))))/,/^(?:\[[^\]]*\])/,/^(?:.)/,/^(?:$)/];e.conditions={mu:{rules:[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32],inclusive:false},emu:{rules:[2],inclusive:false},com:{rules:[3],inclusive:false},INITIAL:{rules:[0,1,32],inclusive:true}};return e}();e.lexer=n;r.prototype=e;e.Parser=r;return new r}();e=t;return e}();var a=function(e,t){"use strict";function s(e){if(e.constructor===i.ProgramNode){return e}r.yy=i;return r.parse(e)}var n={};var r=e;var i=t;n.parser=r;n.parse=s;return n}(u,o);var f=function(e){"use strict";function r(){}function i(e,t,r){if(e==null||typeof e!=="string"&&e.constructor!==r.AST.ProgramNode){throw new n("You must pass a string or Handlebars AST to Handlebars.precompile. You passed "+e)}t=t||{};if(!("data"in t)){t.data=true}var i=r.parse(e);var s=(new r.Compiler).compile(i,t);return(new r.JavaScriptCompiler).compile(s,t)}function s(e,t,r){function s(){var n=r.parse(e);var i=(new r.Compiler).compile(n,t);var s=(new r.JavaScriptCompiler).compile(i,t,undefined,true);return r.template(s)}if(e==null||typeof e!=="string"&&e.constructor!==r.AST.ProgramNode){throw new n("You must pass a string or Handlebars AST to Handlebars.compile. You passed "+e)}t=t||{};if(!("data"in t)){t.data=true}var i;return function(e,t){if(!i){i=s()}return i.call(this,e,t)}}var t={};var n=e;t.Compiler=r;r.prototype={compiler:r,disassemble:function(){var e=this.opcodes,t,n=[],r,i;for(var s=0,o=e.length;s<o;s++){t=e[s];if(t.opcode==="DECLARE"){n.push("DECLARE "+t.name+"="+t.value)}else{r=[];for(var u=0;u<t.args.length;u++){i=t.args[u];if(typeof i==="string"){i='"'+i.replace("\n","\\n")+'"'}r.push(i)}n.push(t.opcode+" "+r.join(" "))}}return n.join("\n")},equals:function(e){var t=this.opcodes.length;if(e.opcodes.length!==t){return false}for(var n=0;n<t;n++){var r=this.opcodes[n],i=e.opcodes[n];if(r.opcode!==i.opcode||r.args.length!==i.args.length){return false}for(var s=0;s<r.args.length;s++){if(r.args[s]!==i.args[s]){return false}}}t=this.children.length;if(e.children.length!==t){return false}for(n=0;n<t;n++){if(!this.children[n].equals(e.children[n])){return false}}return true},guid:0,compile:function(e,t){this.opcodes=[];this.children=[];this.depths={list:[]};this.options=t;var n=this.options.knownHelpers;this.options.knownHelpers={helperMissing:true,blockHelperMissing:true,each:true,"if":true,unless:true,"with":true,log:true};if(n){for(var r in n){this.options.knownHelpers[r]=n[r]}}return this.accept(e)},accept:function(e){var t=e.strip||{},n;if(t.left){this.opcode("strip")}n=this[e.type](e);if(t.right){this.opcode("strip")}return n},program:function(e){var t=e.statements;for(var n=0,r=t.length;n<r;n++){this.accept(t[n])}this.isSimple=r===1;this.depths.list=this.depths.list.sort(function(e,t){return e-t});return this},compileProgram:function(e){var t=(new this.compiler).compile(e,this.options);var n=this.guid++,r;this.usePartial=this.usePartial||t.usePartial;this.children[n]=t;for(var i=0,s=t.depths.list.length;i<s;i++){r=t.depths.list[i];if(r<2){continue}else{this.addDepth(r-1)}}return n},block:function(e){var t=e.mustache,n=e.program,r=e.inverse;if(n){n=this.compileProgram(n)}if(r){r=this.compileProgram(r)}var i=t.sexpr;var s=this.classifySexpr(i);if(s==="helper"){this.helperSexpr(i,n,r)}else if(s==="simple"){this.simpleSexpr(i);this.opcode("pushProgram",n);this.opcode("pushProgram",r);this.opcode("emptyHash");this.opcode("blockValue")}else{this.ambiguousSexpr(i,n,r);this.opcode("pushProgram",n);this.opcode("pushProgram",r);this.opcode("emptyHash");this.opcode("ambiguousBlockValue")}this.opcode("append")},hash:function(e){var t=e.pairs,n,r;this.opcode("pushHash");for(var i=0,s=t.length;i<s;i++){n=t[i];r=n[1];if(this.options.stringParams){if(r.depth){this.addDepth(r.depth)}this.opcode("getContext",r.depth||0);this.opcode("pushStringParam",r.stringModeValue,r.type);if(r.type==="sexpr"){this.sexpr(r)}}else{this.accept(r)}this.opcode("assignToHash",n[0])}this.opcode("popHash")},partial:function(e){var t=e.partialName;this.usePartial=true;if(e.context){this.ID(e.context)}else{this.opcode("push","depth0")}this.opcode("invokePartial",t.name);this.opcode("append")},content:function(e){this.opcode("appendContent",e.string)},mustache:function(e){this.sexpr(e.sexpr);if(e.escaped&&!this.options.noEscape){this.opcode("appendEscaped")}else{this.opcode("append")}},ambiguousSexpr:function(e,t,n){var r=e.id,i=r.parts[0],s=t!=null||n!=null;this.opcode("getContext",r.depth);this.opcode("pushProgram",t);this.opcode("pushProgram",n);this.opcode("invokeAmbiguous",i,s)},simpleSexpr:function(e){var t=e.id;if(t.type==="DATA"){this.DATA(t)}else if(t.parts.length){this.ID(t)}else{this.addDepth(t.depth);this.opcode("getContext",t.depth);this.opcode("pushContext")}this.opcode("resolvePossibleLambda")},helperSexpr:function(e,t,r){var i=this.setupFullMustacheParams(e,t,r),s=e.id.parts[0];if(this.options.knownHelpers[s]){this.opcode("invokeKnownHelper",i.length,s)}else if(this.options.knownHelpersOnly){throw new n("You specified knownHelpersOnly, but used the unknown helper "+s,e)}else{this.opcode("invokeHelper",i.length,s,e.isRoot)}},sexpr:function(e){var t=this.classifySexpr(e);if(t==="simple"){this.simpleSexpr(e)}else if(t==="helper"){this.helperSexpr(e)}else{this.ambiguousSexpr(e)}},ID:function(e){this.addDepth(e.depth);this.opcode("getContext",e.depth);var t=e.parts[0];if(!t){this.opcode("pushContext")}else{this.opcode("lookupOnContext",e.parts[0])}for(var n=1,r=e.parts.length;n<r;n++){this.opcode("lookup",e.parts[n])}},DATA:function(e){this.options.data=true;if(e.id.isScoped||e.id.depth){throw new n("Scoped data references are not supported: "+e.original,e)}this.opcode("lookupData");var t=e.id.parts;for(var r=0,i=t.length;r<i;r++){this.opcode("lookup",t[r])}},STRING:function(e){this.opcode("pushString",e.string)},INTEGER:function(e){this.opcode("pushLiteral",e.integer)},BOOLEAN:function(e){this.opcode("pushLiteral",e.bool)},comment:function(){},opcode:function(e){this.opcodes.push({opcode:e,args:[].slice.call(arguments,1)})},declare:function(e,t){this.opcodes.push({opcode:"DECLARE",name:e,value:t})},addDepth:function(e){if(e===0){return}if(!this.depths[e]){this.depths[e]=true;this.depths.list.push(e)}},classifySexpr:function(e){var t=e.isHelper;var n=e.eligibleHelper;var r=this.options;if(n&&!t){var i=e.id.parts[0];if(r.knownHelpers[i]){t=true}else if(r.knownHelpersOnly){n=false}}if(t){return"helper"}else if(n){return"ambiguous"}else{return"simple"}},pushParams:function(e){var t=e.length,n;while(t--){n=e[t];if(this.options.stringParams){if(n.depth){this.addDepth(n.depth)}this.opcode("getContext",n.depth||0);this.opcode("pushStringParam",n.stringModeValue,n.type);if(n.type==="sexpr"){this.sexpr(n)}}else{this[n.type](n)}}},setupFullMustacheParams:function(e,t,n){var r=e.params;this.pushParams(r);this.opcode("pushProgram",t);this.opcode("pushProgram",n);if(e.hash){this.hash(e.hash)}else{this.opcode("emptyHash")}return r}};t.precompile=i;t.compile=s;return t}(n);var l=function(e,t){"use strict";function u(e){this.value=e}function a(){}var n;var r=e.COMPILER_REVISION;var i=e.REVISION_CHANGES;var s=e.log;var o=t;a.prototype={nameLookup:function(e,t){var n,r;if(e.indexOf("depth")===0){n=true}if(/^[0-9]+$/.test(t)){r=e+"["+t+"]"}else if(a.isValidJavaScriptVariableName(t)){r=e+"."+t}else{r=e+"['"+t+"']"}if(n){return"("+e+" && "+r+")"}else{return r}},compilerInfo:function(){var e=r,t=i[e];return"this.compilerInfo = ["+e+",'"+t+"'];\n"},appendToBuffer:function(e){if(this.environment.isSimple){return"return "+e+";"}else{return{appendToBuffer:true,content:e,toString:function(){return"buffer += "+e+";"}}}},initializeBuffer:function(){return this.quotedString("")},namespace:"Handlebars",compile:function(e,t,n,r){this.environment=e;this.options=t||{};s("debug",this.environment.disassemble()+"\n\n");this.name=this.environment.name;this.isChild=!!n;this.context=n||{programs:[],environments:[],aliases:{}};this.preamble();this.stackSlot=0;this.stackVars=[];this.registers={list:[]};this.hashes=[];this.compileStack=[];this.inlineStack=[];this.compileChildren(e,t);var i=e.opcodes,u;this.i=0;for(var a=i.length;this.i<a;this.i++){u=i[this.i];if(u.opcode==="DECLARE"){this[u.name]=u.value}else{this[u.opcode].apply(this,u.args)}if(u.opcode!==this.stripNext){this.stripNext=false}}this.pushSource("");if(this.stackSlot||this.inlineStack.length||this.compileStack.length){throw new o("Compile completed with content left on stack")}return this.createFunctionContext(r)},preamble:function(){var e=[];if(!this.isChild){var t=this.namespace;var n="helpers = this.merge(helpers, "+t+".helpers);";if(this.environment.usePartial){n=n+" partials = this.merge(partials, "+t+".partials);"}if(this.options.data){n=n+" data = data || {};"}e.push(n)}else{e.push("")}if(!this.environment.isSimple){e.push(", buffer = "+this.initializeBuffer())}else{e.push("")}this.lastContext=0;this.source=e},createFunctionContext:function(e){var t=this.stackVars.concat(this.registers.list);if(t.length>0){this.source[1]=this.source[1]+", "+t.join(", ")}if(!this.isChild){for(var n in this.context.aliases){if(this.context.aliases.hasOwnProperty(n)){this.source[1]=this.source[1]+", "+n+"="+this.context.aliases[n]}}}if(this.source[1]){this.source[1]="var "+this.source[1].substring(2)+";"}if(!this.isChild){this.source[1]+="\n"+this.context.programs.join("\n")+"\n"}if(!this.environment.isSimple){this.pushSource("return buffer;")}var r=this.isChild?["depth0","data"]:["Handlebars","depth0","helpers","partials","data"];for(var i=0,o=this.environment.depths.list.length;i<o;i++){r.push("depth"+this.environment.depths.list[i])}var u=this.mergeSource();if(!this.isChild){u=this.compilerInfo()+u}if(e){r.push(u);return Function.apply(this,r)}else{var a="function "+(this.name||"")+"("+r.join(",")+") {\n  "+u+"}";s("debug",a+"\n\n");return a}},mergeSource:function(){var e="",t;for(var n=0,r=this.source.length;n<r;n++){var i=this.source[n];if(i.appendToBuffer){if(t){t=t+"\n    + "+i.content}else{t=i.content}}else{if(t){e+="buffer += "+t+";\n  ";t=undefined}e+=i+"\n  "}}return e},blockValue:function(){this.context.aliases.blockHelperMissing="helpers.blockHelperMissing";var e=["depth0"];this.setupParams(0,e);this.replaceStack(function(t){e.splice(1,0,t);return"blockHelperMissing.call("+e.join(", ")+")"})},ambiguousBlockValue:function(){this.context.aliases.blockHelperMissing="helpers.blockHelperMissing";var e=["depth0"];this.setupParams(0,e);var t=this.topStack();e.splice(1,0,t);this.pushSource("if (!"+this.lastHelper+") { "+t+" = blockHelperMissing.call("+e.join(", ")+"); }")},appendContent:function(e){if(this.pendingContent){e=this.pendingContent+e}if(this.stripNext){e=e.replace(/^\s+/,"")}this.pendingContent=e},strip:function(){if(this.pendingContent){this.pendingContent=this.pendingContent.replace(/\s+$/,"")}this.stripNext="strip"},append:function(){this.flushInline();var e=this.popStack();this.pushSource("if("+e+" || "+e+" === 0) { "+this.appendToBuffer(e)+" }");if(this.environment.isSimple){this.pushSource("else { "+this.appendToBuffer("''")+" }")}},appendEscaped:function(){this.context.aliases.escapeExpression="this.escapeExpression";this.pushSource(this.appendToBuffer("escapeExpression("+this.popStack()+")"))},getContext:function(e){if(this.lastContext!==e){this.lastContext=e}},lookupOnContext:function(e){this.push(this.nameLookup("depth"+this.lastContext,e,"context"))},pushContext:function(){this.pushStackLiteral("depth"+this.lastContext)},resolvePossibleLambda:function(){this.context.aliases.functionType='"function"';this.replaceStack(function(e){return"typeof "+e+" === functionType ? "+e+".apply(depth0) : "+e})},lookup:function(e){this.replaceStack(function(t){return t+" == null || "+t+" === false ? "+t+" : "+this.nameLookup(t,e,"context")})},lookupData:function(){this.pushStackLiteral("data")},pushStringParam:function(e,t){this.pushStackLiteral("depth"+this.lastContext);this.pushString(t);if(t!=="sexpr"){if(typeof e==="string"){this.pushString(e)}else{this.pushStackLiteral(e)}}},emptyHash:function(){this.pushStackLiteral("{}");if(this.options.stringParams){this.push("{}");this.push("{}")}},pushHash:function(){if(this.hash){this.hashes.push(this.hash)}this.hash={values:[],types:[],contexts:[]}},popHash:function(){var e=this.hash;this.hash=this.hashes.pop();if(this.options.stringParams){this.push("{"+e.contexts.join(",")+"}");this.push("{"+e.types.join(",")+"}")}this.push("{\n    "+e.values.join(",\n    ")+"\n  }")},pushString:function(e){this.pushStackLiteral(this.quotedString(e))},push:function(e){this.inlineStack.push(e);return e},pushLiteral:function(e){this.pushStackLiteral(e)},pushProgram:function(e){if(e!=null){this.pushStackLiteral(this.programExpression(e))}else{this.pushStackLiteral(null)}},invokeHelper:function(e,t,n){this.context.aliases.helperMissing="helpers.helperMissing";this.useRegister("helper");var r=this.lastHelper=this.setupHelper(e,t,true);var i=this.nameLookup("depth"+this.lastContext,t,"context");var s="helper = "+r.name+" || "+i;if(r.paramsInit){s+=","+r.paramsInit}this.push("("+s+",helper "+"? helper.call("+r.callParams+") "+": helperMissing.call("+r.helperMissingParams+"))");if(!n){this.flushInline()}},invokeKnownHelper:function(e,t){var n=this.setupHelper(e,t);this.push(n.name+".call("+n.callParams+")")},invokeAmbiguous:function(e,t){this.context.aliases.functionType='"function"';this.useRegister("helper");this.emptyHash();var n=this.setupHelper(0,e,t);var r=this.lastHelper=this.nameLookup("helpers",e,"helper");var i=this.nameLookup("depth"+this.lastContext,e,"context");var s=this.nextStack();if(n.paramsInit){this.pushSource(n.paramsInit)}this.pushSource("if (helper = "+r+") { "+s+" = helper.call("+n.callParams+"); }");this.pushSource("else { helper = "+i+"; "+s+" = typeof helper === functionType ? helper.call("+n.callParams+") : helper; }")},invokePartial:function(e){var t=[this.nameLookup("partials",e,"partial"),"'"+e+"'",this.popStack(),"helpers","partials"];if(this.options.data){t.push("data")}this.context.aliases.self="this";this.push("self.invokePartial("+t.join(", ")+")")},assignToHash:function(e){var t=this.popStack(),n,r;if(this.options.stringParams){r=this.popStack();n=this.popStack()}var i=this.hash;if(n){i.contexts.push("'"+e+"': "+n)}if(r){i.types.push("'"+e+"': "+r)}i.values.push("'"+e+"': ("+t+")")},compiler:a,compileChildren:function(e,t){var n=e.children,r,i;for(var s=0,o=n.length;s<o;s++){r=n[s];i=new this.compiler;var u=this.matchExistingProgram(r);if(u==null){this.context.programs.push("");u=this.context.programs.length;r.index=u;r.name="program"+u;this.context.programs[u]=i.compile(r,t,this.context);this.context.environments[u]=r}else{r.index=u;r.name="program"+u}}},matchExistingProgram:function(e){for(var t=0,n=this.context.environments.length;t<n;t++){var r=this.context.environments[t];if(r&&r.equals(e)){return t}}},programExpression:function(e){this.context.aliases.self="this";if(e==null){return"self.noop"}var t=this.environment.children[e],n=t.depths.list,r;var i=[t.index,t.name,"data"];for(var s=0,o=n.length;s<o;s++){r=n[s];if(r===1){i.push("depth0")}else{i.push("depth"+(r-1))}}return(n.length===0?"self.program(":"self.programWithDepth(")+i.join(", ")+")"},register:function(e,t){this.useRegister(e);this.pushSource(e+" = "+t+";")},useRegister:function(e){if(!this.registers[e]){this.registers[e]=true;this.registers.list.push(e)}},pushStackLiteral:function(e){return this.push(new u(e))},pushSource:function(e){if(this.pendingContent){this.source.push(this.appendToBuffer(this.quotedString(this.pendingContent)));this.pendingContent=undefined}if(e){this.source.push(e)}},pushStack:function(e){this.flushInline();var t=this.incrStack();if(e){this.pushSource(t+" = "+e+";")}this.compileStack.push(t);return t},replaceStack:function(e){var t="",n=this.isInline(),r,i,s;if(n){var o=this.popStack(true);if(o instanceof u){r=o.value;s=true}else{i=!this.stackSlot;var a=!i?this.topStackName():this.incrStack();t="("+this.push(a)+" = "+o+"),";r=this.topStack()}}else{r=this.topStack()}var f=e.call(this,r);if(n){if(!s){this.popStack()}if(i){this.stackSlot--}this.push("("+t+f+")")}else{if(!/^stack/.test(r)){r=this.nextStack()}this.pushSource(r+" = ("+t+f+");")}return r},nextStack:function(){return this.pushStack()},incrStack:function(){this.stackSlot++;if(this.stackSlot>this.stackVars.length){this.stackVars.push("stack"+this.stackSlot)}return this.topStackName()},topStackName:function(){return"stack"+this.stackSlot},flushInline:function(){var e=this.inlineStack;if(e.length){this.inlineStack=[];for(var t=0,n=e.length;t<n;t++){var r=e[t];if(r instanceof u){this.compileStack.push(r)}else{this.pushStack(r)}}}},isInline:function(){return this.inlineStack.length},popStack:function(e){var t=this.isInline(),n=(t?this.inlineStack:this.compileStack).pop();if(!e&&n instanceof u){return n.value}else{if(!t){if(!this.stackSlot){throw new o("Invalid stack pop")}this.stackSlot--}return n}},topStack:function(e){var t=this.isInline()?this.inlineStack:this.compileStack,n=t[t.length-1];if(!e&&n instanceof u){return n.value}else{return n}},quotedString:function(e){return'"'+e.replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")+'"'},setupHelper:function(e,t,n){var r=[],i=this.setupParams(e,r,n);var s=this.nameLookup("helpers",t,"helper");return{params:r,paramsInit:i,name:s,callParams:["depth0"].concat(r).join(", "),helperMissingParams:n&&["depth0",this.quotedString(t)].concat(r).join(", ")}},setupOptions:function(e,t){var n=[],r=[],i=[],s,o,u;n.push("hash:"+this.popStack());if(this.options.stringParams){n.push("hashTypes:"+this.popStack());n.push("hashContexts:"+this.popStack())}o=this.popStack();u=this.popStack();if(u||o){if(!u){this.context.aliases.self="this";u="self.noop"}if(!o){this.context.aliases.self="this";o="self.noop"}n.push("inverse:"+o);n.push("fn:"+u)}for(var a=0;a<e;a++){s=this.popStack();t.push(s);if(this.options.stringParams){i.push(this.popStack());r.push(this.popStack())}}if(this.options.stringParams){n.push("contexts:["+r.join(",")+"]");n.push("types:["+i.join(",")+"]")}if(this.options.data){n.push("data:data")}return n},setupParams:function(e,t,n){var r="{"+this.setupOptions(e,t).join(",")+"}";if(n){this.useRegister("options");t.push("options");return"options="+r}else{t.push(r);return""}}};var f=("break else new var"+" case finally return void"+" catch for switch while"+" continue function this with"+" default if throw"+" delete in try"+" do instanceof typeof"+" abstract enum int short"+" boolean export interface static"+" byte extends long super"+" char final native synchronized"+" class float package throws"+" const goto private transient"+" debugger implements protected volatile"+" double import public let yield").split(" ");var l=a.RESERVED_WORDS={};for(var c=0,h=f.length;c<h;c++){l[f[c]]=true}a.isValidJavaScriptVariableName=function(e){if(!a.RESERVED_WORDS[e]&&/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(e)){return true}return false};n=a;return n}(r,n);var c=function(e,t,n,r,i){"use strict";var s;var o=e;var u=t;var a=n.parser;var f=n.parse;var l=r.Compiler;var c=r.compile;var h=r.precompile;var p=i;var d=o.create;var v=function(){var e=d();e.compile=function(t,n){return c(t,n,e)};e.precompile=function(t,n){return h(t,n,e)};e.AST=u;e.Compiler=l;e.JavaScriptCompiler=p;e.Parser=a;e.parse=f;return e};o=v();o.create=v;s=o;return s}(s,o,a,f,l);return c}();

/*!
* imagesLoaded PACKAGED v4.1.1
* JavaScript is all like "You images are done yet or what?"
* MIT License
*/
!function(t,e){"function"==typeof define&&define.amd?define("ev-emitter/ev-emitter",e):"object"==typeof module&&module.exports?module.exports=e():t.EvEmitter=e()}("undefined"!=typeof window?window:this,function(){function t(){}var e=t.prototype;return e.on=function(t,e){if(t&&e){var i=this._events=this._events||{},n=i[t]=i[t]||[];return-1==n.indexOf(e)&&n.push(e),this}},e.once=function(t,e){if(t&&e){this.on(t,e);var i=this._onceEvents=this._onceEvents||{},n=i[t]=i[t]||{};return n[e]=!0,this}},e.off=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=i.indexOf(e);return-1!=n&&i.splice(n,1),this}},e.emitEvent=function(t,e){var i=this._events&&this._events[t];if(i&&i.length){var n=0,o=i[n];e=e||[];for(var r=this._onceEvents&&this._onceEvents[t];o;){var s=r&&r[o];s&&(this.off(t,o),delete r[o]),o.apply(this,e),n+=s?0:1,o=i[n]}return this}},t}),function(t,e){"use strict";"function"==typeof define&&define.amd?define(["ev-emitter/ev-emitter"],function(i){return e(t,i)}):"object"==typeof module&&module.exports?module.exports=e(t,require("ev-emitter")):t.imagesLoaded=e(t,t.EvEmitter)}(window,function(t,e){function i(t,e){for(var i in e)t[i]=e[i];return t}function n(t){var e=[];if(Array.isArray(t))e=t;else if("number"==typeof t.length)for(var i=0;i<t.length;i++)e.push(t[i]);else e.push(t);return e}function o(t,e,r){return this instanceof o?("string"==typeof t&&(t=document.querySelectorAll(t)),this.elements=n(t),this.options=i({},this.options),"function"==typeof e?r=e:i(this.options,e),r&&this.on("always",r),this.getImages(),h&&(this.jqDeferred=new h.Deferred),void setTimeout(function(){this.check()}.bind(this))):new o(t,e,r)}function r(t){this.img=t}function s(t,e){this.url=t,this.element=e,this.img=new Image}var h=t.jQuery,a=t.console;o.prototype=Object.create(e.prototype),o.prototype.options={},o.prototype.getImages=function(){this.images=[],this.elements.forEach(this.addElementImages,this)},o.prototype.addElementImages=function(t){"IMG"==t.nodeName&&this.addImage(t),this.options.background===!0&&this.addElementBackgroundImages(t);var e=t.nodeType;if(e&&d[e]){for(var i=t.querySelectorAll("img"),n=0;n<i.length;n++){var o=i[n];this.addImage(o)}if("string"==typeof this.options.background){var r=t.querySelectorAll(this.options.background);for(n=0;n<r.length;n++){var s=r[n];this.addElementBackgroundImages(s)}}}};var d={1:!0,9:!0,11:!0};return o.prototype.addElementBackgroundImages=function(t){var e=getComputedStyle(t);if(e)for(var i=/url\((['"])?(.*?)\1\)/gi,n=i.exec(e.backgroundImage);null!==n;){var o=n&&n[2];o&&this.addBackground(o,t),n=i.exec(e.backgroundImage)}},o.prototype.addImage=function(t){var e=new r(t);this.images.push(e)},o.prototype.addBackground=function(t,e){var i=new s(t,e);this.images.push(i)},o.prototype.check=function(){function t(t,i,n){setTimeout(function(){e.progress(t,i,n)})}var e=this;return this.progressedCount=0,this.hasAnyBroken=!1,this.images.length?void this.images.forEach(function(e){e.once("progress",t),e.check()}):void this.complete()},o.prototype.progress=function(t,e,i){this.progressedCount++,this.hasAnyBroken=this.hasAnyBroken||!t.isLoaded,this.emitEvent("progress",[this,t,e]),this.jqDeferred&&this.jqDeferred.notify&&this.jqDeferred.notify(this,t),this.progressedCount==this.images.length&&this.complete(),this.options.debug&&a&&a.log("progress: "+i,t,e)},o.prototype.complete=function(){var t=this.hasAnyBroken?"fail":"done";if(this.isComplete=!0,this.emitEvent(t,[this]),this.emitEvent("always",[this]),this.jqDeferred){var e=this.hasAnyBroken?"reject":"resolve";this.jqDeferred[e](this)}},r.prototype=Object.create(e.prototype),r.prototype.check=function(){var t=this.getIsImageComplete();return t?void this.confirm(0!==this.img.naturalWidth,"naturalWidth"):(this.proxyImage=new Image,this.proxyImage.addEventListener("load",this),this.proxyImage.addEventListener("error",this),this.img.addEventListener("load",this),this.img.addEventListener("error",this),void(this.proxyImage.src=this.img.src))},r.prototype.getIsImageComplete=function(){return this.img.complete&&void 0!==this.img.naturalWidth},r.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.img,e])},r.prototype.handleEvent=function(t){var e="on"+t.type;this[e]&&this[e](t)},r.prototype.onload=function(){this.confirm(!0,"onload"),this.unbindEvents()},r.prototype.onerror=function(){this.confirm(!1,"onerror"),this.unbindEvents()},r.prototype.unbindEvents=function(){this.proxyImage.removeEventListener("load",this),this.proxyImage.removeEventListener("error",this),this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype=Object.create(r.prototype),s.prototype.check=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this),this.img.src=this.url;var t=this.getIsImageComplete();t&&(this.confirm(0!==this.img.naturalWidth,"naturalWidth"),this.unbindEvents())},s.prototype.unbindEvents=function(){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this)},s.prototype.confirm=function(t,e){this.isLoaded=t,this.emitEvent("progress",[this,this.element,e])},o.makeJQueryPlugin=function(e){e=e||t.jQuery,e&&(h=e,h.fn.imagesLoaded=function(t,e){var i=new o(this,t,e);return i.jqDeferred.promise(h(this))})},o.makeJQueryPlugin(),o});

/*!
 * enquire.js v2.1.6 - Awesome Media Queries in JavaScript
 * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/enquire.js
 * License: MIT */

!function(a){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=a();else if("function"==typeof define&&define.amd)define([],a);else{var b;b="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,b.enquire=a()}}(function(){return function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);var j=new Error("Cannot find module '"+g+"'");throw j.code="MODULE_NOT_FOUND",j}var k=c[g]={exports:{}};b[g][0].call(k.exports,function(a){var c=b[g][1][a];return e(c?c:a)},k,k.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function d(a,b){this.query=a,this.isUnconditional=b,this.handlers=[],this.mql=window.matchMedia(a);var c=this;this.listener=function(a){c.mql=a.currentTarget||a,c.assess()},this.mql.addListener(this.listener)}var e=a(3),f=a(4).each;d.prototype={constuctor:d,addHandler:function(a){var b=new e(a);this.handlers.push(b),this.matches()&&b.on()},removeHandler:function(a){var b=this.handlers;f(b,function(c,d){if(c.equals(a))return c.destroy(),!b.splice(d,1)})},matches:function(){return this.mql.matches||this.isUnconditional},clear:function(){f(this.handlers,function(a){a.destroy()}),this.mql.removeListener(this.listener),this.handlers.length=0},assess:function(){var a=this.matches()?"on":"off";f(this.handlers,function(b){b[a]()})}},b.exports=d},{3:3,4:4}],2:[function(a,b,c){function d(){if(!window.matchMedia)throw new Error("matchMedia not present, legacy browsers require a polyfill");this.queries={},this.browserIsIncapable=!window.matchMedia("only all").matches}var e=a(1),f=a(4),g=f.each,h=f.isFunction,i=f.isArray;d.prototype={constructor:d,register:function(a,b,c){var d=this.queries,f=c&&this.browserIsIncapable;return d[a]||(d[a]=new e(a,f)),h(b)&&(b={match:b}),i(b)||(b=[b]),g(b,function(b){h(b)&&(b={match:b}),d[a].addHandler(b)}),this},unregister:function(a,b){var c=this.queries[a];return c&&(b?c.removeHandler(b):(c.clear(),delete this.queries[a])),this}},b.exports=d},{1:1,4:4}],3:[function(a,b,c){function d(a){this.options=a,!a.deferSetup&&this.setup()}d.prototype={constructor:d,setup:function(){this.options.setup&&this.options.setup(),this.initialised=!0},on:function(){!this.initialised&&this.setup(),this.options.match&&this.options.match()},off:function(){this.options.unmatch&&this.options.unmatch()},destroy:function(){this.options.destroy?this.options.destroy():this.off()},equals:function(a){return this.options===a||this.options.match===a}},b.exports=d},{}],4:[function(a,b,c){function d(a,b){var c=0,d=a.length;for(c;c<d&&b(a[c],c)!==!1;c++);}function e(a){return"[object Array]"===Object.prototype.toString.apply(a)}function f(a){return"function"==typeof a}b.exports={isFunction:f,isArray:e,each:d}},{}],5:[function(a,b,c){var d=a(2);b.exports=new d},{2:2}]},{},[5])(5)});

/*! Select2 4.0.11 | https://github.com/select2/select2/blob/master/LICENSE.md */
!function(n){"function"==typeof define&&define.amd?define(["jquery"],n):"object"==typeof module&&module.exports?module.exports=function(e,t){return void 0===t&&(t="undefined"!=typeof window?require("jquery"):require("jquery")(e)),n(t),t}:n(jQuery)}(function(u){var e=function(){if(u&&u.fn&&u.fn.select2&&u.fn.select2.amd)var e=u.fn.select2.amd;var t,n,r,h,o,s,f,g,m,v,y,_,i,a,w;function b(e,t){return i.call(e,t)}function l(e,t){var n,r,i,o,s,a,l,c,u,d,p,h=t&&t.split("/"),f=y.map,g=f&&f["*"]||{};if(e){for(s=(e=e.split("/")).length-1,y.nodeIdCompat&&w.test(e[s])&&(e[s]=e[s].replace(w,"")),"."===e[0].charAt(0)&&h&&(e=h.slice(0,h.length-1).concat(e)),u=0;u<e.length;u++)if("."===(p=e[u]))e.splice(u,1),u-=1;else if(".."===p){if(0===u||1===u&&".."===e[2]||".."===e[u-1])continue;0<u&&(e.splice(u-1,2),u-=2)}e=e.join("/")}if((h||g)&&f){for(u=(n=e.split("/")).length;0<u;u-=1){if(r=n.slice(0,u).join("/"),h)for(d=h.length;0<d;d-=1)if(i=(i=f[h.slice(0,d).join("/")])&&i[r]){o=i,a=u;break}if(o)break;!l&&g&&g[r]&&(l=g[r],c=u)}!o&&l&&(o=l,a=c),o&&(n.splice(0,a,o),e=n.join("/"))}return e}function A(t,n){return function(){var e=a.call(arguments,0);return"string"!=typeof e[0]&&1===e.length&&e.push(null),s.apply(h,e.concat([t,n]))}}function x(t){return function(e){m[t]=e}}function D(e){if(b(v,e)){var t=v[e];delete v[e],_[e]=!0,o.apply(h,t)}if(!b(m,e)&&!b(_,e))throw new Error("No "+e);return m[e]}function c(e){var t,n=e?e.indexOf("!"):-1;return-1<n&&(t=e.substring(0,n),e=e.substring(n+1,e.length)),[t,e]}function S(e){return e?c(e):[]}return e&&e.requirejs||(e?n=e:e={},m={},v={},y={},_={},i=Object.prototype.hasOwnProperty,a=[].slice,w=/\.js$/,f=function(e,t){var n,r=c(e),i=r[0],o=t[1];return e=r[1],i&&(n=D(i=l(i,o))),i?e=n&&n.normalize?n.normalize(e,function(t){return function(e){return l(e,t)}}(o)):l(e,o):(i=(r=c(e=l(e,o)))[0],e=r[1],i&&(n=D(i))),{f:i?i+"!"+e:e,n:e,pr:i,p:n}},g={require:function(e){return A(e)},exports:function(e){var t=m[e];return void 0!==t?t:m[e]={}},module:function(e){return{id:e,uri:"",exports:m[e],config:function(e){return function(){return y&&y.config&&y.config[e]||{}}}(e)}}},o=function(e,t,n,r){var i,o,s,a,l,c,u,d=[],p=typeof n;if(c=S(r=r||e),"undefined"==p||"function"==p){for(t=!t.length&&n.length?["require","exports","module"]:t,l=0;l<t.length;l+=1)if("require"===(o=(a=f(t[l],c)).f))d[l]=g.require(e);else if("exports"===o)d[l]=g.exports(e),u=!0;else if("module"===o)i=d[l]=g.module(e);else if(b(m,o)||b(v,o)||b(_,o))d[l]=D(o);else{if(!a.p)throw new Error(e+" missing "+o);a.p.load(a.n,A(r,!0),x(o),{}),d[l]=m[o]}s=n?n.apply(m[e],d):void 0,e&&(i&&i.exports!==h&&i.exports!==m[e]?m[e]=i.exports:s===h&&u||(m[e]=s))}else e&&(m[e]=n)},t=n=s=function(e,t,n,r,i){if("string"==typeof e)return g[e]?g[e](t):D(f(e,S(t)).f);if(!e.splice){if((y=e).deps&&s(y.deps,y.callback),!t)return;t.splice?(e=t,t=n,n=null):e=h}return t=t||function(){},"function"==typeof n&&(n=r,r=i),r?o(h,e,t,n):setTimeout(function(){o(h,e,t,n)},4),s},s.config=function(e){return s(e)},t._defined=m,(r=function(e,t,n){if("string"!=typeof e)throw new Error("See almond README: incorrect module build, no module name");t.splice||(n=t,t=[]),b(m,e)||b(v,e)||(v[e]=[e,t,n])}).amd={jQuery:!0},e.requirejs=t,e.require=n,e.define=r),e.define("almond",function(){}),e.define("jquery",[],function(){var e=u||$;return null==e&&console&&console.error&&console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."),e}),e.define("select2/utils",["jquery"],function(o){var i={};function u(e){var t=e.prototype,n=[];for(var r in t){"function"==typeof t[r]&&"constructor"!==r&&n.push(r)}return n}i.Extend=function(e,t){var n={}.hasOwnProperty;function r(){this.constructor=e}for(var i in t)n.call(t,i)&&(e[i]=t[i]);return r.prototype=t.prototype,e.prototype=new r,e.__super__=t.prototype,e},i.Decorate=function(r,i){var e=u(i),t=u(r);function o(){var e=Array.prototype.unshift,t=i.prototype.constructor.length,n=r.prototype.constructor;0<t&&(e.call(arguments,r.prototype.constructor),n=i.prototype.constructor),n.apply(this,arguments)}i.displayName=r.displayName,o.prototype=new function(){this.constructor=o};for(var n=0;n<t.length;n++){var s=t[n];o.prototype[s]=r.prototype[s]}function a(e){var t=function(){};e in o.prototype&&(t=o.prototype[e]);var n=i.prototype[e];return function(){return Array.prototype.unshift.call(arguments,t),n.apply(this,arguments)}}for(var l=0;l<e.length;l++){var c=e[l];o.prototype[c]=a(c)}return o};function e(){this.listeners={}}e.prototype.on=function(e,t){this.listeners=this.listeners||{},e in this.listeners?this.listeners[e].push(t):this.listeners[e]=[t]},e.prototype.trigger=function(e){var t=Array.prototype.slice,n=t.call(arguments,1);this.listeners=this.listeners||{},null==n&&(n=[]),0===n.length&&n.push({}),(n[0]._type=e)in this.listeners&&this.invoke(this.listeners[e],t.call(arguments,1)),"*"in this.listeners&&this.invoke(this.listeners["*"],arguments)},e.prototype.invoke=function(e,t){for(var n=0,r=e.length;n<r;n++)e[n].apply(this,t)},i.Observable=e,i.generateChars=function(e){for(var t="",n=0;n<e;n++){t+=Math.floor(36*Math.random()).toString(36)}return t},i.bind=function(e,t){return function(){e.apply(t,arguments)}},i._convertData=function(e){for(var t in e){var n=t.split("-"),r=e;if(1!==n.length){for(var i=0;i<n.length;i++){var o=n[i];(o=o.substring(0,1).toLowerCase()+o.substring(1))in r||(r[o]={}),i==n.length-1&&(r[o]=e[t]),r=r[o]}delete e[t]}}return e},i.hasScroll=function(e,t){var n=o(t),r=t.style.overflowX,i=t.style.overflowY;return(r!==i||"hidden"!==i&&"visible"!==i)&&("scroll"===r||"scroll"===i||(n.innerHeight()<t.scrollHeight||n.innerWidth()<t.scrollWidth))},i.escapeMarkup=function(e){var t={"\\":"&#92;","&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;","/":"&#47;"};return"string"!=typeof e?e:String(e).replace(/[&<>"'\/\\]/g,function(e){return t[e]})},i.appendMany=function(e,t){if("1.7"===o.fn.jquery.substr(0,3)){var n=o();o.map(t,function(e){n=n.add(e)}),t=n}e.append(t)},i.__cache={};var n=0;return i.GetUniqueElementId=function(e){var t=e.getAttribute("data-select2-id");return null==t&&(e.id?(t=e.id,e.setAttribute("data-select2-id",t)):(e.setAttribute("data-select2-id",++n),t=n.toString())),t},i.StoreData=function(e,t,n){var r=i.GetUniqueElementId(e);i.__cache[r]||(i.__cache[r]={}),i.__cache[r][t]=n},i.GetData=function(e,t){var n=i.GetUniqueElementId(e);return t?i.__cache[n]&&null!=i.__cache[n][t]?i.__cache[n][t]:o(e).data(t):i.__cache[n]},i.RemoveData=function(e){var t=i.GetUniqueElementId(e);null!=i.__cache[t]&&delete i.__cache[t],e.removeAttribute("data-select2-id")},i}),e.define("select2/results",["jquery","./utils"],function(h,f){function r(e,t,n){this.$element=e,this.data=n,this.options=t,r.__super__.constructor.call(this)}return f.Extend(r,f.Observable),r.prototype.render=function(){var e=h('<ul class="select2-results__options" role="listbox"></ul>');return this.options.get("multiple")&&e.attr("aria-multiselectable","true"),this.$results=e},r.prototype.clear=function(){this.$results.empty()},r.prototype.displayMessage=function(e){var t=this.options.get("escapeMarkup");this.clear(),this.hideLoading();var n=h('<li role="alert" aria-live="assertive" class="select2-results__option"></li>'),r=this.options.get("translations").get(e.message);n.append(t(r(e.args))),n[0].className+=" select2-results__message",this.$results.append(n)},r.prototype.hideMessages=function(){this.$results.find(".select2-results__message").remove()},r.prototype.append=function(e){this.hideLoading();var t=[];if(null!=e.results&&0!==e.results.length){e.results=this.sort(e.results);for(var n=0;n<e.results.length;n++){var r=e.results[n],i=this.option(r);t.push(i)}this.$results.append(t)}else 0===this.$results.children().length&&this.trigger("results:message",{message:"noResults"})},r.prototype.position=function(e,t){t.find(".select2-results").append(e)},r.prototype.sort=function(e){return this.options.get("sorter")(e)},r.prototype.highlightFirstItem=function(){var e=this.$results.find(".select2-results__option[aria-selected]"),t=e.filter("[aria-selected=true]");0<t.length?t.first().trigger("mouseenter"):e.first().trigger("mouseenter"),this.ensureHighlightVisible()},r.prototype.setClasses=function(){var t=this;this.data.current(function(e){var r=h.map(e,function(e){return e.id.toString()});t.$results.find(".select2-results__option[aria-selected]").each(function(){var e=h(this),t=f.GetData(this,"data"),n=""+t.id;null!=t.element&&t.element.selected||null==t.element&&-1<h.inArray(n,r)?e.attr("aria-selected","true"):e.attr("aria-selected","false")})})},r.prototype.showLoading=function(e){this.hideLoading();var t={disabled:!0,loading:!0,text:this.options.get("translations").get("searching")(e)},n=this.option(t);n.className+=" loading-results",this.$results.prepend(n)},r.prototype.hideLoading=function(){this.$results.find(".loading-results").remove()},r.prototype.option=function(e){var t=document.createElement("li");t.className="select2-results__option";var n={role:"option","aria-selected":"false"},r=window.Element.prototype.matches||window.Element.prototype.msMatchesSelector||window.Element.prototype.webkitMatchesSelector;for(var i in(null!=e.element&&r.call(e.element,":disabled")||null==e.element&&e.disabled)&&(delete n["aria-selected"],n["aria-disabled"]="true"),null==e.id&&delete n["aria-selected"],null!=e._resultId&&(t.id=e._resultId),e.title&&(t.title=e.title),e.children&&(n.role="group",n["aria-label"]=e.text,delete n["aria-selected"]),n){var o=n[i];t.setAttribute(i,o)}if(e.children){var s=h(t),a=document.createElement("strong");a.className="select2-results__group";h(a);this.template(e,a);for(var l=[],c=0;c<e.children.length;c++){var u=e.children[c],d=this.option(u);l.push(d)}var p=h("<ul></ul>",{class:"select2-results__options select2-results__options--nested"});p.append(l),s.append(a),s.append(p)}else this.template(e,t);return f.StoreData(t,"data",e),t},r.prototype.bind=function(t,e){var l=this,n=t.id+"-results";this.$results.attr("id",n),t.on("results:all",function(e){l.clear(),l.append(e.data),t.isOpen()&&(l.setClasses(),l.highlightFirstItem())}),t.on("results:append",function(e){l.append(e.data),t.isOpen()&&l.setClasses()}),t.on("query",function(e){l.hideMessages(),l.showLoading(e)}),t.on("select",function(){t.isOpen()&&(l.setClasses(),l.options.get("scrollAfterSelect")&&l.highlightFirstItem())}),t.on("unselect",function(){t.isOpen()&&(l.setClasses(),l.options.get("scrollAfterSelect")&&l.highlightFirstItem())}),t.on("open",function(){l.$results.attr("aria-expanded","true"),l.$results.attr("aria-hidden","false"),l.setClasses(),l.ensureHighlightVisible()}),t.on("close",function(){l.$results.attr("aria-expanded","false"),l.$results.attr("aria-hidden","true"),l.$results.removeAttr("aria-activedescendant")}),t.on("results:toggle",function(){var e=l.getHighlightedResults();0!==e.length&&e.trigger("mouseup")}),t.on("results:select",function(){var e=l.getHighlightedResults();if(0!==e.length){var t=f.GetData(e[0],"data");"true"==e.attr("aria-selected")?l.trigger("close",{}):l.trigger("select",{data:t})}}),t.on("results:previous",function(){var e=l.getHighlightedResults(),t=l.$results.find("[aria-selected]"),n=t.index(e);if(!(n<=0)){var r=n-1;0===e.length&&(r=0);var i=t.eq(r);i.trigger("mouseenter");var o=l.$results.offset().top,s=i.offset().top,a=l.$results.scrollTop()+(s-o);0===r?l.$results.scrollTop(0):s-o<0&&l.$results.scrollTop(a)}}),t.on("results:next",function(){var e=l.getHighlightedResults(),t=l.$results.find("[aria-selected]"),n=t.index(e)+1;if(!(n>=t.length)){var r=t.eq(n);r.trigger("mouseenter");var i=l.$results.offset().top+l.$results.outerHeight(!1),o=r.offset().top+r.outerHeight(!1),s=l.$results.scrollTop()+o-i;0===n?l.$results.scrollTop(0):i<o&&l.$results.scrollTop(s)}}),t.on("results:focus",function(e){e.element.addClass("select2-results__option--highlighted")}),t.on("results:message",function(e){l.displayMessage(e)}),h.fn.mousewheel&&this.$results.on("mousewheel",function(e){var t=l.$results.scrollTop(),n=l.$results.get(0).scrollHeight-t+e.deltaY,r=0<e.deltaY&&t-e.deltaY<=0,i=e.deltaY<0&&n<=l.$results.height();r?(l.$results.scrollTop(0),e.preventDefault(),e.stopPropagation()):i&&(l.$results.scrollTop(l.$results.get(0).scrollHeight-l.$results.height()),e.preventDefault(),e.stopPropagation())}),this.$results.on("mouseup",".select2-results__option[aria-selected]",function(e){var t=h(this),n=f.GetData(this,"data");"true"!==t.attr("aria-selected")?l.trigger("select",{originalEvent:e,data:n}):l.options.get("multiple")?l.trigger("unselect",{originalEvent:e,data:n}):l.trigger("close",{})}),this.$results.on("mouseenter",".select2-results__option[aria-selected]",function(e){var t=f.GetData(this,"data");l.getHighlightedResults().removeClass("select2-results__option--highlighted"),l.trigger("results:focus",{data:t,element:h(this)})})},r.prototype.getHighlightedResults=function(){return this.$results.find(".select2-results__option--highlighted")},r.prototype.destroy=function(){this.$results.remove()},r.prototype.ensureHighlightVisible=function(){var e=this.getHighlightedResults();if(0!==e.length){var t=this.$results.find("[aria-selected]").index(e),n=this.$results.offset().top,r=e.offset().top,i=this.$results.scrollTop()+(r-n),o=r-n;i-=2*e.outerHeight(!1),t<=2?this.$results.scrollTop(0):(o>this.$results.outerHeight()||o<0)&&this.$results.scrollTop(i)}},r.prototype.template=function(e,t){var n=this.options.get("templateResult"),r=this.options.get("escapeMarkup"),i=n(e,t);null==i?t.style.display="none":"string"==typeof i?t.innerHTML=r(i):h(t).append(i)},r}),e.define("select2/keys",[],function(){return{BACKSPACE:8,TAB:9,ENTER:13,SHIFT:16,CTRL:17,ALT:18,ESC:27,SPACE:32,PAGE_UP:33,PAGE_DOWN:34,END:35,HOME:36,LEFT:37,UP:38,RIGHT:39,DOWN:40,DELETE:46}}),e.define("select2/selection/base",["jquery","../utils","../keys"],function(n,r,i){function o(e,t){this.$element=e,this.options=t,o.__super__.constructor.call(this)}return r.Extend(o,r.Observable),o.prototype.render=function(){var e=n('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');return this._tabindex=0,null!=r.GetData(this.$element[0],"old-tabindex")?this._tabindex=r.GetData(this.$element[0],"old-tabindex"):null!=this.$element.attr("tabindex")&&(this._tabindex=this.$element.attr("tabindex")),e.attr("title",this.$element.attr("title")),e.attr("tabindex",this._tabindex),e.attr("aria-disabled","false"),this.$selection=e},o.prototype.bind=function(e,t){var n=this,r=e.id+"-results";this.container=e,this.$selection.on("focus",function(e){n.trigger("focus",e)}),this.$selection.on("blur",function(e){n._handleBlur(e)}),this.$selection.on("keydown",function(e){n.trigger("keypress",e),e.which===i.SPACE&&e.preventDefault()}),e.on("results:focus",function(e){n.$selection.attr("aria-activedescendant",e.data._resultId)}),e.on("selection:update",function(e){n.update(e.data)}),e.on("open",function(){n.$selection.attr("aria-expanded","true"),n.$selection.attr("aria-owns",r),n._attachCloseHandler(e)}),e.on("close",function(){n.$selection.attr("aria-expanded","false"),n.$selection.removeAttr("aria-activedescendant"),n.$selection.removeAttr("aria-owns"),n.$selection.trigger("focus"),n._detachCloseHandler(e)}),e.on("enable",function(){n.$selection.attr("tabindex",n._tabindex),n.$selection.attr("aria-disabled","false")}),e.on("disable",function(){n.$selection.attr("tabindex","-1"),n.$selection.attr("aria-disabled","true")})},o.prototype._handleBlur=function(e){var t=this;window.setTimeout(function(){document.activeElement==t.$selection[0]||n.contains(t.$selection[0],document.activeElement)||t.trigger("blur",e)},1)},o.prototype._attachCloseHandler=function(e){n(document.body).on("mousedown.select2."+e.id,function(e){var t=n(e.target).closest(".select2");n(".select2.select2-container--open").each(function(){this!=t[0]&&r.GetData(this,"element").select2("close")})})},o.prototype._detachCloseHandler=function(e){n(document.body).off("mousedown.select2."+e.id)},o.prototype.position=function(e,t){t.find(".selection").append(e)},o.prototype.destroy=function(){this._detachCloseHandler(this.container)},o.prototype.update=function(e){throw new Error("The `update` method must be defined in child classes.")},o}),e.define("select2/selection/single",["jquery","./base","../utils","../keys"],function(e,t,n,r){function i(){i.__super__.constructor.apply(this,arguments)}return n.Extend(i,t),i.prototype.render=function(){var e=i.__super__.render.call(this);return e.addClass("select2-selection--single"),e.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'),e},i.prototype.bind=function(t,e){var n=this;i.__super__.bind.apply(this,arguments);var r=t.id+"-container";this.$selection.find(".select2-selection__rendered").attr("id",r).attr("role","textbox").attr("aria-readonly","true"),this.$selection.attr("aria-labelledby",r),this.$selection.on("mousedown",function(e){1===e.which&&n.trigger("toggle",{originalEvent:e})}),this.$selection.on("focus",function(e){}),this.$selection.on("blur",function(e){}),t.on("focus",function(e){t.isOpen()||n.$selection.trigger("focus")})},i.prototype.clear=function(){var e=this.$selection.find(".select2-selection__rendered");e.empty(),e.removeAttr("title")},i.prototype.display=function(e,t){var n=this.options.get("templateSelection");return this.options.get("escapeMarkup")(n(e,t))},i.prototype.selectionContainer=function(){return e("<span></span>")},i.prototype.update=function(e){if(0!==e.length){var t=e[0],n=this.$selection.find(".select2-selection__rendered"),r=this.display(t,n);n.empty().append(r);var i=t.title||t.text;i?n.attr("title",i):n.removeAttr("title")}else this.clear()},i}),e.define("select2/selection/multiple",["jquery","./base","../utils"],function(i,e,l){function n(e,t){n.__super__.constructor.apply(this,arguments)}return l.Extend(n,e),n.prototype.render=function(){var e=n.__super__.render.call(this);return e.addClass("select2-selection--multiple"),e.html('<ul class="select2-selection__rendered"></ul>'),e},n.prototype.bind=function(e,t){var r=this;n.__super__.bind.apply(this,arguments),this.$selection.on("click",function(e){r.trigger("toggle",{originalEvent:e})}),this.$selection.on("click",".select2-selection__choice__remove",function(e){if(!r.options.get("disabled")){var t=i(this).parent(),n=l.GetData(t[0],"data");r.trigger("unselect",{originalEvent:e,data:n})}})},n.prototype.clear=function(){var e=this.$selection.find(".select2-selection__rendered");e.empty(),e.removeAttr("title")},n.prototype.display=function(e,t){var n=this.options.get("templateSelection");return this.options.get("escapeMarkup")(n(e,t))},n.prototype.selectionContainer=function(){return i('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>')},n.prototype.update=function(e){if(this.clear(),0!==e.length){for(var t=[],n=0;n<e.length;n++){var r=e[n],i=this.selectionContainer(),o=this.display(r,i);i.append(o);var s=r.title||r.text;s&&i.attr("title",s),l.StoreData(i[0],"data",r),t.push(i)}var a=this.$selection.find(".select2-selection__rendered");l.appendMany(a,t)}},n}),e.define("select2/selection/placeholder",["../utils"],function(e){function t(e,t,n){this.placeholder=this.normalizePlaceholder(n.get("placeholder")),e.call(this,t,n)}return t.prototype.normalizePlaceholder=function(e,t){return"string"==typeof t&&(t={id:"",text:t}),t},t.prototype.createPlaceholder=function(e,t){var n=this.selectionContainer();return n.html(this.display(t)),n.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"),n},t.prototype.update=function(e,t){var n=1==t.length&&t[0].id!=this.placeholder.id;if(1<t.length||n)return e.call(this,t);this.clear();var r=this.createPlaceholder(this.placeholder);this.$selection.find(".select2-selection__rendered").append(r)},t}),e.define("select2/selection/allowClear",["jquery","../keys","../utils"],function(i,r,a){function e(){}return e.prototype.bind=function(e,t,n){var r=this;e.call(this,t,n),null==this.placeholder&&this.options.get("debug")&&window.console&&console.error&&console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."),this.$selection.on("mousedown",".select2-selection__clear",function(e){r._handleClear(e)}),t.on("keypress",function(e){r._handleKeyboardClear(e,t)})},e.prototype._handleClear=function(e,t){if(!this.options.get("disabled")){var n=this.$selection.find(".select2-selection__clear");if(0!==n.length){t.stopPropagation();var r=a.GetData(n[0],"data"),i=this.$element.val();this.$element.val(this.placeholder.id);var o={data:r};if(this.trigger("clear",o),o.prevented)this.$element.val(i);else{for(var s=0;s<r.length;s++)if(o={data:r[s]},this.trigger("unselect",o),o.prevented)return void this.$element.val(i);this.$element.trigger("change"),this.trigger("toggle",{})}}}},e.prototype._handleKeyboardClear=function(e,t,n){n.isOpen()||t.which!=r.DELETE&&t.which!=r.BACKSPACE||this._handleClear(t)},e.prototype.update=function(e,t){if(e.call(this,t),!(0<this.$selection.find(".select2-selection__placeholder").length||0===t.length)){var n=this.options.get("translations").get("removeAllItems"),r=i('<span class="select2-selection__clear" title="'+n()+'">&times;</span>');a.StoreData(r[0],"data",t),this.$selection.find(".select2-selection__rendered").prepend(r)}},e}),e.define("select2/selection/search",["jquery","../utils","../keys"],function(r,a,l){function e(e,t,n){e.call(this,t,n)}return e.prototype.render=function(e){var t=r('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></li>');this.$searchContainer=t,this.$search=t.find("input");var n=e.call(this);return this._transferTabIndex(),n},e.prototype.bind=function(e,t,n){var r=this,i=t.id+"-results";e.call(this,t,n),t.on("open",function(){r.$search.attr("aria-controls",i),r.$search.trigger("focus")}),t.on("close",function(){r.$search.val(""),r.$search.removeAttr("aria-controls"),r.$search.removeAttr("aria-activedescendant"),r.$search.trigger("focus")}),t.on("enable",function(){r.$search.prop("disabled",!1),r._transferTabIndex()}),t.on("disable",function(){r.$search.prop("disabled",!0)}),t.on("focus",function(e){r.$search.trigger("focus")}),t.on("results:focus",function(e){e.data._resultId?r.$search.attr("aria-activedescendant",e.data._resultId):r.$search.removeAttr("aria-activedescendant")}),this.$selection.on("focusin",".select2-search--inline",function(e){r.trigger("focus",e)}),this.$selection.on("focusout",".select2-search--inline",function(e){r._handleBlur(e)}),this.$selection.on("keydown",".select2-search--inline",function(e){if(e.stopPropagation(),r.trigger("keypress",e),r._keyUpPrevented=e.isDefaultPrevented(),e.which===l.BACKSPACE&&""===r.$search.val()){var t=r.$searchContainer.prev(".select2-selection__choice");if(0<t.length){var n=a.GetData(t[0],"data");r.searchRemoveChoice(n),e.preventDefault()}}}),this.$selection.on("click",".select2-search--inline",function(e){r.$search.val()&&e.stopPropagation()});var o=document.documentMode,s=o&&o<=11;this.$selection.on("input.searchcheck",".select2-search--inline",function(e){s?r.$selection.off("input.search input.searchcheck"):r.$selection.off("keyup.search")}),this.$selection.on("keyup.search input.search",".select2-search--inline",function(e){if(s&&"input"===e.type)r.$selection.off("input.search input.searchcheck");else{var t=e.which;t!=l.SHIFT&&t!=l.CTRL&&t!=l.ALT&&t!=l.TAB&&r.handleSearch(e)}})},e.prototype._transferTabIndex=function(e){this.$search.attr("tabindex",this.$selection.attr("tabindex")),this.$selection.attr("tabindex","-1")},e.prototype.createPlaceholder=function(e,t){this.$search.attr("placeholder",t.text)},e.prototype.update=function(e,t){var n=this.$search[0]==document.activeElement;this.$search.attr("placeholder",""),e.call(this,t),this.$selection.find(".select2-selection__rendered").append(this.$searchContainer),this.resizeSearch(),n&&this.$search.trigger("focus")},e.prototype.handleSearch=function(){if(this.resizeSearch(),!this._keyUpPrevented){var e=this.$search.val();this.trigger("query",{term:e})}this._keyUpPrevented=!1},e.prototype.searchRemoveChoice=function(e,t){this.trigger("unselect",{data:t}),this.$search.val(t.text),this.handleSearch()},e.prototype.resizeSearch=function(){this.$search.css("width","25px");var e="";""!==this.$search.attr("placeholder")?e=this.$selection.find(".select2-selection__rendered").width():e=.75*(this.$search.val().length+1)+"em";this.$search.css("width",e)},e}),e.define("select2/selection/eventRelay",["jquery"],function(s){function e(){}return e.prototype.bind=function(e,t,n){var r=this,i=["open","opening","close","closing","select","selecting","unselect","unselecting","clear","clearing"],o=["opening","closing","selecting","unselecting","clearing"];e.call(this,t,n),t.on("*",function(e,t){if(-1!==s.inArray(e,i)){t=t||{};var n=s.Event("select2:"+e,{params:t});r.$element.trigger(n),-1!==s.inArray(e,o)&&(t.prevented=n.isDefaultPrevented())}})},e}),e.define("select2/translation",["jquery","require"],function(t,n){function r(e){this.dict=e||{}}return r.prototype.all=function(){return this.dict},r.prototype.get=function(e){return this.dict[e]},r.prototype.extend=function(e){this.dict=t.extend({},e.all(),this.dict)},r._cache={},r.loadPath=function(e){if(!(e in r._cache)){var t=n(e);r._cache[e]=t}return new r(r._cache[e])},r}),e.define("select2/diacritics",[],function(){return{"Ⓐ":"A","Ａ":"A","À":"A","Á":"A","Â":"A","Ầ":"A","Ấ":"A","Ẫ":"A","Ẩ":"A","Ã":"A","Ā":"A","Ă":"A","Ằ":"A","Ắ":"A","Ẵ":"A","Ẳ":"A","Ȧ":"A","Ǡ":"A","Ä":"A","Ǟ":"A","Ả":"A","Å":"A","Ǻ":"A","Ǎ":"A","Ȁ":"A","Ȃ":"A","Ạ":"A","Ậ":"A","Ặ":"A","Ḁ":"A","Ą":"A","Ⱥ":"A","Ɐ":"A","Ꜳ":"AA","Æ":"AE","Ǽ":"AE","Ǣ":"AE","Ꜵ":"AO","Ꜷ":"AU","Ꜹ":"AV","Ꜻ":"AV","Ꜽ":"AY","Ⓑ":"B","Ｂ":"B","Ḃ":"B","Ḅ":"B","Ḇ":"B","Ƀ":"B","Ƃ":"B","Ɓ":"B","Ⓒ":"C","Ｃ":"C","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","Ç":"C","Ḉ":"C","Ƈ":"C","Ȼ":"C","Ꜿ":"C","Ⓓ":"D","Ｄ":"D","Ḋ":"D","Ď":"D","Ḍ":"D","Ḑ":"D","Ḓ":"D","Ḏ":"D","Đ":"D","Ƌ":"D","Ɗ":"D","Ɖ":"D","Ꝺ":"D","Ǳ":"DZ","Ǆ":"DZ","ǲ":"Dz","ǅ":"Dz","Ⓔ":"E","Ｅ":"E","È":"E","É":"E","Ê":"E","Ề":"E","Ế":"E","Ễ":"E","Ể":"E","Ẽ":"E","Ē":"E","Ḕ":"E","Ḗ":"E","Ĕ":"E","Ė":"E","Ë":"E","Ẻ":"E","Ě":"E","Ȅ":"E","Ȇ":"E","Ẹ":"E","Ệ":"E","Ȩ":"E","Ḝ":"E","Ę":"E","Ḙ":"E","Ḛ":"E","Ɛ":"E","Ǝ":"E","Ⓕ":"F","Ｆ":"F","Ḟ":"F","Ƒ":"F","Ꝼ":"F","Ⓖ":"G","Ｇ":"G","Ǵ":"G","Ĝ":"G","Ḡ":"G","Ğ":"G","Ġ":"G","Ǧ":"G","Ģ":"G","Ǥ":"G","Ɠ":"G","Ꞡ":"G","Ᵹ":"G","Ꝿ":"G","Ⓗ":"H","Ｈ":"H","Ĥ":"H","Ḣ":"H","Ḧ":"H","Ȟ":"H","Ḥ":"H","Ḩ":"H","Ḫ":"H","Ħ":"H","Ⱨ":"H","Ⱶ":"H","Ɥ":"H","Ⓘ":"I","Ｉ":"I","Ì":"I","Í":"I","Î":"I","Ĩ":"I","Ī":"I","Ĭ":"I","İ":"I","Ï":"I","Ḯ":"I","Ỉ":"I","Ǐ":"I","Ȉ":"I","Ȋ":"I","Ị":"I","Į":"I","Ḭ":"I","Ɨ":"I","Ⓙ":"J","Ｊ":"J","Ĵ":"J","Ɉ":"J","Ⓚ":"K","Ｋ":"K","Ḱ":"K","Ǩ":"K","Ḳ":"K","Ķ":"K","Ḵ":"K","Ƙ":"K","Ⱪ":"K","Ꝁ":"K","Ꝃ":"K","Ꝅ":"K","Ꞣ":"K","Ⓛ":"L","Ｌ":"L","Ŀ":"L","Ĺ":"L","Ľ":"L","Ḷ":"L","Ḹ":"L","Ļ":"L","Ḽ":"L","Ḻ":"L","Ł":"L","Ƚ":"L","Ɫ":"L","Ⱡ":"L","Ꝉ":"L","Ꝇ":"L","Ꞁ":"L","Ǉ":"LJ","ǈ":"Lj","Ⓜ":"M","Ｍ":"M","Ḿ":"M","Ṁ":"M","Ṃ":"M","Ɱ":"M","Ɯ":"M","Ⓝ":"N","Ｎ":"N","Ǹ":"N","Ń":"N","Ñ":"N","Ṅ":"N","Ň":"N","Ṇ":"N","Ņ":"N","Ṋ":"N","Ṉ":"N","Ƞ":"N","Ɲ":"N","Ꞑ":"N","Ꞥ":"N","Ǌ":"NJ","ǋ":"Nj","Ⓞ":"O","Ｏ":"O","Ò":"O","Ó":"O","Ô":"O","Ồ":"O","Ố":"O","Ỗ":"O","Ổ":"O","Õ":"O","Ṍ":"O","Ȭ":"O","Ṏ":"O","Ō":"O","Ṑ":"O","Ṓ":"O","Ŏ":"O","Ȯ":"O","Ȱ":"O","Ö":"O","Ȫ":"O","Ỏ":"O","Ő":"O","Ǒ":"O","Ȍ":"O","Ȏ":"O","Ơ":"O","Ờ":"O","Ớ":"O","Ỡ":"O","Ở":"O","Ợ":"O","Ọ":"O","Ộ":"O","Ǫ":"O","Ǭ":"O","Ø":"O","Ǿ":"O","Ɔ":"O","Ɵ":"O","Ꝋ":"O","Ꝍ":"O","Œ":"OE","Ƣ":"OI","Ꝏ":"OO","Ȣ":"OU","Ⓟ":"P","Ｐ":"P","Ṕ":"P","Ṗ":"P","Ƥ":"P","Ᵽ":"P","Ꝑ":"P","Ꝓ":"P","Ꝕ":"P","Ⓠ":"Q","Ｑ":"Q","Ꝗ":"Q","Ꝙ":"Q","Ɋ":"Q","Ⓡ":"R","Ｒ":"R","Ŕ":"R","Ṙ":"R","Ř":"R","Ȑ":"R","Ȓ":"R","Ṛ":"R","Ṝ":"R","Ŗ":"R","Ṟ":"R","Ɍ":"R","Ɽ":"R","Ꝛ":"R","Ꞧ":"R","Ꞃ":"R","Ⓢ":"S","Ｓ":"S","ẞ":"S","Ś":"S","Ṥ":"S","Ŝ":"S","Ṡ":"S","Š":"S","Ṧ":"S","Ṣ":"S","Ṩ":"S","Ș":"S","Ş":"S","Ȿ":"S","Ꞩ":"S","Ꞅ":"S","Ⓣ":"T","Ｔ":"T","Ṫ":"T","Ť":"T","Ṭ":"T","Ț":"T","Ţ":"T","Ṱ":"T","Ṯ":"T","Ŧ":"T","Ƭ":"T","Ʈ":"T","Ⱦ":"T","Ꞇ":"T","Ꜩ":"TZ","Ⓤ":"U","Ｕ":"U","Ù":"U","Ú":"U","Û":"U","Ũ":"U","Ṹ":"U","Ū":"U","Ṻ":"U","Ŭ":"U","Ü":"U","Ǜ":"U","Ǘ":"U","Ǖ":"U","Ǚ":"U","Ủ":"U","Ů":"U","Ű":"U","Ǔ":"U","Ȕ":"U","Ȗ":"U","Ư":"U","Ừ":"U","Ứ":"U","Ữ":"U","Ử":"U","Ự":"U","Ụ":"U","Ṳ":"U","Ų":"U","Ṷ":"U","Ṵ":"U","Ʉ":"U","Ⓥ":"V","Ｖ":"V","Ṽ":"V","Ṿ":"V","Ʋ":"V","Ꝟ":"V","Ʌ":"V","Ꝡ":"VY","Ⓦ":"W","Ｗ":"W","Ẁ":"W","Ẃ":"W","Ŵ":"W","Ẇ":"W","Ẅ":"W","Ẉ":"W","Ⱳ":"W","Ⓧ":"X","Ｘ":"X","Ẋ":"X","Ẍ":"X","Ⓨ":"Y","Ｙ":"Y","Ỳ":"Y","Ý":"Y","Ŷ":"Y","Ỹ":"Y","Ȳ":"Y","Ẏ":"Y","Ÿ":"Y","Ỷ":"Y","Ỵ":"Y","Ƴ":"Y","Ɏ":"Y","Ỿ":"Y","Ⓩ":"Z","Ｚ":"Z","Ź":"Z","Ẑ":"Z","Ż":"Z","Ž":"Z","Ẓ":"Z","Ẕ":"Z","Ƶ":"Z","Ȥ":"Z","Ɀ":"Z","Ⱬ":"Z","Ꝣ":"Z","ⓐ":"a","ａ":"a","ẚ":"a","à":"a","á":"a","â":"a","ầ":"a","ấ":"a","ẫ":"a","ẩ":"a","ã":"a","ā":"a","ă":"a","ằ":"a","ắ":"a","ẵ":"a","ẳ":"a","ȧ":"a","ǡ":"a","ä":"a","ǟ":"a","ả":"a","å":"a","ǻ":"a","ǎ":"a","ȁ":"a","ȃ":"a","ạ":"a","ậ":"a","ặ":"a","ḁ":"a","ą":"a","ⱥ":"a","ɐ":"a","ꜳ":"aa","æ":"ae","ǽ":"ae","ǣ":"ae","ꜵ":"ao","ꜷ":"au","ꜹ":"av","ꜻ":"av","ꜽ":"ay","ⓑ":"b","ｂ":"b","ḃ":"b","ḅ":"b","ḇ":"b","ƀ":"b","ƃ":"b","ɓ":"b","ⓒ":"c","ｃ":"c","ć":"c","ĉ":"c","ċ":"c","č":"c","ç":"c","ḉ":"c","ƈ":"c","ȼ":"c","ꜿ":"c","ↄ":"c","ⓓ":"d","ｄ":"d","ḋ":"d","ď":"d","ḍ":"d","ḑ":"d","ḓ":"d","ḏ":"d","đ":"d","ƌ":"d","ɖ":"d","ɗ":"d","ꝺ":"d","ǳ":"dz","ǆ":"dz","ⓔ":"e","ｅ":"e","è":"e","é":"e","ê":"e","ề":"e","ế":"e","ễ":"e","ể":"e","ẽ":"e","ē":"e","ḕ":"e","ḗ":"e","ĕ":"e","ė":"e","ë":"e","ẻ":"e","ě":"e","ȅ":"e","ȇ":"e","ẹ":"e","ệ":"e","ȩ":"e","ḝ":"e","ę":"e","ḙ":"e","ḛ":"e","ɇ":"e","ɛ":"e","ǝ":"e","ⓕ":"f","ｆ":"f","ḟ":"f","ƒ":"f","ꝼ":"f","ⓖ":"g","ｇ":"g","ǵ":"g","ĝ":"g","ḡ":"g","ğ":"g","ġ":"g","ǧ":"g","ģ":"g","ǥ":"g","ɠ":"g","ꞡ":"g","ᵹ":"g","ꝿ":"g","ⓗ":"h","ｈ":"h","ĥ":"h","ḣ":"h","ḧ":"h","ȟ":"h","ḥ":"h","ḩ":"h","ḫ":"h","ẖ":"h","ħ":"h","ⱨ":"h","ⱶ":"h","ɥ":"h","ƕ":"hv","ⓘ":"i","ｉ":"i","ì":"i","í":"i","î":"i","ĩ":"i","ī":"i","ĭ":"i","ï":"i","ḯ":"i","ỉ":"i","ǐ":"i","ȉ":"i","ȋ":"i","ị":"i","į":"i","ḭ":"i","ɨ":"i","ı":"i","ⓙ":"j","ｊ":"j","ĵ":"j","ǰ":"j","ɉ":"j","ⓚ":"k","ｋ":"k","ḱ":"k","ǩ":"k","ḳ":"k","ķ":"k","ḵ":"k","ƙ":"k","ⱪ":"k","ꝁ":"k","ꝃ":"k","ꝅ":"k","ꞣ":"k","ⓛ":"l","ｌ":"l","ŀ":"l","ĺ":"l","ľ":"l","ḷ":"l","ḹ":"l","ļ":"l","ḽ":"l","ḻ":"l","ſ":"l","ł":"l","ƚ":"l","ɫ":"l","ⱡ":"l","ꝉ":"l","ꞁ":"l","ꝇ":"l","ǉ":"lj","ⓜ":"m","ｍ":"m","ḿ":"m","ṁ":"m","ṃ":"m","ɱ":"m","ɯ":"m","ⓝ":"n","ｎ":"n","ǹ":"n","ń":"n","ñ":"n","ṅ":"n","ň":"n","ṇ":"n","ņ":"n","ṋ":"n","ṉ":"n","ƞ":"n","ɲ":"n","ŉ":"n","ꞑ":"n","ꞥ":"n","ǌ":"nj","ⓞ":"o","ｏ":"o","ò":"o","ó":"o","ô":"o","ồ":"o","ố":"o","ỗ":"o","ổ":"o","õ":"o","ṍ":"o","ȭ":"o","ṏ":"o","ō":"o","ṑ":"o","ṓ":"o","ŏ":"o","ȯ":"o","ȱ":"o","ö":"o","ȫ":"o","ỏ":"o","ő":"o","ǒ":"o","ȍ":"o","ȏ":"o","ơ":"o","ờ":"o","ớ":"o","ỡ":"o","ở":"o","ợ":"o","ọ":"o","ộ":"o","ǫ":"o","ǭ":"o","ø":"o","ǿ":"o","ɔ":"o","ꝋ":"o","ꝍ":"o","ɵ":"o","œ":"oe","ƣ":"oi","ȣ":"ou","ꝏ":"oo","ⓟ":"p","ｐ":"p","ṕ":"p","ṗ":"p","ƥ":"p","ᵽ":"p","ꝑ":"p","ꝓ":"p","ꝕ":"p","ⓠ":"q","ｑ":"q","ɋ":"q","ꝗ":"q","ꝙ":"q","ⓡ":"r","ｒ":"r","ŕ":"r","ṙ":"r","ř":"r","ȑ":"r","ȓ":"r","ṛ":"r","ṝ":"r","ŗ":"r","ṟ":"r","ɍ":"r","ɽ":"r","ꝛ":"r","ꞧ":"r","ꞃ":"r","ⓢ":"s","ｓ":"s","ß":"s","ś":"s","ṥ":"s","ŝ":"s","ṡ":"s","š":"s","ṧ":"s","ṣ":"s","ṩ":"s","ș":"s","ş":"s","ȿ":"s","ꞩ":"s","ꞅ":"s","ẛ":"s","ⓣ":"t","ｔ":"t","ṫ":"t","ẗ":"t","ť":"t","ṭ":"t","ț":"t","ţ":"t","ṱ":"t","ṯ":"t","ŧ":"t","ƭ":"t","ʈ":"t","ⱦ":"t","ꞇ":"t","ꜩ":"tz","ⓤ":"u","ｕ":"u","ù":"u","ú":"u","û":"u","ũ":"u","ṹ":"u","ū":"u","ṻ":"u","ŭ":"u","ü":"u","ǜ":"u","ǘ":"u","ǖ":"u","ǚ":"u","ủ":"u","ů":"u","ű":"u","ǔ":"u","ȕ":"u","ȗ":"u","ư":"u","ừ":"u","ứ":"u","ữ":"u","ử":"u","ự":"u","ụ":"u","ṳ":"u","ų":"u","ṷ":"u","ṵ":"u","ʉ":"u","ⓥ":"v","ｖ":"v","ṽ":"v","ṿ":"v","ʋ":"v","ꝟ":"v","ʌ":"v","ꝡ":"vy","ⓦ":"w","ｗ":"w","ẁ":"w","ẃ":"w","ŵ":"w","ẇ":"w","ẅ":"w","ẘ":"w","ẉ":"w","ⱳ":"w","ⓧ":"x","ｘ":"x","ẋ":"x","ẍ":"x","ⓨ":"y","ｙ":"y","ỳ":"y","ý":"y","ŷ":"y","ỹ":"y","ȳ":"y","ẏ":"y","ÿ":"y","ỷ":"y","ẙ":"y","ỵ":"y","ƴ":"y","ɏ":"y","ỿ":"y","ⓩ":"z","ｚ":"z","ź":"z","ẑ":"z","ż":"z","ž":"z","ẓ":"z","ẕ":"z","ƶ":"z","ȥ":"z","ɀ":"z","ⱬ":"z","ꝣ":"z","Ά":"Α","Έ":"Ε","Ή":"Η","Ί":"Ι","Ϊ":"Ι","Ό":"Ο","Ύ":"Υ","Ϋ":"Υ","Ώ":"Ω","ά":"α","έ":"ε","ή":"η","ί":"ι","ϊ":"ι","ΐ":"ι","ό":"ο","ύ":"υ","ϋ":"υ","ΰ":"υ","ώ":"ω","ς":"σ","’":"'"}}),e.define("select2/data/base",["../utils"],function(r){function n(e,t){n.__super__.constructor.call(this)}return r.Extend(n,r.Observable),n.prototype.current=function(e){throw new Error("The `current` method must be defined in child classes.")},n.prototype.query=function(e,t){throw new Error("The `query` method must be defined in child classes.")},n.prototype.bind=function(e,t){},n.prototype.destroy=function(){},n.prototype.generateResultId=function(e,t){var n=e.id+"-result-";return n+=r.generateChars(4),null!=t.id?n+="-"+t.id.toString():n+="-"+r.generateChars(4),n},n}),e.define("select2/data/select",["./base","../utils","jquery"],function(e,a,l){function n(e,t){this.$element=e,this.options=t,n.__super__.constructor.call(this)}return a.Extend(n,e),n.prototype.current=function(e){var n=[],r=this;this.$element.find(":selected").each(function(){var e=l(this),t=r.item(e);n.push(t)}),e(n)},n.prototype.select=function(i){var o=this;if(i.selected=!0,l(i.element).is("option"))return i.element.selected=!0,void this.$element.trigger("change");if(this.$element.prop("multiple"))this.current(function(e){var t=[];(i=[i]).push.apply(i,e);for(var n=0;n<i.length;n++){var r=i[n].id;-1===l.inArray(r,t)&&t.push(r)}o.$element.val(t),o.$element.trigger("change")});else{var e=i.id;this.$element.val(e),this.$element.trigger("change")}},n.prototype.unselect=function(i){var o=this;if(this.$element.prop("multiple")){if(i.selected=!1,l(i.element).is("option"))return i.element.selected=!1,void this.$element.trigger("change");this.current(function(e){for(var t=[],n=0;n<e.length;n++){var r=e[n].id;r!==i.id&&-1===l.inArray(r,t)&&t.push(r)}o.$element.val(t),o.$element.trigger("change")})}},n.prototype.bind=function(e,t){var n=this;(this.container=e).on("select",function(e){n.select(e.data)}),e.on("unselect",function(e){n.unselect(e.data)})},n.prototype.destroy=function(){this.$element.find("*").each(function(){a.RemoveData(this)})},n.prototype.query=function(r,e){var i=[],o=this;this.$element.children().each(function(){var e=l(this);if(e.is("option")||e.is("optgroup")){var t=o.item(e),n=o.matches(r,t);null!==n&&i.push(n)}}),e({results:i})},n.prototype.addOptions=function(e){a.appendMany(this.$element,e)},n.prototype.option=function(e){var t;e.children?(t=document.createElement("optgroup")).label=e.text:void 0!==(t=document.createElement("option")).textContent?t.textContent=e.text:t.innerText=e.text,void 0!==e.id&&(t.value=e.id),e.disabled&&(t.disabled=!0),e.selected&&(t.selected=!0),e.title&&(t.title=e.title);var n=l(t),r=this._normalizeItem(e);return r.element=t,a.StoreData(t,"data",r),n},n.prototype.item=function(e){var t={};if(null!=(t=a.GetData(e[0],"data")))return t;if(e.is("option"))t={id:e.val(),text:e.text(),disabled:e.prop("disabled"),selected:e.prop("selected"),title:e.prop("title")};else if(e.is("optgroup")){t={text:e.prop("label"),children:[],title:e.prop("title")};for(var n=e.children("option"),r=[],i=0;i<n.length;i++){var o=l(n[i]),s=this.item(o);r.push(s)}t.children=r}return(t=this._normalizeItem(t)).element=e[0],a.StoreData(e[0],"data",t),t},n.prototype._normalizeItem=function(e){e!==Object(e)&&(e={id:e,text:e});return null!=(e=l.extend({},{text:""},e)).id&&(e.id=e.id.toString()),null!=e.text&&(e.text=e.text.toString()),null==e._resultId&&e.id&&null!=this.container&&(e._resultId=this.generateResultId(this.container,e)),l.extend({},{selected:!1,disabled:!1},e)},n.prototype.matches=function(e,t){return this.options.get("matcher")(e,t)},n}),e.define("select2/data/array",["./select","../utils","jquery"],function(e,f,g){function r(e,t){this._dataToConvert=t.get("data")||[],r.__super__.constructor.call(this,e,t)}return f.Extend(r,e),r.prototype.bind=function(e,t){r.__super__.bind.call(this,e,t),this.addOptions(this.convertToOptions(this._dataToConvert))},r.prototype.select=function(n){var e=this.$element.find("option").filter(function(e,t){return t.value==n.id.toString()});0===e.length&&(e=this.option(n),this.addOptions(e)),r.__super__.select.call(this,n)},r.prototype.convertToOptions=function(e){var t=this,n=this.$element.find("option"),r=n.map(function(){return t.item(g(this)).id}).get(),i=[];function o(e){return function(){return g(this).val()==e.id}}for(var s=0;s<e.length;s++){var a=this._normalizeItem(e[s]);if(0<=g.inArray(a.id,r)){var l=n.filter(o(a)),c=this.item(l),u=g.extend(!0,{},a,c),d=this.option(u);l.replaceWith(d)}else{var p=this.option(a);if(a.children){var h=this.convertToOptions(a.children);f.appendMany(p,h)}i.push(p)}}return i},r}),e.define("select2/data/ajax",["./array","../utils","jquery"],function(e,t,o){function n(e,t){this.ajaxOptions=this._applyDefaults(t.get("ajax")),null!=this.ajaxOptions.processResults&&(this.processResults=this.ajaxOptions.processResults),n.__super__.constructor.call(this,e,t)}return t.Extend(n,e),n.prototype._applyDefaults=function(e){var t={data:function(e){return o.extend({},e,{q:e.term})},transport:function(e,t,n){var r=o.ajax(e);return r.then(t),r.fail(n),r}};return o.extend({},t,e,!0)},n.prototype.processResults=function(e){return e},n.prototype.query=function(n,r){var i=this;null!=this._request&&(o.isFunction(this._request.abort)&&this._request.abort(),this._request=null);var t=o.extend({type:"GET"},this.ajaxOptions);function e(){var e=t.transport(t,function(e){var t=i.processResults(e,n);i.options.get("debug")&&window.console&&console.error&&(t&&t.results&&o.isArray(t.results)||console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")),r(t)},function(){"status"in e&&(0===e.status||"0"===e.status)||i.trigger("results:message",{message:"errorLoading"})});i._request=e}"function"==typeof t.url&&(t.url=t.url.call(this.$element,n)),"function"==typeof t.data&&(t.data=t.data.call(this.$element,n)),this.ajaxOptions.delay&&null!=n.term?(this._queryTimeout&&window.clearTimeout(this._queryTimeout),this._queryTimeout=window.setTimeout(e,this.ajaxOptions.delay)):e()},n}),e.define("select2/data/tags",["jquery"],function(u){function e(e,t,n){var r=n.get("tags"),i=n.get("createTag");void 0!==i&&(this.createTag=i);var o=n.get("insertTag");if(void 0!==o&&(this.insertTag=o),e.call(this,t,n),u.isArray(r))for(var s=0;s<r.length;s++){var a=r[s],l=this._normalizeItem(a),c=this.option(l);this.$element.append(c)}}return e.prototype.query=function(e,c,u){var d=this;this._removeOldTags(),null!=c.term&&null==c.page?e.call(this,c,function e(t,n){for(var r=t.results,i=0;i<r.length;i++){var o=r[i],s=null!=o.children&&!e({results:o.children},!0);if((o.text||"").toUpperCase()===(c.term||"").toUpperCase()||s)return!n&&(t.data=r,void u(t))}if(n)return!0;var a=d.createTag(c);if(null!=a){var l=d.option(a);l.attr("data-select2-tag",!0),d.addOptions([l]),d.insertTag(r,a)}t.results=r,u(t)}):e.call(this,c,u)},e.prototype.createTag=function(e,t){var n=u.trim(t.term);return""===n?null:{id:n,text:n}},e.prototype.insertTag=function(e,t,n){t.unshift(n)},e.prototype._removeOldTags=function(e){this.$element.find("option[data-select2-tag]").each(function(){this.selected||u(this).remove()})},e}),e.define("select2/data/tokenizer",["jquery"],function(d){function e(e,t,n){var r=n.get("tokenizer");void 0!==r&&(this.tokenizer=r),e.call(this,t,n)}return e.prototype.bind=function(e,t,n){e.call(this,t,n),this.$search=t.dropdown.$search||t.selection.$search||n.find(".select2-search__field")},e.prototype.query=function(e,t,n){var r=this;t.term=t.term||"";var i=this.tokenizer(t,this.options,function(e){var t=r._normalizeItem(e);if(!r.$element.find("option").filter(function(){return d(this).val()===t.id}).length){var n=r.option(t);n.attr("data-select2-tag",!0),r._removeOldTags(),r.addOptions([n])}!function(e){r.trigger("select",{data:e})}(t)});i.term!==t.term&&(this.$search.length&&(this.$search.val(i.term),this.$search.trigger("focus")),t.term=i.term),e.call(this,t,n)},e.prototype.tokenizer=function(e,t,n,r){for(var i=n.get("tokenSeparators")||[],o=t.term,s=0,a=this.createTag||function(e){return{id:e.term,text:e.term}};s<o.length;){var l=o[s];if(-1!==d.inArray(l,i)){var c=o.substr(0,s),u=a(d.extend({},t,{term:c}));null!=u?(r(u),o=o.substr(s+1)||"",s=0):s++}else s++}return{term:o}},e}),e.define("select2/data/minimumInputLength",[],function(){function e(e,t,n){this.minimumInputLength=n.get("minimumInputLength"),e.call(this,t,n)}return e.prototype.query=function(e,t,n){t.term=t.term||"",t.term.length<this.minimumInputLength?this.trigger("results:message",{message:"inputTooShort",args:{minimum:this.minimumInputLength,input:t.term,params:t}}):e.call(this,t,n)},e}),e.define("select2/data/maximumInputLength",[],function(){function e(e,t,n){this.maximumInputLength=n.get("maximumInputLength"),e.call(this,t,n)}return e.prototype.query=function(e,t,n){t.term=t.term||"",0<this.maximumInputLength&&t.term.length>this.maximumInputLength?this.trigger("results:message",{message:"inputTooLong",args:{maximum:this.maximumInputLength,input:t.term,params:t}}):e.call(this,t,n)},e}),e.define("select2/data/maximumSelectionLength",[],function(){function e(e,t,n){this.maximumSelectionLength=n.get("maximumSelectionLength"),e.call(this,t,n)}return e.prototype.bind=function(e,t,n){var r=this;e.call(this,t,n),t.on("select",function(){r._checkIfMaximumSelected()})},e.prototype.query=function(e,t,n){var r=this;this._checkIfMaximumSelected(function(){e.call(r,t,n)})},e.prototype._checkIfMaximumSelected=function(e,n){var r=this;this.current(function(e){var t=null!=e?e.length:0;0<r.maximumSelectionLength&&t>=r.maximumSelectionLength?r.trigger("results:message",{message:"maximumSelected",args:{maximum:r.maximumSelectionLength}}):n&&n()})},e}),e.define("select2/dropdown",["jquery","./utils"],function(t,e){function n(e,t){this.$element=e,this.options=t,n.__super__.constructor.call(this)}return e.Extend(n,e.Observable),n.prototype.render=function(){var e=t('<span class="select2-dropdown"><span class="select2-results"></span></span>');return e.attr("dir",this.options.get("dir")),this.$dropdown=e},n.prototype.bind=function(){},n.prototype.position=function(e,t){},n.prototype.destroy=function(){this.$dropdown.remove()},n}),e.define("select2/dropdown/search",["jquery","../utils"],function(o,e){function t(){}return t.prototype.render=function(e){var t=e.call(this),n=o('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="searchbox" aria-autocomplete="list" /></span>');return this.$searchContainer=n,this.$search=n.find("input"),t.prepend(n),t},t.prototype.bind=function(e,t,n){var r=this,i=t.id+"-results";e.call(this,t,n),this.$search.on("keydown",function(e){r.trigger("keypress",e),r._keyUpPrevented=e.isDefaultPrevented()}),this.$search.on("input",function(e){o(this).off("keyup")}),this.$search.on("keyup input",function(e){r.handleSearch(e)}),t.on("open",function(){r.$search.attr("tabindex",0),r.$search.attr("aria-controls",i),r.$search.trigger("focus"),window.setTimeout(function(){r.$search.trigger("focus")},0)}),t.on("close",function(){r.$search.attr("tabindex",-1),r.$search.removeAttr("aria-controls"),r.$search.removeAttr("aria-activedescendant"),r.$search.val(""),r.$search.trigger("blur")}),t.on("focus",function(){t.isOpen()||r.$search.trigger("focus")}),t.on("results:all",function(e){null!=e.query.term&&""!==e.query.term||(r.showSearch(e)?r.$searchContainer.removeClass("select2-search--hide"):r.$searchContainer.addClass("select2-search--hide"))}),t.on("results:focus",function(e){e.data._resultId?r.$search.attr("aria-activedescendant",e.data._resultId):r.$search.removeAttr("aria-activedescendant")})},t.prototype.handleSearch=function(e){if(!this._keyUpPrevented){var t=this.$search.val();this.trigger("query",{term:t})}this._keyUpPrevented=!1},t.prototype.showSearch=function(e,t){return!0},t}),e.define("select2/dropdown/hidePlaceholder",[],function(){function e(e,t,n,r){this.placeholder=this.normalizePlaceholder(n.get("placeholder")),e.call(this,t,n,r)}return e.prototype.append=function(e,t){t.results=this.removePlaceholder(t.results),e.call(this,t)},e.prototype.normalizePlaceholder=function(e,t){return"string"==typeof t&&(t={id:"",text:t}),t},e.prototype.removePlaceholder=function(e,t){for(var n=t.slice(0),r=t.length-1;0<=r;r--){var i=t[r];this.placeholder.id===i.id&&n.splice(r,1)}return n},e}),e.define("select2/dropdown/infiniteScroll",["jquery"],function(n){function e(e,t,n,r){this.lastParams={},e.call(this,t,n,r),this.$loadingMore=this.createLoadingMore(),this.loading=!1}return e.prototype.append=function(e,t){this.$loadingMore.remove(),this.loading=!1,e.call(this,t),this.showLoadingMore(t)&&(this.$results.append(this.$loadingMore),this.loadMoreIfNeeded())},e.prototype.bind=function(e,t,n){var r=this;e.call(this,t,n),t.on("query",function(e){r.lastParams=e,r.loading=!0}),t.on("query:append",function(e){r.lastParams=e,r.loading=!0}),this.$results.on("scroll",this.loadMoreIfNeeded.bind(this))},e.prototype.loadMoreIfNeeded=function(){var e=n.contains(document.documentElement,this.$loadingMore[0]);if(!this.loading&&e){var t=this.$results.offset().top+this.$results.outerHeight(!1);this.$loadingMore.offset().top+this.$loadingMore.outerHeight(!1)<=t+50&&this.loadMore()}},e.prototype.loadMore=function(){this.loading=!0;var e=n.extend({},{page:1},this.lastParams);e.page++,this.trigger("query:append",e)},e.prototype.showLoadingMore=function(e,t){return t.pagination&&t.pagination.more},e.prototype.createLoadingMore=function(){var e=n('<li class="select2-results__option select2-results__option--load-more"role="option" aria-disabled="true"></li>'),t=this.options.get("translations").get("loadingMore");return e.html(t(this.lastParams)),e},e}),e.define("select2/dropdown/attachBody",["jquery","../utils"],function(f,a){function e(e,t,n){this.$dropdownParent=f(n.get("dropdownParent")||document.body),e.call(this,t,n)}return e.prototype.bind=function(e,t,n){var r=this;e.call(this,t,n),t.on("open",function(){r._showDropdown(),r._attachPositioningHandler(t),r._bindContainerResultHandlers(t)}),t.on("close",function(){r._hideDropdown(),r._detachPositioningHandler(t)}),this.$dropdownContainer.on("mousedown",function(e){e.stopPropagation()})},e.prototype.destroy=function(e){e.call(this),this.$dropdownContainer.remove()},e.prototype.position=function(e,t,n){t.attr("class",n.attr("class")),t.removeClass("select2"),t.addClass("select2-container--open"),t.css({position:"absolute",top:-999999}),this.$container=n},e.prototype.render=function(e){var t=f("<span></span>"),n=e.call(this);return t.append(n),this.$dropdownContainer=t},e.prototype._hideDropdown=function(e){this.$dropdownContainer.detach()},e.prototype._bindContainerResultHandlers=function(e,t){if(!this._containerResultsHandlersBound){var n=this;t.on("results:all",function(){n._positionDropdown(),n._resizeDropdown()}),t.on("results:append",function(){n._positionDropdown(),n._resizeDropdown()}),t.on("results:message",function(){n._positionDropdown(),n._resizeDropdown()}),t.on("select",function(){n._positionDropdown(),n._resizeDropdown()}),t.on("unselect",function(){n._positionDropdown(),n._resizeDropdown()}),this._containerResultsHandlersBound=!0}},e.prototype._attachPositioningHandler=function(e,t){var n=this,r="scroll.select2."+t.id,i="resize.select2."+t.id,o="orientationchange.select2."+t.id,s=this.$container.parents().filter(a.hasScroll);s.each(function(){a.StoreData(this,"select2-scroll-position",{x:f(this).scrollLeft(),y:f(this).scrollTop()})}),s.on(r,function(e){var t=a.GetData(this,"select2-scroll-position");f(this).scrollTop(t.y)}),f(window).on(r+" "+i+" "+o,function(e){n._positionDropdown(),n._resizeDropdown()})},e.prototype._detachPositioningHandler=function(e,t){var n="scroll.select2."+t.id,r="resize.select2."+t.id,i="orientationchange.select2."+t.id;this.$container.parents().filter(a.hasScroll).off(n),f(window).off(n+" "+r+" "+i)},e.prototype._positionDropdown=function(){var e=f(window),t=this.$dropdown.hasClass("select2-dropdown--above"),n=this.$dropdown.hasClass("select2-dropdown--below"),r=null,i=this.$container.offset();i.bottom=i.top+this.$container.outerHeight(!1);var o={height:this.$container.outerHeight(!1)};o.top=i.top,o.bottom=i.top+o.height;var s=this.$dropdown.outerHeight(!1),a=e.scrollTop(),l=e.scrollTop()+e.height(),c=a<i.top-s,u=l>i.bottom+s,d={left:i.left,top:o.bottom},p=this.$dropdownParent;"static"===p.css("position")&&(p=p.offsetParent());var h={top:0,left:0};f.contains(document.body,p[0])&&(h=p.offset()),d.top-=h.top,d.left-=h.left,t||n||(r="below"),u||!c||t?!c&&u&&t&&(r="below"):r="above",("above"==r||t&&"below"!==r)&&(d.top=o.top-h.top-s),null!=r&&(this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--"+r),this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--"+r)),this.$dropdownContainer.css(d)},e.prototype._resizeDropdown=function(){var e={width:this.$container.outerWidth(!1)+"px"};this.options.get("dropdownAutoWidth")&&(e.minWidth=e.width,e.position="relative",e.width="auto"),this.$dropdown.css(e)},e.prototype._showDropdown=function(e){this.$dropdownContainer.appendTo(this.$dropdownParent),this._positionDropdown(),this._resizeDropdown()},e}),e.define("select2/dropdown/minimumResultsForSearch",[],function(){function e(e,t,n,r){this.minimumResultsForSearch=n.get("minimumResultsForSearch"),this.minimumResultsForSearch<0&&(this.minimumResultsForSearch=1/0),e.call(this,t,n,r)}return e.prototype.showSearch=function(e,t){return!(function e(t){for(var n=0,r=0;r<t.length;r++){var i=t[r];i.children?n+=e(i.children):n++}return n}(t.data.results)<this.minimumResultsForSearch)&&e.call(this,t)},e}),e.define("select2/dropdown/selectOnClose",["../utils"],function(o){function e(){}return e.prototype.bind=function(e,t,n){var r=this;e.call(this,t,n),t.on("close",function(e){r._handleSelectOnClose(e)})},e.prototype._handleSelectOnClose=function(e,t){if(t&&null!=t.originalSelect2Event){var n=t.originalSelect2Event;if("select"===n._type||"unselect"===n._type)return}var r=this.getHighlightedResults();if(!(r.length<1)){var i=o.GetData(r[0],"data");null!=i.element&&i.element.selected||null==i.element&&i.selected||this.trigger("select",{data:i})}},e}),e.define("select2/dropdown/closeOnSelect",[],function(){function e(){}return e.prototype.bind=function(e,t,n){var r=this;e.call(this,t,n),t.on("select",function(e){r._selectTriggered(e)}),t.on("unselect",function(e){r._selectTriggered(e)})},e.prototype._selectTriggered=function(e,t){var n=t.originalEvent;n&&(n.ctrlKey||n.metaKey)||this.trigger("close",{originalEvent:n,originalSelect2Event:t})},e}),e.define("select2/i18n/en",[],function(){return{errorLoading:function(){return"The results could not be loaded."},inputTooLong:function(e){var t=e.input.length-e.maximum,n="Please delete "+t+" character";return 1!=t&&(n+="s"),n},inputTooShort:function(e){return"Please enter "+(e.minimum-e.input.length)+" or more characters"},loadingMore:function(){return"Loading more results…"},maximumSelected:function(e){var t="You can only select "+e.maximum+" item";return 1!=e.maximum&&(t+="s"),t},noResults:function(){return"No results found"},searching:function(){return"Searching…"},removeAllItems:function(){return"Remove all items"}}}),e.define("select2/defaults",["jquery","require","./results","./selection/single","./selection/multiple","./selection/placeholder","./selection/allowClear","./selection/search","./selection/eventRelay","./utils","./translation","./diacritics","./data/select","./data/array","./data/ajax","./data/tags","./data/tokenizer","./data/minimumInputLength","./data/maximumInputLength","./data/maximumSelectionLength","./dropdown","./dropdown/search","./dropdown/hidePlaceholder","./dropdown/infiniteScroll","./dropdown/attachBody","./dropdown/minimumResultsForSearch","./dropdown/selectOnClose","./dropdown/closeOnSelect","./i18n/en"],function(c,u,d,p,h,f,g,m,v,y,s,t,_,$,w,b,A,x,D,S,E,C,O,T,q,L,I,j,e){function n(){this.reset()}return n.prototype.apply=function(e){if(null==(e=c.extend(!0,{},this.defaults,e)).dataAdapter){if(null!=e.ajax?e.dataAdapter=w:null!=e.data?e.dataAdapter=$:e.dataAdapter=_,0<e.minimumInputLength&&(e.dataAdapter=y.Decorate(e.dataAdapter,x)),0<e.maximumInputLength&&(e.dataAdapter=y.Decorate(e.dataAdapter,D)),0<e.maximumSelectionLength&&(e.dataAdapter=y.Decorate(e.dataAdapter,S)),e.tags&&(e.dataAdapter=y.Decorate(e.dataAdapter,b)),null==e.tokenSeparators&&null==e.tokenizer||(e.dataAdapter=y.Decorate(e.dataAdapter,A)),null!=e.query){var t=u(e.amdBase+"compat/query");e.dataAdapter=y.Decorate(e.dataAdapter,t)}if(null!=e.initSelection){var n=u(e.amdBase+"compat/initSelection");e.dataAdapter=y.Decorate(e.dataAdapter,n)}}if(null==e.resultsAdapter&&(e.resultsAdapter=d,null!=e.ajax&&(e.resultsAdapter=y.Decorate(e.resultsAdapter,T)),null!=e.placeholder&&(e.resultsAdapter=y.Decorate(e.resultsAdapter,O)),e.selectOnClose&&(e.resultsAdapter=y.Decorate(e.resultsAdapter,I))),null==e.dropdownAdapter){if(e.multiple)e.dropdownAdapter=E;else{var r=y.Decorate(E,C);e.dropdownAdapter=r}if(0!==e.minimumResultsForSearch&&(e.dropdownAdapter=y.Decorate(e.dropdownAdapter,L)),e.closeOnSelect&&(e.dropdownAdapter=y.Decorate(e.dropdownAdapter,j)),null!=e.dropdownCssClass||null!=e.dropdownCss||null!=e.adaptDropdownCssClass){var i=u(e.amdBase+"compat/dropdownCss");e.dropdownAdapter=y.Decorate(e.dropdownAdapter,i)}e.dropdownAdapter=y.Decorate(e.dropdownAdapter,q)}if(null==e.selectionAdapter){if(e.multiple?e.selectionAdapter=h:e.selectionAdapter=p,null!=e.placeholder&&(e.selectionAdapter=y.Decorate(e.selectionAdapter,f)),e.allowClear&&(e.selectionAdapter=y.Decorate(e.selectionAdapter,g)),e.multiple&&(e.selectionAdapter=y.Decorate(e.selectionAdapter,m)),null!=e.containerCssClass||null!=e.containerCss||null!=e.adaptContainerCssClass){var o=u(e.amdBase+"compat/containerCss");e.selectionAdapter=y.Decorate(e.selectionAdapter,o)}e.selectionAdapter=y.Decorate(e.selectionAdapter,v)}e.language=this._resolveLanguage(e.language),e.language.push("en");for(var s=[],a=0;a<e.language.length;a++){var l=e.language[a];-1===s.indexOf(l)&&s.push(l)}return e.language=s,e.translations=this._processTranslations(e.language,e.debug),e},n.prototype.reset=function(){function a(e){return e.replace(/[^\u0000-\u007E]/g,function(e){return t[e]||e})}this.defaults={amdBase:"./",amdLanguageBase:"./i18n/",closeOnSelect:!0,debug:!1,dropdownAutoWidth:!1,escapeMarkup:y.escapeMarkup,language:{},matcher:function e(t,n){if(""===c.trim(t.term))return n;if(n.children&&0<n.children.length){for(var r=c.extend(!0,{},n),i=n.children.length-1;0<=i;i--)null==e(t,n.children[i])&&r.children.splice(i,1);return 0<r.children.length?r:e(t,r)}var o=a(n.text).toUpperCase(),s=a(t.term).toUpperCase();return-1<o.indexOf(s)?n:null},minimumInputLength:0,maximumInputLength:0,maximumSelectionLength:0,minimumResultsForSearch:0,selectOnClose:!1,scrollAfterSelect:!1,sorter:function(e){return e},templateResult:function(e){return e.text},templateSelection:function(e){return e.text},theme:"default",width:"resolve"}},n.prototype.applyFromElement=function(e,t){var n=e.language,r=this.defaults.language,i=t.prop("lang"),o=t.closest("[lang]").prop("lang"),s=Array.prototype.concat.call(this._resolveLanguage(i),this._resolveLanguage(n),this._resolveLanguage(r),this._resolveLanguage(o));return e.language=s,e},n.prototype._resolveLanguage=function(e){if(!e)return[];if(c.isEmptyObject(e))return[];if(c.isPlainObject(e))return[e];var t;t=c.isArray(e)?e:[e];for(var n=[],r=0;r<t.length;r++)if(n.push(t[r]),"string"==typeof t[r]&&0<t[r].indexOf("-")){var i=t[r].split("-")[0];n.push(i)}return n},n.prototype._processTranslations=function(e,t){for(var n=new s,r=0;r<e.length;r++){var i=new s,o=e[r];if("string"==typeof o)try{i=s.loadPath(o)}catch(e){try{o=this.defaults.amdLanguageBase+o,i=s.loadPath(o)}catch(e){t&&window.console&&console.warn&&console.warn('Select2: The language file for "'+o+'" could not be automatically loaded. A fallback will be used instead.')}}else i=c.isPlainObject(o)?new s(o):o;n.extend(i)}return n},n.prototype.set=function(e,t){var n={};n[c.camelCase(e)]=t;var r=y._convertData(n);c.extend(!0,this.defaults,r)},new n}),e.define("select2/options",["require","jquery","./defaults","./utils"],function(r,d,i,p){function e(e,t){if(this.options=e,null!=t&&this.fromElement(t),null!=t&&(this.options=i.applyFromElement(this.options,t)),this.options=i.apply(this.options),t&&t.is("input")){var n=r(this.get("amdBase")+"compat/inputData");this.options.dataAdapter=p.Decorate(this.options.dataAdapter,n)}}return e.prototype.fromElement=function(e){var t=["select2"];null==this.options.multiple&&(this.options.multiple=e.prop("multiple")),null==this.options.disabled&&(this.options.disabled=e.prop("disabled")),null==this.options.dir&&(e.prop("dir")?this.options.dir=e.prop("dir"):e.closest("[dir]").prop("dir")?this.options.dir=e.closest("[dir]").prop("dir"):this.options.dir="ltr"),e.prop("disabled",this.options.disabled),e.prop("multiple",this.options.multiple),p.GetData(e[0],"select2Tags")&&(this.options.debug&&window.console&&console.warn&&console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'),p.StoreData(e[0],"data",p.GetData(e[0],"select2Tags")),p.StoreData(e[0],"tags",!0)),p.GetData(e[0],"ajaxUrl")&&(this.options.debug&&window.console&&console.warn&&console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."),e.attr("ajax--url",p.GetData(e[0],"ajaxUrl")),p.StoreData(e[0],"ajax-Url",p.GetData(e[0],"ajaxUrl")));var n={};function r(e,t){return t.toUpperCase()}for(var i=0;i<e[0].attributes.length;i++){var o=e[0].attributes[i].name,s="data-";if(o.substr(0,s.length)==s){var a=o.substring(s.length),l=p.GetData(e[0],a);n[a.replace(/-([a-z])/g,r)]=l}}d.fn.jquery&&"1."==d.fn.jquery.substr(0,2)&&e[0].dataset&&(n=d.extend(!0,{},e[0].dataset,n));var c=d.extend(!0,{},p.GetData(e[0]),n);for(var u in c=p._convertData(c))-1<d.inArray(u,t)||(d.isPlainObject(this.options[u])?d.extend(this.options[u],c[u]):this.options[u]=c[u]);return this},e.prototype.get=function(e){return this.options[e]},e.prototype.set=function(e,t){this.options[e]=t},e}),e.define("select2/core",["jquery","./options","./utils","./keys"],function(i,c,u,r){var d=function(e,t){null!=u.GetData(e[0],"select2")&&u.GetData(e[0],"select2").destroy(),this.$element=e,this.id=this._generateId(e),t=t||{},this.options=new c(t,e),d.__super__.constructor.call(this);var n=e.attr("tabindex")||0;u.StoreData(e[0],"old-tabindex",n),e.attr("tabindex","-1");var r=this.options.get("dataAdapter");this.dataAdapter=new r(e,this.options);var i=this.render();this._placeContainer(i);var o=this.options.get("selectionAdapter");this.selection=new o(e,this.options),this.$selection=this.selection.render(),this.selection.position(this.$selection,i);var s=this.options.get("dropdownAdapter");this.dropdown=new s(e,this.options),this.$dropdown=this.dropdown.render(),this.dropdown.position(this.$dropdown,i);var a=this.options.get("resultsAdapter");this.results=new a(e,this.options,this.dataAdapter),this.$results=this.results.render(),this.results.position(this.$results,this.$dropdown);var l=this;this._bindAdapters(),this._registerDomEvents(),this._registerDataEvents(),this._registerSelectionEvents(),this._registerDropdownEvents(),this._registerResultsEvents(),this._registerEvents(),this.dataAdapter.current(function(e){l.trigger("selection:update",{data:e})}),e.addClass("select2-hidden-accessible"),e.attr("aria-hidden","true"),this._syncAttributes(),u.StoreData(e[0],"select2",this),e.data("select2",this)};return u.Extend(d,u.Observable),d.prototype._generateId=function(e){return"select2-"+(null!=e.attr("id")?e.attr("id"):null!=e.attr("name")?e.attr("name")+"-"+u.generateChars(2):u.generateChars(4)).replace(/(:|\.|\[|\]|,)/g,"")},d.prototype._placeContainer=function(e){e.insertAfter(this.$element);var t=this._resolveWidth(this.$element,this.options.get("width"));null!=t&&e.css("width",t)},d.prototype._resolveWidth=function(e,t){var n=/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i;if("resolve"==t){var r=this._resolveWidth(e,"style");return null!=r?r:this._resolveWidth(e,"element")}if("element"==t){var i=e.outerWidth(!1);return i<=0?"auto":i+"px"}if("style"!=t)return"computedstyle"!=t?t:window.getComputedStyle(e[0]).width;var o=e.attr("style");if("string"!=typeof o)return null;for(var s=o.split(";"),a=0,l=s.length;a<l;a+=1){var c=s[a].replace(/\s/g,"").match(n);if(null!==c&&1<=c.length)return c[1]}return null},d.prototype._bindAdapters=function(){this.dataAdapter.bind(this,this.$container),this.selection.bind(this,this.$container),this.dropdown.bind(this,this.$container),this.results.bind(this,this.$container)},d.prototype._registerDomEvents=function(){var t=this;this.$element.on("change.select2",function(){t.dataAdapter.current(function(e){t.trigger("selection:update",{data:e})})}),this.$element.on("focus.select2",function(e){t.trigger("focus",e)}),this._syncA=u.bind(this._syncAttributes,this),this._syncS=u.bind(this._syncSubtree,this),this.$element[0].attachEvent&&this.$element[0].attachEvent("onpropertychange",this._syncA);var e=window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver;null!=e?(this._observer=new e(function(e){i.each(e,t._syncA),i.each(e,t._syncS)}),this._observer.observe(this.$element[0],{attributes:!0,childList:!0,subtree:!1})):this.$element[0].addEventListener&&(this.$element[0].addEventListener("DOMAttrModified",t._syncA,!1),this.$element[0].addEventListener("DOMNodeInserted",t._syncS,!1),this.$element[0].addEventListener("DOMNodeRemoved",t._syncS,!1))},d.prototype._registerDataEvents=function(){var n=this;this.dataAdapter.on("*",function(e,t){n.trigger(e,t)})},d.prototype._registerSelectionEvents=function(){var n=this,r=["toggle","focus"];this.selection.on("toggle",function(){n.toggleDropdown()}),this.selection.on("focus",function(e){n.focus(e)}),this.selection.on("*",function(e,t){-1===i.inArray(e,r)&&n.trigger(e,t)})},d.prototype._registerDropdownEvents=function(){var n=this;this.dropdown.on("*",function(e,t){n.trigger(e,t)})},d.prototype._registerResultsEvents=function(){var n=this;this.results.on("*",function(e,t){n.trigger(e,t)})},d.prototype._registerEvents=function(){var n=this;this.on("open",function(){n.$container.addClass("select2-container--open")}),this.on("close",function(){n.$container.removeClass("select2-container--open")}),this.on("enable",function(){n.$container.removeClass("select2-container--disabled")}),this.on("disable",function(){n.$container.addClass("select2-container--disabled")}),this.on("blur",function(){n.$container.removeClass("select2-container--focus")}),this.on("query",function(t){n.isOpen()||n.trigger("open",{}),this.dataAdapter.query(t,function(e){n.trigger("results:all",{data:e,query:t})})}),this.on("query:append",function(t){this.dataAdapter.query(t,function(e){n.trigger("results:append",{data:e,query:t})})}),this.on("keypress",function(e){var t=e.which;n.isOpen()?t===r.ESC||t===r.TAB||t===r.UP&&e.altKey?(n.close(),e.preventDefault()):t===r.ENTER?(n.trigger("results:select",{}),e.preventDefault()):t===r.SPACE&&e.ctrlKey?(n.trigger("results:toggle",{}),e.preventDefault()):t===r.UP?(n.trigger("results:previous",{}),e.preventDefault()):t===r.DOWN&&(n.trigger("results:next",{}),e.preventDefault()):(t===r.ENTER||t===r.SPACE||t===r.DOWN&&e.altKey)&&(n.open(),e.preventDefault())})},d.prototype._syncAttributes=function(){this.options.set("disabled",this.$element.prop("disabled")),this.options.get("disabled")?(this.isOpen()&&this.close(),this.trigger("disable",{})):this.trigger("enable",{})},d.prototype._syncSubtree=function(e,t){var n=!1,r=this;if(!e||!e.target||"OPTION"===e.target.nodeName||"OPTGROUP"===e.target.nodeName){if(t)if(t.addedNodes&&0<t.addedNodes.length)for(var i=0;i<t.addedNodes.length;i++){t.addedNodes[i].selected&&(n=!0)}else t.removedNodes&&0<t.removedNodes.length&&(n=!0);else n=!0;n&&this.dataAdapter.current(function(e){r.trigger("selection:update",{data:e})})}},d.prototype.trigger=function(e,t){var n=d.__super__.trigger,r={open:"opening",close:"closing",select:"selecting",unselect:"unselecting",clear:"clearing"};if(void 0===t&&(t={}),e in r){var i=r[e],o={prevented:!1,name:e,args:t};if(n.call(this,i,o),o.prevented)return void(t.prevented=!0)}n.call(this,e,t)},d.prototype.toggleDropdown=function(){this.options.get("disabled")||(this.isOpen()?this.close():this.open())},d.prototype.open=function(){this.isOpen()||this.trigger("query",{})},d.prototype.close=function(){this.isOpen()&&this.trigger("close",{})},d.prototype.isOpen=function(){return this.$container.hasClass("select2-container--open")},d.prototype.hasFocus=function(){return this.$container.hasClass("select2-container--focus")},d.prototype.focus=function(e){this.hasFocus()||(this.$container.addClass("select2-container--focus"),this.trigger("focus",{}))},d.prototype.enable=function(e){this.options.get("debug")&&window.console&&console.warn&&console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'),null!=e&&0!==e.length||(e=[!0]);var t=!e[0];this.$element.prop("disabled",t)},d.prototype.data=function(){this.options.get("debug")&&0<arguments.length&&window.console&&console.warn&&console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');var t=[];return this.dataAdapter.current(function(e){t=e}),t},d.prototype.val=function(e){if(this.options.get("debug")&&window.console&&console.warn&&console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'),null==e||0===e.length)return this.$element.val();var t=e[0];i.isArray(t)&&(t=i.map(t,function(e){return e.toString()})),this.$element.val(t).trigger("change")},d.prototype.destroy=function(){this.$container.remove(),this.$element[0].detachEvent&&this.$element[0].detachEvent("onpropertychange",this._syncA),null!=this._observer?(this._observer.disconnect(),this._observer=null):this.$element[0].removeEventListener&&(this.$element[0].removeEventListener("DOMAttrModified",this._syncA,!1),this.$element[0].removeEventListener("DOMNodeInserted",this._syncS,!1),this.$element[0].removeEventListener("DOMNodeRemoved",this._syncS,!1)),this._syncA=null,this._syncS=null,this.$element.off(".select2"),this.$element.attr("tabindex",u.GetData(this.$element[0],"old-tabindex")),this.$element.removeClass("select2-hidden-accessible"),this.$element.attr("aria-hidden","false"),u.RemoveData(this.$element[0]),this.$element.removeData("select2"),this.dataAdapter.destroy(),this.selection.destroy(),this.dropdown.destroy(),this.results.destroy(),this.dataAdapter=null,this.selection=null,this.dropdown=null,this.results=null},d.prototype.render=function(){var e=i('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');return e.attr("dir",this.options.get("dir")),this.$container=e,this.$container.addClass("select2-container--"+this.options.get("theme")),u.StoreData(e[0],"element",this.$element),e},d}),e.define("jquery-mousewheel",["jquery"],function(e){return e}),e.define("jquery.select2",["jquery","jquery-mousewheel","./select2/core","./select2/defaults","./select2/utils"],function(i,e,o,t,s){if(null==i.fn.select2){var a=["open","close","destroy"];i.fn.select2=function(t){if("object"==typeof(t=t||{}))return this.each(function(){var e=i.extend(!0,{},t);new o(i(this),e)}),this;if("string"!=typeof t)throw new Error("Invalid arguments for Select2: "+t);var n,r=Array.prototype.slice.call(arguments,1);return this.each(function(){var e=s.GetData(this,"select2");null==e&&window.console&&console.error&&console.error("The select2('"+t+"') method was called on an element that is not using Select2."),n=e[t].apply(e,r)}),-1<i.inArray(t,a)?this:n}}return null==i.fn.select2.defaults&&(i.fn.select2.defaults=t),o}),{define:e.define,require:e.require}}(),t=e.require("jquery.select2");return u.fn.select2.amd=e,t});
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.AOS=t():e.AOS=t()}(this,function(){return function(e){function t(o){if(n[o])return n[o].exports;var i=n[o]={exports:{},id:o,loaded:!1};return e[o].call(i.exports,i,i.exports,t),i.loaded=!0,i.exports}var n={};return t.m=e,t.c=n,t.p="dist/",t(0)}([function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}var i=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},r=n(1),a=(o(r),n(6)),u=o(a),c=n(7),f=o(c),s=n(8),d=o(s),l=n(9),p=o(l),m=n(10),b=o(m),v=n(11),y=o(v),g=n(14),h=o(g),w=[],k=!1,x=document.all&&!window.atob,j={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,startEvent:"DOMContentLoaded"},O=function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(e&&(k=!0),k)return w=(0,y.default)(w,j),(0,b.default)(w,j.once),w},S=function(){w=(0,h.default)(),O()},_=function(){w.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay")})},E=function(e){return e===!0||"mobile"===e&&p.default.mobile()||"phone"===e&&p.default.phone()||"tablet"===e&&p.default.tablet()||"function"==typeof e&&e()===!0},z=function(e){return j=i(j,e),w=(0,h.default)(),E(j.disable)||x?_():(document.querySelector("body").setAttribute("data-aos-easing",j.easing),document.querySelector("body").setAttribute("data-aos-duration",j.duration),document.querySelector("body").setAttribute("data-aos-delay",j.delay),"DOMContentLoaded"===j.startEvent&&["complete","interactive"].indexOf(document.readyState)>-1?O(!0):"load"===j.startEvent?window.addEventListener(j.startEvent,function(){O(!0)}):document.addEventListener(j.startEvent,function(){O(!0)}),window.addEventListener("resize",(0,f.default)(O,50,!0)),window.addEventListener("orientationchange",(0,f.default)(O,50,!0)),window.addEventListener("scroll",(0,u.default)(function(){(0,b.default)(w,j.once)},99)),document.addEventListener("DOMNodeRemoved",function(e){var t=e.target;t&&1===t.nodeType&&t.hasAttribute&&t.hasAttribute("data-aos")&&(0,f.default)(S,50,!0)}),(0,d.default)("[data-aos]",S),w)};e.exports={init:z,refresh:O,refreshHard:S}},function(e,t){},,,,,function(e,t){(function(t){"use strict";function n(e,t,n){function o(t){var n=b,o=v;return b=v=void 0,k=t,g=e.apply(o,n)}function r(e){return k=e,h=setTimeout(s,t),S?o(e):g}function a(e){var n=e-w,o=e-k,i=t-n;return _?j(i,y-o):i}function c(e){var n=e-w,o=e-k;return void 0===w||n>=t||n<0||_&&o>=y}function s(){var e=O();return c(e)?d(e):void(h=setTimeout(s,a(e)))}function d(e){return h=void 0,E&&b?o(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),k=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(O())}function m(){var e=O(),n=c(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(_)return h=setTimeout(s,t),o(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,k=0,S=!1,_=!1,E=!0;if("function"!=typeof e)throw new TypeError(f);return t=u(t)||0,i(n)&&(S=!!n.leading,_="maxWait"in n,y=_?x(u(n.maxWait)||0,t):y,E="trailing"in n?!!n.trailing:E),m.cancel=l,m.flush=p,m}function o(e,t,o){var r=!0,a=!0;if("function"!=typeof e)throw new TypeError(f);return i(o)&&(r="leading"in o?!!o.leading:r,a="trailing"in o?!!o.trailing:a),n(e,t,{leading:r,maxWait:t,trailing:a})}function i(e){var t="undefined"==typeof e?"undefined":c(e);return!!e&&("object"==t||"function"==t)}function r(e){return!!e&&"object"==("undefined"==typeof e?"undefined":c(e))}function a(e){return"symbol"==("undefined"==typeof e?"undefined":c(e))||r(e)&&k.call(e)==d}function u(e){if("number"==typeof e)return e;if(a(e))return s;if(i(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=i(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(l,"");var n=m.test(e);return n||b.test(e)?v(e.slice(2),n?2:8):p.test(e)?s:+e}var c="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},f="Expected a function",s=NaN,d="[object Symbol]",l=/^\s+|\s+$/g,p=/^[-+]0x[0-9a-f]+$/i,m=/^0b[01]+$/i,b=/^0o[0-7]+$/i,v=parseInt,y="object"==("undefined"==typeof t?"undefined":c(t))&&t&&t.Object===Object&&t,g="object"==("undefined"==typeof self?"undefined":c(self))&&self&&self.Object===Object&&self,h=y||g||Function("return this")(),w=Object.prototype,k=w.toString,x=Math.max,j=Math.min,O=function(){return h.Date.now()};e.exports=o}).call(t,function(){return this}())},function(e,t){(function(t){"use strict";function n(e,t,n){function i(t){var n=b,o=v;return b=v=void 0,O=t,g=e.apply(o,n)}function r(e){return O=e,h=setTimeout(s,t),S?i(e):g}function u(e){var n=e-w,o=e-O,i=t-n;return _?x(i,y-o):i}function f(e){var n=e-w,o=e-O;return void 0===w||n>=t||n<0||_&&o>=y}function s(){var e=j();return f(e)?d(e):void(h=setTimeout(s,u(e)))}function d(e){return h=void 0,E&&b?i(e):(b=v=void 0,g)}function l(){void 0!==h&&clearTimeout(h),O=0,b=w=v=h=void 0}function p(){return void 0===h?g:d(j())}function m(){var e=j(),n=f(e);if(b=arguments,v=this,w=e,n){if(void 0===h)return r(w);if(_)return h=setTimeout(s,t),i(w)}return void 0===h&&(h=setTimeout(s,t)),g}var b,v,y,g,h,w,O=0,S=!1,_=!1,E=!0;if("function"!=typeof e)throw new TypeError(c);return t=a(t)||0,o(n)&&(S=!!n.leading,_="maxWait"in n,y=_?k(a(n.maxWait)||0,t):y,E="trailing"in n?!!n.trailing:E),m.cancel=l,m.flush=p,m}function o(e){var t="undefined"==typeof e?"undefined":u(e);return!!e&&("object"==t||"function"==t)}function i(e){return!!e&&"object"==("undefined"==typeof e?"undefined":u(e))}function r(e){return"symbol"==("undefined"==typeof e?"undefined":u(e))||i(e)&&w.call(e)==s}function a(e){if("number"==typeof e)return e;if(r(e))return f;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(d,"");var n=p.test(e);return n||m.test(e)?b(e.slice(2),n?2:8):l.test(e)?f:+e}var u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},c="Expected a function",f=NaN,s="[object Symbol]",d=/^\s+|\s+$/g,l=/^[-+]0x[0-9a-f]+$/i,p=/^0b[01]+$/i,m=/^0o[0-7]+$/i,b=parseInt,v="object"==("undefined"==typeof t?"undefined":u(t))&&t&&t.Object===Object&&t,y="object"==("undefined"==typeof self?"undefined":u(self))&&self&&self.Object===Object&&self,g=v||y||Function("return this")(),h=Object.prototype,w=h.toString,k=Math.max,x=Math.min,j=function(){return g.Date.now()};e.exports=n}).call(t,function(){return this}())},function(e,t){"use strict";function n(e,t){a.push({selector:e,fn:t}),!u&&r&&(u=new r(o),u.observe(i.documentElement,{childList:!0,subtree:!0,removedNodes:!0})),o()}function o(){for(var e,t,n=0,o=a.length;n<o;n++){e=a[n],t=i.querySelectorAll(e.selector);for(var r,u=0,c=t.length;u<c;u++)r=t[u],r.ready||(r.ready=!0,e.fn.call(r,r))}}Object.defineProperty(t,"__esModule",{value:!0});var i=window.document,r=window.MutationObserver||window.WebKitMutationObserver,a=[],u=void 0;t.default=n},function(e,t){"use strict";function n(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function o(){return navigator.userAgent||navigator.vendor||window.opera||""}Object.defineProperty(t,"__esModule",{value:!0});var i=function(){function e(e,t){for(var n=0;n<t.length;n++){var o=t[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o)}}return function(t,n,o){return n&&e(t.prototype,n),o&&e(t,o),t}}(),r=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,a=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,u=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,c=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,f=function(){function e(){n(this,e)}return i(e,[{key:"phone",value:function(){var e=o();return!(!r.test(e)&&!a.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=o();return!(!u.test(e)&&!c.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}}]),e}();t.default=new f},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e,t,n){var o=e.node.getAttribute("data-aos-once");t>e.position?e.node.classList.add("aos-animate"):"undefined"!=typeof o&&("false"===o||!n&&"true"!==o)&&e.node.classList.remove("aos-animate")},o=function(e,t){var o=window.pageYOffset,i=window.innerHeight;e.forEach(function(e,r){n(e,i+o,t)})};t.default=o},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(12),r=o(i),a=function(e,t){return e.forEach(function(e,n){e.node.classList.add("aos-init"),e.position=(0,r.default)(e.node,t.offset)}),e};t.default=a},function(e,t,n){"use strict";function o(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(13),r=o(i),a=function(e,t){var n=0,o=0,i=window.innerHeight,a={offset:e.getAttribute("data-aos-offset"),anchor:e.getAttribute("data-aos-anchor"),anchorPlacement:e.getAttribute("data-aos-anchor-placement")};switch(a.offset&&!isNaN(a.offset)&&(o=parseInt(a.offset)),a.anchor&&document.querySelectorAll(a.anchor)&&(e=document.querySelectorAll(a.anchor)[0]),n=(0,r.default)(e).top,a.anchorPlacement){case"top-bottom":break;case"center-bottom":n+=e.offsetHeight/2;break;case"bottom-bottom":n+=e.offsetHeight;break;case"top-center":n+=i/2;break;case"bottom-center":n+=i/2+e.offsetHeight;break;case"center-center":n+=i/2+e.offsetHeight/2;break;case"top-top":n+=i;break;case"bottom-top":n+=e.offsetHeight+i;break;case"center-top":n+=e.offsetHeight/2+i}return a.anchorPlacement||a.offset||isNaN(t)||(o=t),n+o};t.default=a},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){for(var t=0,n=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),n+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:n,left:t}};t.default=n},function(e,t){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var n=function(e){e=e||document.querySelectorAll("[data-aos]");var t=[];return[].forEach.call(e,function(e,n){t.push({node:e})}),t};t.default=n}])});
//# sourceMappingURL=aos.js.map


/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      // Guard: hashes like "#/" (route-style links) are not valid CSS selectors and crash jQuery with
      // "Syntax error, unrecognized expression: #/". Only proceed for hashes that look like real id targets.
      var hash = evt.currentTarget.hash;
      if (hash && /^#[\w\-]+$/.test(hash)) {
        this.pageLinkFocus($(hash));
      }
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {

  wrapTable: function() {
    $('.rte table').wrap('<div class="rte__table-wrapper"></div>');
  },

  iframeReset: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.rte iframe#admin_bar_iframe');

    $iframeVideo.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });

    $iframeReset.each(function() {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Shopify ================*/
timber.cacheSelectors = function () {
  timber.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),

    // Navigation
    $navigation              : $('.accessibleNav'),

    // Collection Pages
    $changeView              : $('.change-view'),
    $collectionFilters       : $('#collectionFilters'),
    $toggleFilterBtn         : $('#toggleFilters'),

    // Customer Pages
    $recoverPasswordLink     : $('#RecoverPassword'),
    $hideRecoverPasswordLink : $('#HideRecoverPasswordLink'),
    $recoverPasswordForm     : $('#RecoverPasswordForm'),
    $customerLoginForm       : $('#CustomerLoginForm'),
    $passwordResetSuccess    : $('#ResetSuccess')
  }
};

timber.init = function () {
  timber.cacheSelectors();
  timber.accessibleNav();
  timber.toggleFilters();
  timber.collectionViews();
  timber.loginForms();
  timber.preloadHover();
};


timber.accessibleNav = function () {
  var $nav = timber.cache.$navigation,
      $allLinks = $nav.find('a'),
      $topLevel = $nav.children('li').find('a'),
      $parents = $nav.find('.site-nav--has-dropdown'),
      $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
      activeClass = 'nav-hover',
      focusClass = 'nav-focus';

  // Mouseenter
  $parents.on('mouseenter touchstart', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(activeClass)) {
      evt.preventDefault();
    }

    showDropdown($el);
  });

  // Mouseout
  $parents.on('mouseleave', function() {
    hideDropdown($(this));
  });

  $subMenuLinks.on('touchstart', function(evt) {
    // Prevent touchstart on body from firing instead of link
    evt.stopImmediatePropagation();
  });

  $allLinks.focus(function() {
    handleFocus($(this));
  });

  $allLinks.blur(function() {
    removeFocus($topLevel);
  });

  // accessibleNav private methods
  function handleFocus ($el) {
    var $subMenu = $el.next('ul'),
        hasSubMenu = $subMenu.hasClass('sub-nav') ? true : false,
        isSubItem = $('.site-nav__dropdown').has($el).length,
        $newFocus = null;

    // Add focus class for top level items, or keep menu shown
    if (!isSubItem) {
      removeFocus($topLevel);
      addFocus($el);
    } else {
      $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
      addFocus($newFocus);
    }
  }

  function showDropdown ($el) {
    $el.addClass(activeClass);

    setTimeout(function() {
      timber.cache.$body.on('touchstart', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown ($el) {
    $el.removeClass(activeClass);
    timber.cache.$body.off('touchstart');
  }

  function addFocus ($el) {
    $el.addClass(focusClass);
  }

  function removeFocus ($el) {
    $el.removeClass(focusClass);
  }
};

timber.getHash = function () {
  return window.location.hash;
};

timber.updateHash = function (hash) {
  window.location.hash = '#' + hash;
  $('#' + hash).attr('tabindex', -1).focus();
};

timber.switchZoom = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('data-zoom-image', src);
};

timber.toggleFilters = function () {
  if ( timber.cache.$collectionFilters.length ) {
    timber.cache.$toggleFilterBtn.on('click', function() {
      timber.cache.$toggleFilterBtn.toggleClass('is-active');
      timber.cache.$collectionFilters.slideToggle(200);
    });
  };
  var mediaQuerySmall = 'screen and (max-width: 768px)';
  enquire.register(mediaQuerySmall, {
    match: function() {
      timber.cache.$collectionFilters.hide();
    },
    unmatch: function() {
      timber.cache.$collectionFilters.show();
    }
  });
};

timber.preloadHover = function () {
  $('.supports-no-touch .collection__image__bottom').addClass('lazypreload');
};

// Helper function
function replaceUrlParam(url, paramName, paramValue) {
 var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
     newUrl = url;
 if (url.search(pattern) >= 0) {
   newUrl = url.replace(pattern,'$1' + paramValue + '$2');
 } else {
   newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
 }
 return newUrl;
}

timber.collectionViews = function () {
  if (timber.cache.$changeView.length) {
    timber.cache.$changeView.on('click', function() {
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  }
};

timber.loginForms = function() {
  function showRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.show();
    timber.cache.$customerLoginForm.hide();
  }

  function hideRecoverPasswordForm() {
    timber.cache.$recoverPasswordForm.hide();
    timber.cache.$customerLoginForm.show();
  }

  timber.cache.$recoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    showRecoverPasswordForm();
  });

  timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
    evt.preventDefault();
    hideRecoverPasswordForm();
  });

  // Allow deep linking to recover password form
  if (timber.getHash() == '#recover') {
    showRecoverPasswordForm();
  }
};

timber.resetPasswordSuccess = function() {
  timber.cache.$passwordResetSuccess.show();
};

// Initialize Timber's JS on docready
$(timber.init);


/*================ Components ================*/
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    // Guard: if the <quantity-input> element is rendered without an inner <input>
    // (markup variant on some cart line items), this.input is null and the next line
    // throws "Cannot read properties of null (reading 'addEventListener')" — a major
    // contributor to the site-wide error volume. Return early; the element is inert.
    if (!this.input) return;
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    // Guard: connectedCallback invokes this even if the constructor early-returned
    // (no inner input). Without these guards the .min/.max/.value/.classList chains
    // throw on null elements — same family of "reading 'classList'" / "reading 'value'" errors.
    if (!this.input) return;
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      if (buttonMinus) buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      if (buttonPlus) buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);
class CartMain extends HTMLElement {
  constructor() {
    super()
    window.addEventListener("resize", this.updateVar() );
  }

  get test() {
    return this._test
  }

  refresh() {
    $(this).addClass('loading')
    $.get(`${window.Shopify.routes.root}cart?view=drawer`)
      .done(function(data) {
        // CF challenge detection: cart?view=drawer returns HTML, so check for CF markers in response
        if (typeof data === 'string' && (data.indexOf('cf-turnstile') !== -1 || data.indexOf('challenges.cloudflare.com') !== -1 || data.indexOf('challenge-platform') !== -1)) {
          console.error('[Cart] Cloudflare challenge detected on cart?view=drawer (200 response with challenge page). Reloading page for verification.');
          $(this).removeClass('loading');
          var $err = $('cart-error');
          if ($err.length) $err.empty().html('Please verify your connection. Reloading page\u2026').slideDown('fast');
          else $('.cart-message').append('<span class="cart-error">Please verify your connection. Reloading page\u2026</span>');
          setTimeout(function(){ window.location.reload(); }, 2000);
          return;
        }
        $(this).empty().html( $(data).find('cart-main > *') )
        $(this).removeClass('loading')
        this.updateVar()
        /* A11y: after DOM replacement, re-focus into the drawer so keyboard
           users land on the new content instead of losing focus to <body> */
        var drawer = document.querySelector('cart-drawer')
        if (drawer && drawer.classList.contains('in')) {
          drawer.moveFocusIntoDrawer()
        }
        /* Extract the cart count and update the nav cart count */
        console.log('header count update - 1');
        if ($('cart-header .body').html() != undefined) {
          const cartCount = parseInt($('cart-header .body').html().match(/\d+/)[0], 10);
          if (cartCount != NaN) {
            $('.cartCount').html(parseInt($('cart-header .body').html().match(/\d+/)[0], 10))
          }
        } else {
          $('.cartCount').html(0)
        }
        /* Sync cart attribute IDs after every cart change */
        if (window.updateCartProductAttributes) window.updateCartProductAttributes();
      }.bind(this))
      .fail(function(xhr) {
        $(this).removeClass('loading');
        if (xhr.status === 429 || xhr.status === 403) {
          console.error('[Cart] Cloudflare challenge detected on cart?view=drawer (status ' + xhr.status + '). Reloading page for verification.');
          var $err = $('cart-error');
          if ($err.length) $err.empty().html('Please verify your connection. Reloading page\u2026').slideDown('fast');
          else $('.cart-message').append('<span class="cart-error">Please verify your connection. Reloading page\u2026</span>');
          setTimeout(function(){ window.location.reload(); }, 2000);
        } else {
          console.error('[Cart] Failed to refresh cart drawer:', xhr.status, xhr.statusText);
        }
      }.bind(this))
  }

  // Extend - Fixing cart getting cleared

  updateItem(key, quantity, attemptNum) {

      // Extend - Fixing cart getting cleared
      console.log('key is', key)

      // Input validation
      if (!key || quantity < 0) {
        console.error('Invalid key or quantity provided');
        return false;
      }

      attemptNum = attemptNum || 0;
      var maxRetries = window.CART_RETRY_MAX || 2;
      var retryDelay = window.cartRetryDelay || function(n){ return (400 * n) + Math.floor(Math.random() * 300); };

      // Supersession tracking: a 409-retry must not replay an old quantity over
      // a newer user action on the same line (see the 409 retry below).
      this._updateSeq = this._updateSeq || {};
      if (!attemptNum) this._updateSeq[key] = (this._updateSeq[key] || 0) + 1;
      const updateSeq = this._updateSeq[key];

    const $cartItems = $(this)
    const $cartError = $('cart-error')
    $cartItems.addClass('loading')
    $cartError.slideUp('fast')
    /*
    let updates = {
      794864053: 0,
      794864233: 0
    };
    */
    let updates = {}
    updates[key] = quantity
    console.log('Drawer Cart Update - 1');
    if (updates === {}) return;

    // cartFetchDirect: bypass the global 409-retry layer (cart-conflict-retry
    // snippet) — this call site has its own supersession-aware retry below.
    (window.cartFetchDirect || window.fetch)(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
    .then((response) => {
      const ct = (response.headers.get('content-type') || '');
      //if (ct.indexOf('application/json') === -1 && 1>2) {
      if (ct.includes('text/html') || (response.status === 429) || (response.status === 403)) {
        console.error('[Cart] Cloudflare challenge detected on cart/update.js (got HTML instead of JSON). Reloading page for verification.');
        $cartItems.removeClass('loading');
        const $err = $('cart-error');
        if ($err.length) $err.empty().html('Please verify your connection. Reloading page…').slideDown('fast');
        else $('.cart-message').append('<span class="cart-error">Please verify your connection. Reloading page…</span>');
        setTimeout(() => { window.location.reload(); }, 2000);
        throw new Error('CF_BLOCK');
      }
      if (response.status === 409 && attemptNum < maxRetries) {
        /* Concurrent write to the same cart (Shopify returns 409 since Oct 2025).
           The update was rejected, so retrying cannot double-apply. Escalating
           jittered delay so contending writers don't re-collide in lockstep. */
        if (window.reportCartConflict) window.reportCartConflict('cart/update.js (drawer updateItem)', false);
        setTimeout(() => {
          /* Skip if the user has since issued a newer change for this line */
          if (this._updateSeq[key] !== updateSeq) return;
          this.updateItem(key, quantity, attemptNum + 1);
        }, retryDelay(attemptNum + 1));
        throw new Error('RETRY_409');
      }
      if (response.status === 409 && window.reportCartConflict) {
        window.reportCartConflict('cart/update.js (drawer updateItem)', true);
      }
      return response.json();
    })
    .then(data => {
      // Check for various error conditions
      // (409 after a failed retry carries the same {status, message, description}
      // body shape as 422 — reuse its show-message-then-refresh recovery)
      if (data.status && (data.status === 422 || data.status === 409)) {
        // Validation error from Shopify
        console.log('Validation error for Drawer Cart Update - 1');
        console.log('data:', JSON.stringify(data));
        $cartItems.removeClass('loading');
        
        if (data.message && data.message !== undefined) {
          $('.cart-message').append('<span class="cart-error">' + data.message + '</span>');
        } else if (data.description) {
          $('.cart-message').append('<span class="cart-error">' + data.description + '</span>');
        }
        
        /*
        // Don't refresh cart on error - just show error message
        return false;
        */
        
        // Refresh cart on error as well to give clarity on its latest state
        // document.querySelector(`cart-main`).refresh();
        // Add a small delay for the message to be read then refresh
        setTimeout(() => {
          document.querySelector(`cart-main`).refresh();
          $cartItems.removeClass('loading');
        }, 2000);

      } else if (!data.ok && data.hasOwnProperty('ok')) {
        // Generic error condition
        console.log('Error for Drawer Cart Update - 1');
        console.log('data:', JSON.stringify(data));
        $cartItems.removeClass('loading');
        
        if (data.message && data.message !== undefined) {
          $('.cart-message').append('<span class="cart-error">' + data.message + '</span>');
        }
        
        /*
        // Don't refresh cart on error - just show error message
        return false;
        */
        
        // Refresh cart on error as well to give clarity on its latest state
        // document.querySelector(`cart-main`).refresh();
        // Add a small delay for the message to be read then refresh
        setTimeout(() => {
          document.querySelector(`cart-main`).refresh();
          $cartItems.removeClass('loading');
        }, 2000);
        return false;
        
      } else if (data.items || data.item_count !== undefined) {
        // Success - cart data returned with items array or item_count
        console.log('Cart update successful');
        
        // Add small delay to ensure server has processed the update
        setTimeout(() => {
          document.querySelector(`cart-main`).refresh();
          $cartItems.removeClass('loading');
        }, 100);
        
        return data;
      } else {
        // Unexpected response format
        console.error('Unexpected response format:', data);
        $cartItems.removeClass('loading');
        $('.cart-message').append('<span class="cart-error">Unexpected error occurred</span>');
        return false;
      }
    })
    .catch((error) => {
      if (error.message === 'CF_BLOCK') return; /* already handled above */
      if (error.message === 'RETRY_409') return; /* retry scheduled; keep loading state until it lands */
      console.error('Error:', error)
      $cartError.slideUp('fast')
      $cartError.empty().html('Network error: ' + error.message).slideDown('fast')
      $cartItems.removeClass('loading')
      // Don't refresh cart on network error
    })
  }

  updateVar() {
    // Guarded: cart-header / cart-footer are not always rendered when this fires
    // (e.g., empty-cart state, or before child components hydrate). Without these
    // guards we throw "Cannot read properties of null (reading 'clientHeight')"
    // on every page that mounts <cart-main> but doesn't yet have the children.
    const header = this.querySelector('cart-header')
    if (header) {
      this.style.setProperty('--cart-header-height', `${header.clientHeight}px`)
    }
    const footer = this.querySelector('cart-footer')
    if (footer) {
      this.style.setProperty('--cart-footer-height', `${footer.clientHeight}px`)
    }
  }
}
customElements.define('cart-main', CartMain);


class CartItem extends HTMLElement {
  constructor() {
    super()
    this.initQuantityInput()
    this.initRemoveButton()
  }

  initQuantityInput() {
    const quantityInput = this.querySelector('.quantity__input')
    $(quantityInput).change($.debounce(500, function(evt){
      const key = this.getAttribute('data-line-key')
      const quantity = parseInt( quantityInput.value )
      document.querySelector(`cart-main`).updateItem(key, quantity)
    }.bind(this)))

    // Extend - Dispatch event (debounced to fire only once regardless of cart item count)
    if (!window._extendSideCartRefreshScheduled) {
      window._extendSideCartRefreshScheduled = true;
      window.setTimeout(function () { window.dispatchEvent(new Event('refreshAjaxSideCart')); window._extendSideCartRefreshScheduled = false; }, 3000)
    }
    // Extend - End code
    
  }

  initRemoveButton() {
    const removeButton = this.querySelector('cart-remove-button')
    if ( removeButton === null ) {
      return
    }
    removeButton.addEventListener('click', (event) => {
      event.preventDefault()
      const key = this.getAttribute('data-line-key')
      document.querySelector(`cart-main`).updateItem(key, 0)
    })
  }
}
customElements.define('cart-item', CartItem);


class CartUpsellItem extends HTMLElement {
  constructor() {
    super()
    this.form = this.querySelector('form')
    this.variantSelect = this.form.querySelector('[name="id"]')
    this.button = this.form.querySelector('[type="submit"]')

    this.product = JSON.parse( this.querySelector('[data-product-json]').innerHTML )

    this.variantSelect.addEventListener('change', (event) => {
      const variant = this.getCurrentVariant()
      this.querySelector(`[cart-upsell-item-image]`).setAttribute('src', variant.featured_image.src)
      this.querySelector(`[cart-upsell-item-price] .money`).innerHTML = slate.Currency.formatMoney(variant.price, theme.moneyFormat)
      this.querySelectorAll('[cart-item-url]').forEach((link) => {
        link.setAttribute('href', `${Shopify.routes.root}products/${this.product.handle}?variant=${variant.id}`)
      })

      if( variant.comare_at_price > variant.price ) {
        this.querySelector(`[cart-upsell-item-compare-at-price]`).classList.remove('hide')
        this.querySelector(`[cart-upsell-item-compare-at-price] .money`).innerHTML = slate.Currency.formatMoney(variant.comare_at_price, theme.moneyFormat)
      } else {
        this.querySelector(`[cart-upsell-item-compare-at-price]`).classList.add('hide')
      }
    })

    this.form.addEventListener('submit', (event) => {
      event.preventDefault()
      this.addItem()
    })
  }

  getCurrentVariant() {
    const variantId = parseInt( this.variantSelect.value )
    for( let i=0 ; i<this.product.variants.length ; i++ ) {
      if( this.product.variants[i].id == variantId ) {
        return this.product.variants[i]
      }
    }
    return false
  }

  addItem() {
    const variant = this.getCurrentVariant();
    const $this = $(this);
    if( !variant ) {
      console.error('variant not found')
      return
    }
    this.classList.add('loading')
    this.button.classList.add('loading')
    let formData = {
      'items': [{
       'id': variant.id,
       'quantity': 1
       }]
     };
    console.log('Drawer Cart add.js - 1');
     fetch(window.Shopify.routes.root + 'cart/add.js', {
       method: 'POST',
       headers: {
         'Content-Type': 'application/json'
       },
       body: JSON.stringify(formData)
     })
    .then((response) => {
      const ct = (response.headers.get('content-type') || '');
      //if (ct.indexOf('application/json') === -1 && 1>2) {
      if (ct.includes('text/html') || (response.status === 429) || (response.status === 403)) {
        console.error('[Cart] Cloudflare challenge detected on cart/add.js (got HTML instead of JSON). Reloading page for verification.');
        $this.removeClass('loading');
        $('.cart-message').append('<span class="cart-error">Please verify your connection. Reloading page…</span>');
        setTimeout(() => { window.location.reload(); }, 2000);
        throw new Error('CF_BLOCK');
      }
      return response.json();
    })
    .then(data => {
      if (!data.ok) {
        console.log('Error for Drawer Cart Update - 1');
        //$cartItems.removeClass('loading');
        $this.remove('loading')
        if (data.message && data.message != undefined) {
          $('.cart-message').append('<span class="cart-error">' + data.message + '</span>');
        }
        setTimeout(function(){
          //$cartItems.addClass('loading');
          $this.add('loading')
          document.querySelector(`cart-main`).refresh();
          //$('.cart-message').find('.cart-error').remove();
        }, 60);
        return false;
      } else {
        document.querySelector(`cart-main`).refresh()
        return data;
      }
    })


     .catch((error) => {
       if (error.message === 'CF_BLOCK') return;
       console.error('Error:', error);
     });
  }
}
customElements.define('cart-upsell-item', CartUpsellItem);


class CartUpsellCarousel extends HTMLElement {
  constructor() {
    super()
    this.initSlider();
  }

  initSlider() {
    const $slider = $(this).find('> ul')
    if( $slider === null || $slider.hasClass('slick-slider') ) {
      return;
    }
    const upsellCarousel = this;
    $(upsellCarousel).css('opacity', 0);
    $slider.slick({
      'infinite': false,
      'fade': true
    });
    setTimeout(function(){
      $(`cart-upsell-carousel > ul`).slick('resize')
      $(upsellCarousel).css('opacity', 1);
    }, 300)
  }
}
customElements.define('cart-upsell-carousel', CartUpsellCarousel);


class CartDrawer extends HTMLElement {
  constructor() {
    super()
    this._triggerElement = null
    this.initCartToggle()
    this.initOvelay()
    this.initCloseButton()
    this.initKeyboardHandlers()
  }

  open() {
    this._triggerElement = document.activeElement
    this.classList.add('in')
    document.querySelector('body').classList.add('scroll-lock')
    /* A11y: move focus into the drawer after next frame (WCAG 2.4.3) */
    this.moveFocusIntoDrawer()
  }

  /* A11y: move keyboard focus to the first interactive element inside the
     drawer.  Called by open() and again by CartMain.refresh() so that focus
     is restored after the async cart HTML replacement. */
  moveFocusIntoDrawer() {
    requestAnimationFrame(() => {
      var main = this.querySelector('cart-main')
      if (!main) return
      var firstFocusable = main.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      if (firstFocusable) firstFocusable.focus()
      else main.setAttribute('tabindex', '-1'), main.focus()
    })
  }

  close() {
    document.querySelector('body').classList.remove('scroll-lock')
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer.classList.contains('in')) {
      cartDrawer.classList.remove('in');
    }
    /* A11y: return focus to trigger element (WCAG 2.4.3) */
    if (this._triggerElement && typeof this._triggerElement.focus === 'function') {
      this._triggerElement.focus()
      this._triggerElement = null
    }
  }

  /* A11y: Escape to close + focus trap (WCAG 2.1.1, 2.1.2, 2.4.3) */
  initKeyboardHandlers() {
    this.addEventListener('keydown', (event) => {
      if (!this.classList.contains('in')) return

      if (event.key === 'Escape') {
        event.preventDefault()
        this.close()
        return
      }

      if (event.key === 'Tab') {
        var main = this.querySelector('cart-main')
        if (!main) return
        var focusable = main.querySelectorAll('button:not([disabled]), [href]:not([tabindex="-1"]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')
        var visible = Array.prototype.filter.call(focusable, function(el) {
          var s = getComputedStyle(el)
          return s.display !== 'none' && s.visibility !== 'hidden' && el.getBoundingClientRect().width > 0
        })
        if (visible.length === 0) return
        var first = visible[0]
        var last = visible[visible.length - 1]
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault()
          last.focus()
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault()
          first.focus()
        }
      }
    })
  }

  initCartToggle() {
    document.querySelectorAll('[data-cart-toggle]').forEach( (toggle) => {
      toggle.addEventListener('click', (event) => {
        if (this.getAttribute('data-drawer') !== 'on') {
          const href = toggle.getAttribute('href') || `${window.Shopify.routes.root}cart`;
          window.location.href = href;
          return;
        }
        event.preventDefault()
        this.open()
      })
    })
  }

  initOvelay() {
    // Guarded: cart-drawer-overlay child may not be present in some cart-drawer markup variants
    // (e.g., empty-cart state). Without the guard the constructor throws
    // "Cannot read properties of null (reading 'addEventListener')" on every such page mount.
    const overlay = this.querySelector('cart-drawer-overlay')
    if (overlay) {
      overlay.addEventListener('click', (event) => {
        event.preventDefault()
        this.close()
      })
    }
  }

  initCloseButton() {
    // Guarded: same reason as initOvelay — close button child may be absent in some variants.
    const closeBtn = this.querySelector('cart-drawer-close button')
    if (closeBtn) {
      closeBtn.addEventListener('click', (event) => {
        event.preventDefault()
        this.close()
      })
    }
  }
}
customElements.define('cart-drawer', CartDrawer);

//window._gwpEnabled = false;
class CartGWP extends HTMLElement {
  constructor() {
    super()
    this.cart = JSON.parse( this.querySelector('[data-cart]').innerHTML );
    //console.log(this.cart);
    this.variantsToAdd = JSON.parse( this.querySelector('[data-variants-to-add]').innerHTML );
    this.cartTotal = this.cart.items_subtotal_price / 100;
    //console.log(this.cartTotal);
    this.enableGWP()

    if( !Shopify.designMode ) {
      this.addFreebies();
      this.removeFreebies();
    }
  }

  disconnectedCallback() {
    // console.log("CartGWP.disconnectedCallback")
  }

  enableGWP() {
    if (typeof window._gwpEnabled === 'undefined' || (typeof window._gwpEnabled !== 'undefined' && window._gwpEnabled === false)) {
      console.log('enableGWP return');
      return
    }
    this.style.display = 'block';
  }

  addFreebies() {
    if (typeof window._gwpEnabled === 'undefined' || (typeof window._gwpEnabled !== 'undefined' && window._gwpEnabled === false)) {
      console.log('addFreebies stopped from running.');
      return
    }
    console.log('running addFreebies.');
    if (typeof window._gwpEnabled === 'undefined' || (typeof window._gwpEnabled !== 'undefined' && window._gwpEnabled === false)) {
      console.log('addFreebies return');
      return
    }
    if( this.variantsToAdd.length === 0 ) {
      return
    }
    let addItems = []
    for( let i=0 ; i<this.variantsToAdd.length ; i++ ) {
      const variantId = this.variantsToAdd[i]
      
      addItems.push({
        id: variantId,
        quantity: 1,
        properties: {
          "_source": "cart_gift_with_purchase",
        }
      })
      /*
      addItems.push({
        id: variantId,
        quantity: 1
      })
      */
    }
    
    let formData = {
     'items': addItems,
     'attributes': {
        '_free_gwp_eligible': 'true'
     }
    }

    console.log('Drawer Cart add.js - 2');
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if( document.querySelector('cart-drawer[data-drawer="on"]') !== null ) {
        document.querySelector('cart-main').refresh()
        if( !document.querySelector('cart-drawer').classList.contains('in') ) {
          document.querySelector('cart-drawer').open()
        }
      } else {
        location.reload()
      }
      return response.json()
    })
    .catch((error) => {
      console.error('Error:', error)
    })
  }

  removeFreebies() {
    if (typeof window._gwpEnabled === 'undefined' || (typeof window._gwpEnabled !== 'undefined' && window._gwpEnabled === false)) {
      console.log('removeFreebies stopped from running.');
      return
    }
    console.log('about to run removeFreebies. window._gwpEnabled is: ', window._gwpEnabled);
    console.log('running removeFreebies.');

    let updateCart = false
    let updates = []

    //manual check for cart total due to a race condition in discount functions
    //setTimeout(()=>{
    for( let i=0 ; i<this.cart.items.length ; i++ ) {
      const item = this.cart.items[i]
      let quantity = item.quantity
      if( item.final_line_price !== 0 && (item.properties['_source'] == 'cart_gift_with_purchase' || item.properties['source'] == 'cart_gift_with_purchase') ) {
        updateCart = true
        quantity = 0
      } else if( item.final_line_price == 0 && (item.properties['_source'] == 'cart_gift_with_purchase' || item.properties['source'] == 'cart_gift_with_purchase') && this.cartTotal < 80) {
        updateCart = true
        quantity = 0
      }
      updates.push(quantity)
    }

    if( updateCart ) {
      let formData = {
        "updates": updates
      }
      console.log('removeFreebies updates: ', updates);
      console.log('Drawer Cart Update - 2');
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if( document.querySelector('cart-drawer[data-drawer="on"]') !== null ) {
          document.querySelector('cart-main').refresh()
          document.querySelector('cart-drawer').open()
        } else {
          location.reload()
        }
        return response.json()
      })
      .catch((error) => {
        console.error('Error:', error)
      })
    }
    //}, 500);
  }
}
customElements.define('cart-gwp', CartGWP);

/*================ Templates ================*/

theme.init = function () {
  theme.ariaHover();
  theme.lazyImage();
  theme.equalHeight();
  theme.matchHeight();
  theme.navClick();
  theme.overlayClick();
  theme.delayNav();
  theme.smoothScroll();
  theme.detectNav();
  theme.tabletMenu();
  theme.fullHeight();
  theme.contentOverflow();
  theme.createQtySelectors();
  theme.moveTags();
  theme.heightOverride();
  theme.klaviyoForm();
  theme.countdown();
  theme.accordion();
  // theme.utmPersonalization();
  theme.utmDiscountCode();
  theme.USDOnlyKlarna();
  theme.slickSlider();
  theme.tabs();
  theme.localizedContent();
  theme.lpDiscountMessage();
};

// https://www.w3schools.com/js/js_cookies.asp
theme.setCookie = function(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

theme.getCookie = function(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

theme.equalHeight = function() {
  var $columns = $('.equalHeightColumn');
  $columns.height('initial');
  var height = 0;
  $columns.each(function () {
    if ($(this).height() > height) {
      height = $(this).height();
    }
  });
  $columns.height(height);
};

theme.navClick = function() {
  $('.nav--mobile .accessibleNav .grandparent > a.nav__caret, .nav--mobile .accessibleNav .parent > a.nav__caret, .nav--mobile .accessibleNav .grandparent > a[href="#"], .nav--mobile .accessibleNav .parent > a[href="#"]').on('click', function(event){
    event.preventDefault();
    var $dropdownLi = $(this).closest('li'),
        $dropdowncaret = $dropdownLi.children( '.nav__caret' );

    // $dropdownLi.toggleClass('main-menu--expanded');
    // $dropdowncaret.attr('aria-expanded', $dropdowncaret.attr('aria-expanded')=='false' ? 'true' : 'false');

    if( $dropdowncaret.attr('aria-expanded') == 'true' ) {
      // Close this
      $dropdownLi.find('.main-menu-dropdown').slideUp(200, function(){
        $dropdownLi.removeClass('main-menu--expanded');
        $dropdowncaret.attr('aria-expanded', 'false');
        $dropdownLi.find('.main-menu-dropdown').attr('style', '');
      })

      $('.header-wrapper').trigger('mobileNavClosed');

    } else {

      // Close all others
      $('.nav--mobile .parent').removeClass('main-menu--expanded');
      $('.nav--mobile .parent .nav__caret' ).attr('aria-expanded', 'false');

      // Open this
      $dropdownLi.addClass('main-menu--expanded');
      $dropdowncaret.attr('aria-expanded', 'true');
      $('.header-wrapper').trigger('mobileNavOpened');

      return;
    }
  });

  $('.menuToggle').on('click', function(event){
    event.preventDefault();
    var $headerWrapper = $(this).closest('.header-wrapper'),
        $target = $(event.target);
    if( $target.attr('aria-expanded') == 'false' ) {
      $headerWrapper.trigger('openHeaderMenu');
    } else {
      $headerWrapper.trigger('closeHeaderMenu');
    }
  });
};

theme.overlayClick = function() {
  $('.header__overlay').click(function(){
    $('.header-wrapper').trigger('closeHeaderMenu');
  });
};

theme.delayNav = function() {
  var hoverTimeout;
  var $agingGrandparent;
  var $headerWrapper;
  $('.nav--desktop .grandparent').hover(function() {
    $headerWrapper = $(this).closest('.header-wrapper');
    if(typeof $agingGrandparent != 'undefined') {
      $agingGrandparent.removeClass('hover');
      $agingGrandparent.find( '.nav__link' ).attr('aria-expanded','false');
      $headerWrapper.removeClass('showOverlay');
    }
    window.clearTimeout(hoverTimeout);
    var $grandparent = $(this);
    $grandparent.addClass('hover');
    $grandparent.find( '.nav__link' ).attr('aria-expanded','true');
    $headerWrapper.addClass('showOverlay');

  },function() {
    $agingGrandparent = $(this);
    // The hover-out can fire on a closure where hover-in never ran (nav re-init
    // while the cursor is already inside, touch->mouse emulation), leaving
    // $headerWrapper undefined — assign it here too instead of assuming.
    $headerWrapper = $(this).closest('.header-wrapper');
    hoverTimeout = window.setTimeout(function() {
      $agingGrandparent.removeClass('hover');
      $agingGrandparent.find( '.nav__link' ).attr('aria-expanded','false');
      $headerWrapper.removeClass('showOverlay');
    },250);
  });
};

theme.ariaHover = function() {
  $('.nav--desktop .parent').hover(
    function() {
      $(this).children('.nav__link').attr('aria-expanded','true');
    },
    function() {
      $(this).children('.nav__link').attr('aria-expanded','false');
    }
  );
};

theme.lazyImage = function() {
  document.addEventListener('lazyloaded', function(e){
    $(e.target).parent('.lazy-image').css( "background-image", "none" );
  });
};

theme.tabletMenu = function() {
  if (Modernizr.touch){
    $('.nav--desktop .grandparent > a.nav__link, .nav--desktop .main-menu > .parent > a.nav__link').on( 'click', function(event){
      var $headerWrapper = $(this).closest('.header-wrapper');
      if ( $(this).parent().hasClass('hover') ){
        $(this).parent().removeClass('hover');
        $(this).attr('aria-expanded','false');
        $headerWrapper.removeClass('showOverlay');
      } else{
        event.preventDefault();
        $('.grandparent, .parent').removeClass('hover');
        $(this).parent().addClass('hover');
        $(this).attr('aria-expanded','true');
        $headerWrapper.addClass('showOverlay');
      }
    });
  }
};

theme.smoothScroll = function() {
  $('a[href*="#"]:not([href="#"])').click(function(event) {
    // Guard: hashes like "#/" (route-style links) crash jQuery with "Syntax error, unrecognized
    // expression: #/". The :not([href="#"]) filter above only excludes the bare "#", not "#/".
    if (!this.hash || !/^#[\w\-]+$/.test(this.hash)) return;
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
       if (target.length) {
         event.preventDefault();
         $('html,body').animate({
          scrollTop: target.offset().top
        }, 1000);
      }
    }
  });
};

theme.createQtySelectors = function() {
  $cartContainer  = $('body.template-cart');
  // If there is a normal quantity number field in the ajax cart, replace it with our version
  if ($('input[type="number"].js-qty__num', $cartContainer).length) {
    $('input[type="number"].js-qty__num', $cartContainer).each(function() {
      var el = $(this),
          currentQty = el.val();

      var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

      var source   = $("#JsQty--cart").html(),
          template = Handlebars.compile(source),
          data = {
            id: el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus
          };

      // Append new quantity selector then remove original
      el.after(template(data)).remove();
    });
  }

  // Setup listeners to add/subtract from the input
  $('body.template-cart .js-qty__adjust').on('click', function() {
    var el = $(this),
        id = el.data('id'),
        qtySelector = el.siblings('.js-qty__num'),
        qty = parseInt(qtySelector.val().replace(/\D/g, ''))

    // Make sure we have a valid integer
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }

    // Add or subtract from the current quantity
    if (el.hasClass('js-qty__adjust--plus')) {
      qty = qty + 1;
    } else {
      qty = qty - 1;
      if (qty <= 0) qty = 0;
    }

    // Update the input's number
    qtySelector.val(qty).trigger('change');
    $('body.template-cart .update-cart').focus();
  });
}

theme.detectNav = function() {
  var windowWidth = $(window).width();

  // On viewports <= 940px the CSS in <head> already forces mobile nav from
  // first paint.  Skip the showDesktop round-trip to avoid a flash.
  if (windowWidth <= 940) {
    $('.header-wrapper, .site-header').addClass('showMobile').removeClass('showDesktop');
    return;
  }

  $('.header-wrapper, .site-header').addClass('showDesktop').removeClass('showMobile');

  var headerInnerHeight = $(`.nav--desktop [header-desktop-inner]`).outerHeight(),
      menuHeight = $(`.nav--desktop .header-menu`).first().outerHeight(),
      heightDiff =  Math.abs(headerInnerHeight - menuHeight);

  if( heightDiff > 10 ) {
    $('.header-wrapper, .site-header').addClass('showMobile').removeClass('showDesktop');
  }
};

theme.fullHeight = function(){
  var windowHeight = $(window).height();
  var navHeight = ($('.header-wrapper').height());
  var heroHeight = windowHeight - navHeight;
  $('.index-sections > .shopify-section:first-child > .use_screen_full').height(heroHeight).css('min-height', 'initial');
  $('.index-sections > .shopify-section:first-child > .use_screen_full.homepage-slideshow .slideshow__slide').height(heroHeight);
};

theme.contentOverflow = function(){
  $('.preventOverflow').css('min-height', function() {
    var contentHeight = $(this).find('.preventOverflowContent').height();
    return (contentHeight + 30);
  });
};

theme.heightOverride = function(){
  if ((/Android|iPhone|iPad|iPod|BlackBerry/i).test(navigator.userAgent || navigator.vendor || window.opera)) {
    $( '.use_screen_full, .use_screen_three_quarters, .use_screen_two_thirds, .use_screen_one_half, .use_screen_one_third, .use_screen_one_fifth').css('height', function() {
      return $(this).css('height');
    }, 'important');
    $( '.use_screen_full .slideshow__slide, .use_screen_three_quarters .slideshow__slide, .use_screen_two_thirds .slideshow__slide, .use_screen_one_half .slideshow__slide, .use_screen_one_third .slideshow__slide').css('height', function() {
      return $(this).css('height');
    }, 'important');

    $( '.use_screen_full .double__block, .use_screen_three_quarters .double__block, .use_screen_two_thirds .double__block, .use_screen_one_half .double__block, .use_screen_one_third .double__block, .use_screen_one_fifth .double__block').css('height', function() {
      return $(this).css('height');
    }, 'important');
  }
};

theme.matchHeight = function(){
  $('.equalOverflowHeight').css('min-height', function() {
    var blockHeights = $('.preventOverflowContent', $(this) ).map(function() {
      return $(this).height();
    }).get();
    var tallest = Math.max.apply(null, blockHeights);
    return (tallest + 30);
  });
};

theme.moveTags = function(){
  $('.homepage--white:not(.homepage-image)').parent().addClass('adjust--white');
  $('.homepage--light:not(.homepage-image)').parent().addClass('adjust--light');
  $('.homepage--splash:not(.homepage-image)').parent().addClass('adjust--splash');
  $('.homepage--dark:not(.homepage-image)').parent().addClass('adjust--dark');
};

theme.klaviyoForm = function() {
  var selectors = {
    form: '.js-klaviyo-form',
    inputs: '.js-klaviyo-form-inputs',
    success: '.js-klaviyo-form-success',
    error: '.js-klaviyo-form-error'
  };

  $.getScript('//www.klaviyo.com/media/js/public/klaviyo_subscribe.js', function() {
    KlaviyoSubscribe.attachToForms(selectors.form, {
      hide_form_on_success: true,
      custom_success_message: true
    });
  });

  $(document).on('klaviyo.subscribe.success', selectors.form, function() {
    var $form = $(this),
        thankYouUrl = $form.attr('data-success-url');

    if( thankYouUrl ) {
      window.location = thankYouUrl;
    } else {
      $form.find( selectors.inputs ).hide();
      $form.find( selectors.success ).show();
    }
  });

  $(document).on('klaviyo.subscribe.error', selectors.form, function() {
    console.log('klaviyo.subscribe.error()');
    var $form = $(this);
    $form.find( selectors.inputs ).hide();
    $form.find( selectors.error ).show();
  });
};

theme.countdown = function() {

  // https://coderwall.com/p/rbfl6g/how-to-get-the-correct-unix-timestamp-from-any-date-in-javascript
  Date.prototype.getUnixTime = function() { return this.getTime()/1000|0 };
  if(!Date.now) Date.now = function() { return new Date(); }
  Date.time = function() { return Date.now().getUnixTime(); }

  /*
    var dt = new Date();
    dt.setMinutes( dt.getMinutes() + 1 );
    dt.getUnixTime();
    console.log( dt );
    console.log( dt.getUnixTime() );

    theme.setCookie('CompareTimestamp', '', 1);
  */

  $('[data-countdown]').each(function(){
    var $container = $(this),
        $countdownHours = $container.find('[data-countdown-hours]'),
        compareHours = parseInt( $countdownHours.attr('data-countdown-hours') ),
        $output = $countdownHours,
        $timestamp = $container.find('[data-countdown-timestamp]'),
        currentDate = new Date(),
        compareDate,
        countdownFormat = $timestamp.attr('data-format') || 'with_unit',
        compareTimestamp = theme.getCookie('CompareTimestamp');

    if( $timestamp.length ) {

      $output = $timestamp;
      compareTimestamp = $timestamp.attr('data-countdown-timestamp');
      compareDate = new Date(compareTimestamp * 1000);

    } else {

      if( compareTimestamp === '' ) {
        compareDate = new Date();
        compareDate.setHours( compareDate.getHours() + compareHours );
        $timestamp = $countdownHours;

        var compareTimestamp = compareDate.getUnixTime();
        theme.setCookie('CompareTimestamp', compareTimestamp, compareHours/24);
      } else {
        compareDate = new Date(compareTimestamp * 1000);
      }

      if( currentDate > compareDate ) {
        // reset cookie
        theme.setCookie('CompareTimestamp', '', 1);
        return;
      }
    }

    var countdownTrigger = setInterval(function(){
      currentDate = new Date();

      if( currentDate > compareDate ) {
        $container.css('visibility', 'hidden');
        if( $output == $timestamp ) {
          $container.remove();
        }
        clearInterval(countdownTrigger);
        return;
      } else {
        $container.css('visibility', 'visible');
      }

      var diffSecs = Math.floor((compareDate - (currentDate))/1000),
          diffMins = Math.floor(diffSecs/60),
          diffHrs = Math.floor(diffMins/60),
          diffDays = Math.floor(diffHrs/24);

      diffHrs = diffHrs-(diffDays*24);
      diffMins = diffMins-(diffDays*24*60)-(diffHrs*60);
      diffSecs = diffSecs-(diffDays*24*60*60)-(diffHrs*60*60)-(diffMins*60);

      var counterString = '';

      switch(countdownFormat) {
        case '00:00:00':
          /*
          if( $output == $timestamp ) {
            if (diffDays != 0) {
              counterString += ((diffDays<10) ? '0'+diffDays : diffDays ) + ':';
            }
          }
          */

          if (diffDays > 2) {
            counterString += ((diffDays<10) ? '0'+diffDays : diffDays ) + ':';
          } else {
            diffHrs = diffHrs + (diffDays *24);
          }
          
          counterString += ((diffHrs<10) ? '0'+diffHrs : diffHrs) + ':';
          counterString += ((diffMins<10) ? '0'+diffMins : diffMins) + ':';
          counterString += (diffSecs<10) ? '0'+diffSecs : diffSecs;
          break;

        case 'with_unit':
          counterString += `<span>${diffDays}D</span> <span>${diffHrs}H</span> <span>${diffMins}M</span> <span>${diffSecs}S</span>`;
          break;

        default:
          // code block
      }

      if( currentDate < compareDate ) {
        $container.addClass('in');
      }

      $output.html( counterString );
    }, 1000);
  });
}

theme.accordion = function() {
  $('body').on('click', '[data-accordion-toggle]', function(e) {
    var $accordion = $(this).closest('[data-accordion]'),
        $accordionItem = $(this).closest('[data-accordion-item]'),
        $accordionContent = $accordionItem.find('[data-accordion-content]');

    if( $accordionItem.hasClass('in') ) {
      $accordionContent.slideUp('fast');
      setTimeout(function(){
        $accordionItem.removeClass('in');
      }, 200);
    } else {
      if( $accordion.find('[data-accordion-item].in').length ) {
        $accordion.find('[data-accordion-content]').slideUp('fast');
        $accordion.find('[data-accordion-item]').removeClass('in');
        setTimeout(function(){
          $accordionContent.slideDown('fast');
          setTimeout(function(){
            $accordionItem.addClass('in');
          }, 200);
        }, 200);
      } else {
        $accordionContent.slideDown('fast');
        setTimeout(function(){
          $accordionItem.addClass('in');
        }, 200);
      }
    }
  });
};

theme.utmPersonalization = function() {
  console.log('theme.utmPersonalization()');
  // https://rayconglobal.com/products/e25-true-wireless-earbuds?variant=29457527963671
  // https://rayconglobal.com/products/e25-true-wireless-earbuds?preview_theme_id=81319198743&utm_campaign=larray&utm_source=test&utm_medium=test&utm_content=123456abc

  let shopifySAP = theme.getCookie('_shopify_sa_p').split('&'),
      utmCampaign = false,
      utmContent = false;
  for( let i=0 ; i<shopifySAP.length ; i++ ) {
    let param = shopifySAP[i];

    if( typeof( param.split('=')[1] ) !== 'undefined' ) {
      if( param.split('=')[0] === 'utm_campaign' ) {
        utmCampaign = param.split('=')[1];
      }
      if( param.split('=')[0] === 'utm_content' ) {
        utmContent = param.split('=')[1];
      }
    }
  }

  console.log( {
    'utmCampaign': utmCampaign,
    'utm_content': utmContent
  } );

  if( utmContent === false ) {
    return;
  }

  if( $('.info-bar__message .rte p a').length ) {
    $('.info-bar__message .rte p a').html(`Save 15% with <strong>${utmContent.toUpperCase()}</strong> today - Act Now`)
  }
  if( location.href.indexOf('/products/') !== -1 ) {
    $(`<p style="margin:0;"><strong>Save 15% with code ${utmContent.toUpperCase()}</strong></p>`).insertAfter('.product__title');
  }
  if( location.href.indexOf('/cart') !== -1 ) {
    $('.cart__sidebar__footer').prepend(`<p>Save 15% With <strong>${utmContent.toUpperCase()}</strong></p>`);
  }
};

theme.utmDiscountCode = function() {
  // https://www.sitepoint.com/get-url-parameters-with-javascript/
  if( !$(`[dynamic-discount-code-data]`).length ) {
    return;
  }

  const utm_source_codes = JSON.parse( $(`[dynamic-discount-code-data]`).html() );

  const queryString = window.location.search;
  // ?product=shirt&color=blue&newuser&size=m
  // We can then parse the query string’s parameters using URLSearchParams:

  const urlParams = new URLSearchParams(queryString);

  if( urlParams.get('utm_medium') == 'influencer' ) {
    return;
  }

  let dynamicDiscountCode = false;
  const utm_source = urlParams.get('utm_source');
  if( typeof(utm_source_codes[utm_source]) !== 'undefined' ) {
    dynamicDiscountCode = utm_source_codes[utm_source];
  }
  if( dynamicDiscountCode ) {
    $(`[data-dynamic-discount-code]`).html(dynamicDiscountCode);
  }
};

theme.USDOnlyKlarna = function(){
  if( Shopify.currency.active === 'USD' ) {
    $('.product__klarna, .cart__klarna').removeClass('hide');
  }
};

theme.slickSlider = function() {
  $(`[data-slick-slider]`).each(function(){
    if( !$(this).hasClass('slick-slider') ) {
      $(this).slick();
    }
  })
}

theme.tabs  = function() {
  $(document).on(`click`, `[data-tabs-toggle]`, function(evt) {
    const $toggle = $(evt.target)
    const $tabs = $toggle.closest(`[data-tabs]`)
    const $panels = $tabs.find(`[data-tabs-panel]`)
    const sectionId = $toggle.attr(`data-tabs-toggle`)
    const $targetPanel = $tabs.find(`[data-tabs-panel="${sectionId}"]`)

    if( $targetPanel.length ) {
      $panels.removeClass(`in`)
      $targetPanel.addClass(`in`)

      $tabs.find(`[data-tabs-toggle]`).removeClass(`active`)
      $toggle.addClass(`active`)
    }
  })
}

theme.localizedContent = function() {
  switch ( Shopify.country ) {
    case 'CA':
      $(`[data-best-buy-ca]`).show()
      break;
    case 'US':
      break;
  }
}

theme.lpDiscountMessage = function() {
  if( theme.getCookie('lp_discount') === '' && theme.lp_discount.message === '' ) {
    return
  }
  // if( theme.getCookie('lp_discount') === '' && theme.lp_discount.message !== '' ) {
  if( theme.lp_discount.message !== '' ) {
    theme.setCookie('lp_discount', JSON.stringify( theme.lp_discount ), 1)
  }
  const lpDiscount = JSON.parse( theme.getCookie('lp_discount') )
  if( typeof(lpDiscount.message) !== 'undefined' && lpDiscount.message !== '' ) {
    const $infoBarSlider = $(`.header-wrapper .info-bar .info-bar__slider`)
    $infoBarSlider.slick('unslick').html(`<div class="info-bar__slide"><div class="info-bar__message"><div class="rte"><p><strong>${lpDiscount.message}</p></strong></div></div><div>`)
    $infoBarSlider.slick()
    $(`.pdp_promotional__message`).show().html(`<p style="color: #ff2a00;"><strong>${lpDiscount.message}</strong></p>`)
    $(`.cart__discount-content.cart__discount-content--2`).html(`<p><strong>${lpDiscount.message}</strong></p>`)
  }
}

$(window).resize(function() {
  theme.detectNav();
  theme.contentOverflow();
  theme.equalHeight();
  theme.matchHeight();
  theme.fullHeight();
  theme.heightOverride();
}).resize();

$(window).load(function(){
  $(window).resize();
});

$(theme.init);


/*================ Sections ================*/
theme.Cart = (function() {
  function Cart(container) {
    var $container = this.$container = $(container),
        id = $container.attr('data-section-id'),
        selectors = this.selectors = {
          upsell: {
            container: '[upsell-container]',
            slider: '[upsell-item-slider]',
            addToCart: '[upsell-add-to-cart]'
          },
          discount: {
            toggle: '[discount-toggle]',
            div: '[discount-div]',
            field: '[discount-field]',
            btn: '[discount-apply-button]'
          },
          productForm: '[upsell-product-form]'
        };

    this.discountCode();
    this.autoUpdate();
    this.shippingPrice();

    $(window).load(function(){
      $container.trigger('udpateShippingPrice');
    });
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    discountCode: function() {
      var $container = this.$container;
      var selectors = this.selectors;

      // Guard localStorage reads — Safari/Brave/Firefox in private mode (and some
      // strict-cookie / partitioned-storage contexts, e.g. embedded-iframe and
      // Facebook/Instagram in-app webviews) throw SecurityError on access. We
      // don't need to recover, just don't pollute the console with the error.
      try {
        if (localStorage.getItem('storedDiscount')){
          var discountStored = localStorage.getItem('storedDiscount');
          $container.find( selectors.discount.field ).val(localStorage.getItem('storedDiscount'));
        }
      } catch (e) {
        // localStorage unavailable — skip auto-populating saved discount
      }

      $container.find( selectors.discount.btn ).on('click', function(e){
        var discountCode = $(this).closest('.input-group').find( selectors.discount.field ).val();
        $container.find( selectors.discount.field ).val(discountCode);
        try {
          localStorage.setItem('storedDiscount', discountCode);
        } catch (e) {
          // localStorage unavailable — proceed to checkout without persisting
        }
        window.location = `${window.Shopify.routes.root}checkout?discount=${discountCode}`
      });



      $container.find( selectors.discount.toggle ).on('click', function(e){
        $container.find( selectors.discount.div ).slideToggle();
        // $container.find( selectors.discount.toggle ).removeAttr( selectors.discount.toggle );
      });
    },
    autoUpdate: function() {
      var $container = this.$container;
          selectors = this.selectors;

      // https://davidwalsh.name/javascript-debounce-function

      // Returns a function, that, as long as it continues to be invoked, will not
      // be triggered. The function will be called after it stops being called for
      // N milliseconds. If `immediate` is passed, trigger the function on the
      // leading edge, instead of the trailing.

      function debounce(func, wait, immediate) {
        var timeout;
        return function() {
          var context = this, args = arguments;
          var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
        };
      };

      $('body').on('cartChangedCallback', function(){
        console.log('cartChangedCallback');
      })

      var ajaxChangeItem = function( line, attemptNum ) {
        attemptNum = attemptNum || 0;
        var maxRetries = window.CART_RETRY_MAX || 2;
        var retryDelay = window.cartRetryDelay || function(n){ return (400 * n) + Math.floor(Math.random() * 300); };
        var cartItemSelector = '.cart__item[data-line="' + line + '"]',
            cartTotalPriceSelector = '[cart-total-price]',
            quantity = $(cartItemSelector).find('[name="updates[]"]').val();

        // Retry after a 409 re-enters here and re-reads the CURRENT input value,
        // so it can never replay a stale quantity over a newer user change.
        if( attemptNum && (quantity === undefined || quantity === null) ) {
          return;
        }

        if( quantity == 0 ) {
          $(cartItemSelector).slideUp();
        }
        console.log('Cart Change Update - 1');
        $.ajax({
          type: 'POST',
          url: `${window.Shopify.routes.root}cart/change.js`,
          dataType: 'json',
          // Opt out of the global 409-retry layer (cart-conflict-retry snippet):
          // a blind replay of the captured quantity could overwrite a newer
          // change; the self-managed retry below re-reads the DOM instead.
          _cartConflictOptOut: true,
          data: {
            line: line,
            quantity: quantity
          },
          success: function(){
            // Update UI
            $(cartItemSelector).addClass('loading');

            $.ajax({
              type: 'GET',
              url: `${window.Shopify.routes.root}cart`,
              success: function(data){
                if( quantity == 0 ) {
                  window.location.reload();
                }

                window.location.reload();
                return;

                // $(`[data-section-type="cart"]`).html( $(data).find(`[data-section-type="cart"]`).html() )
                // return;

                // $(cartTotalPriceSelector).html( $(data).find(cartTotalPriceSelector).html() );
                $(cartItemSelector)
                  .removeClass('loading')
                  .find('[cart-item-line-price]').html( $(data).find(cartItemSelector + ' [cart-item-line-price]').html() );

                // Update cart count
                $('.cartCount').html( $(data).find('.cartCount').html() );

                // Update shipping price
                $container.trigger('udpateShippingPrice');
              }
            });
          },
          error: function(object, status) {
            var ct = (object.getResponseHeader && object.getResponseHeader('Content-Type')) || '';
            //if (ct.indexOf('text/html') !== -1 || (object.status === 403 && !object.responseJSON)) {
            //const ct = (object.headers.get('content-type') || '');
            //if (ct.indexOf('application/json') === -1 && 1>2) {
            if (ct.includes('text/html') || (object.status === 429) || (object.status === 403)) {
              console.error('[Cart] Cloudflare challenge detected on cart/change.js (got HTML instead of JSON). Reloading page for verification.');
              $(cartItemSelector).removeClass('loading');
              setTimeout(function(){ window.location.reload(); }, 2000);
              throw new Error('CF_BLOCK');
              return;
            }
            if (object.status === 409 && attemptNum < maxRetries) {
              /* Concurrent write to the same cart (Shopify returns 409 since Oct
                 2025) — retry, re-entering ajaxChangeItem so the quantity is
                 re-read from the DOM (never replays a stale value). Escalating
                 jittered delay so contending writers don't re-collide. */
              if (window.reportCartConflict) window.reportCartConflict('cart/change.js (cart page)', false);
              setTimeout(function(){ ajaxChangeItem(line, attemptNum + 1); }, retryDelay(attemptNum + 1));
              return;
            }
            if (object.status === 409 && window.reportCartConflict) {
              window.reportCartConflict('cart/change.js (cart page)', true);
            }
            var msg = (object.responseJSON && object.responseJSON.description) || 'An error occurred. Please try again.';
            console.log('Cart error:', msg);
          }
        });
      };

      $('body').on('change', '[name="updates[]"]', debounce(function(){
        var line = $(this).closest('.cart__item').data('line');
        ajaxChangeItem( line );
      }, 500));
    },
    shippingPrice: function(){
      const freeShippingThreshold = parseInt( this.$container.attr('data-free-shipping-threshold') ) || 0
      this.$container.on('udpateShippingPrice', function(evt){
        console.log('Drawer Cart cart.js - 3');
        let cartContents = fetch(`${window.Shopify.routes.root}cart.js`)
          .then(response => {
            const ct = (response.headers.get('content-type') || '');
            //if (ct.indexOf('application/json') === -1 && 1>2) {
            if (ct.includes('text/html') || (response.status === 429) || (response.status === 403)) {
              console.warn('[Cart] Cloudflare challenge detected on cart.js read. Skipping shipping update.');
              throw new Error('CF_BLOCK');
            }
            return response.json();
          })
          .catch(err => { if (err.message !== 'CF_BLOCK') console.error('[Cart] shipping fetch error:', err); return null; })
          .then(cart => {
            if (!cart) return;
            if( cart.total_price >= freeShippingThreshold ) {
              $('[data-cart-shipping-free]').show()
              $('[data-cart-shipping-calculated]').hide()
            } else {
              $('[data-cart-shipping-free]').hide()
              $('[data-cart-shipping-calculated]').show()
            }
          });
      });
    }
  });

  return Cart;
})();

theme.Video = (function() {

  function Video(container) {
    var $container = this.$container = $(container);
    var id = $container.attr('data-section-id');
    var $featuredImage = this.$featuredImage = $('#FeaturedImage-'+id);
    var featuredImageSelector = this.featuredImageSelector = '#FeaturedImage-'+id;
    var parallaxSliderSelector = this.parallaxSliderSelector = '#FeaturedImage-'+id + " .parallax-slider";

    var $currentVideo = $container.find('.popupVideo');
    $currentVideo.magnificPopup({
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      closeBtnInside: false,
      preloader: false,
      fixedContentPos: false,
      iframe: {
        patterns: {
          youtube: {
            src: '//www.youtube.com/embed/%id%?autoplay=1&rel=0&showinfo=0'
          }
        }
      }
    });

    if ($featuredImage.attr('data-parallax-src')) {
      $featuredImage.parallax({
        src: $featuredImage.data('parallax-src'),
        parallax: 'scroll',
        excludeAgents: /(none)/,
        mirrorSelector: featuredImageSelector
      });
      $.each( $(featuredImageSelector).data(), function(key,val){
        if (key == 'widths' ){
         val = "[" + val + "]"
        }
        var kebabKey = "data-" + key;
        kebabKey = kebabKey.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase();
        $(parallaxSliderSelector).attr( kebabKey,val);
      });
      $(parallaxSliderSelector).addClass('lazyload');

      var loadCount = 0;
      $(parallaxSliderSelector).on('load', function(){
        loadCount++;
        if (loadCount > 1){
          $featuredImage.css("background-image", "none");
        }
      });
    }
  }


  Video.prototype = _.assignIn({}, Video.prototype, {
    onUnload: function() {
      if (this.$container.attr('data-img-src')) {
        this.$container.parallax('destroy');
      }
      var magnificObject = this.$container.find('.popupVideo')
      magnificObject.off('click.magnificpopup');
      magnificObject.removeData('magnificPopup');
    }
  });

  return Video;
})();

theme.Header = (function() {
  function Header(container) {
    var $container = this.$container = $(container),
        id = $container.attr('data-section-id'),
        fixedHeader = ( $container.attr('data-fixed-header') == 'true' );

    this.updateHeaderVars()
    this.updateMainTopMargin();

    if( fixedHeader ) {
      this.fixedHeader();
    }

    $container
      .on('openHeaderMenu', function(){
        this.openHeaderMenu()
      }.bind(this))
      .on('closeHeaderMenu', function(){
        this.closeHeaderMenu()
      }.bind(this))

    const scope = this
    $(window).on('resize scroll', $.debounce(10, function(){
      const headerWrapperHeight = $(`[data-header-wrapper]`).outerHeight();
      $('body')[0].style.setProperty('--header-wrapper-height', `${headerWrapperHeight}px`)

      scope.updateHeaderVars()
      scope.updateMainTopMargin()
    }));
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    fixedHeader: function() {
      var $container = this.$container,
          compressOffset = 150;

      $container
        .addClass('fixed')
        .trigger('updateMainTopMargin');

      $(window).scroll(function(){
        if( $(window).scrollTop() > compressOffset ) {
          $container.addClass('compressed');
        } else {
          $container.removeClass('compressed');
        }
      })
    },

    updateMainTopMargin: function() {
      this.$container.on('updateMainTopMargin', function() {
        const transparentHeader = ( this.$container.attr(`data-transparent`) === 'true' );
        let marginTop = ( this.$container.hasClass('showDesktop') && transparentHeader ) ? 0 : this.$container.outerHeight();
        document.body.style.setProperty('--header-wrapper-height', marginTop + 'px');
      }.bind(this));
    },

    openHeaderMenu: function() {
      var $headerWrapper = $('[data-header-wrapper]');
      $headerWrapper.find('.menuToggle').attr('aria-expanded', 'true');
      $headerWrapper.find('.header-menu').addClass('main-menu--expanded');
      $headerWrapper.find('.header-search').addClass('main-menu--expanded');
      $headerWrapper.addClass('showOverlay');
      $('body').addClass('scrollLock');

     window.igEvents = window.igEvents || [];
     window.igEvents.push({"event": "Mobile Menu Opened"});

      var windowHeight = window.innerHeight ? window.innerHeight : $(window).height();
      var headerMenuHeight = windowHeight - $('[data-header-wrapper] .nav--mobile .mobile-wrapper').outerHeight() - $('[data-header-wrapper] .info-bar').outerHeight();
      $('.nav--mobile .header-menu').css({
        height: headerMenuHeight
      });

      this.updateHeaderVars()
      this.updateMainTopMargin()
    },

    closeHeaderMenu: function() {
      var $headerWrapper = $('[data-header-wrapper]');
      $headerWrapper.find('.menuToggle').attr('aria-expanded', 'false');
      $headerWrapper.find('.header-menu').removeClass('main-menu--expanded');
      $headerWrapper.find('.header-search').removeClass('main-menu--expanded');
      $headerWrapper.removeClass('showOverlay');
      $('body').removeClass('scrollLock');

      $('.nav--mobile .header-menu').attr('style', '')

      this.updateHeaderVars()
      this.updateMainTopMargin()
    },

    updateHeaderVars: function() {
      const headerWrapperHeight = $(`[data-header-wrapper]`).outerHeight();
      $('body')[0].style.setProperty('--header-wrapper-height', `${headerWrapperHeight}px`)
    },
  });

  return Header;
})();

theme.Megamenu = (function() {
  function Megamenu(container) {
    var $container = this.$container = $(container);
    var selectors = this.selectors = {
      navLink: '.megamenu__nav__link',
      content: '.megamenu__content',
      list: '.megamenu__slider'
    };

    // this.linkHoverHandle();
    this.initSlider();
  }

  Megamenu.prototype = _.assignIn({}, Megamenu.prototype, {
    initSlider: function() {
      var $container = this.$container,
          selectors = this.selectors,
          $megamenuList = $container.find(selectors.list),
          $header = $container.closest('.site-header');

      if( !$megamenuList.length ) {
        return;
      }

      $(window).resize(function() {
        if( $header.hasClass('showMobile') ) {
          if( $megamenuList.hasClass('slick-slider') ) {
            return;
          }
          $megamenuList
            .on('touchstart.slick mousedown.slick', function(event){
              var $slider = $(event.target).closest('.slick-slider'),
                  $slides = $slider.find('.slick-slide'),
                  $slide = $(event.target).closest('.slick-slide');

              $slides.addClass('slick-touching')
            })
            .on('touchmove.slick mousemove.slick', function(){
            })
            .on('touchend.slick mouseup.slick', function(event){
              var $slider = $(this).closest('.slick-slider'),
                  $slides = $slider.find('.slick-slide'),
                  $slide = $(this).closest('.slick-slide');
            })
            .on('touchcancel.slick mouseleave.slick', function(){
            })
            .on('dragstart', function(event, slick){
            })
            .on('beforeChange', function(event, slick, currentSlide, nextSlide){
              var $nextSlider = slick.$slides.filter('[data-slick-index="' + nextSlide + '"]');
              slick.$slides.removeClass('slick-touching');
            })
            .on('afterChange', function(event, slick, currentSlide){
              slick.$slides.removeClass('slick-touching');
            })
            .slick({
              arrows: false,
              infinite: false,
              dots: true,
              slidesToShow: 2,
              slidesToScroll: 2,
              speed: 200
            });
        }
      });

      $('.header-wrapper').on('mobileNavOpened', function(){
        if( !$megamenuList.hasClass('slick-initialized') ) {
          return;
        }
        $megamenuList.slick('setPosition');
      });
    },
    linkHoverHandle:function() {
      var $container = this.$container,
          selectors = this.selectors,
          $navLink = $(selectors.navLink);

      if( !$navLink.length ) {
        return;
      }

      $navLink.hover(function() {
        var $megamenu = $(this).closest('.megamenu'),
            $navLink = $(this),
            megamenuId = $navLink.attr('data-megamenu-trigger'),
            $content = $(selectors.content).filter('[data-megamenu-id="' + megamenuId + '"]');
        $megamenu.find(selectors.navLink).removeClass('active');
        $megamenu.find(selectors.content).hide();
        $navLink.addClass('active');
        $content.show();
      });
    }
  });

  return Megamenu;
})();

theme.Parallax = (function() {
  function Parallax(container) {
    var $container = this.$container = $(container);
    var id = $container.attr('data-section-id');
    var $featuredImage = this.$featuredImage = $('#FeaturedImage-'+id);
    var featuredImageSelector = this.featuredImageSelector = '#FeaturedImage-'+id;
    var parallaxSliderSelector = this.parallaxSliderSelector = '#FeaturedImage-'+id + " .parallax-slider";

    if ($featuredImage.attr('data-parallax-src')) {
      $featuredImage.parallax({
        src: $featuredImage.data('parallax-src'),
        parallax: 'scroll',
        excludeAgents: /(none)/,
        mirrorSelector: featuredImageSelector
      });
      $.each( $(featuredImageSelector).data(), function(key,val){
        if (key == 'widths' ){
         val = "[" + val + "]"
        }
        var kebabKey = "data-" + key;
        kebabKey = kebabKey.replace( /([a-z])([A-Z])/g, '$1-$2' ).toLowerCase();
        $(parallaxSliderSelector).attr( kebabKey,val);
      });
      $(parallaxSliderSelector).addClass('lazyload');

      var loadCount = 0;
      $(parallaxSliderSelector).on('load', function(){
        loadCount++;
        if (loadCount > 1){
          $featuredImage.css("background-image", "none");
        }
      });
    }
  }

  Parallax.prototype = _.assignIn({}, Parallax.prototype, {
    onUnload: function() {
      if (this.$featuredImage.attr('data-img-src')) {
        this.$featuredImage.parallax('destroy');
      }
    }
  });

  return Parallax;
})();

theme.BannerImage = (function() {
  function BannerImage(container) {
    var $container = this.$container = $(container),
        id = $container.attr('data-section-id');

    this.init();
  }

  BannerImage.prototype = _.assignIn({}, BannerImage.prototype, {
    init: function() {
      this.$container.find(' > a')
        .mouseenter(function() {
          $(this).find('.btn').addClass('hover');
        })
        .mouseleave(function() {
          $(this).find('.btn').removeClass('hover');
        });
    }
  });

  return BannerImage;
})();

theme.CollectionCompare = (function() {
  function CollectionCompare(container) {
    var $container = this.$container = $(container);
    var id = $container.attr('data-section-id');

    this.equalItemHeight();
    this.tableSlider();
  }

  CollectionCompare.prototype = _.assignIn({}, CollectionCompare.prototype, {
    equalItemHeight: function() {
      var $container = this.$container;
      $container.find('.collection-compare__content').each(function(){
        $(this).find('p').each(function(i){
          $(this).attr('data-compare-item-feature', i);
        });
      });

      $container
        .on('equalItemHeight', function(){
          $container.find('[data-compare-item-feature]').css('height', '');
          $container.find('[data-compare-item-features]').first().find('[data-compare-item-feature]').each(function(){
            var minHeight = $(this).outerHeight(),
                index = $(this).attr('data-compare-item-feature');
            $container.find('[data-compare-item-feature="' + index + '"]').each(function(){
              var height = $(this).outerHeight();
              if( height > minHeight ) {
                minHeight = height;
              }
            });
            $container.find('[data-compare-item-feature="' + index + '"]').css('height', minHeight);
          });
        })

      $(window).load(function(){
        $container.trigger('equalItemHeight');
      });

      $(window).resize(function(){
        $container.trigger('equalItemHeight');
      });
    },
    tableSlider: function() {
      var $container = this.$container,
          $table = $container.find('[data-compare-items]');

      if( !$table.length ) {
        return;
      }

      var itemCount = parseInt( $table.attr('data-item-count') ) || 2;

      $table.slick({
        arrows: true,
        adaptiveHeight: true,
        slidesToShow: itemCount,
        slidesToScroll: 1,
        infinite: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  });

  return CollectionCompare;
})();

theme.CompareProducts = (function() {
  function CompareProducts(container) {
    var $container = this.$container = $(container);
    var id = $container.attr('data-section-id');

    this.initList();
  }

  CompareProducts.prototype = _.assignIn({}, CompareProducts.prototype, {
    initList: function() {
      var $container = this.$container;
      $('[data-compare-products-item-rte]').each(function(){
        $(this).wrapInner('<ul></ul>');
        var $list = $(this).find('ul');
        $(this).find('p').each(function(){
          var $p = $(this);
          $list.append('<li>' + $p.html() + '</li>');
          $p.remove()
        });
      });
    }
  });

  return CompareProducts;
})();

theme.Footer = (function() {
  function Footer(container) {
    var $container = this.$container = $(container),
        id = $container.attr('data-section-id');

    $container.find('.footer__block__heading').click(function(e){
      var $block = $(this).closest('.footer__block'),
          $caret = $block.find('.caret'),
          $nav = $block.find('.footer__nav');

      if( $caret.attr('aria-expanded') == 'false' ) {
        $caret.attr('aria-expanded', 'true');
        $nav.slideDown();
      } else {
        $caret.attr('aria-expanded', 'false');
        $nav.slideUp();
      }
    });
  }

  return Footer;
})();

theme.Slideshow = (function() {
  function Slideshow(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#slideshow-'+sectionId;
    var $slideshow = this.$slideshow = $(this.slideshow);

    this.init();
  }

  Slideshow.prototype = _.assignIn({}, Slideshow.prototype, {
    init: function() {
      this.$slideshow.on('init', function(event, slick){
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.slick-current');
        slick.$prevArrow.addClass($currentSlide.data("color"));
        slick.$nextArrow.addClass($currentSlide.data("color"));
      })
      this.$slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var $slider = slick.$slider;
        var $currentSlide = $slider.find('.slick-current');
        var $nextSlide = $slider.find('.slideshow__slide[data-slick-index="' + nextSlide + '"]');

        slick.$prevArrow.removeClass('homepage--white homepage--light homepage--splash homepage--dark');
        slick.$prevArrow.addClass($nextSlide.data("color"));

        slick.$nextArrow.removeClass('homepage--white homepage--light homepage--splash homepage--dark');
        slick.$nextArrow.addClass($nextSlide.data("color"));
      });
      this.$slideshow.slick({
        autoplay: this.$slideshow.data('autoplay'),
        autoplaySpeed: this.$slideshow.data('speed'),
        adaptiveHeight: false,
        dots: false
      });
    },
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    }
  });
  return Slideshow;
})();

theme.Instagram = (function() {
  function Instagram(container) {
    var $container = this.$container = $(container);
    var id = $container.attr('data-section-id');
    var instafeedEl = this.instagram = $('#Instafeed-' + id);
    var instafeedId = this.instagram = 'Instafeed-' + id;

    var apiSuccess = 0;
    var imageLimit = instafeedEl.attr('data-count');

    var userFeed = new Instafeed({
      get: 'user',
      userId: 'self',
      target: instafeedId,
      accessToken: instafeedEl.attr('data-access-token'),
      sortBy: 'most-recent',
      resolution: 'standard_resolution',
      template: '<a href="{{link}}" target="_blank" style="background-image: url({{image}});" class="grid__item instagram--square '+instafeedEl.attr('data-grid')+'"><span class="icon icon-instagram"></span></a>',
      limit: 24,
      filter: function(image) {
          if (image.id && apiSuccess < imageLimit) {
              apiSuccess = apiSuccess + 1;
              return true;
          }
          return false;
      }
    });
    if( !_.isUndefined( userFeed.options.accessToken) ){
      userFeed.run();
    }
  }

  Instagram.prototype = _.assignIn({}, Instagram.prototype, {});

  return Instagram;
})();

theme.Password = (function() {
  function Password(container) {
    const $container = this.$container = $(container);
    const passwordMd5 = $container.data(`password`);
    const $hiddenSection = $(`.main-content`);

    this.$container.find(`[data-password-submit]`).click(function(evt){
      evt.preventDefault();
      const inputMd5 = $.md5( this.$container.find(`[name="password"]`).val() );
      if( passwordMd5 === inputMd5 ) {
        this.$container.hide();
        $hiddenSection.show();
        $hiddenSection.find('.slick-slider').slick('setPosition');
        $("html, body").animate({ scrollTop: 0 }, 200);
      } else {
        this.$container.find(`[data-password-error]`).slideDown();
      }
    }.bind(this));

  }
  Password.prototype = _.assignIn({}, Password.prototype, {});

  return Password;
})();

theme.Product = (function() {
  function Product(container) {
    this.container = container;
    const $container = this.$container = $(container);
    const sectionId = this.sectionId = $container.attr('data-section-id');
    let enableHistoryState = $container.attr('data-enable-history-state');

    if( enableHistoryState == undefined ) {
      enableHistoryState = false;
    } else {
      enableHistoryState = ( enableHistoryState == 'true' );
    }

    this.settings = {
      sectionId: sectionId,
      enableHistoryState: enableHistoryState,
      namespace: '.product-single'
    }

    this.selectors = {
      productSection: '#ProductSection-'+sectionId,
      productImage: '.ProductImg-'+sectionId,
      productPhoto: '#ProductPhoto-'+sectionId,
      productThumbs: '#ProductThumbs-'+sectionId,

      originalSelectorId: '#ProductSelect-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      singleSwatchSelector: '.swatch-wrapper-' + sectionId,
      quantityInput:    '#Quantity-'+sectionId+' .QuantityInput',
      variantDropdown: '#ProductSelect-'+sectionId,

      productPrice: '[data-product-price]',
      comparePrice: '[data-product-compare-at-price]',
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',

      packUnitPriceFull: '.selected [pack-unit-price-full]',
      packUnitPriceDiscounted: '.selected [pack-unit-price-discounted]',
      packQuantity: '.selected[pack-size]',
      packDiscountMultiplier: '.selected[pack-discount-multiplier]'
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if ( !$container.find('[data-product-json]').html() ) {
      return;
    }

    this.productSingleObject = JSON.parse( $container.find('[data-product-json]').html() );
    this.zoomEnable = $container.data('image-zoom-enable');

    this.initAdd();
    this.stringOverrides();
    this.initProductVariant();
    this.initProductSwatches();
    this.initVariantConstraints();
    this.quantitySelectors();
    this.initSlider();
    this.initSliderDup();
    this.productVideo();
    this.productReviews();
    this.productTiles();
    this.stickyAddToCart();
    this.productAddon();
    this.initUpsellBundle()

    var currentScope = this;
    $(window).resize(function() {
      currentScope.productThumbnailCheck();
    }).resize();

  }
  Product.prototype = _.assignIn({}, Product.prototype, {
    initAdd: function() {
      var $container = this.$container,
          $addToCartWrapper = $container.find('[data-add-to-cart-wrapper]'),
          $addToCartError = $container.find('[data-add-to-cart-error]');

      $container.find('[data-add-to-cart]').on('click', function(evt) {
        const $addToCartBtn = $(evt.target);
        const $productForm = $addToCartBtn.closest('form');
        const formSerialized = $productForm.serializeArray();
        if ( $productForm.find('[type="file"]').length ){
          return;
        }
        var formObject = {};
        $.map(formSerialized, function(val, i){
          formObject[val.name] = val.value;
        });

        if( $addToCartBtn.hasClass('disabled') || !$productForm.length ) {
          return;
        }

        evt.preventDefault();
        $addToCartWrapper.find('[data-add-to-cart]').addClass('loading')

        const addonVariants = this.getAddonVariants();
        if( addonVariants.length ) {
          // $addToCartWrapper.addClass(`loading`);

          let addItems = [],
              variantId = parseInt( $productForm.find(`[name="id"]`).val() ),
              quantity = parseInt( $container.find(`[name="quantity"]`).val() ) || 1;

          addItems.push({
            id: variantId,
            quantity: quantity
          });

          for( let i=0 ; i<addonVariants.length ; i++ ) {
            const addonVariant = addonVariants[i];
            addItems.push({
              id: addonVariant.id,
              quantity: addonVariant.quantity
            });
          }

          addItems.reverse();
          console.log('Drawer Cart add.js - 3');
          // /cart/add.js with items[] is ATOMIC: if ANY line fails (sold-out
          // addon, stale configured variant id, inventory race) nothing is added
          // — not even the main product. This used to be .always(), which ran
          // addSuccess() on failure too: the drawer opened / the page redirected
          // to /cart and the shopper was told the add worked while the cart was
          // unchanged. Split into .done()/.fail() so a rejection surfaces
          // Shopify's own description, mirroring the collector in
          // sections/standalone-product.liquid.
          //
          // dataType:'json' is LOAD-BEARING, not tidiness. `$.post(url, data)`
          // declares no dataType, so jQuery guesses from the response
          // Content-Type; /cart/add.js answers text/javascript, jQuery
          // globalEval()s the JSON body and throws
          // "SyntaxError: Unexpected token ':'". A 200 with both lines already
          // in the cart was therefore routed to .fail() as a "parsererror":
          // the shopper saw "An error occurred. Please try again." over a cart
          // that had worked, addSuccess() never ran (no drawer, no redirect),
          // and the .done() below — which carries the A/B instrumentation —
          // was unreachable. Matches ajaxAddItem() below and
          // sections/standalone-product.liquid:1550, both of which set it.
          $.ajax({
            type: 'POST',
            url: `${window.Shopify.routes.root}cart/add.js`,
            dataType: 'json',
            data: { items: addItems }
          }).done(function(){
            $container.find(`[data-addon-item-radio][value="No"]`).prop('checked', true);

            // A/B instrumentation. Fires ONLY here: inside .done() of the
            // multi-item (bundle) add, so it counts successful bundle adds and
            // never a plain ATC click, a failed add, or the single-product
            // branch below. The "Bundle below" pair layout must push this SAME
            // event name so both arms are directly comparable. No properties —
            // Intelligems segments by assigned variant already (house
            // convention, see line 3058).
            window.igEvents = window.igEvents || [];
            window.igEvents.push({"event": "PDP - Bundle Added"});

            addSuccess();
          }).fail(function(xhr, status){
            // Radios are deliberately NOT reset here so the shopper can retry
            // with the same selection. addError() clears the loading state.
            console.error('[Cart] Multi-item add.js failed', xhr && xhr.status, xhr && xhr.responseJSON);
            addError(xhr, status);
          });

        } else {
          ajaxAddItem(formObject);
        }
      }.bind(this));
      
      var ajaxAddItem = function(data) {
        console.log('Drawer Cart add.js - 4');
        $.ajax({
          type: 'POST',
          url: `${window.Shopify.routes.root}cart/add.js`,
          dataType: 'json',
          data: data,
          error: addError,
          success: addSuccess,
          complete: updateHeaderTotal
        });
      }

      var updateHeaderTotal = function() {
        $.getJSON(`${window.Shopify.routes.root}cart.js`)
         .done(function(cart) {
          $('.cartCount').html(cart.item_count).removeClass('hidden-count');
        });
      }

      var addError = function(object, status) {
        console.log('object', object);
        $addToCartWrapper.find('[data-add-to-cart]').removeClass('loading')
        var ct = (object.getResponseHeader && object.getResponseHeader('Content-Type')) || '';
        //if (ct.indexOf('text/html') !== -1 || (object.status === 403 && !object.responseJSON)) {
        //const ct = (object.headers.get('content-type') || '');
        //if (ct.indexOf('application/json') === -1 && 1>2) {
        if (ct.includes('text/html') || (object.status === 429) || (object.status === 403)) {
          console.error('[Cart] Cloudflare challenge detected on cart/add.js (got HTML instead of JSON). Reloading page for verification.');
          $addToCartError.html('Please verify your connection. Reloading page…').removeClass('hide');
          setTimeout(function(){ window.location.reload(); }, 2000);
          throw new Error('CF_BLOCK');
          return;
        }
        var msg = (object.responseJSON && object.responseJSON.description) || 'An error occurred. Please try again.';
        $addToCartError.html(msg).removeClass('hide');
      }

      var addSuccess = function(product){
        // $addToCartWrapper.removeClass('loading');
        $addToCartWrapper.find('[data-add-to-cart]').removeClass('loading')
        $addToCartError.html('').removeClass('hide');

        // Check return_to FIRST — landing pages with btn_action="checkout"
        // set a hidden return_to="/checkout/" input that must take priority
        // over the cart drawer, otherwise the checkout redirect is swallowed.
        var $returnTo = $container.find('[name="return_to"]');
        if( $returnTo.length ) {
          setTimeout(() => window.location = $returnTo.attr('value'), 60);
        } else if( document.querySelector('cart-drawer[data-drawer="on"]') !== null ) {
          document.querySelector('cart-main').refresh()
          document.querySelector('cart-drawer').open()
        } else {
          setTimeout(() => window.location.href = '/cart', 60);
        }
      }
    },
    initProductVariant: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      }
      this.variants = new slate.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this.updateAllVariants.bind(this));
      this.$container.on('variantChange' + this.settings.namespace, this.renderConstraints.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this.updateImages.bind(this));
      this.$container.on('updateSlider' + this.settings.namespace, this.updateSlider.bind(this));
      this.updateAllVariants({variant: this.variants.currentVariant});
    },
    initProductSwatches: function(){
      var self = this,
          $container = this.$container,
          selectors = {
            wrapper: '[data-swatch-wrapper]',
            swatchList: '[data-swatch-list]',
            swatchItem: '[data-swatch-item]',
            swatchLink: '[data-swatch-link]',
            swatchValue: '[data-swatch-label-value]'

          },
          $singleOptionSelectors = $(this.selectors.singleOptionSelector);

      // Init swatch click handle. selectOption() sets just the clicked option
      // (no auto-switch). Crossed-out colours (variant-disabled — only ever
      // applied to the Colour axis) are inert: clicking does nothing.
      $(this.selectors.singleSwatchSelector).find( selectors.swatchLink ).click(function(e){
        e.preventDefault();

        if ($(this).closest('[data-swatch-item]').hasClass('variant-disabled')) {
          return;
        }

        var value = $(this).attr('data-value'),
            index = $(this).closest( selectors.wrapper ).data('index');

        self.selectOption(index, value);
      });

      let $colorSwatchWrapper = $(selectors.wrapper).filter('[data-option-name="Color"]');
      if( $colorSwatchWrapper.length ) {
        // $colorSwatchWrapper.find( selectors.swatchItem ).filter('.active').removeClass('active').find(' > a').click();
        // if( $colorSwatchWrapper.find('.active').length ) {
        //   $colorSwatchWrapper.find('.active').closest('[data-swatch]').find( selectors.swatchValue ).removeClass('hide');
        // }
        $colorSwatchWrapper.find('[data-swatch]').each(function(){
          let $swatch = $(this);
          if( $swatch.find('[data-swatch-item]:not(.sold-out)').length == 0 ) {
            $swatch.hide();
          }
        });
      }
    },

    /* ──────────────────────────────────────────────────────────────────────
       Dynamic linked-option constraints (multi-option products)

       A variant is "buyable" when it exists, is in stock, and is allowed in
       the visitor's country. For products with 2+ options we keep the
       selection on a buyable variant and, for every option value, either:
         - show it enabled (buyable with the current other-axis selection),
         - show it greyed/disabled (buyable under some other selection, not
           the current one), or
         - hide it (not buyable in any combination).
       Single-option products are left to the existing Liquid `.sold-out`
       behavior (this code no-ops for them).
       ────────────────────────────────────────────────────────────────────── */
    _optionCount: function() {
      return (this.productSingleObject.options || []).length;
    },
    _variantMetaMap: function() {
      if (!this._cachedVariantMeta) {
        var raw = this.$container.find('[data-variants-json]').html();
        try { this._cachedVariantMeta = raw ? JSON.parse(raw) : {}; }
        catch (e) { this._cachedVariantMeta = {}; }
      }
      return this._cachedVariantMeta;
    },
    _isBuyable: function(variant) {
      if (!variant || !variant.available) return false;
      var meta = this._variantMetaMap()[variant.id];
      var country = (window.Shopify && Shopify.country) || 'US';
      if (meta && meta.available_us_only && country !== 'US') return false;
      return true;
    },
    _buyableVariants: function() {
      var self = this;
      return (this.productSingleObject.variants || []).filter(function(v){ return self._isBuyable(v); });
    },
    _currentSelection: function() {
      var sel = {};
      this.$container.find(this.selectors.singleOptionSelector).each(function(){
        sel[$(this).data('index')] = String($(this).val());
      });
      return sel;
    },
    _otherOptionsMatch: function(variant, selection, exceptKey) {
      return Object.keys(selection).every(function(k){
        if (k === exceptKey) return true;
        return String(variant[k]) === String(selection[k]);
      });
    },
    // 'enabled' | 'disabled' | 'hidden' for a single option value
    _valueStatus: function(optionKey, value, selection, buyable) {
      var existsAnywhere = false;
      for (var i = 0; i < buyable.length; i++) {
        var v = buyable[i];
        if (String(v[optionKey]) !== String(value)) continue;
        existsAnywhere = true;
        if (this._otherOptionsMatch(v, selection, optionKey)) return 'enabled';
      }
      return existsAnywhere ? 'disabled' : 'hidden';
    },
    // Called when a swatch is clicked. Sets just that one option — no
    // auto-switch of the other axes, so the customer's selection stays put.
    // Updates the clicked wrapper's active state + label, then fires one change
    // so slate.Variants recomputes price/image/master-select. If the resulting
    // combo isn't available, updateAllVariants shows SOLD OUT / Unavailable.
    selectOption: function(optionKey, value) {
      var $w = this.$container.find('[data-swatch-wrapper][data-index="' + optionKey + '"]');
      var $active = null;
      $w.find('[data-swatch-item]').removeClass('active').attr('aria-selected', 'false');
      $w.find('[data-swatch-item]').each(function(){
        var v = $(this).find('[data-swatch-link]').first().attr('data-value');
        if (String(v) === String(value)) { $(this).addClass('active').attr('aria-selected', 'true'); $active = $(this); }
      });
      // Update the label only for the active item's [data-swatch] group.
      // Limited-edition Color wrappers (MLB/Donut) render TWO groups, each with
      // its own [data-swatch-label-value] (the LE one starts .hide): clear+hide
      // all, then reveal only the active group's label.
      $w.find('[data-swatch-label-value]').html('').addClass('hide');
      var $group = $active ? $active.closest('[data-swatch]') : $w;
      $group.find('[data-swatch-label-value]').html(value).removeClass('hide');

      this.$container.find(this.selectors.singleOptionSelector)
        .filter('[data-index="' + optionKey + '"]').val(value).trigger('change');
    },
    // Hide variant cards whose variant isn't buyable (plan-picker UI).
    _renderCardConstraints: function(buyable) {
      var ids = {};
      buyable.forEach(function(v){ ids[v.id] = true; });
      this.$container.find('[data-variant-card]').each(function(){
        var vid = parseInt($(this).attr('data-variant-id'), 10);
        $(this).toggleClass('variant-card-hidden', !ids[vid]);
      });
    },
    // If the selected card isn't buyable, select the first buyable card.
    _ensureBuyableCard: function(buyable) {
      var ids = {};
      buyable.forEach(function(v){ ids[v.id] = true; });
      var $radios = this.$container.find('[data-variant-card-radio]');
      if (!$radios.length) return;
      var $checked = $radios.filter(':checked');
      var checkedId = $checked.length ? parseInt($checked.val(), 10) : null;
      if (checkedId && ids[checkedId]) return;
      var $firstBuyable = $radios.filter(function(){ return ids[parseInt($(this).val(), 10)]; }).first();
      if ($firstBuyable.length) {
        // The variant-cards snippet listens via native addEventListener('change'),
        // which jQuery's .trigger('change') does not fire — dispatch a native event.
        var radio = $firstBuyable[0];
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    },
    // Reflect buyability on every swatch + <option> + variant card.
    renderConstraints: function() {
      var self = this;
      var buyable = this._buyableVariants();

      // Fully sold out (any product): hide all variant pickers. The SOLD OUT
      // CTA from updateAllVariants is all that remains.
      if (!buyable.length) {
        this.$container.addClass('variant--no-stock');
        return;
      }
      this.$container.removeClass('variant--no-stock');

      // Variant-card selector (plan picker, any option count).
      if (this.$container.find('[data-variant-card]').length) {
        this._renderCardConstraints(buyable);
      }

      // Standard swatches/selects: per-value constraints only matter for 2+ options.
      if (this._optionCount() < 2) return;

      var selection = this._currentSelection();

      this.$container.find('[data-swatch-wrapper]').each(function(){
        var $w = $(this);
        var optionKey = $w.data('index');
        // Only the Colour axis gets the crossed-out "disabled" state. Non-colour
        // axes (size/length/type) stay enabled as long as they have a path to a
        // buyable variant — they're only ever hidden when fully sold out.
        var isColor = /Color/i.test($w.attr('data-option-name') || '');
        $w.find('[data-swatch-item]').each(function(){
          var $item = $(this);
          var value = $item.find('[data-swatch-link]').first().attr('data-value');
          if (value == null) return;
          var status = self._valueStatus(optionKey, value, selection, buyable);
          $item.removeClass('variant-hidden variant-disabled');
          var crossed = false;
          if (status === 'hidden') {
            $item.addClass('variant-hidden');
          } else if (status === 'disabled' && isColor) {
            $item.addClass('variant-disabled');
            crossed = true;
          }
          $item.attr('aria-disabled', crossed ? 'true' : 'false');
        });
      });

      // Hide any swatch group whose items all ended up hidden — e.g. a
      // "Limited Edition:" group whose only colours are sold out / unavailable
      // (or country-blocked). Otherwise the group label renders orphaned with
      // no swatches beneath it. Only groups that had rendered items to begin
      // with are considered, so empty-by-design groups are untouched.
      this.$container.find('[data-swatch]').each(function(){
        var $group = $(this);
        var $items = $group.find('[data-swatch-item]');
        if (!$items.length) return;
        var anyVisible = $items.filter(function(){ return !$(this).hasClass('variant-hidden'); }).length > 0;
        $group.get(0).style.display = anyVisible ? '' : 'none';
      });

      // Mirror onto the (usually hidden) dropdowns for a11y / no-swatch templates.
      this.$container.find(this.selectors.singleOptionSelector).each(function(){
        var optionKey = $(this).data('index');
        $(this).find('option').each(function(){
          var status = self._valueStatus(optionKey, String($(this).val()), selection, buyable);
          $(this).prop('disabled', status === 'hidden');
        });
      });
    },
    // On load: paint constraints. We do NOT auto-switch a deep-linked/rendered
    // unavailable variant — the selection stays and the CTA shows SOLD OUT /
    // Unavailable (consistent with the click behaviour). Variant cards keep
    // their own first-buyable default (separate single-option plan picker).
    initVariantConstraints: function() {
      var buyable = this._buyableVariants();
      if (buyable.length && this.$container.find('[data-variant-card]').length) {
        this._ensureBuyableCard(buyable);
      }
      this.renderConstraints();
    },
    updateAllVariants: function(evt) {
      const variant = evt.variant;
      const moneyFormat = theme.moneyFormat;

      // No matching Shopify variant for the selected option combination
      // (e.g., 10ft + Pink when only 10ft + Black exists). Treat the same
      // as sold out and bail out before reading variant fields.
      if (!variant) {
        this.$container.find(this.selectors.addToCart).addClass('disabled').prop('disabled', true);
        this.$container.find(this.selectors.addToCartText).html(theme.strings.soldOut);
        this.$container.removeClass( "variant--unavailabe" ).addClass( "variant--soldout" );

        // No purchasable variant for this option combo. Fade just the price
        // line (price + compare-at) to transparent so we don't show a stale
        // price for a combination the customer can't buy, while keeping the
        // discount box below visible. Using opacity (not display:none) keeps
        // the line's box, so there's no layout shift. The price text is set to
        // "Unavailable" underneath as an accessible fallback. The valid-variant
        // path below repaints the price and restores opacity when a real
        // variant is selected.
        this.$container.find(this.selectors.productPrice).find('.money').html(theme.strings.unavailable);
        this.$container.find(this.selectors.productPrice).closest('.product__price').css('opacity', 0);
        return;
      }

      const quantity = parseInt( this.$container.find(`[name="quantity"]`).val() ) || 1;

      let variantPrice = variant.price;
      let variantCompareAtPrice = variant.compare_at_price || variantPrice;

      let bundlePrice = variantPrice;
      let bundleCompareAtPrice = variantCompareAtPrice;
      const addonVariants = this.getAddonVariants();
      for( let i=0 ; i<addonVariants.length ; i++ ) {
        const addonVariant = addonVariants[i];
        bundlePrice += (addonVariant.price * addonVariant.quantity);
        bundleCompareAtPrice += (addonVariant.compareAtPrice * addonVariant.quantity);
      }
      if( addonVariants.length ) {
        // apply bundle discount
        const addonDiscount = this.getAddonDiscount() || 1;
        bundlePrice *= addonDiscount;

        this.$container.find(`[data-bundle-price]`).attr('data-value', bundlePrice).find('money').html( slate.Currency.formatMoney(bundlePrice, moneyFormat) );
        this.$container.find(`[data-bundle-compare-at-price]`).attr('data-value', bundleCompareAtPrice);

        // Also update and show the product's compare price if necessary
        if (bundleCompareAtPrice > bundlePrice) {
          this.$container.find(`[data-bundle-compare-at-price]`).find('money').html( slate.Currency.formatMoney(bundleCompareAtPrice, moneyFormat) );
          this.$container.find(`[data-bundle-compare-at-price]`).closest('.compare-at').show();
          this.$container.find(`[data-bundle-price]`).closest('.addon-item__price').addClass('on-sale');
        } else {
          this.$container.find(`[data-bundle-compare-at-price]`).closest('.compare-at').hide();
          this.$container.find(`[data-bundle-price]`).closest('.addon-item__price').removeClass('on-sale');
        }
      }

      /*
      const addonVariants = this.getAddonVariants();
      for( let i=0 ; i<addonVariants.length ; i++ ) {
        const addonVariant = addonVariants[i];
        variantPrice += (addonVariant.price * addonVariant.quantity);
        variantCompareAtPrice += (addonVariant.compareAtPrice * addonVariant.quantity);
      }

      if( addonVariants.length ) {
        // apply bundle discount
        const addonDiscount = this.getAddonDiscount() || 1;
        variantPrice *= addonDiscount;
      }
      */

      if (variant) {

        // Restore the price line's visibility (the null branch above fades it
        // to transparent for option combos that have no matching variant).
        this.$container.find(this.selectors.productPrice).closest('.product__price').css('opacity', '');

        this.variantMetafields = JSON.parse( this.$container.find('[data-variants-json]').html() );
        let variantAvailableOnlyInTheUS = false;
        if (this.variantMetafields != undefined && this.variantMetafields !='') {
          let selectedVariantId = variant.id;
          variantAvailableOnlyInTheUS = this.variantMetafields[selectedVariantId]["available_us_only"];
        }
        console.log('variantAvailableOnlyInTheUS: ', variantAvailableOnlyInTheUS);

        //Decide if variant should be available
        let variantAvailable = variant.available;

        if (variantAvailable && Shopify.country != "US" && variantAvailableOnlyInTheUS) {
          variantAvailable = false;
        }
        console.log('variantAvailable: ', variantAvailable);


        // --- Per-variant badge ---
        (function updateBadge(container, variantMetafields, variant) {
          var $badgeEl = container.find('[data-product-badge]');
          var badgeText = '';

          if (variantMetafields != undefined && variantMetafields != '') {
            badgeText = variantMetafields[variant.id] && variantMetafields[variant.id]["badge"] || '';

            // Fallback to product-level badge if variant has no badge
            if (!badgeText) {
              if (Shopify.country !== 'US' && variantMetafields["_product_badge_non_us"]) {
                badgeText = variantMetafields["_product_badge_non_us"];
              } else {
                badgeText = variantMetafields["_product_badge"] || '';
              }
            }
          }

          /* start HK O15 special discount */
          /* 
          if ((variant.sku == "RBO715-25E-BLA" || variant.sku == "RBO715-25E-BLU" || variant.sku == "RBO715-25E-MIN" || variant.sku == "RBO715-25E-PUR") && Shopify.country == "HK") {
            badgeText = '50% OFF';
          }
           */
          /* end HK O15 special discount */

          /* start HK B42 special discount */
          /* 
          if ((variant.sku.startsWith('RBB842-24E') && Shopify.country == "HK")) {
            badgeText = '30% OFF';
          }
           */
          /* end HK B42 special discount */

          /* start HK E25 special discount */
          /* 
          if ((variant.sku.startsWith('RBE725-21E') && Shopify.country == "HK")) {
            badgeText = '50% OFF';
          }
           */
          /* end HK E25 special discount */

          if (badgeText) {
            if ($badgeEl.length) {
              $badgeEl.html(badgeText).removeClass('badge--sold').addClass('badge--sale').show();
            } else {
              var $slidesWrap = container.find('.product__slides-wrap');
              if ($slidesWrap.length) {
                $slidesWrap.prepend('<div class="badge badge--sale" data-product-badge>' + badgeText + '</div>');
              }
            }
          } else if (!variant.available) {
            if ($badgeEl.length) {
              $badgeEl.html(theme.strings.soldOut).removeClass('badge--sale').addClass('badge--sold').show();
            }
          } else if (variant.compare_at_price > variant.price) {
            // On sale — preserve existing sale badge
            if ($badgeEl.length) { $badgeEl.show(); }
          } else {
            if ($badgeEl.length) { $badgeEl.hide(); }
          }
        })(this.$container, this.variantMetafields, variant);

        // Check if variant is a pre-order (available, continues selling, but out of stock).
        // Gift cards are excluded: Shopify ships them as continue-selling with a
        // permanently negative inventory count, so the inventory test alone reads every
        // denomination as a pre-order. Mirrors the same guard in product-form.liquid.
        var isPreOrder = false;
        var preOrderMessage = '';
        if (variantAvailable && this.variantMetafields && this.variantMetafields[variant.id]) {
          var vmeta = this.variantMetafields[variant.id];
          if (!this.variantMetafields._gift_card && vmeta.inventory_policy === 'continue' && vmeta.inventory_quantity <= 0) {
            isPreOrder = true;
            preOrderMessage = vmeta.preorder_message || '';
          }
        }

        // Select a valid variant if available
        if (variantAvailable) {
          console.log('evt: ', evt)
          // Available, enable the submit button, change text, show quantity elements
          this.$container.find(this.selectors.addToCart).removeClass('disabled').prop('disabled', false);
          this.$container.find(this.selectors.addToCartText).html(isPreOrder ? theme.strings.preOrder : theme.strings.addToCart);
          this.$container.removeClass( "variant--soldout variant--unavailabe" );
        } else {
          // Sold out, disable the submit button, change text, hide quantity elements
          this.$container.find(this.selectors.addToCart).addClass('disabled').prop('disabled', true);
          this.$container.find(this.selectors.addToCartText).html(theme.strings.soldOut);
          this.$container.removeClass( "variant--unavailabe" ).addClass( "variant--soldout" );
        }

        // Keep the pre-order note under the button in step with the button itself.
        // Empty copy hides the row entirely, so a variant the merchant has not written
        // a message for still gets the label change and simply shows no second line.
        var $preOrderNote = this.$container.find('[data-preorder-note]');
        if ($preOrderNote.length) {
          if (variantAvailable && isPreOrder && preOrderMessage) {
            $preOrderNote.text(preOrderMessage).removeAttr('hidden');
          } else {
            $preOrderNote.text('').attr('hidden', 'hidden');
          }
        }

        if( this.container.querySelector('[data-product-promotion]') !== null ) {
          const promotion = JSON.parse( this.container.querySelector('[data-product-promotion]').innerHTML );
          var discountPercentage = parseFloat( promotion.promotion_amount.replace('%', '') );

          if (Shopify.country != "US" && promotion?.promotion_amount_rest_of_world) {
            discountPercentage = parseFloat( promotion.promotion_amount_rest_of_world.replace('%', '') );
          }

          var totalDiscount = variantPrice * discountPercentage / 100;
          /* start HK O15 special discount */
          /*
          if ((variant.sku == "RBO715-25E-BLA" || variant.sku == "RBO715-25E-BLU" || variant.sku == "RBO715-25E-MIN" || variant.sku == "RBO715-25E-PUR") && Shopify.country == "HK") {
            totalDiscount = 34900;
          }
          */
          /* end HK O15 special discount */

          /* start HK B42 special discount */
          /*
          if ((variant.sku.startsWith('RBB842-24E') && Shopify.country == "HK")) {
            totalDiscount = 25200;
          }
          */
          /* end HK B42 special discount */

          /* start HK E25 special discount */
          /*
          if ((variant.sku.startsWith('RBE725-21E') && Shopify.country == "HK")) {
            totalDiscount = variantPrice / 2;
          }
          */
          /* end HK E25 special discount */

          let showVariantDiscount = true;
          /*
          if (variant.sku == "RBE725-21E-AST" || variant.sku == "RBE725-21E-CUB" || variant.sku == "RBE725-21E-DOD" || variant.sku == "RBE725-21E-PHI" || variant.sku == "RBE725-21E-RSX" || variant.sku == "RBE725-21E-YAN") {
            showVariantDiscount = false;
          }
          */
          if (showVariantDiscount) {
            variantPrice -= totalDiscount;
            //console.log('variantPrice: ', variantPrice);
            //ceil for shopify penny roundup when there's sub-penny decimal
            variantPrice = Math.ceil(variantPrice);
          }
        }

        // Regardless of stock, update the product price
        // remove quantity multiplier
        //this.$container.find(this.selectors.productPrice).find('.money').html( slate.Currency.formatMoney(variantPrice*quantity, moneyFormat) );
        this.$container.find(this.selectors.productPrice).find('.money').html( slate.Currency.formatMoney(variantPrice, moneyFormat) );
        this.$container.find(this.selectors.comparePrice).attr('data-value', variantCompareAtPrice);
        this.$container.find(this.selectors.productPrice).attr('data-value', variantPrice);

        // Also update and show the product's compare price if necessary
        if (variantCompareAtPrice > variantPrice) {
          // remove quantity multiplier
          //this.$container.find(this.selectors.comparePrice).find('.money').html( slate.Currency.formatMoney(variantCompareAtPrice*quantity, moneyFormat) );
          this.$container.find(this.selectors.comparePrice).find('.money').html( slate.Currency.formatMoney(variantCompareAtPrice, moneyFormat) );
          this.$container.find(this.selectors.comparePrice).closest('.compare-at').show();
          this.$container.find(this.selectors.productPrice).closest('.product__price').addClass('on-sale');
          this.$container.find('.promo-container').removeClass('hide');
        } else {
          this.$container.find(this.selectors.comparePrice).closest('.compare-at').hide();
          this.$container.find(this.selectors.productPrice).closest('.product__price').removeClass('on-sale');
          this.$container.find('.promo-container').addClass('hide');
        }

        // Update pack's displayed prices if applicable
        try {
          if (this.selectors.packQuantity && this.selectors.packDiscountMultiplier) {
            let packSize = parseFloat(this.$container.find(this.selectors.packQuantity).attr('pack-size'));
            let discountMultiplier = parseFloat(this.$container.find(this.selectors.packQuantity).attr('pack-discount-multiplier'));
            this.$container.find(this.selectors.packUnitPriceFull).html( slate.Currency.formatMoney(variantCompareAtPrice/packSize, moneyFormat) );
            //this.$container.find(this.selectors.packUnitPriceDiscounted).html( slate.Currency.formatMoney(variantPrice/packSize*discountMultiplier, moneyFormat) );
            this.$container.find(this.selectors.packUnitPriceDiscounted).html( slate.Currency.formatMoney(variantPrice/packSize, moneyFormat) );
          }
        } catch (e) {
          //console.log(e);
        }

        this.container.querySelectorAll('[pack-selector-item]').forEach( packSelector => {
          const discountMultiplier = parseFloat( packSelector.getAttribute('data-discount-multiplier') );
          const quantity = parseInt( packSelector.getAttribute('data-quantity') );
          // remove quantity multiplier
          // const savings = (variantPrice - ( variantPrice * discountMultiplier )) * quantity;
          const savings = (variantPrice - ( variantPrice * discountMultiplier ));

          /*
          console.log({
            'variantPrice': variantPrice,
            'discountMultiplier': discountMultiplier,
            'quantity': quantity,
            'savings': savings,
          });
          */

          if( packSelector.querySelector(`[pack-selector-compare-at-price]`) !== null ) {
            // remove quantity multiplier
            //packSelector.querySelector(`[pack-selector-compare-at-price]`).innerHTML = slate.Currency.formatMoney( (variantPrice * quantity), moneyFormat);
            packSelector.querySelector(`[pack-selector-compare-at-price]`).innerHTML = slate.Currency.formatMoney( (variantPrice), moneyFormat);
          }
          if( packSelector.querySelector(`[pack-selector-price]`) !== null ) {
            // remove quantity multiplier
            //packSelector.querySelector(`[pack-selector-price]`).innerHTML = slate.Currency.formatMoney( (variantPrice * discountMultiplier * quantity), moneyFormat);
            packSelector.querySelector(`[pack-selector-price]`).innerHTML = slate.Currency.formatMoney( (variantPrice * discountMultiplier), moneyFormat);
          }
          if( packSelector.querySelector(`[pack-selector-savings]`) !== null ) {
            packSelector.querySelector(`[pack-selector-savings]`).innerHTML = slate.Currency.formatMoney(savings, moneyFormat);
          }
          if( packSelector.querySelector(`[pack-selector-unit-price]`) !== null ) {
            packSelector.querySelector(`[pack-selector-unit-price]`).innerHTML = slate.Currency.formatMoney(variantPrice * discountMultiplier, moneyFormat);
          }
        });

        if( variant.featured_image !== null ) {
          const variantImageUrl = variant.featured_image.src.replace('.png', '_160x.png').replace('.jpg', '_160x.jpg')
          //this.$container.find(`[data-product-featured-image]`).removeAttr('data-bgset').css('background-image', `url(${variantImageUrl})`)

          var color = variant.option1,
              mediaId = variant.featured_image.id;

          this.$container.trigger({
            type: 'updateSlider',
            values: [variant.public_title, color, 'All'],
            mediaId: mediaId
          });
        }

        // update variant id attribute for upsell bundle
        if( this.$container.find(`bundle-form [upsell-bundle-checkbox="main"]`).length ) {
          this.$container.find(`bundle-form [upsell-bundle-checkbox="main"]`).closest(`bundle-item`).attr('data-variant-id', variant.id)
        }

        // ── Update upsell-cards prices on variant change ──
        // variantPrice / variantCompareAtPrice are the EFFECTIVE (post sitewide
        // discount) prices computed above, not variant.price.
        this.updateUpsellCards(variantPrice, variantCompareAtPrice, moneyFormat);

      }
    },
    // Repaint the upsell-cards prices. Multi-card layout: one standalone card +
    // N bundle cards. Each bundle card has its own per-card
    // data-main-product-discount / data-bundle-product-discount attributes and
    // its own addon block (matched via data-bundle-key).
    // Extracted from updateAllVariants() so the [data-addon-item-variant-select]
    // change handler can trigger the same repaint without duplicating the bundle
    // math. Mirrored by the inline copy in sections/standalone-product.liquid —
    // keep the two in sync.
    updateUpsellCards: function(variantPrice, variantCompareAtPrice, moneyFormat) {
      // Remember the effective main-product prices so an addon <select> change
      // can repaint the cards later without re-deriving them.
      this._upsellCardsVariantPrice = variantPrice;
      this._upsellCardsVariantCompareAtPrice = variantCompareAtPrice;

      var $cards = this.$container.find('[data-upsell-cards]');
      if (!$cards.length) return;

      // ── Standalone card (always present, single instance) ──
      var standalonePrice   = variantPrice;
      var standaloneCompare = variantCompareAtPrice;
      var $standPriceEl     = $cards.find('[data-upsell-card-standalone-price]');
      var $standCompareEl   = $cards.find('[data-upsell-card-standalone-compare]');

      $standPriceEl.attr('data-value', standalonePrice)
        .find('.money').html(slate.Currency.formatMoney(standalonePrice, moneyFormat));
      if (standaloneCompare > standalonePrice) {
        $standCompareEl.attr('data-value', standaloneCompare)
          .find('.money').html(slate.Currency.formatMoney(standaloneCompare, moneyFormat))
          .end().show();
      } else {
        $standCompareEl.hide();
      }

      // ── Bundle cards (N per qualifying config entry) ──
      $cards.find('[data-upsell-card^="bundle-"]').each(function() {
        var $card     = $(this);
        var bundleKey = $card.attr('data-upsell-card');
        var $addon    = $cards.find('[data-addon-item][data-bundle-key="' + bundleKey + '"]');

        var addonPrice   = parseInt($addon.attr('data-variant-price')) || 0;
        var addonCompare = parseInt($addon.attr('data-variant-compare-at-price')) || addonPrice;

        var mainDisc   = parseFloat($card.attr('data-main-product-discount')) || 0;
        var upsellDisc = parseFloat($card.attr('data-bundle-product-discount')) || 0;

        var mainPriceForBundle = variantPrice;
        if (mainDisc > 0) {
          var mainBase = variantCompareAtPrice > 0 ? variantCompareAtPrice : variantPrice;
          mainPriceForBundle = Math.ceil(mainBase * (1 - mainDisc / 100));
        }
        if (upsellDisc > 0) {
          var addonBase = addonCompare > 0 ? addonCompare : addonPrice;
          addonPrice = Math.ceil(addonBase * (1 - upsellDisc / 100));
        }

        var bundlePrice   = mainPriceForBundle + addonPrice;
        var bundleCompare = (variantCompareAtPrice || variantPrice) + addonCompare;

        var $bundlePriceEl   = $card.find('[data-upsell-card-bundle-price]');
        var $bundleCompareEl = $card.find('[data-upsell-card-bundle-compare]');

        $bundlePriceEl.attr('data-value', bundlePrice)
          .find('.money').html(slate.Currency.formatMoney(bundlePrice, moneyFormat));
        if (bundleCompare > bundlePrice) {
          $bundleCompareEl.attr('data-value', bundleCompare)
            .find('.money').html(slate.Currency.formatMoney(bundleCompare, moneyFormat))
            .end().show();
        } else {
          $bundleCompareEl.hide();
        }
      });
    },
    updateImages: function(evt) {
      /*
      var variant = evt.variant;
      var mediaId = variant.featured_image.id

      if (variant) {

        // Update variant image, if one is set
        if (variant.featured_image) {
          var newImg = $(this.selectors.productImage+'[data-media-id="'+ variant.featured_image.id +'"]');
          var newPosition = newImg.closest('.product__media').attr('data-slick-index');

          // Slider not loaded
          if (newPosition === undefined) {
            ;
          }else {
            this.$container.find(this.selectors.productPhoto).slick('slickGoTo', newPosition);
          }
        }
      }
      */
    },
    quantitySelectors: function() {
      // Change number inputs to JS ones, similar to ajax cart but without API integration.
      // Make sure to add the existing name and id to the new input element
      var numInputs = this.$container.find('input[type="number"]');

      if (numInputs.length) {
        numInputs.each(function() {
          var el = $(this),
              currentQty = el.val(),
              inputName = el.attr('name'),
              inputId = el.attr('id'),
              inputSubmit = el.data('submit');

          var itemAdd = currentQty + 1,
              itemMinus = currentQty - 1,
              itemQty = currentQty;

          var source   = $("#JsQty").html(),
              template = Handlebars.compile(source),
              data = {
                id: el.data('id'),
                itemQty: itemQty,
                itemAdd: itemAdd,
                itemMinus: itemMinus,
                inputName: inputName,
                inputId: inputId,
                submit: inputSubmit
              };

          // Append new quantity selector then remove original
          el.after(template(data)).remove();
        });

        // Setup listeners to add/subtract from the input
        this.$container.find('.js-qty__adjust').on('click', function(evt) {
          console.log(evt);

          var el = $(evt.target),
              id = el.data('id'),
              qtySelector = el.siblings('.js-qty__num'),
              qty = parseInt(qtySelector.val().replace(/\D/g, '')),
              submit = qtySelector.data('submit');

                // Make sure we have a valid integer
                if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
                  // We have a number!
                } else {
                  // Not a number. Default to 1.
                  qty = 1;
                }


          // Add or subtract from the current quantity
          if (el.hasClass('js-qty__adjust--plus')) {
            qty = qty + 1;
          } else {
            qty = qty - 1;
            if (qty <= 1) qty = 1;
          }

          // Update the input's number
          qtySelector.val(qty).trigger('change');
          if(submit){
            qtySelector.parents('form').submit();
          }

          // Update price
          const $price = this.$container.find(this.selectors.productPrice),
                $compareAtPrice = this.$container.find(this.selectors.comparePrice),
                price = parseInt( $price.attr(`data-value`) ),
                compareAtPrice = parseInt( $compareAtPrice.attr(`data-value`) );
          $price.find('.money').html( slate.Currency.formatMoney(price*qty, theme.moneyFormat) );
          $compareAtPrice.find('.money').html( slate.Currency.formatMoney(compareAtPrice*qty, theme.moneyFormat) );

        }.bind(this));
      }

      this.$container.find(`[data-quantity-select]`).change(function(evt) {
        const quantity = parseInt( $(evt.target).val() ) || 1
        this.$container.find(`[name="quantity"]`).val(quantity).change()

        // Update price
        const $price = this.$container.find(this.selectors.productPrice),
              $compareAtPrice = this.$container.find(this.selectors.comparePrice),
              price = parseInt( $price.attr(`data-value`) ),
              compareAtPrice = parseInt( $compareAtPrice.attr(`data-value`) );
        // remove quantity multiplier
        //$price.find('.money').html( slate.Currency.formatMoney(price*quantity, theme.moneyFormat) );
        //$compareAtPrice.find('.money').html( slate.Currency.formatMoney(compareAtPrice*quantity, theme.moneyFormat) );
        $price.find('.money').html( slate.Currency.formatMoney(price, theme.moneyFormat) );
        $compareAtPrice.find('.money').html( slate.Currency.formatMoney(compareAtPrice, theme.moneyFormat) );
      }.bind(this))
    },
    stringOverrides: function() {
      // Override defaults in theme.strings with membership overrides
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },
    initSlider: function() {
      if( this.$container.find(this.selectors.productPhoto).hasClass('slick-initialized') ) {
        return;
      }

      var swipeEnable = true;
      if ( this.zoomEnable && !Modernizr.touch ){ swipeEnable = false; }

      const $productHero = this.$container.find(`.product__hero`)
      $(this.selectors.productPhoto)
        .on('init', function(event, slick){
          var $slider = slick.$slider,
              $currentSlide = $slider.find('.slick-current');

          $slider.find('.slick-slide').click(function(e){
            $('.product__media').removeClass('active');
            if( $(window).width() <= 768 ) {
              return;
            }
            const $slide = $(this)
            $slide.addClass('active')
            $productHero.html( `<div class="product__media">${$slide.html()}</div>`)
          });

          $currentSlide.click();
        })
        .slick({
          slidesToShow: 5,
          slidesToScroll: 5,
          swipe: swipeEnable,
          speed: 200,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                appendDots: $(this.selectors.productThumbs),
                fade: false
              }
            }
          ],
          customPaging: function(slider, i) {
            var $slide = $(slider.$slides[i]),
                isVideo = ( $slide.hasClass('product__media--video') ) ? true : false,
                thumb = $slide.data('thumb'),
                mediaId = $slide.data('media-id');
            // Guard: no .liquid template currently sets data-thumb on .product__media,
            // so $slide.data('thumb') is undefined for every slide. Without a fallback the
            // generated markup becomes <img src="undefined"> and the browser resolves the
            // relative URL against the current page, producing GET /products/undefined → 404.
            // Fall back to the slide's inner image (data-src for lazy-loaded, then src).
            if( !thumb ) {
              var $innerImg = $slide.find('img').first();
              thumb = $innerImg.attr('data-src') || $innerImg.attr('src') || '';
            }
            if( !thumb ) {
              // No usable thumbnail URL — render an empty span so the slider still gets a paging element
              // but without the broken <img>. (Slick requires non-empty markup for each pagination item.)
              return '<span class="product__thumbs__empty" data-media-id="' + (mediaId || '') + '"></span>';
            }
            if( isVideo ) {
              return '<span class="product__thumbs__video" data-media-id="' + mediaId + '"><img src="' + thumb + '"><span class="btn btn--play"><span>&#9658;</span></span></span>';
            }
            return '<img src="' + thumb + '">';
          }
        })

      // $(this.selectors.productImage).imagesLoaded(function(){
      //   $(this.selectors.productPhoto).slick('setPosition')
      // }.bind(this))

      this.productThumbnailCheck();
    },
    initSliderDup: function() {
      if( this.$container.find(`${this.selectors.productPhoto}--dupslide`).hasClass('slick-initialized') ) {
        return;
      }

      var swipeEnable = true;
      if ( this.zoomEnable && !Modernizr.touch ){ swipeEnable = false; }


      const $productHero = this.$container.find(`.product__hero--dupslide`)
      $(`${this.selectors.productPhoto}--dupslide`)
        .on('init', function(event, slick){
          var $slider = slick.$slider,
              $currentSlide = $slider.find('.slick-current');

          $slider.find('.slick-slide').click(function(e){
            $('.product__media').removeClass('active');
            if( $(window).width() <= 768 ) {
              return;
            }
            const $slide = $(this)
            $slide.addClass('active')
            $productHero.html( `<div class="product__media">${$slide.html()}</div>`)
          });

          $currentSlide.click();
        })
        .slick({
          slidesToShow: 5,
          slidesToScroll: 5,
          swipe: swipeEnable,
          speed: 200,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                appendDots: $(this.selectors.productThumbs),
                fade: false
              }
            }
          ],
          customPaging: function(slider, i) {
            var $slide = $(slider.$slides[i]),
                isVideo = ( $slide.hasClass('product__media--video') ) ? true : false,
                thumb = $slide.data('thumb'),
                mediaId = $slide.data('media-id');
            // Guard: no .liquid template currently sets data-thumb on .product__media,
            // so $slide.data('thumb') is undefined for every slide. Without a fallback the
            // generated markup becomes <img src="undefined"> and the browser resolves the
            // relative URL against the current page, producing GET /products/undefined → 404.
            // Fall back to the slide's inner image (data-src for lazy-loaded, then src).
            if( !thumb ) {
              var $innerImg = $slide.find('img').first();
              thumb = $innerImg.attr('data-src') || $innerImg.attr('src') || '';
            }
            if( !thumb ) {
              // No usable thumbnail URL — render an empty span so the slider still gets a paging element
              // but without the broken <img>. (Slick requires non-empty markup for each pagination item.)
              return '<span class="product__thumbs__empty" data-media-id="' + (mediaId || '') + '"></span>';
            }
            if( isVideo ) {
              return '<span class="product__thumbs__video" data-media-id="' + mediaId + '"><img src="' + thumb + '"><span class="btn btn--play"><span>&#9658;</span></span></span>';
            }
            return '<img src="' + thumb + '">';
          }
        })

      // $(this.selectors.productImage).imagesLoaded(function(){
      //   $(`${this.selectors.productPhoto}--dupslide`).slick('setPosition')
      // }.bind(this))
    },
    destroySlider: function() {
      // unslick it and remove thumbnails html if it's a slick slider
      if( $(this.selectors.productPhoto).hasClass('slick-initialized') ) {
        $(this.selectors.productPhoto).slick('unslick');
        $(this.selectors.productThumbs).html('');
      }
    },
    updateSlider: function(evt) {
      var values = evt.values,
          mediaId = evt.mediaId;

      this.destroySlider();

      // Dynamic slider
      var $sliderWrap = $('.product__slides-wrap'),
          $productSlider = $(this.selectors.productPhoto),
          productSlideItemsHtml = this.$container.find('[product-slide-items-object]').html(),
          $productSlideItems = $(productSlideItemsHtml);

      $sliderWrap.find(this.selectors.productPhoto).html('');

      if( values == undefined ) {

        // Build the slider html with all slides if this is a simple product
        $sliderWrap.find(this.selectors.productPhoto).html( $productSlideItems.find('.product__media') );

      } else {
        const $productPhoto = $sliderWrap.find(this.selectors.productPhoto);
        $productSlideItems.find('.product__media').each(function(){
          const mediaAlt = $(this).attr('data-alt');
          if( values.includes(mediaAlt) ) {
            $productPhoto.append( $(this) );
          }
        });

        this.initSlider();

        if( mediaId == undefined ) {
          return;
        }
        var slickIndex = $productSlider.find('.product__media').filter('[data-media-id="' + mediaId + '"]').data('slick-index');
        if( slickIndex != undefined ) {
          $productSlider.slick('goTo', slickIndex);
        }
      }
    },
    productVideo: function() {
      $('body').on('click', '.productVideo', function(e) {
        if( $(window).width() > 768 &&
            $(this).closest('.product__media--video').length ) {
          e.preventDefault();
          return;
        }

        var videoId = $(this).attr('data-video-id');
        if( videoId === undefined ) {
          return;
        }

        e.preventDefault();
        $(this).html('<iframe frameborder="0" allowfullscreen="" src="https://www.youtube.com/embed/' + videoId + '?rel=0&amp;modestbranding=1&amp;fs=0&amp;showinfo=0&amp;controls=1&amp;autoplay=1"></iframe>');
      });
    },
    productThumbnailCheck: function(){
      // update slick dots alignment class
      var $slickDots = this.$container.find('.slick-dots');
      if( $slickDots.length ) {
        var productThumbsHeight = this.$container.find('.product__thumbs').outerHeight(),
            slickDotsHeight = $slickDots.outerHeight();
        if( slickDotsHeight > productThumbsHeight ) {
          $slickDots.removeClass('align-center');
        } else {
          $slickDots.addClass('align-center');
        }
      }
    },
    productReviews: function() {
      var $reviewBadges = this.$container.find('[data-stamped-badge]');
      if( !$reviewBadges.length ) {
        return;
      }

      $reviewBadges.click(function(e){
        e.preventDefault();
        var $stampedContainer = $('.stamped-container');
        if( !$stampedContainer.length ) {
          return;
        }
        $("html, body").animate({ scrollTop: $stampedContainer.position().top - 100 });
      });
    },
    productTiles: function(evt){
      let $container = this.$container,
          $tiles = $container.find('[product-tiles]'),
          $tileItems = $tiles.find('[product-tiles-item]');

      if( !$tiles.length || !$tileItems.length) {
        return;
      }

      console.log('Product.updateTiles()');

      $container.on('updateSlider' + this.settings.namespace, function(evt){
        var values = evt.values,
            mediaId = evt.mediaId;

        console.log('productTiles');
        console.log({
          'evt':evt,
          'values':values,
          'mediaId':mediaId
        });

        if( values == undefined ) {
          // Show all tile items
          $tileItems.show();
          return;
        }

        $tileItems.hide();
        for( let i=0 ; i<values.length ; i++ ) {
          let value = values[i];
          $tileItems.filter(`[data-alt="${value}"]`).show();
        }
      });
    },
    stickyAddToCart: function(){
      let $container = this.$container;

      if ($container.closest('[data-standalone-product]').length) return;

      let $header = $('.site-header'),
          $addToCartWrapper = $container.find('[data-add-to-cart-wrapper]'),
          $stickyAddToCart = $container.find('[data-add-to-cart-sticky]');

          /* price promo container */
          //confidenceStackPricePromo = document.querySelector('.confidence-stack_price-promo-container');

      if( !$addToCartWrapper.length || !$stickyAddToCart.length ) {
        return;
      }

      $(window).on('load scroll', $.throttle(200, function(){
        let scrollTop = $(window).scrollTop();
        if(
          scrollTop > $addToCartWrapper.position().top+$addToCartWrapper.outerHeight()-$header.outerHeight()
          ||
          (
            window._enableAlwaysOnMobileATC
            &&
            /* Scoped to this section's own arm, not the page's first match.
               Identical behaviour with a single buy box; correct when the PDP
               ships a second (A/B) buy box, where $('[data-add-to-cart-*]')[0]
               would always resolve to arm A even for arm B's instance. */
            window.innerHeight < $addToCartWrapper[0].getBoundingClientRect().bottom + $header.outerHeight()
            &&
            !($stickyAddToCart[0].getBoundingClientRect().top > $addToCartWrapper[0].getBoundingClientRect().top)
          )
        ) {
          $stickyAddToCart.addClass('in');
          //confidenceStackPricePromo.classList.add('fixed');
        } else {
          $stickyAddToCart.removeClass('in');
          //confidenceStackPricePromo.classList.remove('fixed');
        }
      }));
    },
    productAddon: function() {
      const self = this;

      this.$container.find(`[data-addon-item-radio]`).change(function(){
        this.updateAllVariants({variant: this.variants.currentVariant})
      }.bind(this));

      this.$container.find(`[data-addon-item-variant-select]`).change(function(){
        const $addonSelect = $(this);
        const variantId = $addonSelect.val();
        const $option = $addonSelect.find(`option[value="${variantId}"]`);
        const imageUrl = $option.attr(`data-image-url`);
        const $addonItem = $addonSelect.closest(`[data-addon-item]`);
        const $addon = $addonSelect.closest(`[data-addon]`);
        const bundleDiscount = parseFloat( $addon.attr(`data-bundle-discount`) ) || false;

        // Keep the [data-addon-item] wrapper internally consistent. updateUpsellCards()
        // paints each bundle card from the WRAPPER's data-variant-price /
        // data-variant-compare-at-price, so rewriting data-variant-id alone leaves the
        // card priced from the PREVIOUS variant — the same id/price desync class as the
        // duplicate-variant upsell bug. Written unconditionally (outside the
        // bundleDiscount branch below) so the buy_2_widget path stays in sync too.
        const optionPrice = $option.attr(`data-variant-price`);
        // Mirror the price when the option carries no compare-at (Liquid renders an
        // empty string for a nil compare_at_price) — same convention as below.
        const optionCompareAtPrice = $option.attr(`data-variant-compare-at-price`) || optionPrice;

        $addonItem.attr('data-variant-id', variantId);
        if( optionPrice !== undefined ) {
          $addonItem.attr('data-variant-price', optionPrice);
          $addonItem.attr('data-variant-compare-at-price', optionCompareAtPrice);
        }

        // Only repaint the thumbnail when the option actually carries a URL.
        // Options can legitimately omit data-image-url (a variant with no image
        // renders it empty; the synthetic option for a configured id that isn't
        // one of this product's variants has no image to point at), and
        // unguarded this wrote `background-image: url(undefined)` and blanked
        // the thumbnail.
        if( imageUrl ) {
          $addonItem.find(`[data-addon-item-image]`).removeAttr('data-bgset').removeClass('lazyloaded').css(`background-image`, `url(${imageUrl})`);
        }
        $addonItem.find(`[data-addon-item-radio][value="Yes"]`).prop('checked', true).change();

        // Cards layout only: data-bundle-key is emitted solely by
        // snippets/product-upsell-cards.liquid, and that layout has no
        // [data-addon-item-radio], so the .change() above never repaints it. Reuse
        // updateUpsellCards() (rather than re-deriving the bundle math here) so the
        // visible bundle price matches the wrapper attrs we just wrote. The toggle
        // layout has no bundle key and is already repainted by that radio change.
        if( $addonItem.attr('data-bundle-key') !== undefined && self._upsellCardsVariantPrice !== undefined ) {
          self.updateUpsellCards(self._upsellCardsVariantPrice, self._upsellCardsVariantCompareAtPrice, theme.moneyFormat);
        }

        if( bundleDiscount === false ) {
          const moneyFormat = theme.moneyFormat,
                $addonOption = $addonSelect.find(`option[value="${variantId}"]`),
                variantPrice = parseInt( $addonOption.attr(`data-variant-price`) ),
                variantCompareAtPrice = parseInt( $addonOption.attr(`data-variant-compare-at-price`) ) || variantPrice;
          $addonItem.find(`[data-addon-item-price]`).find('.money').html( slate.Currency.formatMoney(variantPrice, moneyFormat) );
          $addonItem.find(`[data-addon-item-compare-at-price]`).attr('data-value', variantCompareAtPrice);
          $addonItem.find(`[data-addon-item-price]`).attr('data-value', variantPrice);

          // Also update the discount badge, if any
          const discountPercentNumber = Math.ceil(parseFloat((1 - (variantPrice / variantCompareAtPrice)) * 100));
          if (discountPercentNumber > 0) {
            $addonItem.find(`[data-addon-item-percent-off]`).html( discountPercentNumber + '% OFF' );
            $addonItem.find(`[data-addon-item-percent-off]`).show();
          } else {
            $addonItem.find(`[data-addon-item-percent-off]`).hide();
          }

          // Also update and show the product's compare price if necessary
          if (variantCompareAtPrice > variantPrice) {
            $addonItem.find(`[data-addon-item-compare-at-price]`).find('.money').html( slate.Currency.formatMoney(variantCompareAtPrice, moneyFormat) );
            $addonItem.find(`[data-addon-item-compare-at-price]`).closest('.compare-at').show();
            $addonItem.find(`[data-addon-item-price]`).closest('.addon-item__price').addClass('on-sale');
          } else {
            $addonItem.find(`[data-addon-item-compare-at-price]`).closest('.compare-at').hide();
            $addonItem.find(`[data-addon-item-price]`).closest('.addon-item__price').removeClass('on-sale');
          }
        }
      });
    },
    initUpsellBundle: function() {
      this.$container.find(`bundle-form button`).click(function(evt){
        evt.preventDefault()
        const $bundleForm = $(evt.target).closest('bundle-form')
        let addItems = []
        $bundleForm.addClass('loading')
        this.$container.find(`bundle-form [upsell-bundle-checkbox]:checked`).each(function(){
          const $bundleItem = $(this).closest(`bundle-item`)
          const variantId = parseInt( $bundleItem.attr('data-variant-id') )
          addItems.push({
            'id': variantId,
            'quantity': 1,
          })
        })
        addItems.reverse()
        console.log('Drawer Cart add.js - 5');
        $.post(`${window.Shopify.routes.root}cart/add.js`, {
          items: addItems
        }).always(function(){
          $bundleForm.removeClass('loading')
          setTimeout(function(){
            window.location.href = `${window.Shopify.routes.root}cart`
          }, 300)
        })
      }.bind(this))

      this.$container.find(`[upsell-bundle-checkbox]`).change(function(evt){
        let totalPrice = 0
        this.$container.find(`bundle-form [upsell-bundle-checkbox]:checked`).each(function(){
          const $bundleItem = $(this).closest(`bundle-item`)
          totalPrice += parseInt( $bundleItem.attr('data-variant-price') )
        })
        this.$container.find(`[bundle-total-price]`).find('.money').html( slate.Currency.formatMoney(totalPrice, theme.moneyFormat) )
      }.bind(this))

      this.$container.find(`bundle-item-swatch input`).change(function(evt){
        const $radio = $(evt.target)
        const value = $radio.attr('value')
        const $bundleItem = $radio.closest(`bundle-item`)
        const bundleProductJson = ($bundleItem.find(`[bundle-item-json]`).length) ? JSON.parse( $bundleItem.find(`[bundle-item-json]`).html() ) : false
        if( !bundleProductJson ) {
          return
        }

        let bundleVariant = false
        for( let i=0 ; i<bundleProductJson.variants.length ; i++ ) {
          if( bundleProductJson.variants[i].title == value ) {
            bundleVariant = bundleProductJson.variants[i]
          }
        }
        if( !bundleVariant ) {
          return
        }

        // console.log({
        //   '$radio': $radio,
        //   'value': value,
        //   'bundleProductJson': bundleProductJson,
        //   'bundleVariant': bundleVariant,
        // })
        $bundleItem.attr('data-variant-id', bundleVariant.id).attr('data-variant-price', bundleVariant.price)
        // TODO: Update price display
        if( bundleVariant.compare_at_price > bundleVariant.price ) {
          $bundleItem.find(`bundle-item-price [data-product-compare-at-price]`).show();
          $bundleItem.find(`bundle-item-price [data-product-compare-at-price] .money`).html( slate.Currency.formatMoney(bundleVariant.compare_at_price, theme.moneyFormat) );
          $bundleItem.find(`bundle-item-price [data-product-price] .money`).html( slate.Currency.formatMoney(bundleVariant.price, theme.moneyFormat) )
        } else {
          $bundleItem.find(`bundle-item-price [data-product-compare-at-price]`).hide();
          $bundleItem.find(`bundle-item-price [data-product-price] .money`).html( slate.Currency.formatMoney(bundleVariant.price, theme.moneyFormat) )
        }
        if( bundleVariant.featured_image !== null ) {
          const variantImageUrl = bundleVariant.featured_image.src.replace('.png', '_160x.png').replace('.jpg', '_160x.jpg')
          $bundleItem.find('bundle-item-hero').removeAttr('data-bgset').css('background-image', `url(${variantImageUrl})`)
        }
      }.bind(this))

      /*
      this.$container.find(`[upsell-bundle-checkbox]`).change(function(evt){
        const $checkbox = $(evt.target)
        console.log(`upsell bundle changed`)
        const $upsellBundle = $checkbox.closest(`[upsell-bundle]`)
        if( $checkbox.is(`:checked`) ) {
          $upsellBundle.find(`[data-addon-item-checkbox]`).prop(`checked`, `checked`).change()
        } else {
          $upsellBundle.find(`[data-addon-item-checkbox]`).prop(`checked`, false).change()
        }
      }.bind(this))
      */
    },
    getAddonVariants: function() {
      let variants = [];

      /* ── Arm-visibility arbitration (upsell layout A/B) ──────────────────
         More than one upsell layout can sit in the DOM at once: the cards arm
         [data-upsell-cards], the legacy toggle fallback
         [data-upsell-above-fallback], and the pair arm [data-upsell-pair].
         Only the arm the shopper can actually SEE may put a line in the cart —
         a hidden arm's pre-checked add-on must never be charged for.

         Test the ARM WRAPPER, never the [data-addon-item] itself. That block
         carries .upsell-cards__hidden-addon, which is display:none !important
         unconditionally (snippets/product-upsell-cards.liquid), so the item is
         ALWAYS hidden and testing it would drop every add-on on the page.

         getComputedStyle walk rather than offsetParent, for two reasons:
         <product-upsell-above> has no customElements.define anywhere, so its
         display:inline is a UA default we would be leaning on implicitly; and
         any element inside a position:fixed ancestor reports
         offsetParent === null while fully visible. The walk is immune to both.

         Mirrored in the two collectors in sections/standalone-product.liquid.
         Keep all three in sync. The upsell builder arm [data-upsell-builder]
         is listed here only: snippets/product-form.liquid renders it for the
         main PDP buy boxes and never inside standalone-product. */
      const $root = this.$container,
            armSelector = `[data-upsell-cards],[data-upsell-above-fallback],[data-upsell-pair],[data-upsell-builder]`;

      const isHiddenByCss = function(el){
        for( let node = el; node && node.nodeType === 1; node = node.parentElement ) {
          const cs = window.getComputedStyle(node);
          if( cs && cs.display === 'none' ) return true;
        }
        return false;
      };

      /* CONTROL INVARIANCE: only arbitrate when there is something to
         arbitrate BETWEEN. If EVERY arm on this product form is hidden, no
         layout is being swapped in over another — that is a merchandiser
         switching the whole upsell off (sections/standalone-product.liquid's
         `unless show_addon` block emits display:none !important over
         [data-upsell-cards] and product-upsell-above, and show_addon is false
         on 20 page.* templates today). In that case leave the pre-existing
         behaviour exactly as it is. A skip therefore only ever happens when a
         DIFFERENT arm is on screen in the hidden one's place, which is
         precisely the A/B case this filter exists for.

         Scoped to form[data-productid], NOT to [data-upsell-region]. The arms
         deliberately live in TWO sibling regions — the control arms in
         [data-upsell-region] above the buy box, the pair arm in
         [data-upsell-pair-region] below it (snippets/product-form.liquid:515
         and :792). Scoping to one region made the other invisible to the
         lookup: a hidden control arm would find no visible arm beside it,
         someArmVisible would return false, and its pre-checked add-on would
         still be charged for while the pair card was on screen. The form is
         the nearest common ancestor of both mounts — the same element the
         activation class goes on — so it is the correct arbitration boundary,
         and it still isolates one product form from another. */
      const someArmVisible = function($arm){
        const $scope = $arm.closest(`form[data-productid]`);
        let visible = false;
        ( $scope.length ? $scope : $root ).find(armSelector).each(function(){
          if( !isHiddenByCss(this) ) { visible = true; return false; }
        });
        return visible;
      };

      this.$container.find(`[data-addon-item-radio][value="Yes"]:checked, [data-addon-item-checkbox]:checked`).each(function(){
        const $addonItem = $(this).closest(`[data-addon-item]`),
              $addonSelect = $addonItem.find(`[data-addon-item-variant-select]`),
              rawVariantId = $addonSelect.val(),
              variantId = parseInt( rawVariantId );

        // An add-on with NO arm-wrapper ancestor is never skipped. That is the
        // buy_2_widget rendered by snippets/product-form-replo-earbuds.liquid,
        // which this collector also runs over (its sections carry
        // data-section-type="product") and which must keep working. Written as
        // "skip only if inside a HIDDEN arm", not "skip unless inside a VISIBLE
        // arm", so an add-on outside the upsell region always passes through.
        const $arm = $addonItem.closest(armSelector);
        if( $arm.length && isHiddenByCss($arm[0]) && someArmVisible($arm) ) {
          console.warn('[Cart] Skipping add-on that belongs to a hidden upsell arm:', $arm[0], $addonItem[0]);
          return;
        }

        // The configured id is not a variant of the add-on product at all —
        // Liquid already determined that server-side and said so with
        // data-addon-unresolved-variant (snippets/product-addon-item.liquid and
        // snippets/product-upsell-cards.liquid). It is a plausible-looking
        // integer, so the numeric guard below waves it through, but Shopify
        // will reject the line and /cart/add.js items[] is ATOMIC: the whole
        // request rolls back and the shopper gets NOTHING, not even the main
        // product. One stale metafield entry would silently disable
        // add-to-cart for everyone who ticks that upsell. Degrade to "add-on
        // not added" instead of "nothing added".
        //
        // Keyed on the PRESENCE of the attribute, not on which id happens to be
        // selected right now. A flagged item is misconfigured as a whole:
        // nothing rendered on it — title, image, price, compare-at — describes
        // the configured id, so no option in its <select> is trustworthy enough
        // to charge for. Skip the item outright, whichever variant the shopper
        // switches to.
        const unresolvedVariantId = $addonItem.attr('data-addon-unresolved-variant');
        if( unresolvedVariantId !== undefined ) {
          console.warn('[Cart] Skipping add-on whose configured variant id is not a variant of the add-on product:', unresolvedVariantId, $addonItem[0]);
          return;
        }

        // Drop anything that is not a plausible variant id before it reaches
        // /cart/add.js. That endpoint's items[] form is ATOMIC, so one bad line
        // (empty <select>, missing <select>, a configured id that resolved to
        // nothing) rejects the WHOLE request and the main product is never
        // added either. Mirrors the `if (vId)` guard in the parallel collector
        // in sections/standalone-product.liquid.
        if( !Number.isFinite(variantId) || variantId <= 0 ) {
          console.warn('[Cart] Skipping add-on with an unusable variant id:', rawVariantId, $addonItem[0]);
          return;
        }

        // Add-ons go in at quantity 1, except the upsell builder's
        // (snippets/product-upsell-builder-row.liquid): its bundle price is
        // quoted per unit of the main product, so those lines follow the main
        // quantity, read the same way the add-to-cart handler reads it.
        const $addonOption = $addonSelect.find(`option[value="${variantId}"]`),
              variantPrice = parseInt( $addonOption.attr(`data-variant-price`) ),
              variantCompareAtPrice = parseInt( $addonOption.attr(`data-variant-compare-at-price`) ) || variantPrice,
              quantity = $addonItem.is(`[data-addon-item-qty-follows-main]`)
                ? ( parseInt( $root.find(`[name="quantity"]`).val() ) || 1 )
                : 1;
        variants.push({
         'id': variantId,
         'quantity': quantity,
         'price': variantPrice,
         'compareAtPrice': variantCompareAtPrice,
        });
      });
      return variants;
    },
    getAddonDiscount: function(){
      return parseFloat( this.$container.find(`[data-addon]`).attr(`data-bundle-discount`) ) || 1;
    },
    onBlockSelect: function(evt) {
      $('*[data-block-id="' + evt.detail.blockId + '"]').click();
    },
    onBlockDeselect: function(evt) {
      $('*[data-block-id="' + evt.detail.blockId + '"]').click();
    }
  });

  return Product;
})();

theme.ProductBundle = (function() {
  function ProductBundle(container) {
    let $container = this.$container = $(container);

    $container
      .on('updatePrice', function(){
        let selectors = {
              productPrice: '[data-product-price]',
              comparePrice: '[data-product-compare-at-price]'
            },
            moneyFormat = theme.moneyFormat,
            variantPrice = 0,
            variantCompareAtPrice = 0;

        $container.find('[data-swatch-wrapper]').each(function(){
          $selectedLink = $(this).find('[data-swatch-item].active [data-swatch-link]');
          let price = parseInt( $selectedLink.attr('data-variant-price') ),
              compareAtPrice = parseInt( $selectedLink.attr('data-variant-compare-at-price') ) || price;

          variantPrice += price;
          variantCompareAtPrice += compareAtPrice;
        });

        let bundleDiscount = $container.find('form[action="/cart/add"]').attr('data-bundle-discount'),
            bundleDiscountType = ( bundleDiscount.indexOf('%') != -1 ) ? 'percentage' : 'fixed_amount';
            bundleDiscountAmount = ( bundleDiscountType == 'percentage' ) ? variantPrice * parseFloat(bundleDiscount.replace('%', '')) / 100 : 0;
        variantPrice -= bundleDiscountAmount;

        // Regardless of stock, update the product price
        $container.find(`${selectors.productPrice} .money`).html( slate.Currency.formatMoney(variantPrice, moneyFormat) );

        // Also update and show the product's compare price if necessary
        if (variantCompareAtPrice > variantPrice) {
          $container.find(`${selectors.comparePrice} .money`).html( slate.Currency.formatMoney(variantCompareAtPrice, moneyFormat) );
          $container.find(selectors.comparePrice).closest('.compare-at').show();
          $container.find(selectors.productPrice).closest('.product__price').addClass('on-sale');
        } else {
          $container.find(selectors.comparePrice).closest('.compare-at').hide();
          $container.find(selectors.productPrice).closest('.product__price').removeClass('on-sale');
        }
      })
      .on('updateImages', function(){
        $container.find('[data-swatch-wrapper]').each(function(){
          let $selectedLink = $(this).find('[data-swatch-item].active [data-swatch-link]'),
              option = $(this).attr('data-option');
              variantImageUrl = $selectedLink.attr('data-variant-image') || false;

          if( variantImageUrl ) {
            $( `[data-product-bundle-image][data-option="${option}"]`)
              .css('opacity', 1)
              .css('background-image', `url(${variantImageUrl})`)
          }
        });
      });

    this.initSwatches();
    this.quantitySelectors();
    this.soldOutHandle();
    this.addToCart();
  }
  ProductBundle.prototype = _.assignIn({}, ProductBundle.prototype, {
    initSwatches: function() {
      let $container = this.$container;

      $container.find('[data-swatch-link]').click(function(evt){
        evt.preventDefault();

        let $swatchWrapper = $(this).closest('[data-swatch-wrapper]'),
            $swatchItem = $(this).closest('[data-swatch-item]'),
            value = $(this).attr('data-value'),
            variantId = $(this).attr('data-vairant-id');

        $swatchWrapper.find(`[data-swatch-item]`).removeClass('active');
        $swatchItem.addClass(`active`);

        $swatchWrapper.find(`[data-swatch-value]`).html(value);

        $swatchWrapper.find(`[name="id[]"]`).attr('value', variantId).val( variantId );

        $container.trigger('updatePrice');
        $container.trigger('updateImages');
      });

      $container.find(`[data-swatch-list]`).each(function(){
        if( $(this).find(`[data-swatch-item].active`).length ) {
          $(this).find(`[data-swatch-item].active [data-swatch-link]`).click()
        } else {
          $(this).find(`[data-swatch-item]:first [data-swatch-link]`).click()
        }
      })
    },

    quantitySelectors: function() {
      // Change number inputs to JS ones, similar to ajax cart but without API integration.
      // Make sure to add the existing name and id to the new input element
      var numInputs = this.$container.find('input[type="number"]');

      if (numInputs.length) {
        numInputs.each(function() {
          var el = $(this),
              currentQty = el.val(),
              inputName = el.attr('name'),
              inputId = el.attr('id'),
              inputSubmit = el.data('submit');

          var itemAdd = currentQty + 1,
              itemMinus = currentQty - 1,
              itemQty = currentQty;

          var source   = $("#JsQty").html(),
              template = Handlebars.compile(source),
              data = {
                id: el.data('id'),
                itemQty: itemQty,
                itemAdd: itemAdd,
                itemMinus: itemMinus,
                inputName: inputName,
                inputId: inputId,
                submit: inputSubmit
              };

          // Append new quantity selector then remove original
          el.after(template(data)).remove();
        });

        // Setup listeners to add/subtract from the input
        this.$container.find('.js-qty__adjust').on('click', function() {
          var el = $(this),
              id = el.data('id'),
              qtySelector = el.siblings('.js-qty__num'),
              qty = parseInt(qtySelector.val().replace(/\D/g, '')),
              submit = qtySelector.data('submit');

                // Make sure we have a valid integer
                if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
                  // We have a number!
                } else {
                  // Not a number. Default to 1.
                  qty = 1;
                }


          // Add or subtract from the current quantity
          if (el.hasClass('js-qty__adjust--plus')) {
            qty = qty + 1;
          } else {
            qty = qty - 1;
            if (qty <= 1) qty = 1;
          }

          // Update the input's number
          qtySelector.val(qty).trigger('change');
          if(submit){
            qtySelector.parents('form').submit();
          }
        });
      }
    },

    soldOutHandle: function() {
      let $container = this.$container;
      $container.find('[data-swatch-wrapper]').each(function(){
        let $swatchWrapper = $(this);
        if( $swatchWrapper.find('[data-swatch-item]').length == 0 ){
          $swatchWrapper.addClass('sold-out').find('[data-swatch-value]').html('<span style="color:red;">SOLD OUT</span>');
        }
      })

      if( $container.find('[data-swatch-wrapper].sold-out').length ) {
        $container.find('[data-add-to-cart-wrapper], .product__quantity-and-price-wrap').remove();
        let productTitle = $container.find('[data-swatch-wrapper]:not(.sold-out)').find('[data-swatch-product-title]').html(),
            btnLink = $container.find('[data-swatch-wrapper]:not(.sold-out)').find('[data-swatch-item].active > [data-swatch-link]').attr('href');//'#',
            btnText = `Shop ${productTitle}`;

        $(`<a href="${btnLink}" class="btn btn--green btn--large btn--full">${btnText}</a>`).insertAfter('[data-swatch-wrapper]:last');
      }
    },

    addToCart: function(){
      console.log('theme.ProductBundle.addToCart');

      const $container = this.$container
      const $addToCartWrapper = $container.find('[data-add-to-cart-wrapper]')

      $container.find(`[action="/cart/add"]`).submit(function(evt){
        console.log('add to cart form submitted');
        evt.preventDefault();
        $addToCartWrapper.find('[data-add-to-cart]').addClass('loading')

        let addItems = {
          items: []
        };
        let quantity = parseInt( $container.find(`[name="quantity"]`).val() ) || 1,
            bundleTitle = $container.find(`[name="properties[Bundle]"]`).val();

        $container.find(`[name="id[]"]`).each(function(){
          let variantId = parseInt( $(this).val() ),
              addToItems = true;

          for( let i=0 ; i<addItems.items.length ; i++ ) {
            let item = addItems.items[i];
            if( item.id == variantId ) {
              item.quantity += quantity;
              addToItems = false;
            }
          }

          if( addToItems ) {
            addItems.items.push({
              quantity: quantity,
              id: variantId,
              properties: {
                'Bundle': bundleTitle
              }
            })
          }
        });

        addItems.items.reverse();
        console.log('Drawer Cart add.js - 6');
        $.ajax({
          type: 'POST',
          url: `${window.Shopify.routes.root}cart/add.js`,
          dataType: 'json',
          data: addItems,
          error: function(object, status){
            var $errEl = $container.find('[data-add-to-cart-error]');
            var ct = (object.getResponseHeader && object.getResponseHeader('Content-Type')) || '';
            //if (ct.indexOf('text/html') !== -1 || (object.status === 403 && !object.responseJSON)) {
            //const ct = (object.headers.get('content-type') || '');
            //if (ct.indexOf('application/json') === -1 && 1>2) {
            if (ct.includes('text/html') || (object.status === 429) || (object.status === 403)) {
              console.error('[Cart] Cloudflare challenge detected on cart/add.js bundle (got HTML instead of JSON). Reloading page for verification.');
              $addToCartWrapper.find('[data-add-to-cart]').removeClass('loading');
              $errEl.html('Please verify your connection. Reloading page…').removeClass('hide');
              setTimeout(function(){ window.location.reload(); }, 2000);
              throw new Error('CF_BLOCK');
              return;
            }
            var msg = (object.responseJSON && object.responseJSON.description) || 'An error occurred. Please try again.';
            $errEl.html(msg).removeClass('hide');
            $addToCartWrapper.find('[data-add-to-cart]').removeClass('loading')
          },
          success: function(){
            $addToCartWrapper.find('[data-add-to-cart]').removeClass('loading')
            if( document.querySelector('cart-drawer[data-drawer="on"]') !== null ) {
              document.querySelector('cart-main').refresh()
              document.querySelector('cart-drawer').open()
            } else {
              location.href = `${window.Shopify.routes.root}cart`;
            }
          },
          complete: function(){
            $addToCartWrapper.find('[data-add-to-cart]').removeClass('loading')
          }
        });
      });
    },

    onUnload: function() {
    },
    onBlockSelect: function(evt) {
    }
  });
  return ProductBundle;
})();

theme.ProductWidget = (function() {
  function ProductWidget(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      sectionId: sectionId,
      enableHistoryState: false,
      namespace: '.product-widget'
    }

    this.selectors = {
      originalSelectorId: '[data-product-select]', // '#ProductSelect-' + sectionId,
      singleOptionSelector: '[data-single-option-selector]', // '.single-option-selector-' + sectionId,
      quantityInput:    '#Quantity-'+sectionId+' .QuantityInput',

      productPriceWrapper: '[data-product-price-wrapper]',
      productPrice: '[data-product-price]',
      comparePrice: '[data-product-compare-at-price]'
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if ( !$container.find('[data-product-json]').html() ) {
      return;
    }
    this.productSingleObject = JSON.parse( $container.find('[data-product-json]').html() );

    this.initProductVariant();
    this.initProductSwatches();
    this.quantitySelectors();
    this.active();
    this.toggle();
    this.select2();

    $container.find('[data-product-image] img').imagesLoaded(function(){
      $container.find('[data-product-image]')
        .css('min-height', '')
        .removeClass('loading');
    });
  }

  ProductWidget.prototype = _.assignIn({}, ProductWidget.prototype, {
    initProductVariant: function() {
      this.variants = new slate.Variants({
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      });
      this.$container.on('variantChange' + this.settings.namespace, this.updateAllVariants.bind(this));
      this.updateAllVariants({variant: this.variants.currentVariant});
    },
    initProductSwatches: function(){
      var $container = this.$container,
          selectors = {
            wrapper: '[data-swatch-wrapper]',
            swatchList: '[data-swatch-list]',
            swatchItem: '[data-swatch-item]',
            swatchLink: '[data-swatch-link]',
            swatchValue: '[data-swatch-label-value]'

          },
          $singleOptionSelectors = $(this.selectors.singleOptionSelector);

      // Init swatch click handle
      $container.find(selectors.swatchLink).click(function(e){
        e.preventDefault();

        var val = $(this).data('value'),
            $swatchWrapper = $(this).closest( selectors.wrapper ),
            index = $swatchWrapper.data('index'),
            $productSwatch = $swatchWrapper.find( selectors.swatchItem );

        // Update swatch label
        $swatchWrapper.find( selectors.swatchValue ).html(val);

        // Update swatch state
        $productSwatch.removeClass('active');
        $(this).closest( selectors.swatchItem ).addClass('active');

        // Update selector
        $singleOptionSelectors.filter('[data-index="' + index + '"]').val(val).change();
      });
    },
    updateAllVariants: function(evt){
      var $container = this.$container,
          selectors = this.selectors,
          variant = evt.variant,
          moneyFormat = theme.moneyFormat;

      if( variant ) {
        if( typeof( variant.featured_image ) !== 'undefined' ) {
          var imageSrc = variant.featured_image.src.replace('.jpg', '_220x.jpg').replace('.png', '_220x.png'),
              $productImageWrap = $container.find('[data-product-image]'),
              $productImage = $productImageWrap.find('img');

          $productImageWrap
            .addClass('loading')
            .css('min-height', $productImageWrap.outerHeight());

          $productImage
            .removeAttr('data-src data-widths data-aspectratio data-parent-fit data-sizes sizes srcset data-srcset src')
            .removeAttr('srcset data-srcset')
            .attr('src', imageSrc)
            .imagesLoaded(function(){
              $productImageWrap
                .css('min-height', '')
                .removeClass('loading');
            });;
        }


        // Regardless of stock, update the product price
        $container.find(`${selectors.productPrice} .money`).html( slate.Currency.formatMoney(variant.price, moneyFormat) );

        // Also update and show the product's compare price if necessary
        if (variant.compare_at_price > variant.price) {
          $container.find(selectors.productPriceWrapper).addClass('on-sale');
          $container.find(`${selectors.comparePrice} .money`).html( slate.Currency.formatMoney(variant.compare_at_price, moneyFormat) ).show();
        } else {
          $container.find(selectors.productPriceWrapper).removeClass('on-sale');
          $container.find(selectors.comparePrice).hide();
        }
      }
    },
    quantitySelectors: function() {
      // Setup listeners to add/subtract from the input
      this.$container.find('.js-qty__adjust').off().on('click', function() {
        var el = $(this),
            id = el.data('id'),
            qtySelector = el.siblings('.js-qty__num'),
            qty = parseInt(qtySelector.val().replace(/\D/g, '')),
            submit = qtySelector.data('submit');

        // Make sure we have a valid integer
        if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
          // We have a number!
        } else {
          // Not a number. Default to 1.
          qty = 1;
        }


        // Add or subtract from the current quantity
        if (el.hasClass('js-qty__adjust--plus')) {
          qty = qty + 1;
        } else {
          qty = qty - 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        qtySelector.val(qty).trigger('change');
        if(submit){
          qtySelector.parents('form').submit();
        }
      });
    },
    active: function(){
      var $container = this.$container;
      var $productSection = $('.product-single');
      if( ! $productSection.length ) {
        return;
      }

      $(window).on('scroll', $.throttle(200, function(){
        var scrollTop = $(window).scrollTop() ,
            productSectionBottom = $productSection.position().top + $productSection.outerHeight()

        if( scrollTop > productSectionBottom ) {
          $container.addClass('active');
        } else {
          $container.removeClass('active');
        }
      }))
    },
    toggle: function(){
      var $container = this.$container;
      $container.find('[data-widget-toggle]').click(function(){
        $container.toggleClass('in');
      });
    },
    select2: function(){
      var $container = this.$container,
          moneyFormat = theme.moneyFormat;

      var formatState = function(state) {
        if (!state.id) {
          return state.text;
        }
        var $option = $(state.element),
            thumb = $option.attr('data-option-thumb'),
            price = $option.attr('data-option-price'),
            compareAtPrice = $option.attr('data-option-compare-at-price'),
            onSale = false;

        var $state = $(
          '<span class="select2__option"><span class="select2__option__thumb"><img src="' + thumb + '" /></span><span class="select2__option__text">' + state.text + '</span></span>'
        );

        var priceHtml = '';
        if( typeof(price) !== 'undefined' ) {
          if( typeof(compareAtPrice) !== 'undefined' &&  compareAtPrice != '' ) {
            if( parseInt(compareAtPrice) > parseInt(price) ) {
              onSale = true;
            }
          }

          if( onSale ) {
            priceHtml += `<span class="small compare-at" data-product-compare-at-price>${slate.Currency.formatMoney(compareAtPrice, moneyFormat)}</span>`
          }
          priceHtml += `<span data-product-price>${slate.Currency.formatMoney(price, moneyFormat)}</span>`

          if( onSale ) {
            priceHtml = '<span class="select2__option__price product__price on-sale">' + priceHtml + '</span>';
          } else {
            priceHtml = '<span class="select2__option__price product__price">' + priceHtml + '</span>';
          }

          $state = $(
            '<span class="select2__option align-items-center"><span class="select2__option__thumb"><img src="' + thumb + '" /></span><span class="select2__option__text">' + state.text + '</span>' + priceHtml + '</span>'
          );
        }

        return $state;
      };

      $container.find('[data-product-select]').select2({
        templateResult: formatState,
        templateSelection: formatState
      });
    }
  });

  return ProductWidget;
})();

theme.ProductFeatureSlider = (function() {
  function ProductFeatureSlider(container) {
    var $container = this.$container = $(container),
        sectionId = $container.attr('data-section-id'),
        slideshow = this.slideshow = '#productFeatureSlider-'+sectionId,
        $slideshow = this.$slideshow = $(this.slideshow);

    this.init();
  }

  ProductFeatureSlider.prototype = _.assignIn({}, ProductFeatureSlider.prototype, {
    init: function() {
      this.$slideshow.on('init', function(event, slick){
        var $slider = slick.$slider,
            $currentSlide = $slider.find('.slick-current');
      })
      this.$slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var $slider = slick.$slider,
            $currentSlide = $slider.find('.slick-current'),
            $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');

      });
      this.$slideshow.slick({
        autoplay: false,
        fade: true,
        adaptiveHeight: false,
        dots: false,
        speed: 200,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              fade: false,
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true
            }
          }
        ]
      });

      var $slideshow = this.$slideshow;
      this.$slideshow.find('.card__nav__btn').click(function(e){
        e.preventDefault();
        var index = $(this).data('index');
        $slideshow.slick('goTo', index);
      })
    },
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      // var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      // var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      // $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    }
  });
  return ProductFeatureSlider;
})();

theme.ProductFeatures = (function() {
  function ProductFeatures(container) {
    var $container = this.$container = $(container),
        sectionId = $container.attr('data-section-id'),
        slideshow = this.slideshow = '#ProductFeaturesSlider-'+sectionId,
        $slideshow = this.$slideshow = $(this.slideshow);

    this.init();
  }

  ProductFeatures.prototype = _.assignIn({}, ProductFeatures.prototype, {
    init: function() {
      console.log('theme.ProductFeatures()');

      this.$slideshow.on('init', function(event, slick){
        var $slider = slick.$slider,
            $currentSlide = $slider.find('.slick-current');
      })
      this.$slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var $slider = slick.$slider,
            $currentSlide = $slider.find('.slick-current'),
            $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');

      });
      this.$slideshow.slick({
        arrows: false,
        dots: true,
        fade: true,
        speed: 200,
        // autoplay: false,
        // adaptiveHeight: false,
        // dots: false,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              // arrows: false,
              fade: false
              // slidesToShow: 1,
              // slidesToScroll: 1,
              // infinite: true
            }
          }
        ]
      });

      var $slideshow = this.$slideshow;
      this.$slideshow.find('.card__nav__btn').click(function(e){
        e.preventDefault();
        var index = $(this).data('index');
        $slideshow.slick('goTo', index);
      })
    },
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      // var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      // var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      // $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    }
  });
  return ProductFeatures;
})();

theme.UGCSlider = (function() {
  function UGCSlider(container) {
    var $container = this.$container = $(container),
        $slider = this.$slider = $container.find('[data-ugc-slider]'),
        $slide = this.$slide = $container.find('[data-ugc-slide]');

    this.init();
  }

  UGCSlider.prototype = _.assignIn({}, UGCSlider.prototype, {
    init: function() {
      var $slider = this.$slider,
          $slide = this.$slide;

      $slider.attr('class', 'ugc__slider');
      $slide.attr('class', 'ugc__slide');

      $slider.slick({
        arrows: false,
        dots: true,
        slidesToShow: 7,
        slidesToScroll: 7,
        infinite: true,
        dots: false,
        speed: 200,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              dots: false
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    },
    onUnload: function() {
    },
    onBlockSelect: function(evt) {
    }
  });
  return UGCSlider;
})();

theme.SectionLogos = (function() {
  function SectionLogos(container) {
    var $container = this.$container = $(container),
        sectionId = $container.attr('data-section-id'),
        blockSize = this.blockSize = parseInt( $container.attr('data-block-size') ) || 5,
        slideshow = this.slideshow = '#SectionLogos-'+sectionId,
        $slideshow = this.$slideshow = $(this.slideshow);

    this.init();
  }

  SectionLogos.prototype = _.assignIn({}, SectionLogos.prototype, {
    init: function() {
      var blockSize = this.blockSize;

      this.$slideshow.attr('class', 'grid--logos');

      this.$slideshow.on('init', function(event, slick){
        var $slider = slick.$slider,
            $currentSlide = $slider.find('.slick-current');
      })
      this.$slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var $slider = slick.$slider,
            $currentSlide = $slider.find('.slick-current'),
            $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');

      });
      this.$slideshow.slick({
        arrows: false,
        fade: false,
        adaptiveHeight: true,
        slidesToShow: blockSize,
        slidesToScroll: blockSize,
        infinite: true,
        speed: 200,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              arrows: false,
              fade: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            }
          }
        ]
      });
    },
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      // var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      // var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      // $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    }
  });
  return SectionLogos;
})();

theme.ProductGridItem = (function() {
  function ProductGridItem(container) {
    const $container = this.$container = $(container)
    const productId = $container.attr('data-product-id')
    const selectors = this.selectors = {
      item: '.swatch__item',
      link: '.swatch__link',
      productPrice: '[data-product-price]',
      comparePrice: '[data-product-compare-at-price]'
    }

    this.init()
    this.bundleElements()
  }

  ProductGridItem.prototype = _.assignIn({}, ProductGridItem.prototype, {
    init: function() {
      this.$container.find(this.selectors.link).click(function(evt){
        evt.preventDefault()

        const $gridLink = $(evt.target).closest(this.selectors.link)
        const imgUrl = $gridLink.attr('data-variant-image')
        const link = $gridLink.attr('href')
        const variantId = $gridLink.attr('data-variant-id')
        const variantSKU = $gridLink.attr('data-variant-sku')
        let additionalSavingMultiplier = parseFloat( this.$container.attr('data-additional-saving-multiplier') ) || 1.0
        /*
        if (variantSKU == "RBE725-21E-AST" || variantSKU == "RBE725-21E-CUB" || variantSKU == "RBE725-21E-DOD" || variantSKU == "RBE725-21E-PHI" || variantSKU == "RBE725-21E-RSX" || variantSKU == "RBE725-21E-YAN") {
          additionalSavingMultiplier = 1;
        }
        */

        /* start HK O15 special discount */
        /*
        if ((variantSKU == "RBO715-25E-BLA" || variantSKU == "RBO715-25E-BLU" || variantSKU == "RBO715-25E-MIN" || variantSKU == "RBO715-25E-PUR") && Shopify.country == "HK") {
          additionalSavingMultiplier = 0.5;
        }
        */
        /* end HK O15 special discount */

        /* start HK B42 special discount */
        /*
        if ((variantSKU.startsWith('RBB842-24E') && Shopify.country == "HK")) {
          additionalSavingMultiplier = 0.7;
        }
        */
        /* end HK B42 special discount */

        /* start HK O25 special discount */
        /*
        if ((variantSKU.startsWith('RBE725-21E') && Shopify.country == "HK")) {
          additionalSavingMultiplier = 0.5;
        }
        */
        /* end HK O25 special discount */
        console.log('grid item price update - 1');
        
        //const price = parseInt( $gridLink.attr('data-variant-price') ) * additionalSavingMultiplier
        const price = Math.ceil( parseFloat( $gridLink.attr('data-variant-price') ) * additionalSavingMultiplier );
        const compareAtPrice = parseInt( $gridLink.attr('data-variant-compare-at-price') )

        this.$container.find(this.selectors.item).removeClass('active')
        $gridLink.closest(this.selectors.item).addClass('active')

        this.$container
          .attr('data-variant-id', variantId)
          .attr('data-variant-price', price)
          .attr('data-variant-compare-at-price', compareAtPrice)
          .attr('data-image-url', imgUrl)

        this.$container.find('.grid__image').attr('src', imgUrl).removeAttr('srcset')
        this.$container.find('.grid__link').attr('href', link)
        if( this.$container.find(`[data-grid-link]`).length ) {
          this.$container.find(`[data-grid-link]`).attr('href', link)
        }
        // $gridItem.find('.collection__image__bottom').remove()

        // Regardless of stock, update the product price
        this.$container.find(this.selectors.productPrice).find('.money').html(`${slate.Currency.formatMoney(price, theme.moneyFormat)}`);

        // Also update and show the product's compare price if necessary
        if (compareAtPrice > price) {
          this.$container.find(this.selectors.comparePrice).find('.money').html(`${slate.Currency.formatMoney(compareAtPrice, theme.moneyFormat)}`);
          this.$container.find(this.selectors.comparePrice).closest('.compare-at').show();
          this.$container.find(this.selectors.productPrice).closest('.product__price').addClass('on-sale');
        } else {
          this.$container.find(this.selectors.comparePrice).closest('.compare-at').hide();
          this.$container.find(this.selectors.productPrice).closest('.product__price').removeClass('on-sale');
        }

        if( this.$container.find(`bundle-builder-buttons`).length ) {
          this.$container.closest(`.shopify-section`).trigger('BundleBuilder:UpdateSummary')
        }
      }.bind(this));
    },

    bundleElements: function() {
      if( !this.$container.find(`bundle-builder-buttons`).length ) {
        return
      }

      const $section = this.$container.closest(`.shopify-section`)
      const $quantitySelector = this.$container.find(`bundle-builder-buttons quantity-selector`)
      const $addButton = this.$container.find(`bundle-builder-buttons button[type="add"]`)
      const $plusButton = this.$container.find(`bundle-builder-buttons button[type="plus"]`)
      const $minusButton = this.$container.find(`bundle-builder-buttons button[type="minus"]`)
      const $quantityInput = this.$container.find(`bundle-builder-buttons input[name="quantity"]`)
      const quantityMax = parseInt( this.$container.attr(`data-quantity-max`) ) || 10

      $addButton.click(function(evt){
        evt.preventDefault()
        $quantityInput.val(1).change()
      }.bind(this))

      $quantityInput.change(function(evt) {
        const val = $(this).val()
        if( val > 0 ) {
          $quantitySelector.addClass('in')
          if( val > quantityMax ) {
            $quantityInput.val(quantityMax)
          }
        } else {
          $quantitySelector.removeClass('in')
          $quantityInput.val(0)
        }

        $section.trigger('BundleBuilder:UpdateSummary')
      })

      $plusButton.click(function(evt) {
        evt.preventDefault()
        const val = parseInt( $quantityInput.val() ) + 1
        $quantityInput.val( val ).change()
      })

      $minusButton.click(function(evt) {
        evt.preventDefault()
        const val = parseInt( $quantityInput.val() ) - 1
        $quantityInput.val( (val<0) ? 0 : val ).change()
      })
    }
  });

  return ProductGridItem;
})();

theme.LandingPageProductForm = (function() {
  function LandingPageProductForm(container) {
    var $container = this.$container = $(container),
        sectionId = $container.attr('data-section-id');

    this.init();
  }

  LandingPageProductForm.prototype = _.assignIn({}, LandingPageProductForm.prototype, {
    init: function() {
      var $container = this.$container,
          sectionId = $container.attr('data-section-id'),
          productTitle = $container.attr('data-product-title'),
          productDescription = $container.attr('data-product-description'),
          productSalePrice = $container.attr('data-product-sale-price'),
          promoCode = $container.attr('data-promo-code');

      if( productTitle !== undefined ) {
        $container.find('.product__title').html( productTitle );
      }

      if( productDescription !== undefined ) {
        $container.find('.product__description').html( '<p>' + productDescription + '</p>' );
      }

      if( productSalePrice !== undefined && productSalePrice !== '' ) {
        if( !$container.find('.product__price').hasClass('on-sale') ) {
          $container
            .find('.product__price-wrap')
              .hide()
              .end()
            .find('.product__price-wrap .grid')
              .removeClass('grid')
              .end()
            .find('.product__price-wrap .grid__item')
              .removeClass('grid__item')
              .end()

            .find('.product__price-wrap .product__price')
              .attr('class', 'product__price uppercase h5');

          $('<p class="product__sale-price">$' + productSalePrice + '</p>').insertBefore('#ProductSection-' + sectionId + ' .product__price');
        }
      }

      // if( promoCode !== undefined ) {
      //   if( $container.find('[name="return_to"]').length ) {
      //     $container.find('[name="return_to"]').attr('value', '/checkout?&amp;discount=' + promoCode);
      //   }
      // }

      // Do not show decimals on landing pages
      // theme.moneyFormat = "${{amount_no_decimals}}";
      $(window).load(function(){
        $container
          .find('.swatch__item.active').first()
            .removeClass('active')
            .find('.swatch__link')
              .click()
        $container.find('.product__price-wrap').show();
      });


      $container.find('[data-landing-page-add-to-cart]').click(function(e){
        e.preventDefault();
        $container.find('[action="/cart/add"] [type="submit"]').click();
      });
    }
  });
  return LandingPageProductForm;
})();

theme.HorizontalScrollContainer = (function() {

  function HorizontalScrollContainer(container) {
    var $container = this.$container = $(container),
        $scrollable = this.$scrollable = $container.find(' > *');

    this.init();
  }

  HorizontalScrollContainer.prototype = _.assignIn({}, HorizontalScrollContainer.prototype, {
    init: function() {
      var $scrollable = this.$scrollable,
          updateState = this.updateState;

      $scrollable.on('scroll', function(){
        updateState( $scrollable );
      });

      $(window).resize(function(){
        updateState( $scrollable );
      });

      $(window).load(function(){
        updateState( $scrollable );
      });
    },
    updateState: function( $scrollable ) {
      var width = parseInt( $scrollable.outerWidth() ),
          scrollWidth = parseInt( $scrollable[0].scrollWidth ),
          scrollLeft = parseInt( $scrollable.scrollLeft() ),
          $container = $scrollable.closest('.horizontal-scroll-container');

      $container.removeClass('right-end');
      $container.removeClass('left-end');

      if ( scrollWidth - scrollLeft <=  width ){
        $container.addClass('right-end');
      }

      if ( scrollLeft <= 0 ){
        $container.addClass('left-end');
      }
    }
  });

  return HorizontalScrollContainer;
})();

theme.CollectionSlider = (function() {
  function CollectionSlider(container) {
    var $container = this.$container = $(container),
        $slider = this.$slider = $container.find('[data-slider]'),
        $slide = this.$slide = $slider.find('.product-grid-item');

    this.init();
  }

  CollectionSlider.prototype = _.assignIn({}, CollectionSlider.prototype, {
    init: function() {

      var $slider = this.$slider,
          $slide = this.$slide,
          productCount = parseInt( $slider.attr('data-product-count') );

      var slidesToShow = 4;

      if( productCount < 4 ) {
        slidesToShow = productCount;
      }

      $slider.attr('class', 'collection__slider');
      $slide.each(function(){
        if( $(this).hasClass('variant-grid-item') ) {
          $(this).attr('class', 'product-grid-item variant-grid-item');
        } else {
          $(this).attr('class', 'product-grid-item');
        }
        if( $(this).attr('data-bestseller') == 'true' ) {
          $(this).addClass('bestseller');
        }
      });

      $slider.slick({
        arrows: false,
        dots: true,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToShow,
        infinite: false,
        dots: false,
        speed: 200,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              dots: false
            }
          },
          {
            breakpoint: 769,
            settings: {
              initialSlide: 1,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 481,
            settings: {
              initialSlide: 1,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    },
    onUnload: function() {
    },
    onBlockSelect: function(evt) {
    }
  });
  return CollectionSlider;
})();

theme.ImageSlider = (function() {
  function ImageSlider(container) {
    var $container = this.$container = $(container),
        id = $container.attr('data-section-id'),
        $slider = $container.find('[data-slider]');

    if( !$slider.length || $slider.children().length <= 1 ) {
      return;
    }

    $slider.slick({
      arrows: false,
      dots: true,
      speed: 200
    });
  }

  ImageSlider.prototype = _.assignIn({}, ImageSlider.prototype, {});

  return ImageSlider;
})();

theme.IconColumns = (function() {
  function IconColumns(container) {
    var $container = this.$container = $(container),
        $slider = this.$slider = $container.find('[data-slider]'),
        $slide = this.$slide = $container.find('[data-slide]');

    this.init();
  }

  IconColumns.prototype = _.assignIn({}, IconColumns.prototype, {
    init: function() {
      var $container = this.$container,
          $slider = this.$slider,
          $slide = this.$slide,
          itemCount = parseInt( $container.attr('data-item-count') ) || 3;

      $slider.attr('class', 'icon-columns__slider');
      $slide.attr('class', 'icon-columns__slide icon-columns__item');

      $slider.slick({
        arrows: true,
        dots: false,
        slidesToShow: itemCount,
        slidesToScroll: 1,
        infinite: true,
        speed: 200,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    },
    onUnload: function() {
    },
    onBlockSelect: function(evt) {
    }
  });
  return IconColumns;
})();

theme.CelebritySightings = (function() {
  function CelebritySightings(container) {
    let $container = this.$container = $(container),
        $slider = this.$slider = $container.find('[data-slider]'),
        $slide = this.$slide = $container.find('[data-slide]');

    this.init();
  }

  CelebritySightings.prototype = _.assignIn({}, CelebritySightings.prototype, {
    init: function() {
      let $container = this.$container,
          $slider = this.$slider,
          $slide = this.$slide;
      console.log(`theme.CelebritySightings()`);

      $container.on(`click`, `.slick-slide`, function(){
        let slickIndex = parseInt( $(this).attr(`data-slick-index`) );
        $slider.slick('goTo', slickIndex);
      })
    }
  });
  return CelebritySightings;
})();

theme.StickyCta = (function() {
  function StickyCta(container) {
    let $container = this.$container = $(container);

    this.init();
  }

  StickyCta.prototype = _.assignIn({}, StickyCta.prototype, {
    init: function() {
      let $container = this.$container,
          ctaBehaviour = $container.attr('data-cta-behaviour');

    switch(ctaBehaviour) {
      case 'show_on_title_click':
        $container.find('[sticky-cta-toggle]').click(function(){
          $container.toggleClass('in');
        })
        break;

      case 'show_on_scroll':
        let $header = $('.site-header'),
            $firstSection = $('.shopify-page-section > section').first();

        $(window).on('scroll', $.throttle(500, function(){
          let scrollTop = $(window).scrollTop();
          if( scrollTop > ($firstSection.position().top+$firstSection.outerHeight()-$header.outerHeight()) ) {
            $container.addClass('in');
          } else {
            $container.removeClass('in');
          }
        }));
        break;

      default:
        // code block
    }

    },
    onUnload: function() {
    },
    onBlockSelect: function(evt) {
    }
  });
  return StickyCta;
})();

theme.FloatingNav = (function() {
  function FloatingNav(container) {
    let $container = this.$container = $(container);

    this.init();
  }

  FloatingNav.prototype = _.assignIn({}, FloatingNav.prototype, {
    init: function() {
      console.log('FloatingNav.init()');

      let $container = this.$container,
          $header = $('.site-header'),
          $firstSection = $('.index-sections > .shopify-section').first();

      $(window).on('scroll', $.throttle(500, function(){
        let scrollTop = $(window).scrollTop();
        if( scrollTop > ($firstSection.position().top+$firstSection.outerHeight()-$header.outerHeight()) ) {
          $container.addClass('in');
        } else {
          $container.removeClass('in');
        }
      }));
    },
    onUnload: function() {
    },
    onBlockSelect: function(evt) {
    }
  });
  return FloatingNav;
})();

theme.GridSlider = (function() {
  function GridSlider(container) {
    let $container = this.$container = $(container);
    if( $container.attr('data-initialized') === 'true' ) {
      return;
    }
    this.init();
  }
  GridSlider.prototype = $.extend({}, GridSlider.prototype, {
    init: function(){
      let $container = this.$container,
          slideSelector = $container.attr('data-slide-selector')
          $slider = $container.find('[data-slider]'),
          $slide = $container.find(slideSelector);

      if( !$slider.length ) {
        return;
      }

      $slide.addClass('grid-slider__item');

      $slider
        .on('init', function(){
          $container.attr('data-initialized', 'true');
        })
        .slick();
    }
  });
  return GridSlider;
})();

theme.FrequentlyBought = (function() {
  function FrequentlyBought(container) {
    let $container = this.$container = $(container);

    console.log('FrequentlyBought') ;
    this.init();
  }
  FrequentlyBought.prototype = _.assignIn({}, FrequentlyBought.prototype, {
    init: function() {
      let $container = this.$container,
          $productGridItems = $container.find('.product-grid-item'),
          scope = this;

      $productGridItems.find(`[data-swatch-link]`).click(function(evt) {
        scope.updatePrices();
      });

      $container.find(`[data-swatch-list]`).each(function(){
        $(this).find(`[data-swatch-item].sold-out`).remove();
        $(this).find(`[data-swatch-item]`).first().find(`[data-swatch-link]`).click()
      });

      $container.find('[data-add-to-cart]').click(function(evt){
        evt.preventDefault();
        console.log('add both to cart');

        let addItems = {
          items: []
        };
        $productGridItems.each(function(){
          let id = parseInt( $(this).find(`[data-swatch-item].active [data-swatch-link]`).attr('data-variant-id') );

          addItems.items.push({
            quantity: 1,
            id: id,
            properties: {
              '_Frequently Bought With': 'true'
            }
          })
        });

        addItems.items.reverse();

        console.log(addItems);
        console.log('Drawer Cart add.js - 7');
        $.ajax({
          type: 'POST',
          url: `${window.Shopify.routes.root}cart/add.js`,
          dataType: 'json',
          data: addItems,
          error: function(object, status){
            var $errEl = $container.find('[data-add-to-cart-error]');
            var ct = (object.getResponseHeader && object.getResponseHeader('Content-Type')) || '';
            //if (ct.indexOf('text/html') !== -1 || (object.status === 403 && !object.responseJSON)) {
            //const ct = (object.headers.get('content-type') || '');
            //if (ct.indexOf('application/json') === -1 && 1>2) {
            if (ct.includes('text/html') || (object.status === 429) || (object.status === 403)) {
              console.error('[Cart] Cloudflare challenge detected on cart/add.js frequently-bought (got HTML instead of JSON). Reloading page for verification.');
              $errEl.html('Please verify your connection. Reloading page…').removeClass('hide');
              setTimeout(function(){ window.location.reload(); }, 2000);
              throw new Error('CF_BLOCK');
              return;
            }
            var msg = (object.responseJSON && object.responseJSON.description) || 'An error occurred. Please try again.';
            $errEl.html(msg).removeClass('hide');
          },
          success: function(){
            // Redirect to checkout page
            location.href = `${window.Shopify.routes.root}cart`;
          },
          complete: function(){
          }
        });
      });
    },

    updatePrices() {
      let $container = this.$container,
          $productGridItems = $container.find('.product-grid-item'),
          moneyFormat = theme.moneyFormat,
          selectors = {
            productPrice: '[product-price]',
            comparePrice: '[product-compare-at-price]'
          };

      let totalVariantCompareAtPrice = 0,
          totalVariantPrice = 0;

      $productGridItems.each(function(){
        let $item = $(this),
            productId = parseInt( $item.attr('data-product-id') ),
            $swatchLink = $item.find(`[data-swatch-link]`),
            variantPrice = parseInt( $swatchLink.attr(`data-variant-price`) ),
            variantCompareAtPrice = parseInt( $swatchLink.attr(`data-variant-compare-at-price`) ) || variantPrice,
            $summaryItem = $container.find(`[summary-item="${productId}"]`);

        totalVariantCompareAtPrice += variantCompareAtPrice;
        totalVariantPrice += variantPrice;

        // Regardless of stock, update the product price
        $summaryItem.find(`${selectors.productPrice} .money`).html( slate.Currency.formatMoney(variantPrice, moneyFormat) );
      });

      let $bundleItemPrice = $container.find('[bundle-item-price]'),
          bundleDiscount = 0;

      totalVariantPrice -= bundleDiscount;

      // Regardless of stock, update the product price
      $bundleItemPrice.find(`${selectors.productPrice} .money`).html( slate.Currency.formatMoney(totalVariantPrice, moneyFormat) );

      // Also update and show the product's compare price if necessary
      if (totalVariantCompareAtPrice > totalVariantPrice) {
        $bundleItemPrice.find(`${selectors.comparePrice} .money`).html( slate.Currency.formatMoney(totalVariantCompareAtPrice, moneyFormat) );
        $bundleItemPrice.find(selectors.comparePrice).closest('.compare-at').show();
        $bundleItemPrice.find(selectors.productPrice).closest('.product__price').addClass('on-sale');
      } else {
        $bundleItemPrice.find(selectors.comparePrice).closest('.compare-at').hide();
        $bundleItemPrice.find(selectors.productPrice).closest('.product__price').removeClass('on-sale');
      }
    }
  });
  return FrequentlyBought;
})();

theme.ProductCompare = (function() {
  function ProductCompare(container) {
    const $container = this.$container = $(container);
    this.init();
  }

  ProductCompare.prototype = _.assignIn({}, ProductCompare.prototype, {
    init: function() {
      if( !this.$container.find(`#ProductCompareContent`).length ) {
        console.error(`Product Compare Content Not found`);
        return;
      }

      const compareColumnsHTML = this.$container.find(`#ProductCompareContent`).html();
      const $compareColumns = $(compareColumnsHTML);

      this.$container.find(`[compare-column-selector]`).change(function(evt){
        const productId = $(evt.target).val();
        const $content = $(evt.target).closest(`[compare-column]`).find(`[compare-column-content]`);
        $content.html( $compareColumns.filter(`[data-product-id="${productId}"]`) );
        this.reselect( evt.target )
      }.bind(this));

      this.$container.find(`[compare-column-selector]`).first().change();
    },

    reselect: function(selector) {
      let selectedIds = [];
      this.$container.find(`[compare-column]`).each(function(){
        const $compareItem = $(this).find(`[compare-item]`)
        if( $compareItem.length ) {
          selectedIds.push( $compareItem.attr(`data-product-id`) );
        }
      });

      this.$container.find(`[compare-column]`).each(function(){
        const $selector = $(this).find(`[compare-column-selector]`)
        const $compareItem = $(this).find(`[compare-item]`)
        if( !$compareItem.length ) {
          $selector.find(`option`).each(function(){
            const id = $(this).val();
            if( selectedIds.indexOf(id) === -1 ) {
              $selector.val(id).change();
              return;
            }
          })
        }
      });
    },
    onUnload: function() {
    },
    onBlockSelect: function(evt) {
    }
  });
  return ProductCompare;
})();

theme.ProductUpsell = (function() {
  function ProductUpsell(container) {
    const $container = this.$container = $(container);
    const selectors = this.selectors = {
      upsell: {
        container: '[upsell-container]',
        slider: '[upsell-item-slider]',
        addToCart: '[upsell-add-to-cart]'
      },
      productForm: '[upsell-product-form]'
    };
    this.init();
  }

  ProductUpsell.prototype = _.assignIn({}, ProductUpsell.prototype, {
    init: function() {
      var $container = this.$container;
      var selectors = this.selectors;

      $('body').on('initUpsellSlider', function(){
        if( $container.find( selectors.upsell.slider ).hasClass('slick-initialized') ) {
          return;
        }

        $container.find( selectors.upsell.slider ).slick({
          arrows: false,
          dots: true,
          adaptiveHeight: false,
          slidesToShow: 5,
          slidesToScroll: 5,
          infinite: true,
          speed: 200,
          responsive: [
            {
              arrows: true,
              breakpoint: 1280,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
              }
            },
            {
              arrows: true,
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              arrows: true,
              breakpoint: 768,
              dots: false,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              arrows: true,
              breakpoint: 480,
              dots: false,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            }
          ]
        });
      });

      $('body').on('click', `[data-cart-upsell-item] [data-swatch-link]`, function(evt){
        evt.preventDefault();
        const $link = $(this);
        const $upsellItem = $link.closest(`[data-cart-upsell-item]`);
        const variantId = $link.attr(`data-variant-id`);
        const image = $link.attr(`data-variant-image`);
        const variantPrice = parseInt( $link.attr(`data-variant-price`) );
        const variantCompareAtPrice = parseInt( $link.attr(`data-variant-compare-at-price`) );

        $upsellItem.find(`[data-swatch-item]`).removeClass('active');
        $link.closest(`[data-swatch-item]`).addClass('active');

        $upsellItem.attr(`data-variant-id`, variantId);


        // Update the product price
        const moneyFormat = theme.moneyFormat;
        $upsellItem.find(`[data-product-price] .money`).html( slate.Currency.formatMoney(variantPrice, moneyFormat) );
        $upsellItem.find(`[data-product-compare-at-price]`).attr('data-value', variantCompareAtPrice);
        $upsellItem.find(`[data-product-price]`).attr('data-value', variantPrice);

        // Also update and show the product's compare price if necessary
        if (variantCompareAtPrice > variantPrice) {
          $upsellItem.find(`[data-product-compare-at-price] .money`).html( slate.Currency.formatMoney(variantCompareAtPrice, moneyFormat) );
          $upsellItem.find(`[data-product-compare-at-price]`).closest('.compare-at').show();
          $upsellItem.find(`[data-product-price]`).closest('.product__price').addClass('on-sale');
        } else {
          $upsellItem.find(`[data-product-compare-at-price]`).closest('.compare-at').hide();
          $upsellItem.find(`[data-product-price]`).closest('.product__price').removeClass('on-sale');
        }
        if( typeof(image) !== 'undefined' ) {
          $upsellItem.find(`[data-cart-upsell-item-image]`).removeAttr(`data-bgset`).css('background-image', `url("${image}")`);
        }
      });

      $(`[data-cart-upsell-item]`).each(function(){
        const $upsellItem =  $(this);
        const variantId = $upsellItem.attr(`data-variant-id`);
        $upsellItem.find(`[data-swatch-link][data-variant-id="${variantId}"]`).click();
      })

      $('body').on('click', selectors.upsell.addToCart, function(e){
        e.preventDefault();

        console.log('updsell atc clicked')
        const $upsellItem =  $(this).closest(`[data-cart-upsell-item]`)
        const variantId = $upsellItem.attr('data-variant-id');
        if( variantId === undefined ) {
          return;
        }

        console.log({
          'variantId': variantId
        })
        $upsellItem.addClass(`loading`);

        var $productForm = $container.find( selectors.productForm );
        $productForm.find('[name="id"]').val( variantId );
        $productForm.submit();
      });

      $('body').trigger('initUpsellSlider');
    },

  });
  return ProductUpsell;
})();

theme.BundleBuilder = (function() {
  function BundleBuilder(container) {
    const $container = this.$container = $(container)
    const bundleSize = this.bundleSize = 3
    this.init();
  }

  BundleBuilder.prototype = _.assignIn({}, BundleBuilder.prototype, {
    init: function() {
      this.$container.closest('.shopify-section').on('BundleBuilder:UpdateSummary', function(evt){
        this.updateSummary()
      }.bind(this))

      const $checkoutButton = this.$container.find('bundle-builder-summary-action button[type="checkout"]')
      $checkoutButton.click(function(evt) {
        $checkoutButton.addClass('loading')
        this.clearCart(function(){
          this.addToCart(function(){
            $checkoutButton.removeClass('loading').html(`Added`)
            window.location.href = `${Shopify.routes.root}checkout`
          }.bind(this))
        }.bind(this))
      }.bind(this))

      const $addButton = this.$container.find('bundle-builder-summary-action button[type="add"]')
      $addButton.click(function(evt) {
        $addButton.addClass('loading')
        this.addToCart(function(){
          const addText = $addButton.html()
          $addButton.addClass('loading').html(`Added`)
          window.location.href = `${Shopify.routes.root}cart`
          // setTimeout(function(){
          //   $addButton.html(addText)
          // }, 600)
        }.bind(this))
      }.bind(this))
    },

    updateSummary: function() {
      let totalQuantity = 0
      let totalPrice = 0
      let totalCompareAtPrice = 0
      let variantImageHtml = ''

      this.$container.find(`quantity-selector.in`).each(function(){
        const quantity = parseInt( $(this).find(`[name="quantity"]`).val() ) || 1
        const $productGridItem = $(this).closest(`.product-grid-item`)
        const imageUrl = $productGridItem.attr('data-image-url')

        totalQuantity += quantity
        // remove quantity multiplier
        //totalPrice += ( parseInt( $productGridItem.attr('data-vairant-price') ) * quantity )
        //totalCompareAtPrice += ( parseInt( $productGridItem.attr('data-vairant-compare-at-price') ) * quantity )
        totalPrice += ( parseInt( $productGridItem.attr('data-vairant-price') ) )
        totalCompareAtPrice += ( parseInt( $productGridItem.attr('data-vairant-compare-at-price') ) )
        variantImageHtml += `<img src="${imageUrl}" />`
      })

      if( totalQuantity === 0 ) {
        $(`bundle-builder-summary`).hide()
        return
      }
      $(`bundle-builder-summary`).show()
      if( totalQuantity >= this.bundleSize ) {
        $(`bundle-builder-summary`).attr('unlocked', true)
      } else {
        $(`bundle-builder-summary`).attr('unlocked', false)
        $(`bundle-builder-summary-status`).html(`Add ${(this.bundleSize-totalQuantity)} More For Savings`).show()
      }

      $(`bundle-builder-summary-images`).html( variantImageHtml )
      $(`bundle-builder-summary-compare-at-price .money`).html( slate.Currency.formatMoney(totalCompareAtPrice, theme.moneyFormat) )
      $(`bundle-builder-summary-price .money`).html( slate.Currency.formatMoney(totalPrice, theme.moneyFormat) )
      $(`bundle-builder-summary-amount-off .money`).html(`${slate.Currency.formatMoney((totalCompareAtPrice - totalPrice), theme.moneyFormat)} OFF`)
    },

    clearCart: function(callback) {
      $.post(`${Shopify.routes.root}cart/clear.js`, function() {
      })
        .done(function() {
        })
        .fail(function() {
        })
        .always(function(){
          if( typeof(callback) === 'function' ) {
            callback()
          }
        })
    },

    addToCart: function(callback) {
      const $bundleSumamry = this.$container.find('bundle-builder-summary')
      // $bundleSumamry.addClass('loading')

      let addItems = []
      this.$container.find(`quantity-selector.in`).each(function(){
        const variantId = parseInt( $(this).closest('.product-grid-item').attr('data-variant-id') )
        const quantity = parseInt( $(this).find(`[name="quantity"]`).val() ) || 1
        addItems.push({
          'id': variantId,
          'quantity': quantity,
          'properties': {
            '_source': 'bundle_builder'
          }
        })
      })
      console.log('Drawer Cart add.js - 8');
      $.post(`${Shopify.routes.root}cart/add.js`, {
        items: addItems
      }).always(function(){
        if( typeof(callback) === 'function' ) {
          callback()
        }
      })
    },

    onUnload: function() {
    },

    onBlockSelect: function(evt) {
    }
  });
  return BundleBuilder;
})();


theme.Default = (function() {
  function Default(container) {}
  return Default;
})();

$(document).on('shopify:section:load', theme.moveTags);

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('parallax', theme.Parallax);
  sections.register('banner-image', theme.Parallax);
  sections.register('banner-image', theme.BannerImage);
  sections.register('header', theme.Header);
  sections.register('megamenu', theme.Megamenu);
  sections.register('instagram', theme.Instagram);
  sections.register('video', theme.Video);
  sections.register('product', theme.Product);
  sections.register('product-bundle', theme.ProductBundle);
  sections.register('footer', theme.Footer);
  sections.register('slideshow', theme.Slideshow);
  sections.register('password', theme.Password);
  sections.register('product-widget', theme.ProductWidget);
  sections.register('product-feature-slider', theme.ProductFeatureSlider);
  sections.register('product-features', theme.ProductFeatures);
  sections.register('ugc-slider', theme.UGCSlider);
  sections.register('section-logos', theme.SectionLogos);
  sections.register('product-grid-item', theme.ProductGridItem);
  sections.register('landing-page-product-form', theme.LandingPageProductForm);
  sections.register('cart', theme.Cart);
  sections.register('horizontal-scroll-container', theme.HorizontalScrollContainer);
  sections.register('collection-slider', theme.CollectionSlider);
  sections.register('image-slider', theme.ImageSlider);
  sections.register('collection-compare', theme.CollectionCompare);
  sections.register('compare-products', theme.CompareProducts);
  sections.register('icon-columns', theme.IconColumns);
  sections.register('celebrity-sightings', theme.CelebritySightings);
  sections.register('celebrity-sightings', theme.GridSlider);
  sections.register('sticky-cta', theme.StickyCta);
  sections.register('floating-nav', theme.FloatingNav);
  sections.register('grid-slider', theme.GridSlider);
  sections.register('frequently-bought', theme.FrequentlyBought);
  sections.register('product-compare', theme.ProductCompare);
  sections.register('product-upsell', theme.ProductUpsell);
  sections.register('bundle-builder', theme.BundleBuilder);


  // Common a11y fixes
  // Guard: hashes like "#/" (route-style links) crash jQuery with "Syntax error, unrecognized
  // expression: #/". Only invoke pageLinkFocus when the hash looks like a real id target.
  var _initHash = window.location.hash;
  if (_initHash && /^#[\w\-]+$/.test(_initHash)) {
    slate.a11y.pageLinkFocus($(_initHash));
  }

  $('.in-page-link').on('click', function(evt) {
    var _h = evt.currentTarget.hash;
    if (_h && /^#[\w\-]+$/.test(_h)) {
      slate.a11y.pageLinkFocus($(_h));
    }
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Animate on scroll
  if( window.AOS ) {
    AOS.init({ once: false });
    $('body').addClass('aos-initialized');
  }

  // --- Autoplay video pause/play toggle (WCAG 2.2.2) ---
  $(document).on('click', '.video-pause-btn', function(e) {
    e.preventDefault();
    var $btn = $(this);
    var $wrapper = $btn.closest('.video-wrapper--autoplay');
    var video = $wrapper.find('video')[0];
    if (!video) return;

    if (video.paused) {
      video.play();
      $btn.attr('aria-label', 'Pause video');
      $btn.attr('data-playing', 'true');
      $btn.find('.video-pause-btn__icon').html('&#10074;&#10074;');
    } else {
      video.pause();
      $btn.attr('aria-label', 'Play video');
      $btn.attr('data-playing', 'false');
      $btn.find('.video-pause-btn__icon').html('&#9654;');
    }
  });

});
